var yl = Object.defineProperty;
var gl = (a, t, e) => t in a ? yl(a, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[t] = e;
var Xt = (a, t, e) => gl(a, typeof t != "symbol" ? t + "" : t, e);
/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const ec = "171";
const rc = "", pt = "srgb", sa = "srgb-linear", ia = "linear", Ir = "srgb";
class Ar {
  addEventListener(t, e) {
    this._listeners === void 0 && (this._listeners = {});
    const r = this._listeners;
    r[t] === void 0 && (r[t] = []), r[t].indexOf(e) === -1 && r[t].push(e);
  }
  hasEventListener(t, e) {
    if (this._listeners === void 0) return !1;
    const r = this._listeners;
    return r[t] !== void 0 && r[t].indexOf(e) !== -1;
  }
  removeEventListener(t, e) {
    if (this._listeners === void 0) return;
    const s = this._listeners[t];
    if (s !== void 0) {
      const i = s.indexOf(e);
      i !== -1 && s.splice(i, 1);
    }
  }
  dispatchEvent(t) {
    if (this._listeners === void 0) return;
    const r = this._listeners[t.type];
    if (r !== void 0) {
      t.target = this;
      const s = r.slice(0);
      for (let i = 0, n = s.length; i < n; i++)
        s[i].call(this, t);
      t.target = null;
    }
  }
}
const X = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
function _e() {
  const a = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, r = Math.random() * 4294967295 | 0;
  return (X[a & 255] + X[a >> 8 & 255] + X[a >> 16 & 255] + X[a >> 24 & 255] + "-" + X[t & 255] + X[t >> 8 & 255] + "-" + X[t >> 16 & 15 | 64] + X[t >> 24 & 255] + "-" + X[e & 63 | 128] + X[e >> 8 & 255] + "-" + X[e >> 16 & 255] + X[e >> 24 & 255] + X[r & 255] + X[r >> 8 & 255] + X[r >> 16 & 255] + X[r >> 24 & 255]).toLowerCase();
}
function P(a, t, e) {
  return Math.max(t, Math.min(e, a));
}
function bl(a, t) {
  return (a % t + t) % t;
}
function Rr(a, t, e) {
  return (1 - e) * a + e * t;
}
function ve(a, t) {
  switch (t.constructor) {
    case Float32Array:
      return a;
    case Uint32Array:
      return a / 4294967295;
    case Uint16Array:
      return a / 65535;
    case Uint8Array:
      return a / 255;
    case Int32Array:
      return Math.max(a / 2147483647, -1);
    case Int16Array:
      return Math.max(a / 32767, -1);
    case Int8Array:
      return Math.max(a / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function tt(a, t) {
  switch (t.constructor) {
    case Float32Array:
      return a;
    case Uint32Array:
      return Math.round(a * 4294967295);
    case Uint16Array:
      return Math.round(a * 65535);
    case Uint8Array:
      return Math.round(a * 255);
    case Int32Array:
      return Math.round(a * 2147483647);
    case Int16Array:
      return Math.round(a * 32767);
    case Int8Array:
      return Math.round(a * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
class E {
  constructor(t = 0, e = 0) {
    E.prototype.isVector2 = !0, this.x = t, this.y = e;
  }
  get width() {
    return this.x;
  }
  set width(t) {
    this.x = t;
  }
  get height() {
    return this.y;
  }
  set height(t) {
    this.y = t;
  }
  set(t, e) {
    return this.x = t, this.y = e, this;
  }
  setScalar(t) {
    return this.x = t, this.y = t, this;
  }
  setX(t) {
    return this.x = t, this;
  }
  setY(t) {
    return this.y = t, this;
  }
  setComponent(t, e) {
    switch (t) {
      case 0:
        this.x = e;
        break;
      case 1:
        this.y = e;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(t) {
    return this.x = t.x, this.y = t.y, this;
  }
  add(t) {
    return this.x += t.x, this.y += t.y, this;
  }
  addScalar(t) {
    return this.x += t, this.y += t, this;
  }
  addVectors(t, e) {
    return this.x = t.x + e.x, this.y = t.y + e.y, this;
  }
  addScaledVector(t, e) {
    return this.x += t.x * e, this.y += t.y * e, this;
  }
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this;
  }
  subScalar(t) {
    return this.x -= t, this.y -= t, this;
  }
  subVectors(t, e) {
    return this.x = t.x - e.x, this.y = t.y - e.y, this;
  }
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this;
  }
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this;
  }
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this;
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  applyMatrix3(t) {
    const e = this.x, r = this.y, s = t.elements;
    return this.x = s[0] * e + s[3] * r + s[6], this.y = s[1] * e + s[4] * r + s[7], this;
  }
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
  }
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
  }
  clamp(t, e) {
    return this.x = P(this.x, t.x, e.x), this.y = P(this.y, t.y, e.y), this;
  }
  clampScalar(t, e) {
    return this.x = P(this.x, t, e), this.y = P(this.y, t, e), this;
  }
  clampLength(t, e) {
    const r = this.length();
    return this.divideScalar(r || 1).multiplyScalar(P(r, t, e));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  dot(t) {
    return this.x * t.x + this.y * t.y;
  }
  cross(t) {
    return this.x * t.y - this.y * t.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  angleTo(t) {
    const e = Math.sqrt(this.lengthSq() * t.lengthSq());
    if (e === 0) return Math.PI / 2;
    const r = this.dot(t) / e;
    return Math.acos(P(r, -1, 1));
  }
  distanceTo(t) {
    return Math.sqrt(this.distanceToSquared(t));
  }
  distanceToSquared(t) {
    const e = this.x - t.x, r = this.y - t.y;
    return e * e + r * r;
  }
  manhattanDistanceTo(t) {
    return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, e) {
    return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this;
  }
  lerpVectors(t, e, r) {
    return this.x = t.x + (e.x - t.x) * r, this.y = t.y + (e.y - t.y) * r, this;
  }
  equals(t) {
    return t.x === this.x && t.y === this.y;
  }
  fromArray(t, e = 0) {
    return this.x = t[e], this.y = t[e + 1], this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.x, t[e + 1] = this.y, t;
  }
  fromBufferAttribute(t, e) {
    return this.x = t.getX(e), this.y = t.getY(e), this;
  }
  rotateAround(t, e) {
    const r = Math.cos(e), s = Math.sin(e), i = this.x - t.x, n = this.y - t.y;
    return this.x = i * r - n * s + t.x, this.y = i * s + n * r + t.y, this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
}
class Ct {
  constructor(t, e, r, s, i, n, o, h, c) {
    Ct.prototype.isMatrix3 = !0, this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ], t !== void 0 && this.set(t, e, r, s, i, n, o, h, c);
  }
  set(t, e, r, s, i, n, o, h, c) {
    const l = this.elements;
    return l[0] = t, l[1] = s, l[2] = o, l[3] = e, l[4] = i, l[5] = h, l[6] = r, l[7] = n, l[8] = c, this;
  }
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ), this;
  }
  copy(t) {
    const e = this.elements, r = t.elements;
    return e[0] = r[0], e[1] = r[1], e[2] = r[2], e[3] = r[3], e[4] = r[4], e[5] = r[5], e[6] = r[6], e[7] = r[7], e[8] = r[8], this;
  }
  extractBasis(t, e, r) {
    return t.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), r.setFromMatrix3Column(this, 2), this;
  }
  setFromMatrix4(t) {
    const e = t.elements;
    return this.set(
      e[0],
      e[4],
      e[8],
      e[1],
      e[5],
      e[9],
      e[2],
      e[6],
      e[10]
    ), this;
  }
  multiply(t) {
    return this.multiplyMatrices(this, t);
  }
  premultiply(t) {
    return this.multiplyMatrices(t, this);
  }
  multiplyMatrices(t, e) {
    const r = t.elements, s = e.elements, i = this.elements, n = r[0], o = r[3], h = r[6], c = r[1], l = r[4], u = r[7], f = r[2], d = r[5], p = r[8], x = s[0], m = s[3], y = s[6], _ = s[1], b = s[4], w = s[7], M = s[2], A = s[5], v = s[8];
    return i[0] = n * x + o * _ + h * M, i[3] = n * m + o * b + h * A, i[6] = n * y + o * w + h * v, i[1] = c * x + l * _ + u * M, i[4] = c * m + l * b + u * A, i[7] = c * y + l * w + u * v, i[2] = f * x + d * _ + p * M, i[5] = f * m + d * b + p * A, i[8] = f * y + d * w + p * v, this;
  }
  multiplyScalar(t) {
    const e = this.elements;
    return e[0] *= t, e[3] *= t, e[6] *= t, e[1] *= t, e[4] *= t, e[7] *= t, e[2] *= t, e[5] *= t, e[8] *= t, this;
  }
  determinant() {
    const t = this.elements, e = t[0], r = t[1], s = t[2], i = t[3], n = t[4], o = t[5], h = t[6], c = t[7], l = t[8];
    return e * n * l - e * o * c - r * i * l + r * o * h + s * i * c - s * n * h;
  }
  invert() {
    const t = this.elements, e = t[0], r = t[1], s = t[2], i = t[3], n = t[4], o = t[5], h = t[6], c = t[7], l = t[8], u = l * n - o * c, f = o * h - l * i, d = c * i - n * h, p = e * u + r * f + s * d;
    if (p === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const x = 1 / p;
    return t[0] = u * x, t[1] = (s * c - l * r) * x, t[2] = (o * r - s * n) * x, t[3] = f * x, t[4] = (l * e - s * h) * x, t[5] = (s * i - o * e) * x, t[6] = d * x, t[7] = (r * h - c * e) * x, t[8] = (n * e - r * i) * x, this;
  }
  transpose() {
    let t;
    const e = this.elements;
    return t = e[1], e[1] = e[3], e[3] = t, t = e[2], e[2] = e[6], e[6] = t, t = e[5], e[5] = e[7], e[7] = t, this;
  }
  getNormalMatrix(t) {
    return this.setFromMatrix4(t).invert().transpose();
  }
  transposeIntoArray(t) {
    const e = this.elements;
    return t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8], this;
  }
  setUvTransform(t, e, r, s, i, n, o) {
    const h = Math.cos(i), c = Math.sin(i);
    return this.set(
      r * h,
      r * c,
      -r * (h * n + c * o) + n + t,
      -s * c,
      s * h,
      -s * (-c * n + h * o) + o + e,
      0,
      0,
      1
    ), this;
  }
  //
  scale(t, e) {
    return this.premultiply(Lr.makeScale(t, e)), this;
  }
  rotate(t) {
    return this.premultiply(Lr.makeRotation(-t)), this;
  }
  translate(t, e) {
    return this.premultiply(Lr.makeTranslation(t, e)), this;
  }
  // for 2D Transforms
  makeTranslation(t, e) {
    return t.isVector2 ? this.set(
      1,
      0,
      t.x,
      0,
      1,
      t.y,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      t,
      0,
      1,
      e,
      0,
      0,
      1
    ), this;
  }
  makeRotation(t) {
    const e = Math.cos(t), r = Math.sin(t);
    return this.set(
      e,
      -r,
      0,
      r,
      e,
      0,
      0,
      0,
      1
    ), this;
  }
  makeScale(t, e) {
    return this.set(
      t,
      0,
      0,
      0,
      e,
      0,
      0,
      0,
      1
    ), this;
  }
  //
  equals(t) {
    const e = this.elements, r = t.elements;
    for (let s = 0; s < 9; s++)
      if (e[s] !== r[s]) return !1;
    return !0;
  }
  fromArray(t, e = 0) {
    for (let r = 0; r < 9; r++)
      this.elements[r] = t[r + e];
    return this;
  }
  toArray(t = [], e = 0) {
    const r = this.elements;
    return t[e] = r[0], t[e + 1] = r[1], t[e + 2] = r[2], t[e + 3] = r[3], t[e + 4] = r[4], t[e + 5] = r[5], t[e + 6] = r[6], t[e + 7] = r[7], t[e + 8] = r[8], t;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
const Lr = /* @__PURE__ */ new Ct();
function _l(a) {
  for (let t = a.length - 1; t >= 0; --t)
    if (a[t] >= 65535) return !0;
  return !1;
}
function na(a) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", a);
}
const aa = /* @__PURE__ */ new Ct().set(
  0.4123908,
  0.3575843,
  0.1804808,
  0.212639,
  0.7151687,
  0.0721923,
  0.0193308,
  0.1191948,
  0.9505322
), oa = /* @__PURE__ */ new Ct().set(
  3.2409699,
  -1.5373832,
  -0.4986108,
  -0.9692436,
  1.8759675,
  0.0415551,
  0.0556301,
  -0.203977,
  1.0569715
);
function wl() {
  const a = {
    enabled: !0,
    workingColorSpace: sa,
    /**
     * Implementations of supported color spaces.
     *
     * Required:
     *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
     *	- whitePoint: reference white [ x y ]
     *	- transfer: transfer function (pre-defined)
     *	- toXYZ: Matrix3 RGB to XYZ transform
     *	- fromXYZ: Matrix3 XYZ to RGB transform
     *	- luminanceCoefficients: RGB luminance coefficients
     *
     * Optional:
     *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
     *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
     *
     * Reference:
     * - https://www.russellcottrell.com/photo/matrixCalculator.htm
     */
    spaces: {},
    convert: function(s, i, n) {
      return this.enabled === !1 || i === n || !i || !n || (this.spaces[i].transfer === Ir && (s.r = Tt(s.r), s.g = Tt(s.g), s.b = Tt(s.b)), this.spaces[i].primaries !== this.spaces[n].primaries && (s.applyMatrix3(this.spaces[i].toXYZ), s.applyMatrix3(this.spaces[n].fromXYZ)), this.spaces[n].transfer === Ir && (s.r = ge(s.r), s.g = ge(s.g), s.b = ge(s.b))), s;
    },
    fromWorkingColorSpace: function(s, i) {
      return this.convert(s, this.workingColorSpace, i);
    },
    toWorkingColorSpace: function(s, i) {
      return this.convert(s, i, this.workingColorSpace);
    },
    getPrimaries: function(s) {
      return this.spaces[s].primaries;
    },
    getTransfer: function(s) {
      return s === rc ? ia : this.spaces[s].transfer;
    },
    getLuminanceCoefficients: function(s, i = this.workingColorSpace) {
      return s.fromArray(this.spaces[i].luminanceCoefficients);
    },
    define: function(s) {
      Object.assign(this.spaces, s);
    },
    // Internal APIs
    _getMatrix: function(s, i, n) {
      return s.copy(this.spaces[i].toXYZ).multiply(this.spaces[n].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(s) {
      return this.spaces[s].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(s = this.workingColorSpace) {
      return this.spaces[s].workingColorSpaceConfig.unpackColorSpace;
    }
  }, t = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06], e = [0.2126, 0.7152, 0.0722], r = [0.3127, 0.329];
  return a.define({
    [sa]: {
      primaries: t,
      whitePoint: r,
      transfer: ia,
      toXYZ: aa,
      fromXYZ: oa,
      luminanceCoefficients: e,
      workingColorSpaceConfig: { unpackColorSpace: pt },
      outputColorSpaceConfig: { drawingBufferColorSpace: pt }
    },
    [pt]: {
      primaries: t,
      whitePoint: r,
      transfer: Ir,
      toXYZ: aa,
      fromXYZ: oa,
      luminanceCoefficients: e,
      outputColorSpaceConfig: { drawingBufferColorSpace: pt }
    }
  }), a;
}
const lt = /* @__PURE__ */ wl();
function Tt(a) {
  return a < 0.04045 ? a * 0.0773993808 : Math.pow(a * 0.9478672986 + 0.0521327014, 2.4);
}
function ge(a) {
  return a < 31308e-7 ? a * 12.92 : 1.055 * Math.pow(a, 0.41666) - 0.055;
}
let ae;
class vl {
  static getDataURL(t) {
    if (/^data:/i.test(t.src) || typeof HTMLCanvasElement > "u")
      return t.src;
    let e;
    if (t instanceof HTMLCanvasElement)
      e = t;
    else {
      ae === void 0 && (ae = na("canvas")), ae.width = t.width, ae.height = t.height;
      const r = ae.getContext("2d");
      t instanceof ImageData ? r.putImageData(t, 0, 0) : r.drawImage(t, 0, 0, t.width, t.height), e = ae;
    }
    return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t), e.toDataURL("image/jpeg", 0.6)) : e.toDataURL("image/png");
  }
  static sRGBToLinear(t) {
    if (typeof HTMLImageElement < "u" && t instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && t instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && t instanceof ImageBitmap) {
      const e = na("canvas");
      e.width = t.width, e.height = t.height;
      const r = e.getContext("2d");
      r.drawImage(t, 0, 0, t.width, t.height);
      const s = r.getImageData(0, 0, t.width, t.height), i = s.data;
      for (let n = 0; n < i.length; n++)
        i[n] = Tt(i[n] / 255) * 255;
      return r.putImageData(s, 0, 0), e;
    } else if (t.data) {
      const e = t.data.slice(0);
      for (let r = 0; r < e.length; r++)
        e instanceof Uint8Array || e instanceof Uint8ClampedArray ? e[r] = Math.floor(Tt(e[r] / 255) * 255) : e[r] = Tt(e[r]);
      return {
        data: e,
        width: t.width,
        height: t.height
      };
    } else
      return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t;
  }
}
let Ml = 0;
class Al {
  constructor(t = null) {
    this.isSource = !0, Object.defineProperty(this, "id", { value: Ml++ }), this.uuid = _e(), this.data = t, this.dataReady = !0, this.version = 0;
  }
  set needsUpdate(t) {
    t === !0 && this.version++;
  }
  toJSON(t) {
    const e = t === void 0 || typeof t == "string";
    if (!e && t.images[this.uuid] !== void 0)
      return t.images[this.uuid];
    const r = {
      uuid: this.uuid,
      url: ""
    }, s = this.data;
    if (s !== null) {
      let i;
      if (Array.isArray(s)) {
        i = [];
        for (let n = 0, o = s.length; n < o; n++)
          s[n].isDataTexture ? i.push(Or(s[n].image)) : i.push(Or(s[n]));
      } else
        i = Or(s);
      r.url = i;
    }
    return e || (t.images[this.uuid] = r), r;
  }
}
function Or(a) {
  return typeof HTMLImageElement < "u" && a instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && a instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && a instanceof ImageBitmap ? vl.getDataURL(a) : a.data ? {
    data: Array.from(a.data),
    width: a.width,
    height: a.height,
    type: a.data.constructor.name
  } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
let Sl = 0;
class Zt extends Ar {
  constructor(t = Zt.DEFAULT_IMAGE, e = Zt.DEFAULT_MAPPING, r = 1001, s = 1001, i = 1006, n = 1008, o = 1023, h = 1009, c = Zt.DEFAULT_ANISOTROPY, l = rc) {
    super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: Sl++ }), this.uuid = _e(), this.name = "", this.source = new Al(t), this.mipmaps = [], this.mapping = e, this.channel = 0, this.wrapS = r, this.wrapT = s, this.magFilter = i, this.minFilter = n, this.anisotropy = c, this.format = o, this.internalFormat = null, this.type = h, this.offset = new E(0, 0), this.repeat = new E(1, 1), this.center = new E(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Ct(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = l, this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.pmremVersion = 0;
  }
  get image() {
    return this.source.data;
  }
  set image(t = null) {
    this.source.data = t;
  }
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    return this.name = t.name, this.source = t.source, this.mipmaps = t.mipmaps.slice(0), this.mapping = t.mapping, this.channel = t.channel, this.wrapS = t.wrapS, this.wrapT = t.wrapT, this.magFilter = t.magFilter, this.minFilter = t.minFilter, this.anisotropy = t.anisotropy, this.format = t.format, this.internalFormat = t.internalFormat, this.type = t.type, this.offset.copy(t.offset), this.repeat.copy(t.repeat), this.center.copy(t.center), this.rotation = t.rotation, this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrix.copy(t.matrix), this.generateMipmaps = t.generateMipmaps, this.premultiplyAlpha = t.premultiplyAlpha, this.flipY = t.flipY, this.unpackAlignment = t.unpackAlignment, this.colorSpace = t.colorSpace, this.userData = JSON.parse(JSON.stringify(t.userData)), this.needsUpdate = !0, this;
  }
  toJSON(t) {
    const e = t === void 0 || typeof t == "string";
    if (!e && t.textures[this.uuid] !== void 0)
      return t.textures[this.uuid];
    const r = {
      metadata: {
        version: 4.6,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(t).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    return Object.keys(this.userData).length > 0 && (r.userData = this.userData), e || (t.textures[this.uuid] = r), r;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  transformUv(t) {
    if (this.mapping !== 300) return t;
    if (t.applyMatrix3(this.matrix), t.x < 0 || t.x > 1)
      switch (this.wrapS) {
        case 1e3:
          t.x = t.x - Math.floor(t.x);
          break;
        case 1001:
          t.x = t.x < 0 ? 0 : 1;
          break;
        case 1002:
          Math.abs(Math.floor(t.x) % 2) === 1 ? t.x = Math.ceil(t.x) - t.x : t.x = t.x - Math.floor(t.x);
          break;
      }
    if (t.y < 0 || t.y > 1)
      switch (this.wrapT) {
        case 1e3:
          t.y = t.y - Math.floor(t.y);
          break;
        case 1001:
          t.y = t.y < 0 ? 0 : 1;
          break;
        case 1002:
          Math.abs(Math.floor(t.y) % 2) === 1 ? t.y = Math.ceil(t.y) - t.y : t.y = t.y - Math.floor(t.y);
          break;
      }
    return this.flipY && (t.y = 1 - t.y), t;
  }
  set needsUpdate(t) {
    t === !0 && (this.version++, this.source.needsUpdate = !0);
  }
  set needsPMREMUpdate(t) {
    t === !0 && this.pmremVersion++;
  }
}
Zt.DEFAULT_IMAGE = null;
Zt.DEFAULT_MAPPING = 300;
Zt.DEFAULT_ANISOTROPY = 1;
class Oe {
  constructor(t = 0, e = 0, r = 0, s = 1) {
    Oe.prototype.isVector4 = !0, this.x = t, this.y = e, this.z = r, this.w = s;
  }
  get width() {
    return this.z;
  }
  set width(t) {
    this.z = t;
  }
  get height() {
    return this.w;
  }
  set height(t) {
    this.w = t;
  }
  set(t, e, r, s) {
    return this.x = t, this.y = e, this.z = r, this.w = s, this;
  }
  setScalar(t) {
    return this.x = t, this.y = t, this.z = t, this.w = t, this;
  }
  setX(t) {
    return this.x = t, this;
  }
  setY(t) {
    return this.y = t, this;
  }
  setZ(t) {
    return this.z = t, this;
  }
  setW(t) {
    return this.w = t, this;
  }
  setComponent(t, e) {
    switch (t) {
      case 0:
        this.x = e;
        break;
      case 1:
        this.y = e;
        break;
      case 2:
        this.z = e;
        break;
      case 3:
        this.w = e;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(t) {
    return this.x = t.x, this.y = t.y, this.z = t.z, this.w = t.w !== void 0 ? t.w : 1, this;
  }
  add(t) {
    return this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this;
  }
  addScalar(t) {
    return this.x += t, this.y += t, this.z += t, this.w += t, this;
  }
  addVectors(t, e) {
    return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this.w = t.w + e.w, this;
  }
  addScaledVector(t, e) {
    return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this.w += t.w * e, this;
  }
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this;
  }
  subScalar(t) {
    return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
  }
  subVectors(t, e) {
    return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this.w = t.w - e.w, this;
  }
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this.z *= t.z, this.w *= t.w, this;
  }
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
  }
  applyMatrix4(t) {
    const e = this.x, r = this.y, s = this.z, i = this.w, n = t.elements;
    return this.x = n[0] * e + n[4] * r + n[8] * s + n[12] * i, this.y = n[1] * e + n[5] * r + n[9] * s + n[13] * i, this.z = n[2] * e + n[6] * r + n[10] * s + n[14] * i, this.w = n[3] * e + n[7] * r + n[11] * s + n[15] * i, this;
  }
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this.z /= t.z, this.w /= t.w, this;
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  setAxisAngleFromQuaternion(t) {
    this.w = 2 * Math.acos(t.w);
    const e = Math.sqrt(1 - t.w * t.w);
    return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / e, this.y = t.y / e, this.z = t.z / e), this;
  }
  setAxisAngleFromRotationMatrix(t) {
    let e, r, s, i;
    const h = t.elements, c = h[0], l = h[4], u = h[8], f = h[1], d = h[5], p = h[9], x = h[2], m = h[6], y = h[10];
    if (Math.abs(l - f) < 0.01 && Math.abs(u - x) < 0.01 && Math.abs(p - m) < 0.01) {
      if (Math.abs(l + f) < 0.1 && Math.abs(u + x) < 0.1 && Math.abs(p + m) < 0.1 && Math.abs(c + d + y - 3) < 0.1)
        return this.set(1, 0, 0, 0), this;
      e = Math.PI;
      const b = (c + 1) / 2, w = (d + 1) / 2, M = (y + 1) / 2, A = (l + f) / 4, v = (u + x) / 4, S = (p + m) / 4;
      return b > w && b > M ? b < 0.01 ? (r = 0, s = 0.707106781, i = 0.707106781) : (r = Math.sqrt(b), s = A / r, i = v / r) : w > M ? w < 0.01 ? (r = 0.707106781, s = 0, i = 0.707106781) : (s = Math.sqrt(w), r = A / s, i = S / s) : M < 0.01 ? (r = 0.707106781, s = 0.707106781, i = 0) : (i = Math.sqrt(M), r = v / i, s = S / i), this.set(r, s, i, e), this;
    }
    let _ = Math.sqrt((m - p) * (m - p) + (u - x) * (u - x) + (f - l) * (f - l));
    return Math.abs(_) < 1e-3 && (_ = 1), this.x = (m - p) / _, this.y = (u - x) / _, this.z = (f - l) / _, this.w = Math.acos((c + d + y - 1) / 2), this;
  }
  setFromMatrixPosition(t) {
    const e = t.elements;
    return this.x = e[12], this.y = e[13], this.z = e[14], this.w = e[15], this;
  }
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
  }
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
  }
  clamp(t, e) {
    return this.x = P(this.x, t.x, e.x), this.y = P(this.y, t.y, e.y), this.z = P(this.z, t.z, e.z), this.w = P(this.w, t.w, e.w), this;
  }
  clampScalar(t, e) {
    return this.x = P(this.x, t, e), this.y = P(this.y, t, e), this.z = P(this.z, t, e), this.w = P(this.w, t, e), this;
  }
  clampLength(t, e) {
    const r = this.length();
    return this.divideScalar(r || 1).multiplyScalar(P(r, t, e));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  dot(t) {
    return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, e) {
    return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this.w += (t.w - this.w) * e, this;
  }
  lerpVectors(t, e, r) {
    return this.x = t.x + (e.x - t.x) * r, this.y = t.y + (e.y - t.y) * r, this.z = t.z + (e.z - t.z) * r, this.w = t.w + (e.w - t.w) * r, this;
  }
  equals(t) {
    return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
  }
  fromArray(t, e = 0) {
    return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this.w = t[e + 3], this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t[e + 3] = this.w, t;
  }
  fromBufferAttribute(t, e) {
    return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this.w = t.getW(e), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
let Kt = class {
  constructor(t = 0, e = 0, r = 0, s = 1) {
    this.isQuaternion = !0, this._x = t, this._y = e, this._z = r, this._w = s;
  }
  static slerpFlat(t, e, r, s, i, n, o) {
    let h = r[s + 0], c = r[s + 1], l = r[s + 2], u = r[s + 3];
    const f = i[n + 0], d = i[n + 1], p = i[n + 2], x = i[n + 3];
    if (o === 0) {
      t[e + 0] = h, t[e + 1] = c, t[e + 2] = l, t[e + 3] = u;
      return;
    }
    if (o === 1) {
      t[e + 0] = f, t[e + 1] = d, t[e + 2] = p, t[e + 3] = x;
      return;
    }
    if (u !== x || h !== f || c !== d || l !== p) {
      let m = 1 - o;
      const y = h * f + c * d + l * p + u * x, _ = y >= 0 ? 1 : -1, b = 1 - y * y;
      if (b > Number.EPSILON) {
        const M = Math.sqrt(b), A = Math.atan2(M, y * _);
        m = Math.sin(m * A) / M, o = Math.sin(o * A) / M;
      }
      const w = o * _;
      if (h = h * m + f * w, c = c * m + d * w, l = l * m + p * w, u = u * m + x * w, m === 1 - o) {
        const M = 1 / Math.sqrt(h * h + c * c + l * l + u * u);
        h *= M, c *= M, l *= M, u *= M;
      }
    }
    t[e] = h, t[e + 1] = c, t[e + 2] = l, t[e + 3] = u;
  }
  static multiplyQuaternionsFlat(t, e, r, s, i, n) {
    const o = r[s], h = r[s + 1], c = r[s + 2], l = r[s + 3], u = i[n], f = i[n + 1], d = i[n + 2], p = i[n + 3];
    return t[e] = o * p + l * u + h * d - c * f, t[e + 1] = h * p + l * f + c * u - o * d, t[e + 2] = c * p + l * d + o * f - h * u, t[e + 3] = l * p - o * u - h * f - c * d, t;
  }
  get x() {
    return this._x;
  }
  set x(t) {
    this._x = t, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(t) {
    this._y = t, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(t) {
    this._z = t, this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(t) {
    this._w = t, this._onChangeCallback();
  }
  set(t, e, r, s) {
    return this._x = t, this._y = e, this._z = r, this._w = s, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(t) {
    return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this._onChangeCallback(), this;
  }
  setFromEuler(t, e = !0) {
    const r = t._x, s = t._y, i = t._z, n = t._order, o = Math.cos, h = Math.sin, c = o(r / 2), l = o(s / 2), u = o(i / 2), f = h(r / 2), d = h(s / 2), p = h(i / 2);
    switch (n) {
      case "XYZ":
        this._x = f * l * u + c * d * p, this._y = c * d * u - f * l * p, this._z = c * l * p + f * d * u, this._w = c * l * u - f * d * p;
        break;
      case "YXZ":
        this._x = f * l * u + c * d * p, this._y = c * d * u - f * l * p, this._z = c * l * p - f * d * u, this._w = c * l * u + f * d * p;
        break;
      case "ZXY":
        this._x = f * l * u - c * d * p, this._y = c * d * u + f * l * p, this._z = c * l * p + f * d * u, this._w = c * l * u - f * d * p;
        break;
      case "ZYX":
        this._x = f * l * u - c * d * p, this._y = c * d * u + f * l * p, this._z = c * l * p - f * d * u, this._w = c * l * u + f * d * p;
        break;
      case "YZX":
        this._x = f * l * u + c * d * p, this._y = c * d * u + f * l * p, this._z = c * l * p - f * d * u, this._w = c * l * u - f * d * p;
        break;
      case "XZY":
        this._x = f * l * u - c * d * p, this._y = c * d * u - f * l * p, this._z = c * l * p + f * d * u, this._w = c * l * u + f * d * p;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + n);
    }
    return e === !0 && this._onChangeCallback(), this;
  }
  setFromAxisAngle(t, e) {
    const r = e / 2, s = Math.sin(r);
    return this._x = t.x * s, this._y = t.y * s, this._z = t.z * s, this._w = Math.cos(r), this._onChangeCallback(), this;
  }
  setFromRotationMatrix(t) {
    const e = t.elements, r = e[0], s = e[4], i = e[8], n = e[1], o = e[5], h = e[9], c = e[2], l = e[6], u = e[10], f = r + o + u;
    if (f > 0) {
      const d = 0.5 / Math.sqrt(f + 1);
      this._w = 0.25 / d, this._x = (l - h) * d, this._y = (i - c) * d, this._z = (n - s) * d;
    } else if (r > o && r > u) {
      const d = 2 * Math.sqrt(1 + r - o - u);
      this._w = (l - h) / d, this._x = 0.25 * d, this._y = (s + n) / d, this._z = (i + c) / d;
    } else if (o > u) {
      const d = 2 * Math.sqrt(1 + o - r - u);
      this._w = (i - c) / d, this._x = (s + n) / d, this._y = 0.25 * d, this._z = (h + l) / d;
    } else {
      const d = 2 * Math.sqrt(1 + u - r - o);
      this._w = (n - s) / d, this._x = (i + c) / d, this._y = (h + l) / d, this._z = 0.25 * d;
    }
    return this._onChangeCallback(), this;
  }
  setFromUnitVectors(t, e) {
    let r = t.dot(e) + 1;
    return r < Number.EPSILON ? (r = 0, Math.abs(t.x) > Math.abs(t.z) ? (this._x = -t.y, this._y = t.x, this._z = 0, this._w = r) : (this._x = 0, this._y = -t.z, this._z = t.y, this._w = r)) : (this._x = t.y * e.z - t.z * e.y, this._y = t.z * e.x - t.x * e.z, this._z = t.x * e.y - t.y * e.x, this._w = r), this.normalize();
  }
  angleTo(t) {
    return 2 * Math.acos(Math.abs(P(this.dot(t), -1, 1)));
  }
  rotateTowards(t, e) {
    const r = this.angleTo(t);
    if (r === 0) return this;
    const s = Math.min(1, e / r);
    return this.slerp(t, s), this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  dot(t) {
    return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let t = this.length();
    return t === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this._onChangeCallback(), this;
  }
  multiply(t) {
    return this.multiplyQuaternions(this, t);
  }
  premultiply(t) {
    return this.multiplyQuaternions(t, this);
  }
  multiplyQuaternions(t, e) {
    const r = t._x, s = t._y, i = t._z, n = t._w, o = e._x, h = e._y, c = e._z, l = e._w;
    return this._x = r * l + n * o + s * c - i * h, this._y = s * l + n * h + i * o - r * c, this._z = i * l + n * c + r * h - s * o, this._w = n * l - r * o - s * h - i * c, this._onChangeCallback(), this;
  }
  slerp(t, e) {
    if (e === 0) return this;
    if (e === 1) return this.copy(t);
    const r = this._x, s = this._y, i = this._z, n = this._w;
    let o = n * t._w + r * t._x + s * t._y + i * t._z;
    if (o < 0 ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, o = -o) : this.copy(t), o >= 1)
      return this._w = n, this._x = r, this._y = s, this._z = i, this;
    const h = 1 - o * o;
    if (h <= Number.EPSILON) {
      const d = 1 - e;
      return this._w = d * n + e * this._w, this._x = d * r + e * this._x, this._y = d * s + e * this._y, this._z = d * i + e * this._z, this.normalize(), this;
    }
    const c = Math.sqrt(h), l = Math.atan2(c, o), u = Math.sin((1 - e) * l) / c, f = Math.sin(e * l) / c;
    return this._w = n * u + this._w * f, this._x = r * u + this._x * f, this._y = s * u + this._y * f, this._z = i * u + this._z * f, this._onChangeCallback(), this;
  }
  slerpQuaternions(t, e, r) {
    return this.copy(t).slerp(e, r);
  }
  random() {
    const t = 2 * Math.PI * Math.random(), e = 2 * Math.PI * Math.random(), r = Math.random(), s = Math.sqrt(1 - r), i = Math.sqrt(r);
    return this.set(
      s * Math.sin(t),
      s * Math.cos(t),
      i * Math.sin(e),
      i * Math.cos(e)
    );
  }
  equals(t) {
    return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
  }
  fromArray(t, e = 0) {
    return this._x = t[e], this._y = t[e + 1], this._z = t[e + 2], this._w = t[e + 3], this._onChangeCallback(), this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._w, t;
  }
  fromBufferAttribute(t, e) {
    return this._x = t.getX(e), this._y = t.getY(e), this._z = t.getZ(e), this._w = t.getW(e), this._onChangeCallback(), this;
  }
  toJSON() {
    return this.toArray();
  }
  _onChange(t) {
    return this._onChangeCallback = t, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
};
class g {
  constructor(t = 0, e = 0, r = 0) {
    g.prototype.isVector3 = !0, this.x = t, this.y = e, this.z = r;
  }
  set(t, e, r) {
    return r === void 0 && (r = this.z), this.x = t, this.y = e, this.z = r, this;
  }
  setScalar(t) {
    return this.x = t, this.y = t, this.z = t, this;
  }
  setX(t) {
    return this.x = t, this;
  }
  setY(t) {
    return this.y = t, this;
  }
  setZ(t) {
    return this.z = t, this;
  }
  setComponent(t, e) {
    switch (t) {
      case 0:
        this.x = e;
        break;
      case 1:
        this.y = e;
        break;
      case 2:
        this.z = e;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(t) {
    return this.x = t.x, this.y = t.y, this.z = t.z, this;
  }
  add(t) {
    return this.x += t.x, this.y += t.y, this.z += t.z, this;
  }
  addScalar(t) {
    return this.x += t, this.y += t, this.z += t, this;
  }
  addVectors(t, e) {
    return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this;
  }
  addScaledVector(t, e) {
    return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this;
  }
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this.z -= t.z, this;
  }
  subScalar(t) {
    return this.x -= t, this.y -= t, this.z -= t, this;
  }
  subVectors(t, e) {
    return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this;
  }
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this.z *= t.z, this;
  }
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this.z *= t, this;
  }
  multiplyVectors(t, e) {
    return this.x = t.x * e.x, this.y = t.y * e.y, this.z = t.z * e.z, this;
  }
  applyEuler(t) {
    return this.applyQuaternion(ha.setFromEuler(t));
  }
  applyAxisAngle(t, e) {
    return this.applyQuaternion(ha.setFromAxisAngle(t, e));
  }
  applyMatrix3(t) {
    const e = this.x, r = this.y, s = this.z, i = t.elements;
    return this.x = i[0] * e + i[3] * r + i[6] * s, this.y = i[1] * e + i[4] * r + i[7] * s, this.z = i[2] * e + i[5] * r + i[8] * s, this;
  }
  applyNormalMatrix(t) {
    return this.applyMatrix3(t).normalize();
  }
  applyMatrix4(t) {
    const e = this.x, r = this.y, s = this.z, i = t.elements, n = 1 / (i[3] * e + i[7] * r + i[11] * s + i[15]);
    return this.x = (i[0] * e + i[4] * r + i[8] * s + i[12]) * n, this.y = (i[1] * e + i[5] * r + i[9] * s + i[13]) * n, this.z = (i[2] * e + i[6] * r + i[10] * s + i[14]) * n, this;
  }
  applyQuaternion(t) {
    const e = this.x, r = this.y, s = this.z, i = t.x, n = t.y, o = t.z, h = t.w, c = 2 * (n * s - o * r), l = 2 * (o * e - i * s), u = 2 * (i * r - n * e);
    return this.x = e + h * c + n * u - o * l, this.y = r + h * l + o * c - i * u, this.z = s + h * u + i * l - n * c, this;
  }
  project(t) {
    return this.applyMatrix4(t.matrixWorldInverse).applyMatrix4(t.projectionMatrix);
  }
  unproject(t) {
    return this.applyMatrix4(t.projectionMatrixInverse).applyMatrix4(t.matrixWorld);
  }
  transformDirection(t) {
    const e = this.x, r = this.y, s = this.z, i = t.elements;
    return this.x = i[0] * e + i[4] * r + i[8] * s, this.y = i[1] * e + i[5] * r + i[9] * s, this.z = i[2] * e + i[6] * r + i[10] * s, this.normalize();
  }
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
  }
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
  }
  clamp(t, e) {
    return this.x = P(this.x, t.x, e.x), this.y = P(this.y, t.y, e.y), this.z = P(this.z, t.z, e.z), this;
  }
  clampScalar(t, e) {
    return this.x = P(this.x, t, e), this.y = P(this.y, t, e), this.z = P(this.z, t, e), this;
  }
  clampLength(t, e) {
    const r = this.length();
    return this.divideScalar(r || 1).multiplyScalar(P(r, t, e));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  dot(t) {
    return this.x * t.x + this.y * t.y + this.z * t.z;
  }
  // TODO lengthSquared?
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, e) {
    return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this;
  }
  lerpVectors(t, e, r) {
    return this.x = t.x + (e.x - t.x) * r, this.y = t.y + (e.y - t.y) * r, this.z = t.z + (e.z - t.z) * r, this;
  }
  cross(t) {
    return this.crossVectors(this, t);
  }
  crossVectors(t, e) {
    const r = t.x, s = t.y, i = t.z, n = e.x, o = e.y, h = e.z;
    return this.x = s * h - i * o, this.y = i * n - r * h, this.z = r * o - s * n, this;
  }
  projectOnVector(t) {
    const e = t.lengthSq();
    if (e === 0) return this.set(0, 0, 0);
    const r = t.dot(this) / e;
    return this.copy(t).multiplyScalar(r);
  }
  projectOnPlane(t) {
    return qr.copy(this).projectOnVector(t), this.sub(qr);
  }
  reflect(t) {
    return this.sub(qr.copy(t).multiplyScalar(2 * this.dot(t)));
  }
  angleTo(t) {
    const e = Math.sqrt(this.lengthSq() * t.lengthSq());
    if (e === 0) return Math.PI / 2;
    const r = this.dot(t) / e;
    return Math.acos(P(r, -1, 1));
  }
  distanceTo(t) {
    return Math.sqrt(this.distanceToSquared(t));
  }
  distanceToSquared(t) {
    const e = this.x - t.x, r = this.y - t.y, s = this.z - t.z;
    return e * e + r * r + s * s;
  }
  manhattanDistanceTo(t) {
    return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
  }
  setFromSpherical(t) {
    return this.setFromSphericalCoords(t.radius, t.phi, t.theta);
  }
  setFromSphericalCoords(t, e, r) {
    const s = Math.sin(e) * t;
    return this.x = s * Math.sin(r), this.y = Math.cos(e) * t, this.z = s * Math.cos(r), this;
  }
  setFromCylindrical(t) {
    return this.setFromCylindricalCoords(t.radius, t.theta, t.y);
  }
  setFromCylindricalCoords(t, e, r) {
    return this.x = t * Math.sin(e), this.y = r, this.z = t * Math.cos(e), this;
  }
  setFromMatrixPosition(t) {
    const e = t.elements;
    return this.x = e[12], this.y = e[13], this.z = e[14], this;
  }
  setFromMatrixScale(t) {
    const e = this.setFromMatrixColumn(t, 0).length(), r = this.setFromMatrixColumn(t, 1).length(), s = this.setFromMatrixColumn(t, 2).length();
    return this.x = e, this.y = r, this.z = s, this;
  }
  setFromMatrixColumn(t, e) {
    return this.fromArray(t.elements, e * 4);
  }
  setFromMatrix3Column(t, e) {
    return this.fromArray(t.elements, e * 3);
  }
  setFromEuler(t) {
    return this.x = t._x, this.y = t._y, this.z = t._z, this;
  }
  setFromColor(t) {
    return this.x = t.r, this.y = t.g, this.z = t.b, this;
  }
  equals(t) {
    return t.x === this.x && t.y === this.y && t.z === this.z;
  }
  fromArray(t, e = 0) {
    return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t;
  }
  fromBufferAttribute(t, e) {
    return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  randomDirection() {
    const t = Math.random() * Math.PI * 2, e = Math.random() * 2 - 1, r = Math.sqrt(1 - e * e);
    return this.x = r * Math.cos(t), this.y = e, this.z = r * Math.sin(t), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
}
const qr = /* @__PURE__ */ new g(), ha = /* @__PURE__ */ new Kt();
let zt = class {
  constructor(t = new g(1 / 0, 1 / 0, 1 / 0), e = new g(-1 / 0, -1 / 0, -1 / 0)) {
    this.isBox3 = !0, this.min = t, this.max = e;
  }
  set(t, e) {
    return this.min.copy(t), this.max.copy(e), this;
  }
  setFromArray(t) {
    this.makeEmpty();
    for (let e = 0, r = t.length; e < r; e += 3)
      this.expandByPoint(ut.fromArray(t, e));
    return this;
  }
  setFromBufferAttribute(t) {
    this.makeEmpty();
    for (let e = 0, r = t.count; e < r; e++)
      this.expandByPoint(ut.fromBufferAttribute(t, e));
    return this;
  }
  setFromPoints(t) {
    this.makeEmpty();
    for (let e = 0, r = t.length; e < r; e++)
      this.expandByPoint(t[e]);
    return this;
  }
  setFromCenterAndSize(t, e) {
    const r = ut.copy(e).multiplyScalar(0.5);
    return this.min.copy(t).sub(r), this.max.copy(t).add(r), this;
  }
  setFromObject(t, e = !1) {
    return this.makeEmpty(), this.expandByObject(t, e);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    return this.min.copy(t.min), this.max.copy(t.max), this;
  }
  makeEmpty() {
    return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(t) {
    return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(t) {
    return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
  }
  expandByPoint(t) {
    return this.min.min(t), this.max.max(t), this;
  }
  expandByVector(t) {
    return this.min.sub(t), this.max.add(t), this;
  }
  expandByScalar(t) {
    return this.min.addScalar(-t), this.max.addScalar(t), this;
  }
  expandByObject(t, e = !1) {
    t.updateWorldMatrix(!1, !1);
    const r = t.geometry;
    if (r !== void 0) {
      const i = r.getAttribute("position");
      if (e === !0 && i !== void 0 && t.isInstancedMesh !== !0)
        for (let n = 0, o = i.count; n < o; n++)
          t.isMesh === !0 ? t.getVertexPosition(n, ut) : ut.fromBufferAttribute(i, n), ut.applyMatrix4(t.matrixWorld), this.expandByPoint(ut);
      else
        t.boundingBox !== void 0 ? (t.boundingBox === null && t.computeBoundingBox(), Je.copy(t.boundingBox)) : (r.boundingBox === null && r.computeBoundingBox(), Je.copy(r.boundingBox)), Je.applyMatrix4(t.matrixWorld), this.union(Je);
    }
    const s = t.children;
    for (let i = 0, n = s.length; i < n; i++)
      this.expandByObject(s[i], e);
    return this;
  }
  containsPoint(t) {
    return t.x >= this.min.x && t.x <= this.max.x && t.y >= this.min.y && t.y <= this.max.y && t.z >= this.min.z && t.z <= this.max.z;
  }
  containsBox(t) {
    return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z;
  }
  getParameter(t, e) {
    return e.set(
      (t.x - this.min.x) / (this.max.x - this.min.x),
      (t.y - this.min.y) / (this.max.y - this.min.y),
      (t.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  intersectsBox(t) {
    return t.max.x >= this.min.x && t.min.x <= this.max.x && t.max.y >= this.min.y && t.min.y <= this.max.y && t.max.z >= this.min.z && t.min.z <= this.max.z;
  }
  intersectsSphere(t) {
    return this.clampPoint(t.center, ut), ut.distanceToSquared(t.center) <= t.radius * t.radius;
  }
  intersectsPlane(t) {
    let e, r;
    return t.normal.x > 0 ? (e = t.normal.x * this.min.x, r = t.normal.x * this.max.x) : (e = t.normal.x * this.max.x, r = t.normal.x * this.min.x), t.normal.y > 0 ? (e += t.normal.y * this.min.y, r += t.normal.y * this.max.y) : (e += t.normal.y * this.max.y, r += t.normal.y * this.min.y), t.normal.z > 0 ? (e += t.normal.z * this.min.z, r += t.normal.z * this.max.z) : (e += t.normal.z * this.max.z, r += t.normal.z * this.min.z), e <= -t.constant && r >= -t.constant;
  }
  intersectsTriangle(t) {
    if (this.isEmpty())
      return !1;
    this.getCenter(Me), Ke.subVectors(this.max, Me), oe.subVectors(t.a, Me), he.subVectors(t.b, Me), ce.subVectors(t.c, Me), Ot.subVectors(he, oe), qt.subVectors(ce, he), Yt.subVectors(oe, ce);
    let e = [
      0,
      -Ot.z,
      Ot.y,
      0,
      -qt.z,
      qt.y,
      0,
      -Yt.z,
      Yt.y,
      Ot.z,
      0,
      -Ot.x,
      qt.z,
      0,
      -qt.x,
      Yt.z,
      0,
      -Yt.x,
      -Ot.y,
      Ot.x,
      0,
      -qt.y,
      qt.x,
      0,
      -Yt.y,
      Yt.x,
      0
    ];
    return !Nr(e, oe, he, ce, Ke) || (e = [1, 0, 0, 0, 1, 0, 0, 0, 1], !Nr(e, oe, he, ce, Ke)) ? !1 : (Qe.crossVectors(Ot, qt), e = [Qe.x, Qe.y, Qe.z], Nr(e, oe, he, ce, Ke));
  }
  clampPoint(t, e) {
    return e.copy(t).clamp(this.min, this.max);
  }
  distanceToPoint(t) {
    return this.clampPoint(t, ut).distanceTo(t);
  }
  getBoundingSphere(t) {
    return this.isEmpty() ? t.makeEmpty() : (this.getCenter(t.center), t.radius = this.getSize(ut).length() * 0.5), t;
  }
  intersect(t) {
    return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
  }
  union(t) {
    return this.min.min(t.min), this.max.max(t.max), this;
  }
  applyMatrix4(t) {
    return this.isEmpty() ? this : (_t[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t), _t[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t), _t[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t), _t[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t), _t[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t), _t[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t), _t[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t), _t[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t), this.setFromPoints(_t), this);
  }
  translate(t) {
    return this.min.add(t), this.max.add(t), this;
  }
  equals(t) {
    return t.min.equals(this.min) && t.max.equals(this.max);
  }
};
const _t = [
  /* @__PURE__ */ new g(),
  /* @__PURE__ */ new g(),
  /* @__PURE__ */ new g(),
  /* @__PURE__ */ new g(),
  /* @__PURE__ */ new g(),
  /* @__PURE__ */ new g(),
  /* @__PURE__ */ new g(),
  /* @__PURE__ */ new g()
], ut = /* @__PURE__ */ new g(), Je = /* @__PURE__ */ new zt(), oe = /* @__PURE__ */ new g(), he = /* @__PURE__ */ new g(), ce = /* @__PURE__ */ new g(), Ot = /* @__PURE__ */ new g(), qt = /* @__PURE__ */ new g(), Yt = /* @__PURE__ */ new g(), Me = /* @__PURE__ */ new g(), Ke = /* @__PURE__ */ new g(), Qe = /* @__PURE__ */ new g(), Wt = /* @__PURE__ */ new g();
function Nr(a, t, e, r, s) {
  for (let i = 0, n = a.length - 3; i <= n; i += 3) {
    Wt.fromArray(a, i);
    const o = s.x * Math.abs(Wt.x) + s.y * Math.abs(Wt.y) + s.z * Math.abs(Wt.z), h = t.dot(Wt), c = e.dot(Wt), l = r.dot(Wt);
    if (Math.max(-Math.max(h, c, l), Math.min(h, c, l)) > o)
      return !1;
  }
  return !0;
}
const kl = /* @__PURE__ */ new zt(), Ae = /* @__PURE__ */ new g(), Hr = /* @__PURE__ */ new g();
class Sn {
  constructor(t = new g(), e = -1) {
    this.isSphere = !0, this.center = t, this.radius = e;
  }
  set(t, e) {
    return this.center.copy(t), this.radius = e, this;
  }
  setFromPoints(t, e) {
    const r = this.center;
    e !== void 0 ? r.copy(e) : kl.setFromPoints(t).getCenter(r);
    let s = 0;
    for (let i = 0, n = t.length; i < n; i++)
      s = Math.max(s, r.distanceToSquared(t[i]));
    return this.radius = Math.sqrt(s), this;
  }
  copy(t) {
    return this.center.copy(t.center), this.radius = t.radius, this;
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    return this.center.set(0, 0, 0), this.radius = -1, this;
  }
  containsPoint(t) {
    return t.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(t) {
    return t.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(t) {
    const e = this.radius + t.radius;
    return t.center.distanceToSquared(this.center) <= e * e;
  }
  intersectsBox(t) {
    return t.intersectsSphere(this);
  }
  intersectsPlane(t) {
    return Math.abs(t.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(t, e) {
    const r = this.center.distanceToSquared(t);
    return e.copy(t), r > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
  }
  getBoundingBox(t) {
    return this.isEmpty() ? (t.makeEmpty(), t) : (t.set(this.center, this.center), t.expandByScalar(this.radius), t);
  }
  applyMatrix4(t) {
    return this.center.applyMatrix4(t), this.radius = this.radius * t.getMaxScaleOnAxis(), this;
  }
  translate(t) {
    return this.center.add(t), this;
  }
  expandByPoint(t) {
    if (this.isEmpty())
      return this.center.copy(t), this.radius = 0, this;
    Ae.subVectors(t, this.center);
    const e = Ae.lengthSq();
    if (e > this.radius * this.radius) {
      const r = Math.sqrt(e), s = (r - this.radius) * 0.5;
      this.center.addScaledVector(Ae, s / r), this.radius += s;
    }
    return this;
  }
  union(t) {
    return t.isEmpty() ? this : this.isEmpty() ? (this.copy(t), this) : (this.center.equals(t.center) === !0 ? this.radius = Math.max(this.radius, t.radius) : (Hr.subVectors(t.center, this.center).setLength(t.radius), this.expandByPoint(Ae.copy(t.center).add(Hr)), this.expandByPoint(Ae.copy(t.center).sub(Hr))), this);
  }
  equals(t) {
    return t.center.equals(this.center) && t.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const wt = /* @__PURE__ */ new g(), Vr = /* @__PURE__ */ new g(), tr = /* @__PURE__ */ new g(), Nt = /* @__PURE__ */ new g(), jr = /* @__PURE__ */ new g(), er = /* @__PURE__ */ new g(), Ur = /* @__PURE__ */ new g();
class kn {
  constructor(t = new g(), e = new g(0, 0, -1)) {
    this.origin = t, this.direction = e;
  }
  set(t, e) {
    return this.origin.copy(t), this.direction.copy(e), this;
  }
  copy(t) {
    return this.origin.copy(t.origin), this.direction.copy(t.direction), this;
  }
  at(t, e) {
    return e.copy(this.origin).addScaledVector(this.direction, t);
  }
  lookAt(t) {
    return this.direction.copy(t).sub(this.origin).normalize(), this;
  }
  recast(t) {
    return this.origin.copy(this.at(t, wt)), this;
  }
  closestPointToPoint(t, e) {
    e.subVectors(t, this.origin);
    const r = e.dot(this.direction);
    return r < 0 ? e.copy(this.origin) : e.copy(this.origin).addScaledVector(this.direction, r);
  }
  distanceToPoint(t) {
    return Math.sqrt(this.distanceSqToPoint(t));
  }
  distanceSqToPoint(t) {
    const e = wt.subVectors(t, this.origin).dot(this.direction);
    return e < 0 ? this.origin.distanceToSquared(t) : (wt.copy(this.origin).addScaledVector(this.direction, e), wt.distanceToSquared(t));
  }
  distanceSqToSegment(t, e, r, s) {
    Vr.copy(t).add(e).multiplyScalar(0.5), tr.copy(e).sub(t).normalize(), Nt.copy(this.origin).sub(Vr);
    const i = t.distanceTo(e) * 0.5, n = -this.direction.dot(tr), o = Nt.dot(this.direction), h = -Nt.dot(tr), c = Nt.lengthSq(), l = Math.abs(1 - n * n);
    let u, f, d, p;
    if (l > 0)
      if (u = n * h - o, f = n * o - h, p = i * l, u >= 0)
        if (f >= -p)
          if (f <= p) {
            const x = 1 / l;
            u *= x, f *= x, d = u * (u + n * f + 2 * o) + f * (n * u + f + 2 * h) + c;
          } else
            f = i, u = Math.max(0, -(n * f + o)), d = -u * u + f * (f + 2 * h) + c;
        else
          f = -i, u = Math.max(0, -(n * f + o)), d = -u * u + f * (f + 2 * h) + c;
      else
        f <= -p ? (u = Math.max(0, -(-n * i + o)), f = u > 0 ? -i : Math.min(Math.max(-i, -h), i), d = -u * u + f * (f + 2 * h) + c) : f <= p ? (u = 0, f = Math.min(Math.max(-i, -h), i), d = f * (f + 2 * h) + c) : (u = Math.max(0, -(n * i + o)), f = u > 0 ? i : Math.min(Math.max(-i, -h), i), d = -u * u + f * (f + 2 * h) + c);
    else
      f = n > 0 ? -i : i, u = Math.max(0, -(n * f + o)), d = -u * u + f * (f + 2 * h) + c;
    return r && r.copy(this.origin).addScaledVector(this.direction, u), s && s.copy(Vr).addScaledVector(tr, f), d;
  }
  intersectSphere(t, e) {
    wt.subVectors(t.center, this.origin);
    const r = wt.dot(this.direction), s = wt.dot(wt) - r * r, i = t.radius * t.radius;
    if (s > i) return null;
    const n = Math.sqrt(i - s), o = r - n, h = r + n;
    return h < 0 ? null : o < 0 ? this.at(h, e) : this.at(o, e);
  }
  intersectsSphere(t) {
    return this.distanceSqToPoint(t.center) <= t.radius * t.radius;
  }
  distanceToPlane(t) {
    const e = t.normal.dot(this.direction);
    if (e === 0)
      return t.distanceToPoint(this.origin) === 0 ? 0 : null;
    const r = -(this.origin.dot(t.normal) + t.constant) / e;
    return r >= 0 ? r : null;
  }
  intersectPlane(t, e) {
    const r = this.distanceToPlane(t);
    return r === null ? null : this.at(r, e);
  }
  intersectsPlane(t) {
    const e = t.distanceToPoint(this.origin);
    return e === 0 || t.normal.dot(this.direction) * e < 0;
  }
  intersectBox(t, e) {
    let r, s, i, n, o, h;
    const c = 1 / this.direction.x, l = 1 / this.direction.y, u = 1 / this.direction.z, f = this.origin;
    return c >= 0 ? (r = (t.min.x - f.x) * c, s = (t.max.x - f.x) * c) : (r = (t.max.x - f.x) * c, s = (t.min.x - f.x) * c), l >= 0 ? (i = (t.min.y - f.y) * l, n = (t.max.y - f.y) * l) : (i = (t.max.y - f.y) * l, n = (t.min.y - f.y) * l), r > n || i > s || ((i > r || isNaN(r)) && (r = i), (n < s || isNaN(s)) && (s = n), u >= 0 ? (o = (t.min.z - f.z) * u, h = (t.max.z - f.z) * u) : (o = (t.max.z - f.z) * u, h = (t.min.z - f.z) * u), r > h || o > s) || ((o > r || r !== r) && (r = o), (h < s || s !== s) && (s = h), s < 0) ? null : this.at(r >= 0 ? r : s, e);
  }
  intersectsBox(t) {
    return this.intersectBox(t, wt) !== null;
  }
  intersectTriangle(t, e, r, s, i) {
    jr.subVectors(e, t), er.subVectors(r, t), Ur.crossVectors(jr, er);
    let n = this.direction.dot(Ur), o;
    if (n > 0) {
      if (s) return null;
      o = 1;
    } else if (n < 0)
      o = -1, n = -n;
    else
      return null;
    Nt.subVectors(this.origin, t);
    const h = o * this.direction.dot(er.crossVectors(Nt, er));
    if (h < 0)
      return null;
    const c = o * this.direction.dot(jr.cross(Nt));
    if (c < 0 || h + c > n)
      return null;
    const l = -o * Nt.dot(Ur);
    return l < 0 ? null : this.at(l / n, i);
  }
  applyMatrix4(t) {
    return this.origin.applyMatrix4(t), this.direction.transformDirection(t), this;
  }
  equals(t) {
    return t.origin.equals(this.origin) && t.direction.equals(this.direction);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class et {
  constructor(t, e, r, s, i, n, o, h, c, l, u, f, d, p, x, m) {
    et.prototype.isMatrix4 = !0, this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ], t !== void 0 && this.set(t, e, r, s, i, n, o, h, c, l, u, f, d, p, x, m);
  }
  set(t, e, r, s, i, n, o, h, c, l, u, f, d, p, x, m) {
    const y = this.elements;
    return y[0] = t, y[4] = e, y[8] = r, y[12] = s, y[1] = i, y[5] = n, y[9] = o, y[13] = h, y[2] = c, y[6] = l, y[10] = u, y[14] = f, y[3] = d, y[7] = p, y[11] = x, y[15] = m, this;
  }
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  clone() {
    return new et().fromArray(this.elements);
  }
  copy(t) {
    const e = this.elements, r = t.elements;
    return e[0] = r[0], e[1] = r[1], e[2] = r[2], e[3] = r[3], e[4] = r[4], e[5] = r[5], e[6] = r[6], e[7] = r[7], e[8] = r[8], e[9] = r[9], e[10] = r[10], e[11] = r[11], e[12] = r[12], e[13] = r[13], e[14] = r[14], e[15] = r[15], this;
  }
  copyPosition(t) {
    const e = this.elements, r = t.elements;
    return e[12] = r[12], e[13] = r[13], e[14] = r[14], this;
  }
  setFromMatrix3(t) {
    const e = t.elements;
    return this.set(
      e[0],
      e[3],
      e[6],
      0,
      e[1],
      e[4],
      e[7],
      0,
      e[2],
      e[5],
      e[8],
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  extractBasis(t, e, r) {
    return t.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), r.setFromMatrixColumn(this, 2), this;
  }
  makeBasis(t, e, r) {
    return this.set(
      t.x,
      e.x,
      r.x,
      0,
      t.y,
      e.y,
      r.y,
      0,
      t.z,
      e.z,
      r.z,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  extractRotation(t) {
    const e = this.elements, r = t.elements, s = 1 / le.setFromMatrixColumn(t, 0).length(), i = 1 / le.setFromMatrixColumn(t, 1).length(), n = 1 / le.setFromMatrixColumn(t, 2).length();
    return e[0] = r[0] * s, e[1] = r[1] * s, e[2] = r[2] * s, e[3] = 0, e[4] = r[4] * i, e[5] = r[5] * i, e[6] = r[6] * i, e[7] = 0, e[8] = r[8] * n, e[9] = r[9] * n, e[10] = r[10] * n, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
  }
  makeRotationFromEuler(t) {
    const e = this.elements, r = t.x, s = t.y, i = t.z, n = Math.cos(r), o = Math.sin(r), h = Math.cos(s), c = Math.sin(s), l = Math.cos(i), u = Math.sin(i);
    if (t.order === "XYZ") {
      const f = n * l, d = n * u, p = o * l, x = o * u;
      e[0] = h * l, e[4] = -h * u, e[8] = c, e[1] = d + p * c, e[5] = f - x * c, e[9] = -o * h, e[2] = x - f * c, e[6] = p + d * c, e[10] = n * h;
    } else if (t.order === "YXZ") {
      const f = h * l, d = h * u, p = c * l, x = c * u;
      e[0] = f + x * o, e[4] = p * o - d, e[8] = n * c, e[1] = n * u, e[5] = n * l, e[9] = -o, e[2] = d * o - p, e[6] = x + f * o, e[10] = n * h;
    } else if (t.order === "ZXY") {
      const f = h * l, d = h * u, p = c * l, x = c * u;
      e[0] = f - x * o, e[4] = -n * u, e[8] = p + d * o, e[1] = d + p * o, e[5] = n * l, e[9] = x - f * o, e[2] = -n * c, e[6] = o, e[10] = n * h;
    } else if (t.order === "ZYX") {
      const f = n * l, d = n * u, p = o * l, x = o * u;
      e[0] = h * l, e[4] = p * c - d, e[8] = f * c + x, e[1] = h * u, e[5] = x * c + f, e[9] = d * c - p, e[2] = -c, e[6] = o * h, e[10] = n * h;
    } else if (t.order === "YZX") {
      const f = n * h, d = n * c, p = o * h, x = o * c;
      e[0] = h * l, e[4] = x - f * u, e[8] = p * u + d, e[1] = u, e[5] = n * l, e[9] = -o * l, e[2] = -c * l, e[6] = d * u + p, e[10] = f - x * u;
    } else if (t.order === "XZY") {
      const f = n * h, d = n * c, p = o * h, x = o * c;
      e[0] = h * l, e[4] = -u, e[8] = c * l, e[1] = f * u + x, e[5] = n * l, e[9] = d * u - p, e[2] = p * u - d, e[6] = o * l, e[10] = x * u + f;
    }
    return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
  }
  makeRotationFromQuaternion(t) {
    return this.compose(Fl, t, Tl);
  }
  lookAt(t, e, r) {
    const s = this.elements;
    return rt.subVectors(t, e), rt.lengthSq() === 0 && (rt.z = 1), rt.normalize(), Ht.crossVectors(r, rt), Ht.lengthSq() === 0 && (Math.abs(r.z) === 1 ? rt.x += 1e-4 : rt.z += 1e-4, rt.normalize(), Ht.crossVectors(r, rt)), Ht.normalize(), rr.crossVectors(rt, Ht), s[0] = Ht.x, s[4] = rr.x, s[8] = rt.x, s[1] = Ht.y, s[5] = rr.y, s[9] = rt.y, s[2] = Ht.z, s[6] = rr.z, s[10] = rt.z, this;
  }
  multiply(t) {
    return this.multiplyMatrices(this, t);
  }
  premultiply(t) {
    return this.multiplyMatrices(t, this);
  }
  multiplyMatrices(t, e) {
    const r = t.elements, s = e.elements, i = this.elements, n = r[0], o = r[4], h = r[8], c = r[12], l = r[1], u = r[5], f = r[9], d = r[13], p = r[2], x = r[6], m = r[10], y = r[14], _ = r[3], b = r[7], w = r[11], M = r[15], A = s[0], v = s[4], S = s[8], F = s[12], T = s[1], k = s[5], L = s[9], B = s[13], G = s[2], nt = s[6], Dt = s[10], bt = s[14], ct = s[3], q = s[7], V = s[11], $ = s[15];
    return i[0] = n * A + o * T + h * G + c * ct, i[4] = n * v + o * k + h * nt + c * q, i[8] = n * S + o * L + h * Dt + c * V, i[12] = n * F + o * B + h * bt + c * $, i[1] = l * A + u * T + f * G + d * ct, i[5] = l * v + u * k + f * nt + d * q, i[9] = l * S + u * L + f * Dt + d * V, i[13] = l * F + u * B + f * bt + d * $, i[2] = p * A + x * T + m * G + y * ct, i[6] = p * v + x * k + m * nt + y * q, i[10] = p * S + x * L + m * Dt + y * V, i[14] = p * F + x * B + m * bt + y * $, i[3] = _ * A + b * T + w * G + M * ct, i[7] = _ * v + b * k + w * nt + M * q, i[11] = _ * S + b * L + w * Dt + M * V, i[15] = _ * F + b * B + w * bt + M * $, this;
  }
  multiplyScalar(t) {
    const e = this.elements;
    return e[0] *= t, e[4] *= t, e[8] *= t, e[12] *= t, e[1] *= t, e[5] *= t, e[9] *= t, e[13] *= t, e[2] *= t, e[6] *= t, e[10] *= t, e[14] *= t, e[3] *= t, e[7] *= t, e[11] *= t, e[15] *= t, this;
  }
  determinant() {
    const t = this.elements, e = t[0], r = t[4], s = t[8], i = t[12], n = t[1], o = t[5], h = t[9], c = t[13], l = t[2], u = t[6], f = t[10], d = t[14], p = t[3], x = t[7], m = t[11], y = t[15];
    return p * (+i * h * u - s * c * u - i * o * f + r * c * f + s * o * d - r * h * d) + x * (+e * h * d - e * c * f + i * n * f - s * n * d + s * c * l - i * h * l) + m * (+e * c * u - e * o * d - i * n * u + r * n * d + i * o * l - r * c * l) + y * (-s * o * l - e * h * u + e * o * f + s * n * u - r * n * f + r * h * l);
  }
  transpose() {
    const t = this.elements;
    let e;
    return e = t[1], t[1] = t[4], t[4] = e, e = t[2], t[2] = t[8], t[8] = e, e = t[6], t[6] = t[9], t[9] = e, e = t[3], t[3] = t[12], t[12] = e, e = t[7], t[7] = t[13], t[13] = e, e = t[11], t[11] = t[14], t[14] = e, this;
  }
  setPosition(t, e, r) {
    const s = this.elements;
    return t.isVector3 ? (s[12] = t.x, s[13] = t.y, s[14] = t.z) : (s[12] = t, s[13] = e, s[14] = r), this;
  }
  invert() {
    const t = this.elements, e = t[0], r = t[1], s = t[2], i = t[3], n = t[4], o = t[5], h = t[6], c = t[7], l = t[8], u = t[9], f = t[10], d = t[11], p = t[12], x = t[13], m = t[14], y = t[15], _ = u * m * c - x * f * c + x * h * d - o * m * d - u * h * y + o * f * y, b = p * f * c - l * m * c - p * h * d + n * m * d + l * h * y - n * f * y, w = l * x * c - p * u * c + p * o * d - n * x * d - l * o * y + n * u * y, M = p * u * h - l * x * h - p * o * f + n * x * f + l * o * m - n * u * m, A = e * _ + r * b + s * w + i * M;
    if (A === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const v = 1 / A;
    return t[0] = _ * v, t[1] = (x * f * i - u * m * i - x * s * d + r * m * d + u * s * y - r * f * y) * v, t[2] = (o * m * i - x * h * i + x * s * c - r * m * c - o * s * y + r * h * y) * v, t[3] = (u * h * i - o * f * i - u * s * c + r * f * c + o * s * d - r * h * d) * v, t[4] = b * v, t[5] = (l * m * i - p * f * i + p * s * d - e * m * d - l * s * y + e * f * y) * v, t[6] = (p * h * i - n * m * i - p * s * c + e * m * c + n * s * y - e * h * y) * v, t[7] = (n * f * i - l * h * i + l * s * c - e * f * c - n * s * d + e * h * d) * v, t[8] = w * v, t[9] = (p * u * i - l * x * i - p * r * d + e * x * d + l * r * y - e * u * y) * v, t[10] = (n * x * i - p * o * i + p * r * c - e * x * c - n * r * y + e * o * y) * v, t[11] = (l * o * i - n * u * i - l * r * c + e * u * c + n * r * d - e * o * d) * v, t[12] = M * v, t[13] = (l * x * s - p * u * s + p * r * f - e * x * f - l * r * m + e * u * m) * v, t[14] = (p * o * s - n * x * s - p * r * h + e * x * h + n * r * m - e * o * m) * v, t[15] = (n * u * s - l * o * s + l * r * h - e * u * h - n * r * f + e * o * f) * v, this;
  }
  scale(t) {
    const e = this.elements, r = t.x, s = t.y, i = t.z;
    return e[0] *= r, e[4] *= s, e[8] *= i, e[1] *= r, e[5] *= s, e[9] *= i, e[2] *= r, e[6] *= s, e[10] *= i, e[3] *= r, e[7] *= s, e[11] *= i, this;
  }
  getMaxScaleOnAxis() {
    const t = this.elements, e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2], r = t[4] * t[4] + t[5] * t[5] + t[6] * t[6], s = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
    return Math.sqrt(Math.max(e, r, s));
  }
  makeTranslation(t, e, r) {
    return t.isVector3 ? this.set(
      1,
      0,
      0,
      t.x,
      0,
      1,
      0,
      t.y,
      0,
      0,
      1,
      t.z,
      0,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      0,
      t,
      0,
      1,
      0,
      e,
      0,
      0,
      1,
      r,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationX(t) {
    const e = Math.cos(t), r = Math.sin(t);
    return this.set(
      1,
      0,
      0,
      0,
      0,
      e,
      -r,
      0,
      0,
      r,
      e,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationY(t) {
    const e = Math.cos(t), r = Math.sin(t);
    return this.set(
      e,
      0,
      r,
      0,
      0,
      1,
      0,
      0,
      -r,
      0,
      e,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationZ(t) {
    const e = Math.cos(t), r = Math.sin(t);
    return this.set(
      e,
      -r,
      0,
      0,
      r,
      e,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationAxis(t, e) {
    const r = Math.cos(e), s = Math.sin(e), i = 1 - r, n = t.x, o = t.y, h = t.z, c = i * n, l = i * o;
    return this.set(
      c * n + r,
      c * o - s * h,
      c * h + s * o,
      0,
      c * o + s * h,
      l * o + r,
      l * h - s * n,
      0,
      c * h - s * o,
      l * h + s * n,
      i * h * h + r,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeScale(t, e, r) {
    return this.set(
      t,
      0,
      0,
      0,
      0,
      e,
      0,
      0,
      0,
      0,
      r,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeShear(t, e, r, s, i, n) {
    return this.set(
      1,
      r,
      i,
      0,
      t,
      1,
      n,
      0,
      e,
      s,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  compose(t, e, r) {
    const s = this.elements, i = e._x, n = e._y, o = e._z, h = e._w, c = i + i, l = n + n, u = o + o, f = i * c, d = i * l, p = i * u, x = n * l, m = n * u, y = o * u, _ = h * c, b = h * l, w = h * u, M = r.x, A = r.y, v = r.z;
    return s[0] = (1 - (x + y)) * M, s[1] = (d + w) * M, s[2] = (p - b) * M, s[3] = 0, s[4] = (d - w) * A, s[5] = (1 - (f + y)) * A, s[6] = (m + _) * A, s[7] = 0, s[8] = (p + b) * v, s[9] = (m - _) * v, s[10] = (1 - (f + x)) * v, s[11] = 0, s[12] = t.x, s[13] = t.y, s[14] = t.z, s[15] = 1, this;
  }
  decompose(t, e, r) {
    const s = this.elements;
    let i = le.set(s[0], s[1], s[2]).length();
    const n = le.set(s[4], s[5], s[6]).length(), o = le.set(s[8], s[9], s[10]).length();
    this.determinant() < 0 && (i = -i), t.x = s[12], t.y = s[13], t.z = s[14], ft.copy(this);
    const c = 1 / i, l = 1 / n, u = 1 / o;
    return ft.elements[0] *= c, ft.elements[1] *= c, ft.elements[2] *= c, ft.elements[4] *= l, ft.elements[5] *= l, ft.elements[6] *= l, ft.elements[8] *= u, ft.elements[9] *= u, ft.elements[10] *= u, e.setFromRotationMatrix(ft), r.x = i, r.y = n, r.z = o, this;
  }
  makePerspective(t, e, r, s, i, n, o = 2e3) {
    const h = this.elements, c = 2 * i / (e - t), l = 2 * i / (r - s), u = (e + t) / (e - t), f = (r + s) / (r - s);
    let d, p;
    if (o === 2e3)
      d = -(n + i) / (n - i), p = -2 * n * i / (n - i);
    else if (o === 2001)
      d = -n / (n - i), p = -n * i / (n - i);
    else
      throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + o);
    return h[0] = c, h[4] = 0, h[8] = u, h[12] = 0, h[1] = 0, h[5] = l, h[9] = f, h[13] = 0, h[2] = 0, h[6] = 0, h[10] = d, h[14] = p, h[3] = 0, h[7] = 0, h[11] = -1, h[15] = 0, this;
  }
  makeOrthographic(t, e, r, s, i, n, o = 2e3) {
    const h = this.elements, c = 1 / (e - t), l = 1 / (r - s), u = 1 / (n - i), f = (e + t) * c, d = (r + s) * l;
    let p, x;
    if (o === 2e3)
      p = (n + i) * u, x = -2 * u;
    else if (o === 2001)
      p = i * u, x = -1 * u;
    else
      throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + o);
    return h[0] = 2 * c, h[4] = 0, h[8] = 0, h[12] = -f, h[1] = 0, h[5] = 2 * l, h[9] = 0, h[13] = -d, h[2] = 0, h[6] = 0, h[10] = x, h[14] = -p, h[3] = 0, h[7] = 0, h[11] = 0, h[15] = 1, this;
  }
  equals(t) {
    const e = this.elements, r = t.elements;
    for (let s = 0; s < 16; s++)
      if (e[s] !== r[s]) return !1;
    return !0;
  }
  fromArray(t, e = 0) {
    for (let r = 0; r < 16; r++)
      this.elements[r] = t[r + e];
    return this;
  }
  toArray(t = [], e = 0) {
    const r = this.elements;
    return t[e] = r[0], t[e + 1] = r[1], t[e + 2] = r[2], t[e + 3] = r[3], t[e + 4] = r[4], t[e + 5] = r[5], t[e + 6] = r[6], t[e + 7] = r[7], t[e + 8] = r[8], t[e + 9] = r[9], t[e + 10] = r[10], t[e + 11] = r[11], t[e + 12] = r[12], t[e + 13] = r[13], t[e + 14] = r[14], t[e + 15] = r[15], t;
  }
}
const le = /* @__PURE__ */ new g(), ft = /* @__PURE__ */ new et(), Fl = /* @__PURE__ */ new g(0, 0, 0), Tl = /* @__PURE__ */ new g(1, 1, 1), Ht = /* @__PURE__ */ new g(), rr = /* @__PURE__ */ new g(), rt = /* @__PURE__ */ new g(), ca = /* @__PURE__ */ new et(), la = /* @__PURE__ */ new Kt();
class qe {
  constructor(t = 0, e = 0, r = 0, s = qe.DEFAULT_ORDER) {
    this.isEuler = !0, this._x = t, this._y = e, this._z = r, this._order = s;
  }
  get x() {
    return this._x;
  }
  set x(t) {
    this._x = t, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(t) {
    this._y = t, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(t) {
    this._z = t, this._onChangeCallback();
  }
  get order() {
    return this._order;
  }
  set order(t) {
    this._order = t, this._onChangeCallback();
  }
  set(t, e, r, s = this._order) {
    return this._x = t, this._y = e, this._z = r, this._order = s, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  copy(t) {
    return this._x = t._x, this._y = t._y, this._z = t._z, this._order = t._order, this._onChangeCallback(), this;
  }
  setFromRotationMatrix(t, e = this._order, r = !0) {
    const s = t.elements, i = s[0], n = s[4], o = s[8], h = s[1], c = s[5], l = s[9], u = s[2], f = s[6], d = s[10];
    switch (e) {
      case "XYZ":
        this._y = Math.asin(P(o, -1, 1)), Math.abs(o) < 0.9999999 ? (this._x = Math.atan2(-l, d), this._z = Math.atan2(-n, i)) : (this._x = Math.atan2(f, c), this._z = 0);
        break;
      case "YXZ":
        this._x = Math.asin(-P(l, -1, 1)), Math.abs(l) < 0.9999999 ? (this._y = Math.atan2(o, d), this._z = Math.atan2(h, c)) : (this._y = Math.atan2(-u, i), this._z = 0);
        break;
      case "ZXY":
        this._x = Math.asin(P(f, -1, 1)), Math.abs(f) < 0.9999999 ? (this._y = Math.atan2(-u, d), this._z = Math.atan2(-n, c)) : (this._y = 0, this._z = Math.atan2(h, i));
        break;
      case "ZYX":
        this._y = Math.asin(-P(u, -1, 1)), Math.abs(u) < 0.9999999 ? (this._x = Math.atan2(f, d), this._z = Math.atan2(h, i)) : (this._x = 0, this._z = Math.atan2(-n, c));
        break;
      case "YZX":
        this._z = Math.asin(P(h, -1, 1)), Math.abs(h) < 0.9999999 ? (this._x = Math.atan2(-l, c), this._y = Math.atan2(-u, i)) : (this._x = 0, this._y = Math.atan2(o, d));
        break;
      case "XZY":
        this._z = Math.asin(-P(n, -1, 1)), Math.abs(n) < 0.9999999 ? (this._x = Math.atan2(f, c), this._y = Math.atan2(o, i)) : (this._x = Math.atan2(-l, d), this._y = 0);
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
    }
    return this._order = e, r === !0 && this._onChangeCallback(), this;
  }
  setFromQuaternion(t, e, r) {
    return ca.makeRotationFromQuaternion(t), this.setFromRotationMatrix(ca, e, r);
  }
  setFromVector3(t, e = this._order) {
    return this.set(t.x, t.y, t.z, e);
  }
  reorder(t) {
    return la.setFromEuler(this), this.setFromQuaternion(la, t);
  }
  equals(t) {
    return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order;
  }
  fromArray(t) {
    return this._x = t[0], this._y = t[1], this._z = t[2], t[3] !== void 0 && (this._order = t[3]), this._onChangeCallback(), this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._order, t;
  }
  _onChange(t) {
    return this._onChangeCallback = t, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._order;
  }
}
qe.DEFAULT_ORDER = "XYZ";
class sc {
  constructor() {
    this.mask = 1;
  }
  set(t) {
    this.mask = (1 << t | 0) >>> 0;
  }
  enable(t) {
    this.mask |= 1 << t | 0;
  }
  enableAll() {
    this.mask = -1;
  }
  toggle(t) {
    this.mask ^= 1 << t | 0;
  }
  disable(t) {
    this.mask &= ~(1 << t | 0);
  }
  disableAll() {
    this.mask = 0;
  }
  test(t) {
    return (this.mask & t.mask) !== 0;
  }
  isEnabled(t) {
    return (this.mask & (1 << t | 0)) !== 0;
  }
}
let El = 0;
const ua = /* @__PURE__ */ new g(), ue = /* @__PURE__ */ new Kt(), vt = /* @__PURE__ */ new et(), sr = /* @__PURE__ */ new g(), Se = /* @__PURE__ */ new g(), Pl = /* @__PURE__ */ new g(), zl = /* @__PURE__ */ new Kt(), fa = /* @__PURE__ */ new g(1, 0, 0), da = /* @__PURE__ */ new g(0, 1, 0), pa = /* @__PURE__ */ new g(0, 0, 1), xa = { type: "added" }, Cl = { type: "removed" }, fe = { type: "childadded", child: null }, Gr = { type: "childremoved", child: null };
class mt extends Ar {
  constructor() {
    super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: El++ }), this.uuid = _e(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = mt.DEFAULT_UP.clone();
    const t = new g(), e = new qe(), r = new Kt(), s = new g(1, 1, 1);
    function i() {
      r.setFromEuler(e, !1);
    }
    function n() {
      e.setFromQuaternion(r, void 0, !1);
    }
    e._onChange(i), r._onChange(n), Object.defineProperties(this, {
      position: {
        configurable: !0,
        enumerable: !0,
        value: t
      },
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: e
      },
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: r
      },
      scale: {
        configurable: !0,
        enumerable: !0,
        value: s
      },
      modelViewMatrix: {
        value: new et()
      },
      normalMatrix: {
        value: new Ct()
      }
    }), this.matrix = new et(), this.matrixWorld = new et(), this.matrixAutoUpdate = mt.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = mt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new sc(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
  }
  onBeforeShadow() {
  }
  onAfterShadow() {
  }
  onBeforeRender() {
  }
  onAfterRender() {
  }
  applyMatrix4(t) {
    this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t), this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  applyQuaternion(t) {
    return this.quaternion.premultiply(t), this;
  }
  setRotationFromAxisAngle(t, e) {
    this.quaternion.setFromAxisAngle(t, e);
  }
  setRotationFromEuler(t) {
    this.quaternion.setFromEuler(t, !0);
  }
  setRotationFromMatrix(t) {
    this.quaternion.setFromRotationMatrix(t);
  }
  setRotationFromQuaternion(t) {
    this.quaternion.copy(t);
  }
  rotateOnAxis(t, e) {
    return ue.setFromAxisAngle(t, e), this.quaternion.multiply(ue), this;
  }
  rotateOnWorldAxis(t, e) {
    return ue.setFromAxisAngle(t, e), this.quaternion.premultiply(ue), this;
  }
  rotateX(t) {
    return this.rotateOnAxis(fa, t);
  }
  rotateY(t) {
    return this.rotateOnAxis(da, t);
  }
  rotateZ(t) {
    return this.rotateOnAxis(pa, t);
  }
  translateOnAxis(t, e) {
    return ua.copy(t).applyQuaternion(this.quaternion), this.position.add(ua.multiplyScalar(e)), this;
  }
  translateX(t) {
    return this.translateOnAxis(fa, t);
  }
  translateY(t) {
    return this.translateOnAxis(da, t);
  }
  translateZ(t) {
    return this.translateOnAxis(pa, t);
  }
  localToWorld(t) {
    return this.updateWorldMatrix(!0, !1), t.applyMatrix4(this.matrixWorld);
  }
  worldToLocal(t) {
    return this.updateWorldMatrix(!0, !1), t.applyMatrix4(vt.copy(this.matrixWorld).invert());
  }
  lookAt(t, e, r) {
    t.isVector3 ? sr.copy(t) : sr.set(t, e, r);
    const s = this.parent;
    this.updateWorldMatrix(!0, !1), Se.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? vt.lookAt(Se, sr, this.up) : vt.lookAt(sr, Se, this.up), this.quaternion.setFromRotationMatrix(vt), s && (vt.extractRotation(s.matrixWorld), ue.setFromRotationMatrix(vt), this.quaternion.premultiply(ue.invert()));
  }
  add(t) {
    if (arguments.length > 1) {
      for (let e = 0; e < arguments.length; e++)
        this.add(arguments[e]);
      return this;
    }
    return t === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t), this) : (t && t.isObject3D ? (t.removeFromParent(), t.parent = this, this.children.push(t), t.dispatchEvent(xa), fe.child = t, this.dispatchEvent(fe), fe.child = null) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t), this);
  }
  remove(t) {
    if (arguments.length > 1) {
      for (let r = 0; r < arguments.length; r++)
        this.remove(arguments[r]);
      return this;
    }
    const e = this.children.indexOf(t);
    return e !== -1 && (t.parent = null, this.children.splice(e, 1), t.dispatchEvent(Cl), Gr.child = t, this.dispatchEvent(Gr), Gr.child = null), this;
  }
  removeFromParent() {
    const t = this.parent;
    return t !== null && t.remove(this), this;
  }
  clear() {
    return this.remove(...this.children);
  }
  attach(t) {
    return this.updateWorldMatrix(!0, !1), vt.copy(this.matrixWorld).invert(), t.parent !== null && (t.parent.updateWorldMatrix(!0, !1), vt.multiply(t.parent.matrixWorld)), t.applyMatrix4(vt), t.removeFromParent(), t.parent = this, this.children.push(t), t.updateWorldMatrix(!1, !0), t.dispatchEvent(xa), fe.child = t, this.dispatchEvent(fe), fe.child = null, this;
  }
  getObjectById(t) {
    return this.getObjectByProperty("id", t);
  }
  getObjectByName(t) {
    return this.getObjectByProperty("name", t);
  }
  getObjectByProperty(t, e) {
    if (this[t] === e) return this;
    for (let r = 0, s = this.children.length; r < s; r++) {
      const n = this.children[r].getObjectByProperty(t, e);
      if (n !== void 0)
        return n;
    }
  }
  getObjectsByProperty(t, e, r = []) {
    this[t] === e && r.push(this);
    const s = this.children;
    for (let i = 0, n = s.length; i < n; i++)
      s[i].getObjectsByProperty(t, e, r);
    return r;
  }
  getWorldPosition(t) {
    return this.updateWorldMatrix(!0, !1), t.setFromMatrixPosition(this.matrixWorld);
  }
  getWorldQuaternion(t) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Se, t, Pl), t;
  }
  getWorldScale(t) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Se, zl, t), t;
  }
  getWorldDirection(t) {
    this.updateWorldMatrix(!0, !1);
    const e = this.matrixWorld.elements;
    return t.set(e[8], e[9], e[10]).normalize();
  }
  raycast() {
  }
  traverse(t) {
    t(this);
    const e = this.children;
    for (let r = 0, s = e.length; r < s; r++)
      e[r].traverse(t);
  }
  traverseVisible(t) {
    if (this.visible === !1) return;
    t(this);
    const e = this.children;
    for (let r = 0, s = e.length; r < s; r++)
      e[r].traverseVisible(t);
  }
  traverseAncestors(t) {
    const e = this.parent;
    e !== null && (t(e), e.traverseAncestors(t));
  }
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
  }
  updateMatrixWorld(t) {
    this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, t = !0);
    const e = this.children;
    for (let r = 0, s = e.length; r < s; r++)
      e[r].updateMatrixWorld(t);
  }
  updateWorldMatrix(t, e) {
    const r = this.parent;
    if (t === !0 && r !== null && r.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), e === !0) {
      const s = this.children;
      for (let i = 0, n = s.length; i < n; i++)
        s[i].updateWorldMatrix(!1, !0);
    }
  }
  toJSON(t) {
    const e = t === void 0 || typeof t == "string", r = {};
    e && (t = {
      geometries: {},
      materials: {},
      textures: {},
      images: {},
      shapes: {},
      skeletons: {},
      animations: {},
      nodes: {}
    }, r.metadata = {
      version: 4.6,
      type: "Object",
      generator: "Object3D.toJSON"
    });
    const s = {};
    s.uuid = this.uuid, s.type = this.type, this.name !== "" && (s.name = this.name), this.castShadow === !0 && (s.castShadow = !0), this.receiveShadow === !0 && (s.receiveShadow = !0), this.visible === !1 && (s.visible = !1), this.frustumCulled === !1 && (s.frustumCulled = !1), this.renderOrder !== 0 && (s.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (s.userData = this.userData), s.layers = this.layers.mask, s.matrix = this.matrix.toArray(), s.up = this.up.toArray(), this.matrixAutoUpdate === !1 && (s.matrixAutoUpdate = !1), this.isInstancedMesh && (s.type = "InstancedMesh", s.count = this.count, s.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (s.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (s.type = "BatchedMesh", s.perObjectFrustumCulled = this.perObjectFrustumCulled, s.sortObjects = this.sortObjects, s.drawRanges = this._drawRanges, s.reservedRanges = this._reservedRanges, s.visibility = this._visibility, s.active = this._active, s.bounds = this._bounds.map((o) => ({
      boxInitialized: o.boxInitialized,
      boxMin: o.box.min.toArray(),
      boxMax: o.box.max.toArray(),
      sphereInitialized: o.sphereInitialized,
      sphereRadius: o.sphere.radius,
      sphereCenter: o.sphere.center.toArray()
    })), s.maxInstanceCount = this._maxInstanceCount, s.maxVertexCount = this._maxVertexCount, s.maxIndexCount = this._maxIndexCount, s.geometryInitialized = this._geometryInitialized, s.geometryCount = this._geometryCount, s.matricesTexture = this._matricesTexture.toJSON(t), this._colorsTexture !== null && (s.colorsTexture = this._colorsTexture.toJSON(t)), this.boundingSphere !== null && (s.boundingSphere = {
      center: s.boundingSphere.center.toArray(),
      radius: s.boundingSphere.radius
    }), this.boundingBox !== null && (s.boundingBox = {
      min: s.boundingBox.min.toArray(),
      max: s.boundingBox.max.toArray()
    }));
    function i(o, h) {
      return o[h.uuid] === void 0 && (o[h.uuid] = h.toJSON(t)), h.uuid;
    }
    if (this.isScene)
      this.background && (this.background.isColor ? s.background = this.background.toJSON() : this.background.isTexture && (s.background = this.background.toJSON(t).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (s.environment = this.environment.toJSON(t).uuid);
    else if (this.isMesh || this.isLine || this.isPoints) {
      s.geometry = i(t.geometries, this.geometry);
      const o = this.geometry.parameters;
      if (o !== void 0 && o.shapes !== void 0) {
        const h = o.shapes;
        if (Array.isArray(h))
          for (let c = 0, l = h.length; c < l; c++) {
            const u = h[c];
            i(t.shapes, u);
          }
        else
          i(t.shapes, h);
      }
    }
    if (this.isSkinnedMesh && (s.bindMode = this.bindMode, s.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (i(t.skeletons, this.skeleton), s.skeleton = this.skeleton.uuid)), this.material !== void 0)
      if (Array.isArray(this.material)) {
        const o = [];
        for (let h = 0, c = this.material.length; h < c; h++)
          o.push(i(t.materials, this.material[h]));
        s.material = o;
      } else
        s.material = i(t.materials, this.material);
    if (this.children.length > 0) {
      s.children = [];
      for (let o = 0; o < this.children.length; o++)
        s.children.push(this.children[o].toJSON(t).object);
    }
    if (this.animations.length > 0) {
      s.animations = [];
      for (let o = 0; o < this.animations.length; o++) {
        const h = this.animations[o];
        s.animations.push(i(t.animations, h));
      }
    }
    if (e) {
      const o = n(t.geometries), h = n(t.materials), c = n(t.textures), l = n(t.images), u = n(t.shapes), f = n(t.skeletons), d = n(t.animations), p = n(t.nodes);
      o.length > 0 && (r.geometries = o), h.length > 0 && (r.materials = h), c.length > 0 && (r.textures = c), l.length > 0 && (r.images = l), u.length > 0 && (r.shapes = u), f.length > 0 && (r.skeletons = f), d.length > 0 && (r.animations = d), p.length > 0 && (r.nodes = p);
    }
    return r.object = s, r;
    function n(o) {
      const h = [];
      for (const c in o) {
        const l = o[c];
        delete l.metadata, h.push(l);
      }
      return h;
    }
  }
  clone(t) {
    return new this.constructor().copy(this, t);
  }
  copy(t, e = !0) {
    if (this.name = t.name, this.up.copy(t.up), this.position.copy(t.position), this.rotation.order = t.rotation.order, this.quaternion.copy(t.quaternion), this.scale.copy(t.scale), this.matrix.copy(t.matrix), this.matrixWorld.copy(t.matrixWorld), this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrixWorldAutoUpdate = t.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate, this.layers.mask = t.layers.mask, this.visible = t.visible, this.castShadow = t.castShadow, this.receiveShadow = t.receiveShadow, this.frustumCulled = t.frustumCulled, this.renderOrder = t.renderOrder, this.animations = t.animations.slice(), this.userData = JSON.parse(JSON.stringify(t.userData)), e === !0)
      for (let r = 0; r < t.children.length; r++) {
        const s = t.children[r];
        this.add(s.clone());
      }
    return this;
  }
}
mt.DEFAULT_UP = /* @__PURE__ */ new g(0, 1, 0);
mt.DEFAULT_MATRIX_AUTO_UPDATE = !0;
mt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
const dt = /* @__PURE__ */ new g(), Mt = /* @__PURE__ */ new g(), Xr = /* @__PURE__ */ new g(), At = /* @__PURE__ */ new g(), de = /* @__PURE__ */ new g(), pe = /* @__PURE__ */ new g(), ma = /* @__PURE__ */ new g(), Yr = /* @__PURE__ */ new g(), Wr = /* @__PURE__ */ new g(), $r = /* @__PURE__ */ new g(), Zr = /* @__PURE__ */ new Oe(), Jr = /* @__PURE__ */ new Oe(), Kr = /* @__PURE__ */ new Oe();
class xt {
  constructor(t = new g(), e = new g(), r = new g()) {
    this.a = t, this.b = e, this.c = r;
  }
  static getNormal(t, e, r, s) {
    s.subVectors(r, e), dt.subVectors(t, e), s.cross(dt);
    const i = s.lengthSq();
    return i > 0 ? s.multiplyScalar(1 / Math.sqrt(i)) : s.set(0, 0, 0);
  }
  // static/instance method to calculate barycentric coordinates
  // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
  static getBarycoord(t, e, r, s, i) {
    dt.subVectors(s, e), Mt.subVectors(r, e), Xr.subVectors(t, e);
    const n = dt.dot(dt), o = dt.dot(Mt), h = dt.dot(Xr), c = Mt.dot(Mt), l = Mt.dot(Xr), u = n * c - o * o;
    if (u === 0)
      return i.set(0, 0, 0), null;
    const f = 1 / u, d = (c * h - o * l) * f, p = (n * l - o * h) * f;
    return i.set(1 - d - p, p, d);
  }
  static containsPoint(t, e, r, s) {
    return this.getBarycoord(t, e, r, s, At) === null ? !1 : At.x >= 0 && At.y >= 0 && At.x + At.y <= 1;
  }
  static getInterpolation(t, e, r, s, i, n, o, h) {
    return this.getBarycoord(t, e, r, s, At) === null ? (h.x = 0, h.y = 0, "z" in h && (h.z = 0), "w" in h && (h.w = 0), null) : (h.setScalar(0), h.addScaledVector(i, At.x), h.addScaledVector(n, At.y), h.addScaledVector(o, At.z), h);
  }
  static getInterpolatedAttribute(t, e, r, s, i, n) {
    return Zr.setScalar(0), Jr.setScalar(0), Kr.setScalar(0), Zr.fromBufferAttribute(t, e), Jr.fromBufferAttribute(t, r), Kr.fromBufferAttribute(t, s), n.setScalar(0), n.addScaledVector(Zr, i.x), n.addScaledVector(Jr, i.y), n.addScaledVector(Kr, i.z), n;
  }
  static isFrontFacing(t, e, r, s) {
    return dt.subVectors(r, e), Mt.subVectors(t, e), dt.cross(Mt).dot(s) < 0;
  }
  set(t, e, r) {
    return this.a.copy(t), this.b.copy(e), this.c.copy(r), this;
  }
  setFromPointsAndIndices(t, e, r, s) {
    return this.a.copy(t[e]), this.b.copy(t[r]), this.c.copy(t[s]), this;
  }
  setFromAttributeAndIndices(t, e, r, s) {
    return this.a.fromBufferAttribute(t, e), this.b.fromBufferAttribute(t, r), this.c.fromBufferAttribute(t, s), this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    return this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this;
  }
  getArea() {
    return dt.subVectors(this.c, this.b), Mt.subVectors(this.a, this.b), dt.cross(Mt).length() * 0.5;
  }
  getMidpoint(t) {
    return t.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  getNormal(t) {
    return xt.getNormal(this.a, this.b, this.c, t);
  }
  getPlane(t) {
    return t.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  getBarycoord(t, e) {
    return xt.getBarycoord(t, this.a, this.b, this.c, e);
  }
  getInterpolation(t, e, r, s, i) {
    return xt.getInterpolation(t, this.a, this.b, this.c, e, r, s, i);
  }
  containsPoint(t) {
    return xt.containsPoint(t, this.a, this.b, this.c);
  }
  isFrontFacing(t) {
    return xt.isFrontFacing(this.a, this.b, this.c, t);
  }
  intersectsBox(t) {
    return t.intersectsTriangle(this);
  }
  closestPointToPoint(t, e) {
    const r = this.a, s = this.b, i = this.c;
    let n, o;
    de.subVectors(s, r), pe.subVectors(i, r), Yr.subVectors(t, r);
    const h = de.dot(Yr), c = pe.dot(Yr);
    if (h <= 0 && c <= 0)
      return e.copy(r);
    Wr.subVectors(t, s);
    const l = de.dot(Wr), u = pe.dot(Wr);
    if (l >= 0 && u <= l)
      return e.copy(s);
    const f = h * u - l * c;
    if (f <= 0 && h >= 0 && l <= 0)
      return n = h / (h - l), e.copy(r).addScaledVector(de, n);
    $r.subVectors(t, i);
    const d = de.dot($r), p = pe.dot($r);
    if (p >= 0 && d <= p)
      return e.copy(i);
    const x = d * c - h * p;
    if (x <= 0 && c >= 0 && p <= 0)
      return o = c / (c - p), e.copy(r).addScaledVector(pe, o);
    const m = l * p - d * u;
    if (m <= 0 && u - l >= 0 && d - p >= 0)
      return ma.subVectors(i, s), o = (u - l) / (u - l + (d - p)), e.copy(s).addScaledVector(ma, o);
    const y = 1 / (m + x + f);
    return n = x * y, o = f * y, e.copy(r).addScaledVector(de, n).addScaledVector(pe, o);
  }
  equals(t) {
    return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
  }
}
const ic = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
}, Vt = { h: 0, s: 0, l: 0 }, ir = { h: 0, s: 0, l: 0 };
function Qr(a, t, e) {
  return e < 0 && (e += 1), e > 1 && (e -= 1), e < 1 / 6 ? a + (t - a) * 6 * e : e < 1 / 2 ? t : e < 2 / 3 ? a + (t - a) * 6 * (2 / 3 - e) : a;
}
class we {
  constructor(t, e, r) {
    return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(t, e, r);
  }
  set(t, e, r) {
    if (e === void 0 && r === void 0) {
      const s = t;
      s && s.isColor ? this.copy(s) : typeof s == "number" ? this.setHex(s) : typeof s == "string" && this.setStyle(s);
    } else
      this.setRGB(t, e, r);
    return this;
  }
  setScalar(t) {
    return this.r = t, this.g = t, this.b = t, this;
  }
  setHex(t, e = pt) {
    return t = Math.floor(t), this.r = (t >> 16 & 255) / 255, this.g = (t >> 8 & 255) / 255, this.b = (t & 255) / 255, lt.toWorkingColorSpace(this, e), this;
  }
  setRGB(t, e, r, s = lt.workingColorSpace) {
    return this.r = t, this.g = e, this.b = r, lt.toWorkingColorSpace(this, s), this;
  }
  setHSL(t, e, r, s = lt.workingColorSpace) {
    if (t = bl(t, 1), e = P(e, 0, 1), r = P(r, 0, 1), e === 0)
      this.r = this.g = this.b = r;
    else {
      const i = r <= 0.5 ? r * (1 + e) : r + e - r * e, n = 2 * r - i;
      this.r = Qr(n, i, t + 1 / 3), this.g = Qr(n, i, t), this.b = Qr(n, i, t - 1 / 3);
    }
    return lt.toWorkingColorSpace(this, s), this;
  }
  setStyle(t, e = pt) {
    function r(i) {
      i !== void 0 && parseFloat(i) < 1 && console.warn("THREE.Color: Alpha component of " + t + " will be ignored.");
    }
    let s;
    if (s = /^(\w+)\(([^\)]*)\)/.exec(t)) {
      let i;
      const n = s[1], o = s[2];
      switch (n) {
        case "rgb":
        case "rgba":
          if (i = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return r(i[4]), this.setRGB(
              Math.min(255, parseInt(i[1], 10)) / 255,
              Math.min(255, parseInt(i[2], 10)) / 255,
              Math.min(255, parseInt(i[3], 10)) / 255,
              e
            );
          if (i = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return r(i[4]), this.setRGB(
              Math.min(100, parseInt(i[1], 10)) / 100,
              Math.min(100, parseInt(i[2], 10)) / 100,
              Math.min(100, parseInt(i[3], 10)) / 100,
              e
            );
          break;
        case "hsl":
        case "hsla":
          if (i = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return r(i[4]), this.setHSL(
              parseFloat(i[1]) / 360,
              parseFloat(i[2]) / 100,
              parseFloat(i[3]) / 100,
              e
            );
          break;
        default:
          console.warn("THREE.Color: Unknown color model " + t);
      }
    } else if (s = /^\#([A-Fa-f\d]+)$/.exec(t)) {
      const i = s[1], n = i.length;
      if (n === 3)
        return this.setRGB(
          parseInt(i.charAt(0), 16) / 15,
          parseInt(i.charAt(1), 16) / 15,
          parseInt(i.charAt(2), 16) / 15,
          e
        );
      if (n === 6)
        return this.setHex(parseInt(i, 16), e);
      console.warn("THREE.Color: Invalid hex color " + t);
    } else if (t && t.length > 0)
      return this.setColorName(t, e);
    return this;
  }
  setColorName(t, e = pt) {
    const r = ic[t.toLowerCase()];
    return r !== void 0 ? this.setHex(r, e) : console.warn("THREE.Color: Unknown color " + t), this;
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  copy(t) {
    return this.r = t.r, this.g = t.g, this.b = t.b, this;
  }
  copySRGBToLinear(t) {
    return this.r = Tt(t.r), this.g = Tt(t.g), this.b = Tt(t.b), this;
  }
  copyLinearToSRGB(t) {
    return this.r = ge(t.r), this.g = ge(t.g), this.b = ge(t.b), this;
  }
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  getHex(t = pt) {
    return lt.fromWorkingColorSpace(Y.copy(this), t), Math.round(P(Y.r * 255, 0, 255)) * 65536 + Math.round(P(Y.g * 255, 0, 255)) * 256 + Math.round(P(Y.b * 255, 0, 255));
  }
  getHexString(t = pt) {
    return ("000000" + this.getHex(t).toString(16)).slice(-6);
  }
  getHSL(t, e = lt.workingColorSpace) {
    lt.fromWorkingColorSpace(Y.copy(this), e);
    const r = Y.r, s = Y.g, i = Y.b, n = Math.max(r, s, i), o = Math.min(r, s, i);
    let h, c;
    const l = (o + n) / 2;
    if (o === n)
      h = 0, c = 0;
    else {
      const u = n - o;
      switch (c = l <= 0.5 ? u / (n + o) : u / (2 - n - o), n) {
        case r:
          h = (s - i) / u + (s < i ? 6 : 0);
          break;
        case s:
          h = (i - r) / u + 2;
          break;
        case i:
          h = (r - s) / u + 4;
          break;
      }
      h /= 6;
    }
    return t.h = h, t.s = c, t.l = l, t;
  }
  getRGB(t, e = lt.workingColorSpace) {
    return lt.fromWorkingColorSpace(Y.copy(this), e), t.r = Y.r, t.g = Y.g, t.b = Y.b, t;
  }
  getStyle(t = pt) {
    lt.fromWorkingColorSpace(Y.copy(this), t);
    const e = Y.r, r = Y.g, s = Y.b;
    return t !== pt ? `color(${t} ${e.toFixed(3)} ${r.toFixed(3)} ${s.toFixed(3)})` : `rgb(${Math.round(e * 255)},${Math.round(r * 255)},${Math.round(s * 255)})`;
  }
  offsetHSL(t, e, r) {
    return this.getHSL(Vt), this.setHSL(Vt.h + t, Vt.s + e, Vt.l + r);
  }
  add(t) {
    return this.r += t.r, this.g += t.g, this.b += t.b, this;
  }
  addColors(t, e) {
    return this.r = t.r + e.r, this.g = t.g + e.g, this.b = t.b + e.b, this;
  }
  addScalar(t) {
    return this.r += t, this.g += t, this.b += t, this;
  }
  sub(t) {
    return this.r = Math.max(0, this.r - t.r), this.g = Math.max(0, this.g - t.g), this.b = Math.max(0, this.b - t.b), this;
  }
  multiply(t) {
    return this.r *= t.r, this.g *= t.g, this.b *= t.b, this;
  }
  multiplyScalar(t) {
    return this.r *= t, this.g *= t, this.b *= t, this;
  }
  lerp(t, e) {
    return this.r += (t.r - this.r) * e, this.g += (t.g - this.g) * e, this.b += (t.b - this.b) * e, this;
  }
  lerpColors(t, e, r) {
    return this.r = t.r + (e.r - t.r) * r, this.g = t.g + (e.g - t.g) * r, this.b = t.b + (e.b - t.b) * r, this;
  }
  lerpHSL(t, e) {
    this.getHSL(Vt), t.getHSL(ir);
    const r = Rr(Vt.h, ir.h, e), s = Rr(Vt.s, ir.s, e), i = Rr(Vt.l, ir.l, e);
    return this.setHSL(r, s, i), this;
  }
  setFromVector3(t) {
    return this.r = t.x, this.g = t.y, this.b = t.z, this;
  }
  applyMatrix3(t) {
    const e = this.r, r = this.g, s = this.b, i = t.elements;
    return this.r = i[0] * e + i[3] * r + i[6] * s, this.g = i[1] * e + i[4] * r + i[7] * s, this.b = i[2] * e + i[5] * r + i[8] * s, this;
  }
  equals(t) {
    return t.r === this.r && t.g === this.g && t.b === this.b;
  }
  fromArray(t, e = 0) {
    return this.r = t[e], this.g = t[e + 1], this.b = t[e + 2], this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.r, t[e + 1] = this.g, t[e + 2] = this.b, t;
  }
  fromBufferAttribute(t, e) {
    return this.r = t.getX(e), this.g = t.getY(e), this.b = t.getZ(e), this;
  }
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b;
  }
}
const Y = /* @__PURE__ */ new we();
we.NAMES = ic;
let Bl = 0;
class nc extends Ar {
  constructor() {
    super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: Bl++ }), this.uuid = _e(), this.name = "", this.type = "Material", this.blending = 1, this.side = 0, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = 204, this.blendDst = 205, this.blendEquation = 100, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new we(0, 0, 0), this.blendAlpha = 0, this.depthFunc = 3, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = 519, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = 7680, this.stencilZFail = 7680, this.stencilZPass = 7680, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
  }
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(t) {
    this._alphaTest > 0 != t > 0 && this.version++, this._alphaTest = t;
  }
  // onBeforeRender and onBeforeCompile only supported in WebGLRenderer
  onBeforeRender() {
  }
  onBeforeCompile() {
  }
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  setValues(t) {
    if (t !== void 0)
      for (const e in t) {
        const r = t[e];
        if (r === void 0) {
          console.warn(`THREE.Material: parameter '${e}' has value of undefined.`);
          continue;
        }
        const s = this[e];
        if (s === void 0) {
          console.warn(`THREE.Material: '${e}' is not a property of THREE.${this.type}.`);
          continue;
        }
        s && s.isColor ? s.set(r) : s && s.isVector3 && r && r.isVector3 ? s.copy(r) : this[e] = r;
      }
  }
  toJSON(t) {
    const e = t === void 0 || typeof t == "string";
    e && (t = {
      textures: {},
      images: {}
    });
    const r = {
      metadata: {
        version: 4.6,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    r.uuid = this.uuid, r.type = this.type, this.name !== "" && (r.name = this.name), this.color && this.color.isColor && (r.color = this.color.getHex()), this.roughness !== void 0 && (r.roughness = this.roughness), this.metalness !== void 0 && (r.metalness = this.metalness), this.sheen !== void 0 && (r.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (r.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (r.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (r.emissive = this.emissive.getHex()), this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1 && (r.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (r.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (r.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (r.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (r.shininess = this.shininess), this.clearcoat !== void 0 && (r.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (r.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (r.clearcoatMap = this.clearcoatMap.toJSON(t).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (r.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (r.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t).uuid, r.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.dispersion !== void 0 && (r.dispersion = this.dispersion), this.iridescence !== void 0 && (r.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (r.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (r.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (r.iridescenceMap = this.iridescenceMap.toJSON(t).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (r.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(t).uuid), this.anisotropy !== void 0 && (r.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (r.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (r.anisotropyMap = this.anisotropyMap.toJSON(t).uuid), this.map && this.map.isTexture && (r.map = this.map.toJSON(t).uuid), this.matcap && this.matcap.isTexture && (r.matcap = this.matcap.toJSON(t).uuid), this.alphaMap && this.alphaMap.isTexture && (r.alphaMap = this.alphaMap.toJSON(t).uuid), this.lightMap && this.lightMap.isTexture && (r.lightMap = this.lightMap.toJSON(t).uuid, r.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (r.aoMap = this.aoMap.toJSON(t).uuid, r.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (r.bumpMap = this.bumpMap.toJSON(t).uuid, r.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (r.normalMap = this.normalMap.toJSON(t).uuid, r.normalMapType = this.normalMapType, r.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (r.displacementMap = this.displacementMap.toJSON(t).uuid, r.displacementScale = this.displacementScale, r.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (r.roughnessMap = this.roughnessMap.toJSON(t).uuid), this.metalnessMap && this.metalnessMap.isTexture && (r.metalnessMap = this.metalnessMap.toJSON(t).uuid), this.emissiveMap && this.emissiveMap.isTexture && (r.emissiveMap = this.emissiveMap.toJSON(t).uuid), this.specularMap && this.specularMap.isTexture && (r.specularMap = this.specularMap.toJSON(t).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (r.specularIntensityMap = this.specularIntensityMap.toJSON(t).uuid), this.specularColorMap && this.specularColorMap.isTexture && (r.specularColorMap = this.specularColorMap.toJSON(t).uuid), this.envMap && this.envMap.isTexture && (r.envMap = this.envMap.toJSON(t).uuid, this.combine !== void 0 && (r.combine = this.combine)), this.envMapRotation !== void 0 && (r.envMapRotation = this.envMapRotation.toArray()), this.envMapIntensity !== void 0 && (r.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (r.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (r.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (r.gradientMap = this.gradientMap.toJSON(t).uuid), this.transmission !== void 0 && (r.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (r.transmissionMap = this.transmissionMap.toJSON(t).uuid), this.thickness !== void 0 && (r.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (r.thicknessMap = this.thicknessMap.toJSON(t).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (r.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (r.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (r.size = this.size), this.shadowSide !== null && (r.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (r.sizeAttenuation = this.sizeAttenuation), this.blending !== 1 && (r.blending = this.blending), this.side !== 0 && (r.side = this.side), this.vertexColors === !0 && (r.vertexColors = !0), this.opacity < 1 && (r.opacity = this.opacity), this.transparent === !0 && (r.transparent = !0), this.blendSrc !== 204 && (r.blendSrc = this.blendSrc), this.blendDst !== 205 && (r.blendDst = this.blendDst), this.blendEquation !== 100 && (r.blendEquation = this.blendEquation), this.blendSrcAlpha !== null && (r.blendSrcAlpha = this.blendSrcAlpha), this.blendDstAlpha !== null && (r.blendDstAlpha = this.blendDstAlpha), this.blendEquationAlpha !== null && (r.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (r.blendColor = this.blendColor.getHex()), this.blendAlpha !== 0 && (r.blendAlpha = this.blendAlpha), this.depthFunc !== 3 && (r.depthFunc = this.depthFunc), this.depthTest === !1 && (r.depthTest = this.depthTest), this.depthWrite === !1 && (r.depthWrite = this.depthWrite), this.colorWrite === !1 && (r.colorWrite = this.colorWrite), this.stencilWriteMask !== 255 && (r.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== 519 && (r.stencilFunc = this.stencilFunc), this.stencilRef !== 0 && (r.stencilRef = this.stencilRef), this.stencilFuncMask !== 255 && (r.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== 7680 && (r.stencilFail = this.stencilFail), this.stencilZFail !== 7680 && (r.stencilZFail = this.stencilZFail), this.stencilZPass !== 7680 && (r.stencilZPass = this.stencilZPass), this.stencilWrite === !0 && (r.stencilWrite = this.stencilWrite), this.rotation !== void 0 && this.rotation !== 0 && (r.rotation = this.rotation), this.polygonOffset === !0 && (r.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (r.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (r.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (r.linewidth = this.linewidth), this.dashSize !== void 0 && (r.dashSize = this.dashSize), this.gapSize !== void 0 && (r.gapSize = this.gapSize), this.scale !== void 0 && (r.scale = this.scale), this.dithering === !0 && (r.dithering = !0), this.alphaTest > 0 && (r.alphaTest = this.alphaTest), this.alphaHash === !0 && (r.alphaHash = !0), this.alphaToCoverage === !0 && (r.alphaToCoverage = !0), this.premultipliedAlpha === !0 && (r.premultipliedAlpha = !0), this.forceSinglePass === !0 && (r.forceSinglePass = !0), this.wireframe === !0 && (r.wireframe = !0), this.wireframeLinewidth > 1 && (r.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (r.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (r.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (r.flatShading = !0), this.visible === !1 && (r.visible = !1), this.toneMapped === !1 && (r.toneMapped = !1), this.fog === !1 && (r.fog = !1), Object.keys(this.userData).length > 0 && (r.userData = this.userData);
    function s(i) {
      const n = [];
      for (const o in i) {
        const h = i[o];
        delete h.metadata, n.push(h);
      }
      return n;
    }
    if (e) {
      const i = s(t.textures), n = s(t.images);
      i.length > 0 && (r.textures = i), n.length > 0 && (r.images = n);
    }
    return r;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    this.name = t.name, this.blending = t.blending, this.side = t.side, this.vertexColors = t.vertexColors, this.opacity = t.opacity, this.transparent = t.transparent, this.blendSrc = t.blendSrc, this.blendDst = t.blendDst, this.blendEquation = t.blendEquation, this.blendSrcAlpha = t.blendSrcAlpha, this.blendDstAlpha = t.blendDstAlpha, this.blendEquationAlpha = t.blendEquationAlpha, this.blendColor.copy(t.blendColor), this.blendAlpha = t.blendAlpha, this.depthFunc = t.depthFunc, this.depthTest = t.depthTest, this.depthWrite = t.depthWrite, this.stencilWriteMask = t.stencilWriteMask, this.stencilFunc = t.stencilFunc, this.stencilRef = t.stencilRef, this.stencilFuncMask = t.stencilFuncMask, this.stencilFail = t.stencilFail, this.stencilZFail = t.stencilZFail, this.stencilZPass = t.stencilZPass, this.stencilWrite = t.stencilWrite;
    const e = t.clippingPlanes;
    let r = null;
    if (e !== null) {
      const s = e.length;
      r = new Array(s);
      for (let i = 0; i !== s; ++i)
        r[i] = e[i].clone();
    }
    return this.clippingPlanes = r, this.clipIntersection = t.clipIntersection, this.clipShadows = t.clipShadows, this.shadowSide = t.shadowSide, this.colorWrite = t.colorWrite, this.precision = t.precision, this.polygonOffset = t.polygonOffset, this.polygonOffsetFactor = t.polygonOffsetFactor, this.polygonOffsetUnits = t.polygonOffsetUnits, this.dithering = t.dithering, this.alphaTest = t.alphaTest, this.alphaHash = t.alphaHash, this.alphaToCoverage = t.alphaToCoverage, this.premultipliedAlpha = t.premultipliedAlpha, this.forceSinglePass = t.forceSinglePass, this.visible = t.visible, this.toneMapped = t.toneMapped, this.userData = JSON.parse(JSON.stringify(t.userData)), this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  set needsUpdate(t) {
    t === !0 && this.version++;
  }
  onBuild() {
    console.warn("Material: onBuild() has been removed.");
  }
}
class Ne extends nc {
  constructor(t) {
    super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new we(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new qe(), this.combine = 0, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.envMapRotation.copy(t.envMapRotation), this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.fog = t.fog, this;
  }
}
const O = /* @__PURE__ */ new g(), nr = /* @__PURE__ */ new E();
class K {
  constructor(t, e, r = !1) {
    if (Array.isArray(t))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.isBufferAttribute = !0, this.name = "", this.array = t, this.itemSize = e, this.count = t !== void 0 ? t.length / e : 0, this.normalized = r, this.usage = 35044, this.updateRanges = [], this.gpuType = 1015, this.version = 0;
  }
  onUploadCallback() {
  }
  set needsUpdate(t) {
    t === !0 && this.version++;
  }
  setUsage(t) {
    return this.usage = t, this;
  }
  addUpdateRange(t, e) {
    this.updateRanges.push({ start: t, count: e });
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  copy(t) {
    return this.name = t.name, this.array = new t.array.constructor(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this.usage = t.usage, this.gpuType = t.gpuType, this;
  }
  copyAt(t, e, r) {
    t *= this.itemSize, r *= e.itemSize;
    for (let s = 0, i = this.itemSize; s < i; s++)
      this.array[t + s] = e.array[r + s];
    return this;
  }
  copyArray(t) {
    return this.array.set(t), this;
  }
  applyMatrix3(t) {
    if (this.itemSize === 2)
      for (let e = 0, r = this.count; e < r; e++)
        nr.fromBufferAttribute(this, e), nr.applyMatrix3(t), this.setXY(e, nr.x, nr.y);
    else if (this.itemSize === 3)
      for (let e = 0, r = this.count; e < r; e++)
        O.fromBufferAttribute(this, e), O.applyMatrix3(t), this.setXYZ(e, O.x, O.y, O.z);
    return this;
  }
  applyMatrix4(t) {
    for (let e = 0, r = this.count; e < r; e++)
      O.fromBufferAttribute(this, e), O.applyMatrix4(t), this.setXYZ(e, O.x, O.y, O.z);
    return this;
  }
  applyNormalMatrix(t) {
    for (let e = 0, r = this.count; e < r; e++)
      O.fromBufferAttribute(this, e), O.applyNormalMatrix(t), this.setXYZ(e, O.x, O.y, O.z);
    return this;
  }
  transformDirection(t) {
    for (let e = 0, r = this.count; e < r; e++)
      O.fromBufferAttribute(this, e), O.transformDirection(t), this.setXYZ(e, O.x, O.y, O.z);
    return this;
  }
  set(t, e = 0) {
    return this.array.set(t, e), this;
  }
  getComponent(t, e) {
    let r = this.array[t * this.itemSize + e];
    return this.normalized && (r = ve(r, this.array)), r;
  }
  setComponent(t, e, r) {
    return this.normalized && (r = tt(r, this.array)), this.array[t * this.itemSize + e] = r, this;
  }
  getX(t) {
    let e = this.array[t * this.itemSize];
    return this.normalized && (e = ve(e, this.array)), e;
  }
  setX(t, e) {
    return this.normalized && (e = tt(e, this.array)), this.array[t * this.itemSize] = e, this;
  }
  getY(t) {
    let e = this.array[t * this.itemSize + 1];
    return this.normalized && (e = ve(e, this.array)), e;
  }
  setY(t, e) {
    return this.normalized && (e = tt(e, this.array)), this.array[t * this.itemSize + 1] = e, this;
  }
  getZ(t) {
    let e = this.array[t * this.itemSize + 2];
    return this.normalized && (e = ve(e, this.array)), e;
  }
  setZ(t, e) {
    return this.normalized && (e = tt(e, this.array)), this.array[t * this.itemSize + 2] = e, this;
  }
  getW(t) {
    let e = this.array[t * this.itemSize + 3];
    return this.normalized && (e = ve(e, this.array)), e;
  }
  setW(t, e) {
    return this.normalized && (e = tt(e, this.array)), this.array[t * this.itemSize + 3] = e, this;
  }
  setXY(t, e, r) {
    return t *= this.itemSize, this.normalized && (e = tt(e, this.array), r = tt(r, this.array)), this.array[t + 0] = e, this.array[t + 1] = r, this;
  }
  setXYZ(t, e, r, s) {
    return t *= this.itemSize, this.normalized && (e = tt(e, this.array), r = tt(r, this.array), s = tt(s, this.array)), this.array[t + 0] = e, this.array[t + 1] = r, this.array[t + 2] = s, this;
  }
  setXYZW(t, e, r, s, i) {
    return t *= this.itemSize, this.normalized && (e = tt(e, this.array), r = tt(r, this.array), s = tt(s, this.array), i = tt(i, this.array)), this.array[t + 0] = e, this.array[t + 1] = r, this.array[t + 2] = s, this.array[t + 3] = i, this;
  }
  onUpload(t) {
    return this.onUploadCallback = t, this;
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  toJSON() {
    const t = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    return this.name !== "" && (t.name = this.name), this.usage !== 35044 && (t.usage = this.usage), t;
  }
}
class Dl extends K {
  constructor(t, e, r) {
    super(new Uint16Array(t), e, r);
  }
}
class Il extends K {
  constructor(t, e, r) {
    super(new Uint32Array(t), e, r);
  }
}
class Et extends K {
  constructor(t, e, r) {
    super(new Float32Array(t), e, r);
  }
}
let Rl = 0;
const at = /* @__PURE__ */ new et(), ts = /* @__PURE__ */ new mt(), xe = /* @__PURE__ */ new g(), st = /* @__PURE__ */ new zt(), ke = /* @__PURE__ */ new zt(), j = /* @__PURE__ */ new g();
class ht extends Ar {
  constructor() {
    super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: Rl++ }), this.uuid = _e(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = { start: 0, count: 1 / 0 }, this.userData = {};
  }
  getIndex() {
    return this.index;
  }
  setIndex(t) {
    return Array.isArray(t) ? this.index = new (_l(t) ? Il : Dl)(t, 1) : this.index = t, this;
  }
  setIndirect(t) {
    return this.indirect = t, this;
  }
  getIndirect() {
    return this.indirect;
  }
  getAttribute(t) {
    return this.attributes[t];
  }
  setAttribute(t, e) {
    return this.attributes[t] = e, this;
  }
  deleteAttribute(t) {
    return delete this.attributes[t], this;
  }
  hasAttribute(t) {
    return this.attributes[t] !== void 0;
  }
  addGroup(t, e, r = 0) {
    this.groups.push({
      start: t,
      count: e,
      materialIndex: r
    });
  }
  clearGroups() {
    this.groups = [];
  }
  setDrawRange(t, e) {
    this.drawRange.start = t, this.drawRange.count = e;
  }
  applyMatrix4(t) {
    const e = this.attributes.position;
    e !== void 0 && (e.applyMatrix4(t), e.needsUpdate = !0);
    const r = this.attributes.normal;
    if (r !== void 0) {
      const i = new Ct().getNormalMatrix(t);
      r.applyNormalMatrix(i), r.needsUpdate = !0;
    }
    const s = this.attributes.tangent;
    return s !== void 0 && (s.transformDirection(t), s.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  applyQuaternion(t) {
    return at.makeRotationFromQuaternion(t), this.applyMatrix4(at), this;
  }
  rotateX(t) {
    return at.makeRotationX(t), this.applyMatrix4(at), this;
  }
  rotateY(t) {
    return at.makeRotationY(t), this.applyMatrix4(at), this;
  }
  rotateZ(t) {
    return at.makeRotationZ(t), this.applyMatrix4(at), this;
  }
  translate(t, e, r) {
    return at.makeTranslation(t, e, r), this.applyMatrix4(at), this;
  }
  scale(t, e, r) {
    return at.makeScale(t, e, r), this.applyMatrix4(at), this;
  }
  lookAt(t) {
    return ts.lookAt(t), ts.updateMatrix(), this.applyMatrix4(ts.matrix), this;
  }
  center() {
    return this.computeBoundingBox(), this.boundingBox.getCenter(xe).negate(), this.translate(xe.x, xe.y, xe.z), this;
  }
  setFromPoints(t) {
    const e = this.getAttribute("position");
    if (e === void 0) {
      const r = [];
      for (let s = 0, i = t.length; s < i; s++) {
        const n = t[s];
        r.push(n.x, n.y, n.z || 0);
      }
      this.setAttribute("position", new Et(r, 3));
    } else {
      const r = Math.min(t.length, e.count);
      for (let s = 0; s < r; s++) {
        const i = t[s];
        e.setXYZ(s, i.x, i.y, i.z || 0);
      }
      t.length > e.count && console.warn("THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), e.needsUpdate = !0;
    }
    return this;
  }
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new zt());
    const t = this.attributes.position, e = this.morphAttributes.position;
    if (t && t.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), this.boundingBox.set(
        new g(-1 / 0, -1 / 0, -1 / 0),
        new g(1 / 0, 1 / 0, 1 / 0)
      );
      return;
    }
    if (t !== void 0) {
      if (this.boundingBox.setFromBufferAttribute(t), e)
        for (let r = 0, s = e.length; r < s; r++) {
          const i = e[r];
          st.setFromBufferAttribute(i), this.morphTargetsRelative ? (j.addVectors(this.boundingBox.min, st.min), this.boundingBox.expandByPoint(j), j.addVectors(this.boundingBox.max, st.max), this.boundingBox.expandByPoint(j)) : (this.boundingBox.expandByPoint(st.min), this.boundingBox.expandByPoint(st.max));
        }
    } else
      this.boundingBox.makeEmpty();
    (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
  }
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new Sn());
    const t = this.attributes.position, e = this.morphAttributes.position;
    if (t && t.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), this.boundingSphere.set(new g(), 1 / 0);
      return;
    }
    if (t) {
      const r = this.boundingSphere.center;
      if (st.setFromBufferAttribute(t), e)
        for (let i = 0, n = e.length; i < n; i++) {
          const o = e[i];
          ke.setFromBufferAttribute(o), this.morphTargetsRelative ? (j.addVectors(st.min, ke.min), st.expandByPoint(j), j.addVectors(st.max, ke.max), st.expandByPoint(j)) : (st.expandByPoint(ke.min), st.expandByPoint(ke.max));
        }
      st.getCenter(r);
      let s = 0;
      for (let i = 0, n = t.count; i < n; i++)
        j.fromBufferAttribute(t, i), s = Math.max(s, r.distanceToSquared(j));
      if (e)
        for (let i = 0, n = e.length; i < n; i++) {
          const o = e[i], h = this.morphTargetsRelative;
          for (let c = 0, l = o.count; c < l; c++)
            j.fromBufferAttribute(o, c), h && (xe.fromBufferAttribute(t, c), j.add(xe)), s = Math.max(s, r.distanceToSquared(j));
        }
      this.boundingSphere.radius = Math.sqrt(s), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
    }
  }
  computeTangents() {
    const t = this.index, e = this.attributes;
    if (t === null || e.position === void 0 || e.normal === void 0 || e.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const r = e.position, s = e.normal, i = e.uv;
    this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new K(new Float32Array(4 * r.count), 4));
    const n = this.getAttribute("tangent"), o = [], h = [];
    for (let S = 0; S < r.count; S++)
      o[S] = new g(), h[S] = new g();
    const c = new g(), l = new g(), u = new g(), f = new E(), d = new E(), p = new E(), x = new g(), m = new g();
    function y(S, F, T) {
      c.fromBufferAttribute(r, S), l.fromBufferAttribute(r, F), u.fromBufferAttribute(r, T), f.fromBufferAttribute(i, S), d.fromBufferAttribute(i, F), p.fromBufferAttribute(i, T), l.sub(c), u.sub(c), d.sub(f), p.sub(f);
      const k = 1 / (d.x * p.y - p.x * d.y);
      isFinite(k) && (x.copy(l).multiplyScalar(p.y).addScaledVector(u, -d.y).multiplyScalar(k), m.copy(u).multiplyScalar(d.x).addScaledVector(l, -p.x).multiplyScalar(k), o[S].add(x), o[F].add(x), o[T].add(x), h[S].add(m), h[F].add(m), h[T].add(m));
    }
    let _ = this.groups;
    _.length === 0 && (_ = [{
      start: 0,
      count: t.count
    }]);
    for (let S = 0, F = _.length; S < F; ++S) {
      const T = _[S], k = T.start, L = T.count;
      for (let B = k, G = k + L; B < G; B += 3)
        y(
          t.getX(B + 0),
          t.getX(B + 1),
          t.getX(B + 2)
        );
    }
    const b = new g(), w = new g(), M = new g(), A = new g();
    function v(S) {
      M.fromBufferAttribute(s, S), A.copy(M);
      const F = o[S];
      b.copy(F), b.sub(M.multiplyScalar(M.dot(F))).normalize(), w.crossVectors(A, F);
      const k = w.dot(h[S]) < 0 ? -1 : 1;
      n.setXYZW(S, b.x, b.y, b.z, k);
    }
    for (let S = 0, F = _.length; S < F; ++S) {
      const T = _[S], k = T.start, L = T.count;
      for (let B = k, G = k + L; B < G; B += 3)
        v(t.getX(B + 0)), v(t.getX(B + 1)), v(t.getX(B + 2));
    }
  }
  computeVertexNormals() {
    const t = this.index, e = this.getAttribute("position");
    if (e !== void 0) {
      let r = this.getAttribute("normal");
      if (r === void 0)
        r = new K(new Float32Array(e.count * 3), 3), this.setAttribute("normal", r);
      else
        for (let f = 0, d = r.count; f < d; f++)
          r.setXYZ(f, 0, 0, 0);
      const s = new g(), i = new g(), n = new g(), o = new g(), h = new g(), c = new g(), l = new g(), u = new g();
      if (t)
        for (let f = 0, d = t.count; f < d; f += 3) {
          const p = t.getX(f + 0), x = t.getX(f + 1), m = t.getX(f + 2);
          s.fromBufferAttribute(e, p), i.fromBufferAttribute(e, x), n.fromBufferAttribute(e, m), l.subVectors(n, i), u.subVectors(s, i), l.cross(u), o.fromBufferAttribute(r, p), h.fromBufferAttribute(r, x), c.fromBufferAttribute(r, m), o.add(l), h.add(l), c.add(l), r.setXYZ(p, o.x, o.y, o.z), r.setXYZ(x, h.x, h.y, h.z), r.setXYZ(m, c.x, c.y, c.z);
        }
      else
        for (let f = 0, d = e.count; f < d; f += 3)
          s.fromBufferAttribute(e, f + 0), i.fromBufferAttribute(e, f + 1), n.fromBufferAttribute(e, f + 2), l.subVectors(n, i), u.subVectors(s, i), l.cross(u), r.setXYZ(f + 0, l.x, l.y, l.z), r.setXYZ(f + 1, l.x, l.y, l.z), r.setXYZ(f + 2, l.x, l.y, l.z);
      this.normalizeNormals(), r.needsUpdate = !0;
    }
  }
  normalizeNormals() {
    const t = this.attributes.normal;
    for (let e = 0, r = t.count; e < r; e++)
      j.fromBufferAttribute(t, e), j.normalize(), t.setXYZ(e, j.x, j.y, j.z);
  }
  toNonIndexed() {
    function t(o, h) {
      const c = o.array, l = o.itemSize, u = o.normalized, f = new c.constructor(h.length * l);
      let d = 0, p = 0;
      for (let x = 0, m = h.length; x < m; x++) {
        o.isInterleavedBufferAttribute ? d = h[x] * o.data.stride + o.offset : d = h[x] * l;
        for (let y = 0; y < l; y++)
          f[p++] = c[d++];
      }
      return new K(f, l, u);
    }
    if (this.index === null)
      return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
    const e = new ht(), r = this.index.array, s = this.attributes;
    for (const o in s) {
      const h = s[o], c = t(h, r);
      e.setAttribute(o, c);
    }
    const i = this.morphAttributes;
    for (const o in i) {
      const h = [], c = i[o];
      for (let l = 0, u = c.length; l < u; l++) {
        const f = c[l], d = t(f, r);
        h.push(d);
      }
      e.morphAttributes[o] = h;
    }
    e.morphTargetsRelative = this.morphTargetsRelative;
    const n = this.groups;
    for (let o = 0, h = n.length; o < h; o++) {
      const c = n[o];
      e.addGroup(c.start, c.count, c.materialIndex);
    }
    return e;
  }
  toJSON() {
    const t = {
      metadata: {
        version: 4.6,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    if (t.uuid = this.uuid, t.type = this.type, this.name !== "" && (t.name = this.name), Object.keys(this.userData).length > 0 && (t.userData = this.userData), this.parameters !== void 0) {
      const h = this.parameters;
      for (const c in h)
        h[c] !== void 0 && (t[c] = h[c]);
      return t;
    }
    t.data = { attributes: {} };
    const e = this.index;
    e !== null && (t.data.index = {
      type: e.array.constructor.name,
      array: Array.prototype.slice.call(e.array)
    });
    const r = this.attributes;
    for (const h in r) {
      const c = r[h];
      t.data.attributes[h] = c.toJSON(t.data);
    }
    const s = {};
    let i = !1;
    for (const h in this.morphAttributes) {
      const c = this.morphAttributes[h], l = [];
      for (let u = 0, f = c.length; u < f; u++) {
        const d = c[u];
        l.push(d.toJSON(t.data));
      }
      l.length > 0 && (s[h] = l, i = !0);
    }
    i && (t.data.morphAttributes = s, t.data.morphTargetsRelative = this.morphTargetsRelative);
    const n = this.groups;
    n.length > 0 && (t.data.groups = JSON.parse(JSON.stringify(n)));
    const o = this.boundingSphere;
    return o !== null && (t.data.boundingSphere = {
      center: o.center.toArray(),
      radius: o.radius
    }), t;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
    const e = {};
    this.name = t.name;
    const r = t.index;
    r !== null && this.setIndex(r.clone(e));
    const s = t.attributes;
    for (const c in s) {
      const l = s[c];
      this.setAttribute(c, l.clone(e));
    }
    const i = t.morphAttributes;
    for (const c in i) {
      const l = [], u = i[c];
      for (let f = 0, d = u.length; f < d; f++)
        l.push(u[f].clone(e));
      this.morphAttributes[c] = l;
    }
    this.morphTargetsRelative = t.morphTargetsRelative;
    const n = t.groups;
    for (let c = 0, l = n.length; c < l; c++) {
      const u = n[c];
      this.addGroup(u.start, u.count, u.materialIndex);
    }
    const o = t.boundingBox;
    o !== null && (this.boundingBox = o.clone());
    const h = t.boundingSphere;
    return h !== null && (this.boundingSphere = h.clone()), this.drawRange.start = t.drawRange.start, this.drawRange.count = t.drawRange.count, this.userData = t.userData, this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
const ya = /* @__PURE__ */ new et(), $t = /* @__PURE__ */ new kn(), ar = /* @__PURE__ */ new Sn(), ga = /* @__PURE__ */ new g(), or = /* @__PURE__ */ new g(), hr = /* @__PURE__ */ new g(), cr = /* @__PURE__ */ new g(), es = /* @__PURE__ */ new g(), lr = /* @__PURE__ */ new g(), ba = /* @__PURE__ */ new g(), ur = /* @__PURE__ */ new g();
class Pt extends mt {
  constructor(t = new ht(), e = new Ne()) {
    super(), this.isMesh = !0, this.type = "Mesh", this.geometry = t, this.material = e, this.updateMorphTargets();
  }
  copy(t, e) {
    return super.copy(t, e), t.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = t.morphTargetInfluences.slice()), t.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, t.morphTargetDictionary)), this.material = Array.isArray(t.material) ? t.material.slice() : t.material, this.geometry = t.geometry, this;
  }
  updateMorphTargets() {
    const e = this.geometry.morphAttributes, r = Object.keys(e);
    if (r.length > 0) {
      const s = e[r[0]];
      if (s !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let i = 0, n = s.length; i < n; i++) {
          const o = s[i].name || String(i);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = i;
        }
      }
    }
  }
  getVertexPosition(t, e) {
    const r = this.geometry, s = r.attributes.position, i = r.morphAttributes.position, n = r.morphTargetsRelative;
    e.fromBufferAttribute(s, t);
    const o = this.morphTargetInfluences;
    if (i && o) {
      lr.set(0, 0, 0);
      for (let h = 0, c = i.length; h < c; h++) {
        const l = o[h], u = i[h];
        l !== 0 && (es.fromBufferAttribute(u, t), n ? lr.addScaledVector(es, l) : lr.addScaledVector(es.sub(e), l));
      }
      e.add(lr);
    }
    return e;
  }
  raycast(t, e) {
    const r = this.geometry, s = this.material, i = this.matrixWorld;
    s !== void 0 && (r.boundingSphere === null && r.computeBoundingSphere(), ar.copy(r.boundingSphere), ar.applyMatrix4(i), $t.copy(t.ray).recast(t.near), !(ar.containsPoint($t.origin) === !1 && ($t.intersectSphere(ar, ga) === null || $t.origin.distanceToSquared(ga) > (t.far - t.near) ** 2)) && (ya.copy(i).invert(), $t.copy(t.ray).applyMatrix4(ya), !(r.boundingBox !== null && $t.intersectsBox(r.boundingBox) === !1) && this._computeIntersections(t, e, $t)));
  }
  _computeIntersections(t, e, r) {
    let s;
    const i = this.geometry, n = this.material, o = i.index, h = i.attributes.position, c = i.attributes.uv, l = i.attributes.uv1, u = i.attributes.normal, f = i.groups, d = i.drawRange;
    if (o !== null)
      if (Array.isArray(n))
        for (let p = 0, x = f.length; p < x; p++) {
          const m = f[p], y = n[m.materialIndex], _ = Math.max(m.start, d.start), b = Math.min(o.count, Math.min(m.start + m.count, d.start + d.count));
          for (let w = _, M = b; w < M; w += 3) {
            const A = o.getX(w), v = o.getX(w + 1), S = o.getX(w + 2);
            s = fr(this, y, t, r, c, l, u, A, v, S), s && (s.faceIndex = Math.floor(w / 3), s.face.materialIndex = m.materialIndex, e.push(s));
          }
        }
      else {
        const p = Math.max(0, d.start), x = Math.min(o.count, d.start + d.count);
        for (let m = p, y = x; m < y; m += 3) {
          const _ = o.getX(m), b = o.getX(m + 1), w = o.getX(m + 2);
          s = fr(this, n, t, r, c, l, u, _, b, w), s && (s.faceIndex = Math.floor(m / 3), e.push(s));
        }
      }
    else if (h !== void 0)
      if (Array.isArray(n))
        for (let p = 0, x = f.length; p < x; p++) {
          const m = f[p], y = n[m.materialIndex], _ = Math.max(m.start, d.start), b = Math.min(h.count, Math.min(m.start + m.count, d.start + d.count));
          for (let w = _, M = b; w < M; w += 3) {
            const A = w, v = w + 1, S = w + 2;
            s = fr(this, y, t, r, c, l, u, A, v, S), s && (s.faceIndex = Math.floor(w / 3), s.face.materialIndex = m.materialIndex, e.push(s));
          }
        }
      else {
        const p = Math.max(0, d.start), x = Math.min(h.count, d.start + d.count);
        for (let m = p, y = x; m < y; m += 3) {
          const _ = m, b = m + 1, w = m + 2;
          s = fr(this, n, t, r, c, l, u, _, b, w), s && (s.faceIndex = Math.floor(m / 3), e.push(s));
        }
      }
  }
}
function Ll(a, t, e, r, s, i, n, o) {
  let h;
  if (t.side === 1 ? h = r.intersectTriangle(n, i, s, !0, o) : h = r.intersectTriangle(s, i, n, t.side === 0, o), h === null) return null;
  ur.copy(o), ur.applyMatrix4(a.matrixWorld);
  const c = e.ray.origin.distanceTo(ur);
  return c < e.near || c > e.far ? null : {
    distance: c,
    point: ur.clone(),
    object: a
  };
}
function fr(a, t, e, r, s, i, n, o, h, c) {
  a.getVertexPosition(o, or), a.getVertexPosition(h, hr), a.getVertexPosition(c, cr);
  const l = Ll(a, t, e, r, or, hr, cr, ba);
  if (l) {
    const u = new g();
    xt.getBarycoord(ba, or, hr, cr, u), s && (l.uv = xt.getInterpolatedAttribute(s, o, h, c, u, new E())), i && (l.uv1 = xt.getInterpolatedAttribute(i, o, h, c, u, new E())), n && (l.normal = xt.getInterpolatedAttribute(n, o, h, c, u, new g()), l.normal.dot(r.direction) > 0 && l.normal.multiplyScalar(-1));
    const f = {
      a: o,
      b: h,
      c,
      normal: new g(),
      materialIndex: 0
    };
    xt.getNormal(or, hr, cr, f.normal), l.face = f, l.barycoord = u;
  }
  return l;
}
class Fn extends ht {
  constructor(t = 1, e = 1, r = 1, s = 1, i = 1, n = 1) {
    super(), this.type = "BoxGeometry", this.parameters = {
      width: t,
      height: e,
      depth: r,
      widthSegments: s,
      heightSegments: i,
      depthSegments: n
    };
    const o = this;
    s = Math.floor(s), i = Math.floor(i), n = Math.floor(n);
    const h = [], c = [], l = [], u = [];
    let f = 0, d = 0;
    p("z", "y", "x", -1, -1, r, e, t, n, i, 0), p("z", "y", "x", 1, -1, r, e, -t, n, i, 1), p("x", "z", "y", 1, 1, t, r, e, s, n, 2), p("x", "z", "y", 1, -1, t, r, -e, s, n, 3), p("x", "y", "z", 1, -1, t, e, r, s, i, 4), p("x", "y", "z", -1, -1, t, e, -r, s, i, 5), this.setIndex(h), this.setAttribute("position", new Et(c, 3)), this.setAttribute("normal", new Et(l, 3)), this.setAttribute("uv", new Et(u, 2));
    function p(x, m, y, _, b, w, M, A, v, S, F) {
      const T = w / v, k = M / S, L = w / 2, B = M / 2, G = A / 2, nt = v + 1, Dt = S + 1;
      let bt = 0, ct = 0;
      const q = new g();
      for (let V = 0; V < Dt; V++) {
        const $ = V * k - B;
        for (let It = 0; It < nt; It++) {
          const re = It * T - L;
          q[x] = re * _, q[m] = $ * b, q[y] = G, c.push(q.x, q.y, q.z), q[x] = 0, q[m] = 0, q[y] = A > 0 ? 1 : -1, l.push(q.x, q.y, q.z), u.push(It / v), u.push(1 - V / S), bt += 1;
        }
      }
      for (let V = 0; V < S; V++)
        for (let $ = 0; $ < v; $++) {
          const It = f + $ + nt * V, re = f + $ + nt * (V + 1), Dr = f + ($ + 1) + nt * (V + 1), Xe = f + ($ + 1) + nt * V;
          h.push(It, re, Xe), h.push(re, Dr, Xe), ct += 6;
        }
      o.addGroup(d, ct, F), d += ct, f += bt;
    }
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  static fromJSON(t) {
    return new Fn(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
  }
}
const rs = /* @__PURE__ */ new g(), Ol = /* @__PURE__ */ new g(), ql = /* @__PURE__ */ new Ct();
class Nl {
  constructor(t = new g(1, 0, 0), e = 0) {
    this.isPlane = !0, this.normal = t, this.constant = e;
  }
  set(t, e) {
    return this.normal.copy(t), this.constant = e, this;
  }
  setComponents(t, e, r, s) {
    return this.normal.set(t, e, r), this.constant = s, this;
  }
  setFromNormalAndCoplanarPoint(t, e) {
    return this.normal.copy(t), this.constant = -e.dot(this.normal), this;
  }
  setFromCoplanarPoints(t, e, r) {
    const s = rs.subVectors(r, e).cross(Ol.subVectors(t, e)).normalize();
    return this.setFromNormalAndCoplanarPoint(s, t), this;
  }
  copy(t) {
    return this.normal.copy(t.normal), this.constant = t.constant, this;
  }
  normalize() {
    const t = 1 / this.normal.length();
    return this.normal.multiplyScalar(t), this.constant *= t, this;
  }
  negate() {
    return this.constant *= -1, this.normal.negate(), this;
  }
  distanceToPoint(t) {
    return this.normal.dot(t) + this.constant;
  }
  distanceToSphere(t) {
    return this.distanceToPoint(t.center) - t.radius;
  }
  projectPoint(t, e) {
    return e.copy(t).addScaledVector(this.normal, -this.distanceToPoint(t));
  }
  intersectLine(t, e) {
    const r = t.delta(rs), s = this.normal.dot(r);
    if (s === 0)
      return this.distanceToPoint(t.start) === 0 ? e.copy(t.start) : null;
    const i = -(t.start.dot(this.normal) + this.constant) / s;
    return i < 0 || i > 1 ? null : e.copy(t.start).addScaledVector(r, i);
  }
  intersectsLine(t) {
    const e = this.distanceToPoint(t.start), r = this.distanceToPoint(t.end);
    return e < 0 && r > 0 || r < 0 && e > 0;
  }
  intersectsBox(t) {
    return t.intersectsPlane(this);
  }
  intersectsSphere(t) {
    return t.intersectsPlane(this);
  }
  coplanarPoint(t) {
    return t.copy(this.normal).multiplyScalar(-this.constant);
  }
  applyMatrix4(t, e) {
    const r = e || ql.getNormalMatrix(t), s = this.coplanarPoint(rs).applyMatrix4(t), i = this.normal.applyMatrix3(r).normalize();
    return this.constant = -s.dot(i), this;
  }
  translate(t) {
    return this.constant -= t.dot(this.normal), this;
  }
  equals(t) {
    return t.normal.equals(this.normal) && t.constant === this.constant;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Tn extends nc {
  constructor(t) {
    super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new we(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.color.copy(t.color), this.map = t.map, this.linewidth = t.linewidth, this.linecap = t.linecap, this.linejoin = t.linejoin, this.fog = t.fog, this;
  }
}
const vr = /* @__PURE__ */ new g(), Mr = /* @__PURE__ */ new g(), _a = /* @__PURE__ */ new et(), Fe = /* @__PURE__ */ new kn(), dr = /* @__PURE__ */ new Sn(), ss = /* @__PURE__ */ new g(), wa = /* @__PURE__ */ new g();
class Ft extends mt {
  constructor(t = new ht(), e = new Tn()) {
    super(), this.isLine = !0, this.type = "Line", this.geometry = t, this.material = e, this.updateMorphTargets();
  }
  copy(t, e) {
    return super.copy(t, e), this.material = Array.isArray(t.material) ? t.material.slice() : t.material, this.geometry = t.geometry, this;
  }
  computeLineDistances() {
    const t = this.geometry;
    if (t.index === null) {
      const e = t.attributes.position, r = [0];
      for (let s = 1, i = e.count; s < i; s++)
        vr.fromBufferAttribute(e, s - 1), Mr.fromBufferAttribute(e, s), r[s] = r[s - 1], r[s] += vr.distanceTo(Mr);
      t.setAttribute("lineDistance", new Et(r, 1));
    } else
      console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
  raycast(t, e) {
    const r = this.geometry, s = this.matrixWorld, i = t.params.Line.threshold, n = r.drawRange;
    if (r.boundingSphere === null && r.computeBoundingSphere(), dr.copy(r.boundingSphere), dr.applyMatrix4(s), dr.radius += i, t.ray.intersectsSphere(dr) === !1) return;
    _a.copy(s).invert(), Fe.copy(t.ray).applyMatrix4(_a);
    const o = i / ((this.scale.x + this.scale.y + this.scale.z) / 3), h = o * o, c = this.isLineSegments ? 2 : 1, l = r.index, f = r.attributes.position;
    if (l !== null) {
      const d = Math.max(0, n.start), p = Math.min(l.count, n.start + n.count);
      for (let x = d, m = p - 1; x < m; x += c) {
        const y = l.getX(x), _ = l.getX(x + 1), b = pr(this, t, Fe, h, y, _);
        b && e.push(b);
      }
      if (this.isLineLoop) {
        const x = l.getX(p - 1), m = l.getX(d), y = pr(this, t, Fe, h, x, m);
        y && e.push(y);
      }
    } else {
      const d = Math.max(0, n.start), p = Math.min(f.count, n.start + n.count);
      for (let x = d, m = p - 1; x < m; x += c) {
        const y = pr(this, t, Fe, h, x, x + 1);
        y && e.push(y);
      }
      if (this.isLineLoop) {
        const x = pr(this, t, Fe, h, p - 1, d);
        x && e.push(x);
      }
    }
  }
  updateMorphTargets() {
    const e = this.geometry.morphAttributes, r = Object.keys(e);
    if (r.length > 0) {
      const s = e[r[0]];
      if (s !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let i = 0, n = s.length; i < n; i++) {
          const o = s[i].name || String(i);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = i;
        }
      }
    }
  }
}
function pr(a, t, e, r, s, i) {
  const n = a.geometry.attributes.position;
  if (vr.fromBufferAttribute(n, s), Mr.fromBufferAttribute(n, i), e.distanceSqToSegment(vr, Mr, ss, wa) > r) return;
  ss.applyMatrix4(a.matrixWorld);
  const h = t.ray.origin.distanceTo(ss);
  if (!(h < t.near || h > t.far))
    return {
      distance: h,
      // What do we want? intersection point on the ray or on the segment??
      // point: raycaster.ray.at( distance ),
      point: wa.clone().applyMatrix4(a.matrixWorld),
      index: s,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: a
    };
}
const va = /* @__PURE__ */ new g(), Ma = /* @__PURE__ */ new g();
class En extends Ft {
  constructor(t, e) {
    super(t, e), this.isLineSegments = !0, this.type = "LineSegments";
  }
  computeLineDistances() {
    const t = this.geometry;
    if (t.index === null) {
      const e = t.attributes.position, r = [];
      for (let s = 0, i = e.count; s < i; s += 2)
        va.fromBufferAttribute(e, s), Ma.fromBufferAttribute(e, s + 1), r[s] = s === 0 ? 0 : r[s - 1], r[s + 1] = r[s] + va.distanceTo(Ma);
      t.setAttribute("lineDistance", new Et(r, 1));
    } else
      console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
}
class it extends mt {
  constructor() {
    super(), this.isGroup = !0, this.type = "Group";
  }
}
class yt {
  constructor() {
    this.type = "Curve", this.arcLengthDivisions = 200;
  }
  // Virtual base class method to overwrite and implement in subclasses
  //	- t [0 .. 1]
  getPoint() {
    return console.warn("THREE.Curve: .getPoint() not implemented."), null;
  }
  // Get point at relative position in curve according to arc length
  // - u [0 .. 1]
  getPointAt(t, e) {
    const r = this.getUtoTmapping(t);
    return this.getPoint(r, e);
  }
  // Get sequence of points using getPoint( t )
  getPoints(t = 5) {
    const e = [];
    for (let r = 0; r <= t; r++)
      e.push(this.getPoint(r / t));
    return e;
  }
  // Get sequence of points using getPointAt( u )
  getSpacedPoints(t = 5) {
    const e = [];
    for (let r = 0; r <= t; r++)
      e.push(this.getPointAt(r / t));
    return e;
  }
  // Get total curve arc length
  getLength() {
    const t = this.getLengths();
    return t[t.length - 1];
  }
  // Get list of cumulative segment lengths
  getLengths(t = this.arcLengthDivisions) {
    if (this.cacheArcLengths && this.cacheArcLengths.length === t + 1 && !this.needsUpdate)
      return this.cacheArcLengths;
    this.needsUpdate = !1;
    const e = [];
    let r, s = this.getPoint(0), i = 0;
    e.push(0);
    for (let n = 1; n <= t; n++)
      r = this.getPoint(n / t), i += r.distanceTo(s), e.push(i), s = r;
    return this.cacheArcLengths = e, e;
  }
  updateArcLengths() {
    this.needsUpdate = !0, this.getLengths();
  }
  // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
  getUtoTmapping(t, e) {
    const r = this.getLengths();
    let s = 0;
    const i = r.length;
    let n;
    e ? n = e : n = t * r[i - 1];
    let o = 0, h = i - 1, c;
    for (; o <= h; )
      if (s = Math.floor(o + (h - o) / 2), c = r[s] - n, c < 0)
        o = s + 1;
      else if (c > 0)
        h = s - 1;
      else {
        h = s;
        break;
      }
    if (s = h, r[s] === n)
      return s / (i - 1);
    const l = r[s], f = r[s + 1] - l, d = (n - l) / f;
    return (s + d) / (i - 1);
  }
  // Returns a unit vector tangent at t
  // In case any sub curve does not implement its tangent derivation,
  // 2 points a small delta apart will be used to find its gradient
  // which seems to give a reasonable approximation
  getTangent(t, e) {
    let s = t - 1e-4, i = t + 1e-4;
    s < 0 && (s = 0), i > 1 && (i = 1);
    const n = this.getPoint(s), o = this.getPoint(i), h = e || (n.isVector2 ? new E() : new g());
    return h.copy(o).sub(n).normalize(), h;
  }
  getTangentAt(t, e) {
    const r = this.getUtoTmapping(t);
    return this.getTangent(r, e);
  }
  computeFrenetFrames(t, e) {
    const r = new g(), s = [], i = [], n = [], o = new g(), h = new et();
    for (let d = 0; d <= t; d++) {
      const p = d / t;
      s[d] = this.getTangentAt(p, new g());
    }
    i[0] = new g(), n[0] = new g();
    let c = Number.MAX_VALUE;
    const l = Math.abs(s[0].x), u = Math.abs(s[0].y), f = Math.abs(s[0].z);
    l <= c && (c = l, r.set(1, 0, 0)), u <= c && (c = u, r.set(0, 1, 0)), f <= c && r.set(0, 0, 1), o.crossVectors(s[0], r).normalize(), i[0].crossVectors(s[0], o), n[0].crossVectors(s[0], i[0]);
    for (let d = 1; d <= t; d++) {
      if (i[d] = i[d - 1].clone(), n[d] = n[d - 1].clone(), o.crossVectors(s[d - 1], s[d]), o.length() > Number.EPSILON) {
        o.normalize();
        const p = Math.acos(P(s[d - 1].dot(s[d]), -1, 1));
        i[d].applyMatrix4(h.makeRotationAxis(o, p));
      }
      n[d].crossVectors(s[d], i[d]);
    }
    if (e === !0) {
      let d = Math.acos(P(i[0].dot(i[t]), -1, 1));
      d /= t, s[0].dot(o.crossVectors(i[0], i[t])) > 0 && (d = -d);
      for (let p = 1; p <= t; p++)
        i[p].applyMatrix4(h.makeRotationAxis(s[p], d * p)), n[p].crossVectors(s[p], i[p]);
    }
    return {
      tangents: s,
      normals: i,
      binormals: n
    };
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(t) {
    return this.arcLengthDivisions = t.arcLengthDivisions, this;
  }
  toJSON() {
    const t = {
      metadata: {
        version: 4.6,
        type: "Curve",
        generator: "Curve.toJSON"
      }
    };
    return t.arcLengthDivisions = this.arcLengthDivisions, t.type = this.type, t;
  }
  fromJSON(t) {
    return this.arcLengthDivisions = t.arcLengthDivisions, this;
  }
}
class He extends yt {
  constructor(t = 0, e = 0, r = 1, s = 1, i = 0, n = Math.PI * 2, o = !1, h = 0) {
    super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = t, this.aY = e, this.xRadius = r, this.yRadius = s, this.aStartAngle = i, this.aEndAngle = n, this.aClockwise = o, this.aRotation = h;
  }
  getPoint(t, e = new E()) {
    const r = e, s = Math.PI * 2;
    let i = this.aEndAngle - this.aStartAngle;
    const n = Math.abs(i) < Number.EPSILON;
    for (; i < 0; ) i += s;
    for (; i > s; ) i -= s;
    i < Number.EPSILON && (n ? i = 0 : i = s), this.aClockwise === !0 && !n && (i === s ? i = -s : i = i - s);
    const o = this.aStartAngle + t * i;
    let h = this.aX + this.xRadius * Math.cos(o), c = this.aY + this.yRadius * Math.sin(o);
    if (this.aRotation !== 0) {
      const l = Math.cos(this.aRotation), u = Math.sin(this.aRotation), f = h - this.aX, d = c - this.aY;
      h = f * l - d * u + this.aX, c = f * u + d * l + this.aY;
    }
    return r.set(h, c);
  }
  copy(t) {
    return super.copy(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
  }
  toJSON() {
    const t = super.toJSON();
    return t.aX = this.aX, t.aY = this.aY, t.xRadius = this.xRadius, t.yRadius = this.yRadius, t.aStartAngle = this.aStartAngle, t.aEndAngle = this.aEndAngle, t.aClockwise = this.aClockwise, t.aRotation = this.aRotation, t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
  }
}
class Pn extends He {
  constructor(t, e, r, s, i, n) {
    super(t, e, r, r, s, i, n), this.isArcCurve = !0, this.type = "ArcCurve";
  }
}
function zn() {
  let a = 0, t = 0, e = 0, r = 0;
  function s(i, n, o, h) {
    a = i, t = o, e = -3 * i + 3 * n - 2 * o - h, r = 2 * i - 2 * n + o + h;
  }
  return {
    initCatmullRom: function(i, n, o, h, c) {
      s(n, o, c * (o - i), c * (h - n));
    },
    initNonuniformCatmullRom: function(i, n, o, h, c, l, u) {
      let f = (n - i) / c - (o - i) / (c + l) + (o - n) / l, d = (o - n) / l - (h - n) / (l + u) + (h - o) / u;
      f *= l, d *= l, s(n, o, f, d);
    },
    calc: function(i) {
      const n = i * i, o = n * i;
      return a + t * i + e * n + r * o;
    }
  };
}
const xr = /* @__PURE__ */ new g(), is = /* @__PURE__ */ new zn(), ns = /* @__PURE__ */ new zn(), as = /* @__PURE__ */ new zn();
class Hl extends yt {
  constructor(t = [], e = !1, r = "centripetal", s = 0.5) {
    super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = t, this.closed = e, this.curveType = r, this.tension = s;
  }
  getPoint(t, e = new g()) {
    const r = e, s = this.points, i = s.length, n = (i - (this.closed ? 0 : 1)) * t;
    let o = Math.floor(n), h = n - o;
    this.closed ? o += o > 0 ? 0 : (Math.floor(Math.abs(o) / i) + 1) * i : h === 0 && o === i - 1 && (o = i - 2, h = 1);
    let c, l;
    this.closed || o > 0 ? c = s[(o - 1) % i] : (xr.subVectors(s[0], s[1]).add(s[0]), c = xr);
    const u = s[o % i], f = s[(o + 1) % i];
    if (this.closed || o + 2 < i ? l = s[(o + 2) % i] : (xr.subVectors(s[i - 1], s[i - 2]).add(s[i - 1]), l = xr), this.curveType === "centripetal" || this.curveType === "chordal") {
      const d = this.curveType === "chordal" ? 0.5 : 0.25;
      let p = Math.pow(c.distanceToSquared(u), d), x = Math.pow(u.distanceToSquared(f), d), m = Math.pow(f.distanceToSquared(l), d);
      x < 1e-4 && (x = 1), p < 1e-4 && (p = x), m < 1e-4 && (m = x), is.initNonuniformCatmullRom(c.x, u.x, f.x, l.x, p, x, m), ns.initNonuniformCatmullRom(c.y, u.y, f.y, l.y, p, x, m), as.initNonuniformCatmullRom(c.z, u.z, f.z, l.z, p, x, m);
    } else this.curveType === "catmullrom" && (is.initCatmullRom(c.x, u.x, f.x, l.x, this.tension), ns.initCatmullRom(c.y, u.y, f.y, l.y, this.tension), as.initCatmullRom(c.z, u.z, f.z, l.z, this.tension));
    return r.set(
      is.calc(h),
      ns.calc(h),
      as.calc(h)
    ), r;
  }
  copy(t) {
    super.copy(t), this.points = [];
    for (let e = 0, r = t.points.length; e < r; e++) {
      const s = t.points[e];
      this.points.push(s.clone());
    }
    return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
  }
  toJSON() {
    const t = super.toJSON();
    t.points = [];
    for (let e = 0, r = this.points.length; e < r; e++) {
      const s = this.points[e];
      t.points.push(s.toArray());
    }
    return t.closed = this.closed, t.curveType = this.curveType, t.tension = this.tension, t;
  }
  fromJSON(t) {
    super.fromJSON(t), this.points = [];
    for (let e = 0, r = t.points.length; e < r; e++) {
      const s = t.points[e];
      this.points.push(new g().fromArray(s));
    }
    return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
  }
}
function Aa(a, t, e, r, s) {
  const i = (r - t) * 0.5, n = (s - e) * 0.5, o = a * a, h = a * o;
  return (2 * e - 2 * r + i + n) * h + (-3 * e + 3 * r - 2 * i - n) * o + i * a + e;
}
function Vl(a, t) {
  const e = 1 - a;
  return e * e * t;
}
function jl(a, t) {
  return 2 * (1 - a) * a * t;
}
function Ul(a, t) {
  return a * a * t;
}
function Be(a, t, e, r) {
  return Vl(a, t) + jl(a, e) + Ul(a, r);
}
function Gl(a, t) {
  const e = 1 - a;
  return e * e * e * t;
}
function Xl(a, t) {
  const e = 1 - a;
  return 3 * e * e * a * t;
}
function Yl(a, t) {
  return 3 * (1 - a) * a * a * t;
}
function Wl(a, t) {
  return a * a * a * t;
}
function De(a, t, e, r, s) {
  return Gl(a, t) + Xl(a, e) + Yl(a, r) + Wl(a, s);
}
class ac extends yt {
  constructor(t = new E(), e = new E(), r = new E(), s = new E()) {
    super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = t, this.v1 = e, this.v2 = r, this.v3 = s;
  }
  getPoint(t, e = new E()) {
    const r = e, s = this.v0, i = this.v1, n = this.v2, o = this.v3;
    return r.set(
      De(t, s.x, i.x, n.x, o.x),
      De(t, s.y, i.y, n.y, o.y)
    ), r;
  }
  copy(t) {
    return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
  }
  toJSON() {
    const t = super.toJSON();
    return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
  }
}
class $l extends yt {
  constructor(t = new g(), e = new g(), r = new g(), s = new g()) {
    super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = r, this.v3 = s;
  }
  getPoint(t, e = new g()) {
    const r = e, s = this.v0, i = this.v1, n = this.v2, o = this.v3;
    return r.set(
      De(t, s.x, i.x, n.x, o.x),
      De(t, s.y, i.y, n.y, o.y),
      De(t, s.z, i.z, n.z, o.z)
    ), r;
  }
  copy(t) {
    return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
  }
  toJSON() {
    const t = super.toJSON();
    return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
  }
}
class oc extends yt {
  constructor(t = new E(), e = new E()) {
    super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = t, this.v2 = e;
  }
  getPoint(t, e = new E()) {
    const r = e;
    return t === 1 ? r.copy(this.v2) : (r.copy(this.v2).sub(this.v1), r.multiplyScalar(t).add(this.v1)), r;
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(t, e) {
    return this.getPoint(t, e);
  }
  getTangent(t, e = new E()) {
    return e.subVectors(this.v2, this.v1).normalize();
  }
  getTangentAt(t, e) {
    return this.getTangent(t, e);
  }
  copy(t) {
    return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
  }
  toJSON() {
    const t = super.toJSON();
    return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
  }
}
class Zl extends yt {
  constructor(t = new g(), e = new g()) {
    super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = t, this.v2 = e;
  }
  getPoint(t, e = new g()) {
    const r = e;
    return t === 1 ? r.copy(this.v2) : (r.copy(this.v2).sub(this.v1), r.multiplyScalar(t).add(this.v1)), r;
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(t, e) {
    return this.getPoint(t, e);
  }
  getTangent(t, e = new g()) {
    return e.subVectors(this.v2, this.v1).normalize();
  }
  getTangentAt(t, e) {
    return this.getTangent(t, e);
  }
  copy(t) {
    return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
  }
  toJSON() {
    const t = super.toJSON();
    return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
  }
}
class hc extends yt {
  constructor(t = new E(), e = new E(), r = new E()) {
    super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = t, this.v1 = e, this.v2 = r;
  }
  getPoint(t, e = new E()) {
    const r = e, s = this.v0, i = this.v1, n = this.v2;
    return r.set(
      Be(t, s.x, i.x, n.x),
      Be(t, s.y, i.y, n.y)
    ), r;
  }
  copy(t) {
    return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
  }
  toJSON() {
    const t = super.toJSON();
    return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
  }
}
class Jl extends yt {
  constructor(t = new g(), e = new g(), r = new g()) {
    super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = r;
  }
  getPoint(t, e = new g()) {
    const r = e, s = this.v0, i = this.v1, n = this.v2;
    return r.set(
      Be(t, s.x, i.x, n.x),
      Be(t, s.y, i.y, n.y),
      Be(t, s.z, i.z, n.z)
    ), r;
  }
  copy(t) {
    return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
  }
  toJSON() {
    const t = super.toJSON();
    return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
  }
}
class cc extends yt {
  constructor(t = []) {
    super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = t;
  }
  getPoint(t, e = new E()) {
    const r = e, s = this.points, i = (s.length - 1) * t, n = Math.floor(i), o = i - n, h = s[n === 0 ? n : n - 1], c = s[n], l = s[n > s.length - 2 ? s.length - 1 : n + 1], u = s[n > s.length - 3 ? s.length - 1 : n + 2];
    return r.set(
      Aa(o, h.x, c.x, l.x, u.x),
      Aa(o, h.y, c.y, l.y, u.y)
    ), r;
  }
  copy(t) {
    super.copy(t), this.points = [];
    for (let e = 0, r = t.points.length; e < r; e++) {
      const s = t.points[e];
      this.points.push(s.clone());
    }
    return this;
  }
  toJSON() {
    const t = super.toJSON();
    t.points = [];
    for (let e = 0, r = this.points.length; e < r; e++) {
      const s = this.points[e];
      t.points.push(s.toArray());
    }
    return t;
  }
  fromJSON(t) {
    super.fromJSON(t), this.points = [];
    for (let e = 0, r = t.points.length; e < r; e++) {
      const s = t.points[e];
      this.points.push(new E().fromArray(s));
    }
    return this;
  }
}
var Sa = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcCurve: Pn,
  CatmullRomCurve3: Hl,
  CubicBezierCurve: ac,
  CubicBezierCurve3: $l,
  EllipseCurve: He,
  LineCurve: oc,
  LineCurve3: Zl,
  QuadraticBezierCurve: hc,
  QuadraticBezierCurve3: Jl,
  SplineCurve: cc
});
class Kl extends yt {
  constructor() {
    super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
  }
  add(t) {
    this.curves.push(t);
  }
  closePath() {
    const t = this.curves[0].getPoint(0), e = this.curves[this.curves.length - 1].getPoint(1);
    if (!t.equals(e)) {
      const r = t.isVector2 === !0 ? "LineCurve" : "LineCurve3";
      this.curves.push(new Sa[r](e, t));
    }
    return this;
  }
  // To get accurate point with reference to
  // entire path distance at time t,
  // following has to be done:
  // 1. Length of each sub path have to be known
  // 2. Locate and identify type of curve
  // 3. Get t for the curve
  // 4. Return curve.getPointAt(t')
  getPoint(t, e) {
    const r = t * this.getLength(), s = this.getCurveLengths();
    let i = 0;
    for (; i < s.length; ) {
      if (s[i] >= r) {
        const n = s[i] - r, o = this.curves[i], h = o.getLength(), c = h === 0 ? 0 : 1 - n / h;
        return o.getPointAt(c, e);
      }
      i++;
    }
    return null;
  }
  // We cannot use the default THREE.Curve getPoint() with getLength() because in
  // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
  // getPoint() depends on getLength
  getLength() {
    const t = this.getCurveLengths();
    return t[t.length - 1];
  }
  // cacheLengths must be recalculated.
  updateArcLengths() {
    this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
  }
  // Compute lengths and cache them
  // We cannot overwrite getLengths() because UtoT mapping uses it.
  getCurveLengths() {
    if (this.cacheLengths && this.cacheLengths.length === this.curves.length)
      return this.cacheLengths;
    const t = [];
    let e = 0;
    for (let r = 0, s = this.curves.length; r < s; r++)
      e += this.curves[r].getLength(), t.push(e);
    return this.cacheLengths = t, t;
  }
  getSpacedPoints(t = 40) {
    const e = [];
    for (let r = 0; r <= t; r++)
      e.push(this.getPoint(r / t));
    return this.autoClose && e.push(e[0]), e;
  }
  getPoints(t = 12) {
    const e = [];
    let r;
    for (let s = 0, i = this.curves; s < i.length; s++) {
      const n = i[s], o = n.isEllipseCurve ? t * 2 : n.isLineCurve || n.isLineCurve3 ? 1 : n.isSplineCurve ? t * n.points.length : t, h = n.getPoints(o);
      for (let c = 0; c < h.length; c++) {
        const l = h[c];
        r && r.equals(l) || (e.push(l), r = l);
      }
    }
    return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
  }
  copy(t) {
    super.copy(t), this.curves = [];
    for (let e = 0, r = t.curves.length; e < r; e++) {
      const s = t.curves[e];
      this.curves.push(s.clone());
    }
    return this.autoClose = t.autoClose, this;
  }
  toJSON() {
    const t = super.toJSON();
    t.autoClose = this.autoClose, t.curves = [];
    for (let e = 0, r = this.curves.length; e < r; e++) {
      const s = this.curves[e];
      t.curves.push(s.toJSON());
    }
    return t;
  }
  fromJSON(t) {
    super.fromJSON(t), this.autoClose = t.autoClose, this.curves = [];
    for (let e = 0, r = t.curves.length; e < r; e++) {
      const s = t.curves[e];
      this.curves.push(new Sa[s.type]().fromJSON(s));
    }
    return this;
  }
}
class _n extends Kl {
  constructor(t) {
    super(), this.type = "Path", this.currentPoint = new E(), t && this.setFromPoints(t);
  }
  setFromPoints(t) {
    this.moveTo(t[0].x, t[0].y);
    for (let e = 1, r = t.length; e < r; e++)
      this.lineTo(t[e].x, t[e].y);
    return this;
  }
  moveTo(t, e) {
    return this.currentPoint.set(t, e), this;
  }
  lineTo(t, e) {
    const r = new oc(this.currentPoint.clone(), new E(t, e));
    return this.curves.push(r), this.currentPoint.set(t, e), this;
  }
  quadraticCurveTo(t, e, r, s) {
    const i = new hc(
      this.currentPoint.clone(),
      new E(t, e),
      new E(r, s)
    );
    return this.curves.push(i), this.currentPoint.set(r, s), this;
  }
  bezierCurveTo(t, e, r, s, i, n) {
    const o = new ac(
      this.currentPoint.clone(),
      new E(t, e),
      new E(r, s),
      new E(i, n)
    );
    return this.curves.push(o), this.currentPoint.set(i, n), this;
  }
  splineThru(t) {
    const e = [this.currentPoint.clone()].concat(t), r = new cc(e);
    return this.curves.push(r), this.currentPoint.copy(t[t.length - 1]), this;
  }
  arc(t, e, r, s, i, n) {
    const o = this.currentPoint.x, h = this.currentPoint.y;
    return this.absarc(
      t + o,
      e + h,
      r,
      s,
      i,
      n
    ), this;
  }
  absarc(t, e, r, s, i, n) {
    return this.absellipse(t, e, r, r, s, i, n), this;
  }
  ellipse(t, e, r, s, i, n, o, h) {
    const c = this.currentPoint.x, l = this.currentPoint.y;
    return this.absellipse(t + c, e + l, r, s, i, n, o, h), this;
  }
  absellipse(t, e, r, s, i, n, o, h) {
    const c = new He(t, e, r, s, i, n, o, h);
    if (this.curves.length > 0) {
      const u = c.getPoint(0);
      u.equals(this.currentPoint) || this.lineTo(u.x, u.y);
    }
    this.curves.push(c);
    const l = c.getPoint(1);
    return this.currentPoint.copy(l), this;
  }
  copy(t) {
    return super.copy(t), this.currentPoint.copy(t.currentPoint), this;
  }
  toJSON() {
    const t = super.toJSON();
    return t.currentPoint = this.currentPoint.toArray(), t;
  }
  fromJSON(t) {
    return super.fromJSON(t), this.currentPoint.fromArray(t.currentPoint), this;
  }
}
class Jt extends _n {
  constructor(t) {
    super(t), this.uuid = _e(), this.type = "Shape", this.holes = [];
  }
  getPointsHoles(t) {
    const e = [];
    for (let r = 0, s = this.holes.length; r < s; r++)
      e[r] = this.holes[r].getPoints(t);
    return e;
  }
  // get points of shape and holes (keypoints based on segments parameter)
  extractPoints(t) {
    return {
      shape: this.getPoints(t),
      holes: this.getPointsHoles(t)
    };
  }
  copy(t) {
    super.copy(t), this.holes = [];
    for (let e = 0, r = t.holes.length; e < r; e++) {
      const s = t.holes[e];
      this.holes.push(s.clone());
    }
    return this;
  }
  toJSON() {
    const t = super.toJSON();
    t.uuid = this.uuid, t.holes = [];
    for (let e = 0, r = this.holes.length; e < r; e++) {
      const s = this.holes[e];
      t.holes.push(s.toJSON());
    }
    return t;
  }
  fromJSON(t) {
    super.fromJSON(t), this.uuid = t.uuid, this.holes = [];
    for (let e = 0, r = t.holes.length; e < r; e++) {
      const s = t.holes[e];
      this.holes.push(new _n().fromJSON(s));
    }
    return this;
  }
}
const Ql = {
  triangulate: function(a, t, e = 2) {
    const r = t && t.length, s = r ? t[0] * e : a.length;
    let i = lc(a, 0, s, e, !0);
    const n = [];
    if (!i || i.next === i.prev) return n;
    let o, h, c, l, u, f, d;
    if (r && (i = iu(a, t, i, e)), a.length > 80 * e) {
      o = c = a[0], h = l = a[1];
      for (let p = e; p < s; p += e)
        u = a[p], f = a[p + 1], u < o && (o = u), f < h && (h = f), u > c && (c = u), f > l && (l = f);
      d = Math.max(c - o, l - h), d = d !== 0 ? 32767 / d : 0;
    }
    return Ie(i, n, e, o, h, d, 0), n;
  }
};
function lc(a, t, e, r, s) {
  let i, n;
  if (s === xu(a, t, e, r) > 0)
    for (i = t; i < e; i += r) n = ka(i, a[i], a[i + 1], n);
  else
    for (i = e - r; i >= t; i -= r) n = ka(i, a[i], a[i + 1], n);
  return n && Sr(n, n.next) && (Le(n), n = n.next), n;
}
function Qt(a, t) {
  if (!a) return a;
  t || (t = a);
  let e = a, r;
  do
    if (r = !1, !e.steiner && (Sr(e, e.next) || R(e.prev, e, e.next) === 0)) {
      if (Le(e), e = t = e.prev, e === e.next) break;
      r = !0;
    } else
      e = e.next;
  while (r || e !== t);
  return t;
}
function Ie(a, t, e, r, s, i, n) {
  if (!a) return;
  !n && i && cu(a, r, s, i);
  let o = a, h, c;
  for (; a.prev !== a.next; ) {
    if (h = a.prev, c = a.next, i ? eu(a, r, s, i) : tu(a)) {
      t.push(h.i / e | 0), t.push(a.i / e | 0), t.push(c.i / e | 0), Le(a), a = c.next, o = c.next;
      continue;
    }
    if (a = c, a === o) {
      n ? n === 1 ? (a = ru(Qt(a), t, e), Ie(a, t, e, r, s, i, 2)) : n === 2 && su(a, t, e, r, s, i) : Ie(Qt(a), t, e, r, s, i, 1);
      break;
    }
  }
}
function tu(a) {
  const t = a.prev, e = a, r = a.next;
  if (R(t, e, r) >= 0) return !1;
  const s = t.x, i = e.x, n = r.x, o = t.y, h = e.y, c = r.y, l = s < i ? s < n ? s : n : i < n ? i : n, u = o < h ? o < c ? o : c : h < c ? h : c, f = s > i ? s > n ? s : n : i > n ? i : n, d = o > h ? o > c ? o : c : h > c ? h : c;
  let p = r.next;
  for (; p !== t; ) {
    if (p.x >= l && p.x <= f && p.y >= u && p.y <= d && ye(s, o, i, h, n, c, p.x, p.y) && R(p.prev, p, p.next) >= 0) return !1;
    p = p.next;
  }
  return !0;
}
function eu(a, t, e, r) {
  const s = a.prev, i = a, n = a.next;
  if (R(s, i, n) >= 0) return !1;
  const o = s.x, h = i.x, c = n.x, l = s.y, u = i.y, f = n.y, d = o < h ? o < c ? o : c : h < c ? h : c, p = l < u ? l < f ? l : f : u < f ? u : f, x = o > h ? o > c ? o : c : h > c ? h : c, m = l > u ? l > f ? l : f : u > f ? u : f, y = wn(d, p, t, e, r), _ = wn(x, m, t, e, r);
  let b = a.prevZ, w = a.nextZ;
  for (; b && b.z >= y && w && w.z <= _; ) {
    if (b.x >= d && b.x <= x && b.y >= p && b.y <= m && b !== s && b !== n && ye(o, l, h, u, c, f, b.x, b.y) && R(b.prev, b, b.next) >= 0 || (b = b.prevZ, w.x >= d && w.x <= x && w.y >= p && w.y <= m && w !== s && w !== n && ye(o, l, h, u, c, f, w.x, w.y) && R(w.prev, w, w.next) >= 0)) return !1;
    w = w.nextZ;
  }
  for (; b && b.z >= y; ) {
    if (b.x >= d && b.x <= x && b.y >= p && b.y <= m && b !== s && b !== n && ye(o, l, h, u, c, f, b.x, b.y) && R(b.prev, b, b.next) >= 0) return !1;
    b = b.prevZ;
  }
  for (; w && w.z <= _; ) {
    if (w.x >= d && w.x <= x && w.y >= p && w.y <= m && w !== s && w !== n && ye(o, l, h, u, c, f, w.x, w.y) && R(w.prev, w, w.next) >= 0) return !1;
    w = w.nextZ;
  }
  return !0;
}
function ru(a, t, e) {
  let r = a;
  do {
    const s = r.prev, i = r.next.next;
    !Sr(s, i) && uc(s, r, r.next, i) && Re(s, i) && Re(i, s) && (t.push(s.i / e | 0), t.push(r.i / e | 0), t.push(i.i / e | 0), Le(r), Le(r.next), r = a = i), r = r.next;
  } while (r !== a);
  return Qt(r);
}
function su(a, t, e, r, s, i) {
  let n = a;
  do {
    let o = n.next.next;
    for (; o !== n.prev; ) {
      if (n.i !== o.i && fu(n, o)) {
        let h = fc(n, o);
        n = Qt(n, n.next), h = Qt(h, h.next), Ie(n, t, e, r, s, i, 0), Ie(h, t, e, r, s, i, 0);
        return;
      }
      o = o.next;
    }
    n = n.next;
  } while (n !== a);
}
function iu(a, t, e, r) {
  const s = [];
  let i, n, o, h, c;
  for (i = 0, n = t.length; i < n; i++)
    o = t[i] * r, h = i < n - 1 ? t[i + 1] * r : a.length, c = lc(a, o, h, r, !1), c === c.next && (c.steiner = !0), s.push(uu(c));
  for (s.sort(nu), i = 0; i < s.length; i++)
    e = au(s[i], e);
  return e;
}
function nu(a, t) {
  return a.x - t.x;
}
function au(a, t) {
  const e = ou(a, t);
  if (!e)
    return t;
  const r = fc(e, a);
  return Qt(r, r.next), Qt(e, e.next);
}
function ou(a, t) {
  let e = t, r = -1 / 0, s;
  const i = a.x, n = a.y;
  do {
    if (n <= e.y && n >= e.next.y && e.next.y !== e.y) {
      const f = e.x + (n - e.y) * (e.next.x - e.x) / (e.next.y - e.y);
      if (f <= i && f > r && (r = f, s = e.x < e.next.x ? e : e.next, f === i))
        return s;
    }
    e = e.next;
  } while (e !== t);
  if (!s) return null;
  const o = s, h = s.x, c = s.y;
  let l = 1 / 0, u;
  e = s;
  do
    i >= e.x && e.x >= h && i !== e.x && ye(n < c ? i : r, n, h, c, n < c ? r : i, n, e.x, e.y) && (u = Math.abs(n - e.y) / (i - e.x), Re(e, a) && (u < l || u === l && (e.x > s.x || e.x === s.x && hu(s, e))) && (s = e, l = u)), e = e.next;
  while (e !== o);
  return s;
}
function hu(a, t) {
  return R(a.prev, a, t.prev) < 0 && R(t.next, a, a.next) < 0;
}
function cu(a, t, e, r) {
  let s = a;
  do
    s.z === 0 && (s.z = wn(s.x, s.y, t, e, r)), s.prevZ = s.prev, s.nextZ = s.next, s = s.next;
  while (s !== a);
  s.prevZ.nextZ = null, s.prevZ = null, lu(s);
}
function lu(a) {
  let t, e, r, s, i, n, o, h, c = 1;
  do {
    for (e = a, a = null, i = null, n = 0; e; ) {
      for (n++, r = e, o = 0, t = 0; t < c && (o++, r = r.nextZ, !!r); t++)
        ;
      for (h = c; o > 0 || h > 0 && r; )
        o !== 0 && (h === 0 || !r || e.z <= r.z) ? (s = e, e = e.nextZ, o--) : (s = r, r = r.nextZ, h--), i ? i.nextZ = s : a = s, s.prevZ = i, i = s;
      e = r;
    }
    i.nextZ = null, c *= 2;
  } while (n > 1);
  return a;
}
function wn(a, t, e, r, s) {
  return a = (a - e) * s | 0, t = (t - r) * s | 0, a = (a | a << 8) & 16711935, a = (a | a << 4) & 252645135, a = (a | a << 2) & 858993459, a = (a | a << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, a | t << 1;
}
function uu(a) {
  let t = a, e = a;
  do
    (t.x < e.x || t.x === e.x && t.y < e.y) && (e = t), t = t.next;
  while (t !== a);
  return e;
}
function ye(a, t, e, r, s, i, n, o) {
  return (s - n) * (t - o) >= (a - n) * (i - o) && (a - n) * (r - o) >= (e - n) * (t - o) && (e - n) * (i - o) >= (s - n) * (r - o);
}
function fu(a, t) {
  return a.next.i !== t.i && a.prev.i !== t.i && !du(a, t) && // dones't intersect other edges
  (Re(a, t) && Re(t, a) && pu(a, t) && // locally visible
  (R(a.prev, a, t.prev) || R(a, t.prev, t)) || // does not create opposite-facing sectors
  Sr(a, t) && R(a.prev, a, a.next) > 0 && R(t.prev, t, t.next) > 0);
}
function R(a, t, e) {
  return (t.y - a.y) * (e.x - t.x) - (t.x - a.x) * (e.y - t.y);
}
function Sr(a, t) {
  return a.x === t.x && a.y === t.y;
}
function uc(a, t, e, r) {
  const s = yr(R(a, t, e)), i = yr(R(a, t, r)), n = yr(R(e, r, a)), o = yr(R(e, r, t));
  return !!(s !== i && n !== o || s === 0 && mr(a, e, t) || i === 0 && mr(a, r, t) || n === 0 && mr(e, a, r) || o === 0 && mr(e, t, r));
}
function mr(a, t, e) {
  return t.x <= Math.max(a.x, e.x) && t.x >= Math.min(a.x, e.x) && t.y <= Math.max(a.y, e.y) && t.y >= Math.min(a.y, e.y);
}
function yr(a) {
  return a > 0 ? 1 : a < 0 ? -1 : 0;
}
function du(a, t) {
  let e = a;
  do {
    if (e.i !== a.i && e.next.i !== a.i && e.i !== t.i && e.next.i !== t.i && uc(e, e.next, a, t)) return !0;
    e = e.next;
  } while (e !== a);
  return !1;
}
function Re(a, t) {
  return R(a.prev, a, a.next) < 0 ? R(a, t, a.next) >= 0 && R(a, a.prev, t) >= 0 : R(a, t, a.prev) < 0 || R(a, a.next, t) < 0;
}
function pu(a, t) {
  let e = a, r = !1;
  const s = (a.x + t.x) / 2, i = (a.y + t.y) / 2;
  do
    e.y > i != e.next.y > i && e.next.y !== e.y && s < (e.next.x - e.x) * (i - e.y) / (e.next.y - e.y) + e.x && (r = !r), e = e.next;
  while (e !== a);
  return r;
}
function fc(a, t) {
  const e = new vn(a.i, a.x, a.y), r = new vn(t.i, t.x, t.y), s = a.next, i = t.prev;
  return a.next = t, t.prev = a, e.next = s, s.prev = e, r.next = e, e.prev = r, i.next = r, r.prev = i, r;
}
function ka(a, t, e, r) {
  const s = new vn(a, t, e);
  return r ? (s.next = r.next, s.prev = r, r.next.prev = s, r.next = s) : (s.prev = s, s.next = s), s;
}
function Le(a) {
  a.next.prev = a.prev, a.prev.next = a.next, a.prevZ && (a.prevZ.nextZ = a.nextZ), a.nextZ && (a.nextZ.prevZ = a.prevZ);
}
function vn(a, t, e) {
  this.i = a, this.x = t, this.y = e, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}
function xu(a, t, e, r) {
  let s = 0;
  for (let i = t, n = e - r; i < e; i += r)
    s += (a[n] - a[i]) * (a[i + 1] + a[n + 1]), n = i;
  return s;
}
class be {
  // calculate area of the contour polygon
  static area(t) {
    const e = t.length;
    let r = 0;
    for (let s = e - 1, i = 0; i < e; s = i++)
      r += t[s].x * t[i].y - t[i].x * t[s].y;
    return r * 0.5;
  }
  static isClockWise(t) {
    return be.area(t) < 0;
  }
  static triangulateShape(t, e) {
    const r = [], s = [], i = [];
    Fa(t), Ta(r, t);
    let n = t.length;
    e.forEach(Fa);
    for (let h = 0; h < e.length; h++)
      s.push(n), n += e[h].length, Ta(r, e[h]);
    const o = Ql.triangulate(r, s);
    for (let h = 0; h < o.length; h += 3)
      i.push(o.slice(h, h + 3));
    return i;
  }
}
function Fa(a) {
  const t = a.length;
  t > 2 && a[t - 1].equals(a[0]) && a.pop();
}
function Ta(a, t) {
  for (let e = 0; e < t.length; e++)
    a.push(t[e].x), a.push(t[e].y);
}
class Ve extends ht {
  constructor(t = new Jt([new E(0, 0.5), new E(-0.5, -0.5), new E(0.5, -0.5)]), e = 12) {
    super(), this.type = "ShapeGeometry", this.parameters = {
      shapes: t,
      curveSegments: e
    };
    const r = [], s = [], i = [], n = [];
    let o = 0, h = 0;
    if (Array.isArray(t) === !1)
      c(t);
    else
      for (let l = 0; l < t.length; l++)
        c(t[l]), this.addGroup(o, h, l), o += h, h = 0;
    this.setIndex(r), this.setAttribute("position", new Et(s, 3)), this.setAttribute("normal", new Et(i, 3)), this.setAttribute("uv", new Et(n, 2));
    function c(l) {
      const u = s.length / 3, f = l.extractPoints(e);
      let d = f.shape;
      const p = f.holes;
      be.isClockWise(d) === !1 && (d = d.reverse());
      for (let m = 0, y = p.length; m < y; m++) {
        const _ = p[m];
        be.isClockWise(_) === !0 && (p[m] = _.reverse());
      }
      const x = be.triangulateShape(d, p);
      for (let m = 0, y = p.length; m < y; m++) {
        const _ = p[m];
        d = d.concat(_);
      }
      for (let m = 0, y = d.length; m < y; m++) {
        const _ = d[m];
        s.push(_.x, _.y, 0), i.push(0, 0, 1), n.push(_.x, _.y);
      }
      for (let m = 0, y = x.length; m < y; m++) {
        const _ = x[m], b = _[0] + u, w = _[1] + u, M = _[2] + u;
        r.push(b, w, M), h += 3;
      }
    }
  }
  copy(t) {
    return super.copy(t), this.parameters = Object.assign({}, t.parameters), this;
  }
  toJSON() {
    const t = super.toJSON(), e = this.parameters.shapes;
    return mu(e, t);
  }
  static fromJSON(t, e) {
    const r = [];
    for (let s = 0, i = t.shapes.length; s < i; s++) {
      const n = e[t.shapes[s]];
      r.push(n);
    }
    return new Ve(r, t.curveSegments);
  }
}
function mu(a, t) {
  if (t.shapes = [], Array.isArray(a))
    for (let e = 0, r = a.length; e < r; e++) {
      const s = a[e];
      t.shapes.push(s.uuid);
    }
  else
    t.shapes.push(a.uuid);
  return t;
}
class yu extends Tn {
  constructor(t) {
    super(), this.isLineDashedMaterial = !0, this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(t);
  }
  copy(t) {
    return super.copy(t), this.scale = t.scale, this.dashSize = t.dashSize, this.gapSize = t.gapSize, this;
  }
}
const Ea = {
  enabled: !1,
  files: {},
  add: function(a, t) {
    this.enabled !== !1 && (this.files[a] = t);
  },
  get: function(a) {
    if (this.enabled !== !1)
      return this.files[a];
  },
  remove: function(a) {
    delete this.files[a];
  },
  clear: function() {
    this.files = {};
  }
};
class gu {
  constructor(t, e, r) {
    const s = this;
    let i = !1, n = 0, o = 0, h;
    const c = [];
    this.onStart = void 0, this.onLoad = t, this.onProgress = e, this.onError = r, this.itemStart = function(l) {
      o++, i === !1 && s.onStart !== void 0 && s.onStart(l, n, o), i = !0;
    }, this.itemEnd = function(l) {
      n++, s.onProgress !== void 0 && s.onProgress(l, n, o), n === o && (i = !1, s.onLoad !== void 0 && s.onLoad());
    }, this.itemError = function(l) {
      s.onError !== void 0 && s.onError(l);
    }, this.resolveURL = function(l) {
      return h ? h(l) : l;
    }, this.setURLModifier = function(l) {
      return h = l, this;
    }, this.addHandler = function(l, u) {
      return c.push(l, u), this;
    }, this.removeHandler = function(l) {
      const u = c.indexOf(l);
      return u !== -1 && c.splice(u, 2), this;
    }, this.getHandler = function(l) {
      for (let u = 0, f = c.length; u < f; u += 2) {
        const d = c[u], p = c[u + 1];
        if (d.global && (d.lastIndex = 0), d.test(l))
          return p;
      }
      return null;
    };
  }
}
const bu = /* @__PURE__ */ new gu();
class Cn {
  constructor(t) {
    this.manager = t !== void 0 ? t : bu, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
  }
  load() {
  }
  loadAsync(t, e) {
    const r = this;
    return new Promise(function(s, i) {
      r.load(t, s, e, i);
    });
  }
  parse() {
  }
  setCrossOrigin(t) {
    return this.crossOrigin = t, this;
  }
  setWithCredentials(t) {
    return this.withCredentials = t, this;
  }
  setPath(t) {
    return this.path = t, this;
  }
  setResourcePath(t) {
    return this.resourcePath = t, this;
  }
  setRequestHeader(t) {
    return this.requestHeader = t, this;
  }
}
Cn.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const St = {};
class _u extends Error {
  constructor(t, e) {
    super(t), this.response = e;
  }
}
class wu extends Cn {
  constructor(t) {
    super(t);
  }
  load(t, e, r, s) {
    t === void 0 && (t = ""), this.path !== void 0 && (t = this.path + t), t = this.manager.resolveURL(t);
    const i = Ea.get(t);
    if (i !== void 0)
      return this.manager.itemStart(t), setTimeout(() => {
        e && e(i), this.manager.itemEnd(t);
      }, 0), i;
    if (St[t] !== void 0) {
      St[t].push({
        onLoad: e,
        onProgress: r,
        onError: s
      });
      return;
    }
    St[t] = [], St[t].push({
      onLoad: e,
      onProgress: r,
      onError: s
    });
    const n = new Request(t, {
      headers: new Headers(this.requestHeader),
      credentials: this.withCredentials ? "include" : "same-origin"
      // An abort controller could be added within a future PR
    }), o = this.mimeType, h = this.responseType;
    fetch(n).then((c) => {
      if (c.status === 200 || c.status === 0) {
        if (c.status === 0 && console.warn("THREE.FileLoader: HTTP Status 0 received."), typeof ReadableStream > "u" || c.body === void 0 || c.body.getReader === void 0)
          return c;
        const l = St[t], u = c.body.getReader(), f = c.headers.get("X-File-Size") || c.headers.get("Content-Length"), d = f ? parseInt(f) : 0, p = d !== 0;
        let x = 0;
        const m = new ReadableStream({
          start(y) {
            _();
            function _() {
              u.read().then(({ done: b, value: w }) => {
                if (b)
                  y.close();
                else {
                  x += w.byteLength;
                  const M = new ProgressEvent("progress", { lengthComputable: p, loaded: x, total: d });
                  for (let A = 0, v = l.length; A < v; A++) {
                    const S = l[A];
                    S.onProgress && S.onProgress(M);
                  }
                  y.enqueue(w), _();
                }
              }, (b) => {
                y.error(b);
              });
            }
          }
        });
        return new Response(m);
      } else
        throw new _u(`fetch for "${c.url}" responded with ${c.status}: ${c.statusText}`, c);
    }).then((c) => {
      switch (h) {
        case "arraybuffer":
          return c.arrayBuffer();
        case "blob":
          return c.blob();
        case "document":
          return c.text().then((l) => new DOMParser().parseFromString(l, o));
        case "json":
          return c.json();
        default:
          if (o === void 0)
            return c.text();
          {
            const u = /charset="?([^;"\s]*)"?/i.exec(o), f = u && u[1] ? u[1].toLowerCase() : void 0, d = new TextDecoder(f);
            return c.arrayBuffer().then((p) => d.decode(p));
          }
      }
    }).then((c) => {
      Ea.add(t, c);
      const l = St[t];
      delete St[t];
      for (let u = 0, f = l.length; u < f; u++) {
        const d = l[u];
        d.onLoad && d.onLoad(c);
      }
    }).catch((c) => {
      const l = St[t];
      if (l === void 0)
        throw this.manager.itemError(t), c;
      delete St[t];
      for (let u = 0, f = l.length; u < f; u++) {
        const d = l[u];
        d.onError && d.onError(c);
      }
      this.manager.itemError(t);
    }).finally(() => {
      this.manager.itemEnd(t);
    }), this.manager.itemStart(t);
  }
  setResponseType(t) {
    return this.responseType = t, this;
  }
  setMimeType(t) {
    return this.mimeType = t, this;
  }
}
const Pa = /* @__PURE__ */ new et();
let dc = class {
  constructor(t, e, r = 0, s = 1 / 0) {
    this.ray = new kn(t, e), this.near = r, this.far = s, this.camera = null, this.layers = new sc(), this.params = {
      Mesh: {},
      Line: { threshold: 1 },
      LOD: {},
      Points: { threshold: 1 },
      Sprite: {}
    };
  }
  set(t, e) {
    this.ray.set(t, e);
  }
  setFromCamera(t, e) {
    e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t.x, t.y, 0.5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : console.error("THREE.Raycaster: Unsupported camera type: " + e.type);
  }
  setFromXRController(t) {
    return Pa.identity().extractRotation(t.matrixWorld), this.ray.origin.setFromMatrixPosition(t.matrixWorld), this.ray.direction.set(0, 0, -1).applyMatrix4(Pa), this;
  }
  intersectObject(t, e = !0, r = []) {
    return Mn(t, this, r, e), r.sort(za), r;
  }
  intersectObjects(t, e = !0, r = []) {
    for (let s = 0, i = t.length; s < i; s++)
      Mn(t[s], this, r, e);
    return r.sort(za), r;
  }
};
function za(a, t) {
  return a.distance - t.distance;
}
function Mn(a, t, e, r) {
  let s = !0;
  if (a.layers.test(t.layers) && a.raycast(t, e) === !1 && (s = !1), s === !0 && r === !0) {
    const i = a.children;
    for (let n = 0, o = i.length; n < o; n++)
      Mn(i[n], t, e, !0);
  }
}
class vu {
  constructor() {
    this.type = "ShapePath", this.color = new we(), this.subPaths = [], this.currentPath = null;
  }
  moveTo(t, e) {
    return this.currentPath = new _n(), this.subPaths.push(this.currentPath), this.currentPath.moveTo(t, e), this;
  }
  lineTo(t, e) {
    return this.currentPath.lineTo(t, e), this;
  }
  quadraticCurveTo(t, e, r, s) {
    return this.currentPath.quadraticCurveTo(t, e, r, s), this;
  }
  bezierCurveTo(t, e, r, s, i, n) {
    return this.currentPath.bezierCurveTo(t, e, r, s, i, n), this;
  }
  splineThru(t) {
    return this.currentPath.splineThru(t), this;
  }
  toShapes(t) {
    function e(y) {
      const _ = [];
      for (let b = 0, w = y.length; b < w; b++) {
        const M = y[b], A = new Jt();
        A.curves = M.curves, _.push(A);
      }
      return _;
    }
    function r(y, _) {
      const b = _.length;
      let w = !1;
      for (let M = b - 1, A = 0; A < b; M = A++) {
        let v = _[M], S = _[A], F = S.x - v.x, T = S.y - v.y;
        if (Math.abs(T) > Number.EPSILON) {
          if (T < 0 && (v = _[A], F = -F, S = _[M], T = -T), y.y < v.y || y.y > S.y) continue;
          if (y.y === v.y) {
            if (y.x === v.x) return !0;
          } else {
            const k = T * (y.x - v.x) - F * (y.y - v.y);
            if (k === 0) return !0;
            if (k < 0) continue;
            w = !w;
          }
        } else {
          if (y.y !== v.y) continue;
          if (S.x <= y.x && y.x <= v.x || v.x <= y.x && y.x <= S.x) return !0;
        }
      }
      return w;
    }
    const s = be.isClockWise, i = this.subPaths;
    if (i.length === 0) return [];
    let n, o, h;
    const c = [];
    if (i.length === 1)
      return o = i[0], h = new Jt(), h.curves = o.curves, c.push(h), c;
    let l = !s(i[0].getPoints());
    l = t ? !l : l;
    const u = [], f = [];
    let d = [], p = 0, x;
    f[p] = void 0, d[p] = [];
    for (let y = 0, _ = i.length; y < _; y++)
      o = i[y], x = o.getPoints(), n = s(x), n = t ? !n : n, n ? (!l && f[p] && p++, f[p] = { s: new Jt(), p: x }, f[p].s.curves = o.curves, l && p++, d[p] = []) : d[p].push({ h: o, p: x[0] });
    if (!f[0]) return e(i);
    if (f.length > 1) {
      let y = !1, _ = 0;
      for (let b = 0, w = f.length; b < w; b++)
        u[b] = [];
      for (let b = 0, w = f.length; b < w; b++) {
        const M = d[b];
        for (let A = 0; A < M.length; A++) {
          const v = M[A];
          let S = !0;
          for (let F = 0; F < f.length; F++)
            r(v.p, f[F].p) && (b !== F && _++, S ? (S = !1, u[F].push(v)) : y = !0);
          S && u[b].push(v);
        }
      }
      _ > 0 && y === !1 && (d = u);
    }
    let m;
    for (let y = 0, _ = f.length; y < _; y++) {
      h = f[y].s, c.push(h), m = d[y];
      for (let b = 0, w = m.length; b < w; b++)
        h.holes.push(m[b].h);
    }
    return c;
  }
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
  revision: ec
} }));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = ec);
class Mu extends Cn {
  constructor(t) {
    super(t);
  }
  load(t, e, r, s) {
    const i = this, n = new wu(this.manager);
    n.setPath(this.path), n.setRequestHeader(this.requestHeader), n.setWithCredentials(this.withCredentials), n.load(t, function(o) {
      const h = i.parse(JSON.parse(o));
      e && e(h);
    }, r, s);
  }
  parse(t) {
    return new Au(t);
  }
}
class Au {
  constructor(t) {
    this.isFont = !0, this.type = "Font", this.data = t;
  }
  generateShapes(t, e = 100) {
    const r = [], s = Su(t, e, this.data);
    for (let i = 0, n = s.length; i < n; i++)
      r.push(...s[i].toShapes());
    return r;
  }
}
function Su(a, t, e) {
  const r = Array.from(a), s = t / e.resolution, i = (e.boundingBox.yMax - e.boundingBox.yMin + e.underlineThickness) * s, n = [];
  let o = 0, h = 0;
  for (let c = 0; c < r.length; c++) {
    const l = r[c];
    if (l === `
`)
      o = 0, h -= i;
    else {
      const u = ku(l, s, o, h, e);
      o += u.offsetX, n.push(u.path);
    }
  }
  return n;
}
function ku(a, t, e, r, s) {
  const i = s.glyphs[a] || s.glyphs["?"];
  if (!i) {
    console.error('THREE.Font: character "' + a + '" does not exists in font family ' + s.familyName + ".");
    return;
  }
  const n = new vu();
  let o, h, c, l, u, f, d, p;
  if (i.o) {
    const x = i._cachedOutline || (i._cachedOutline = i.o.split(" "));
    for (let m = 0, y = x.length; m < y; )
      switch (x[m++]) {
        case "m":
          o = x[m++] * t + e, h = x[m++] * t + r, n.moveTo(o, h);
          break;
        case "l":
          o = x[m++] * t + e, h = x[m++] * t + r, n.lineTo(o, h);
          break;
        case "q":
          c = x[m++] * t + e, l = x[m++] * t + r, u = x[m++] * t + e, f = x[m++] * t + r, n.quadraticCurveTo(u, f, c, l);
          break;
        case "b":
          c = x[m++] * t + e, l = x[m++] * t + r, u = x[m++] * t + e, f = x[m++] * t + r, d = x[m++] * t + e, p = x[m++] * t + r, n.bezierCurveTo(u, f, d, p, c, l);
          break;
      }
  }
  return { offsetX: i.ha * t, path: n };
}
class H {
}
/** @property cache {boolean} Checks if module will cache generated entities or not */
Xt(H, "cache", !0), /** @property showFrozen {boolean} Checks if module will show frozen dxf entities */
Xt(H, "showFrozen", !1), /** @property showLocked {boolean} Checks if module will show locked dxf entities */
Xt(H, "showLocked", !0), /** @property paperSpace {int} also called  sheet or layout. 0 is always model. */
Xt(H, "paperSpace", 0), /** @property decimal {int} readed decimals in a number */
Xt(H, "decimals", 6), /** @property onBeforeTextDraw {method} An event to change text values before rendering it. Useful to change dimensions or text */
Xt(H, "onBeforeTextDraw", null);
var Ca = {}, Ba = 1;
class Fu {
  constructor() {
    this.cache = !0;
  }
  /**
   * Returns the cached object if exist. Otherwise null
   * @param entity {Entity} DXFViewer Entity.
      * @return {Object} object  usually composed as {geometry: THREE.Geometry, material: THREE.Material}
  */
  _getCached(t) {
    return t._cache && H.cache ? Ca[t._cache] : null;
  }
  /**
   * Stores the entity in the cache. Adds _cache property to the entity to store the cache key 
   * @param entity {Entity} DXFViewer Entity.
   * @param model {Object} object to be stored. usually an object composed as {geometry: THREE.Geometry, material: THREE.Material}.
  */
  _setCache(t, e) {
    t._cache = "e" + Ba, Ba++, Ca[t._cache] = e;
  }
}
var os = {};
class Bn {
  constructor() {
  }
  /**
   * Returns the entity's material. It will create a new material if it doesn't exist in the cache.
   * @param entity {Entity} DXFViewer Entity.
      * @param type {string} A flag to indicate the type of material to be created. It can be 'shape', 'line' or 'dashed'.
   * @param tables {Object} dxf tables object, conatining at least layers and ltypes.
      * @return {THREE.Material} Material
  */
  getMaterial(t, e, r) {
    let s = this._getColorHex(t, r.layers), i = t.lineTypeName + e + s;
    if (os[i]) return os[i];
    let n = e === "shape" ? new Ne({ side: 2 }) : e === "line" ? new Tn() : this._createDashedMaterial(t, r.ltypes);
    return n.color.setHex(s), n.color.convertSRGBToLinear(), n.name = i, os[i] = n, n;
  }
  _createDashedMaterial(t, e) {
    let r = 4, s = 4, i = t.lineTypeName && Object.prototype.hasOwnProperty.call(e, t.lineTypeName) ? e[t.lineTypeName] : null;
    return s = i.pattern && i.pattern.length > 0 ? Math.max(...i.pattern.map((n) => n.length)) : 4, r = i.pattern && i.pattern.length > 0 ? i.pattern.map((n) => n.length === -1).length : 4, s = s === 0 ? 4 : s, new yu({ gapSize: r, dashSize: s });
  }
  _getColorHex(t, e) {
    let r = t.fillColor ? t.fillColor : t.colorNumber;
    if (!r || r === 0) {
      let s = Object.prototype.hasOwnProperty.call(e, t.layer) ? e[t.layer] : null;
      if (s) return s.color;
    }
    return this.getColorByNumber(r);
  }
  /**
   * Returns hex color from color number. Based on DXF format table colors
   * @param colorNumber {Number} dxf colorNumber.
      * @return {Hexadecimal} color's hex number
  */
  getColorByNumber(t) {
    switch (t) {
      case 0:
        return 0;
      case 1:
        return 16711680;
      case 2:
        return 16776960;
      case 3:
        return 65280;
      case 4:
        return 65535;
      case 5:
        return 255;
      case 6:
        return 16711935;
      case 7:
        return 16777215;
      case 8:
        return 4276545;
      case 9:
        return 8421504;
      case 10:
        return 16711680;
      case 11:
        return 16755370;
      case 12:
        return 12386304;
      case 13:
        return 12418686;
      case 14:
        return 8454144;
      case 15:
        return 8476246;
      case 16:
        return 6815744;
      case 17:
        return 6833477;
      case 18:
        return 5177344;
      case 19:
        return 5190965;
      case 20:
        return 16727808;
      case 21:
        return 16760746;
      case 22:
        return 12398080;
      case 23:
        return 12422526;
      case 24:
        return 8462080;
      case 25:
        return 8478806;
      case 26:
        return 6822144;
      case 27:
        return 6835781;
      case 28:
        return 5182208;
      case 29:
        return 5192501;
      case 30:
        return 16744192;
      case 31:
        return 16766122;
      case 32:
        return 12410368;
      case 33:
        return 12426622;
      case 34:
        return 8470528;
      case 35:
        return 8481622;
      case 36:
        return 6829056;
      case 37:
        return 6837829;
      case 38:
        return 5187328;
      case 39:
        return 5194293;
      case 40:
        return 16760576;
      case 41:
        return 16771754;
      case 42:
        return 12422400;
      case 43:
        return 12430718;
      case 44:
        return 8478720;
      case 45:
        return 8484438;
      case 46:
        return 6835712;
      case 47:
        return 6840133;
      case 48:
        return 5192448;
      case 49:
        return 5196085;
      case 50:
        return 16776960;
      case 51:
        return 16777130;
      case 52:
        return 12434688;
      case 53:
        return 12434814;
      case 54:
        return 8487168;
      case 55:
        return 8487254;
      case 56:
        return 6842368;
      case 57:
        return 6842437;
      case 58:
        return 5197568;
      case 59:
        return 5197621;
      case 60:
        return 12582656;
      case 61:
        return 15400874;
      case 62:
        return 9288960;
      case 63:
        return 11386238;
      case 64:
        return 6324480;
      case 65:
        return 7766358;
      case 66:
        return 5138432;
      case 67:
        return 6252613;
      case 68:
        return 3886848;
      case 69:
        return 4804405;
      case 70:
        return 8388352;
      case 71:
        return 13959082;
      case 72:
        return 6208768;
      case 73:
        return 10337662;
      case 74:
        return 4227328;
      case 75:
        return 7045462;
      case 76:
        return 3434496;
      case 77:
        return 5662789;
      case 78:
        return 2576128;
      case 79:
        return 4345653;
      case 80:
        return 4194048;
      case 81:
        return 12582826;
      case 82:
        return 3063040;
      case 83:
        return 9289086;
      case 84:
        return 2064640;
      case 85:
        return 6324566;
      case 86:
        return 1665024;
      case 87:
        return 5138501;
      case 88:
        return 1265408;
      case 89:
        return 3886901;
      case 90:
        return 65280;
      case 91:
        return 11206570;
      case 92:
        return 48384;
      case 93:
        return 8306046;
      case 94:
        return 33024;
      case 95:
        return 5669206;
      case 96:
        return 26624;
      case 97:
        return 4548677;
      case 98:
        return 20224;
      case 99:
        return 3493685;
      case 100:
        return 65343;
      case 101:
        return 11206591;
      case 102:
        return 48430;
      case 103:
        return 8306061;
      case 104:
        return 33055;
      case 105:
        return 5669216;
      case 106:
        return 26649;
      case 107:
        return 4548686;
      case 108:
        return 20243;
      case 109:
        return 3493691;
      case 110:
        return 65407;
      case 111:
        return 11206612;
      case 112:
        return 48478;
      case 113:
        return 8306077;
      case 114:
        return 33088;
      case 115:
        return 5669227;
      case 116:
        return 26676;
      case 117:
        return 4548694;
      case 118:
        return 20263;
      case 119:
        return 3493698;
      case 120:
        return 65471;
      case 121:
        return 11206634;
      case 122:
        return 48525;
      case 123:
        return 8306093;
      case 124:
        return 33120;
      case 125:
        return 5669238;
      case 126:
        return 26702;
      case 127:
        return 4548703;
      case 128:
        return 20283;
      case 129:
        return 3493705;
      case 130:
        return 65535;
      case 131:
        return 11206655;
      case 132:
        return 48573;
      case 133:
        return 8306109;
      case 134:
        return 33153;
      case 135:
        return 5669249;
      case 136:
        return 26728;
      case 137:
        return 4548712;
      case 138:
        return 20303;
      case 139:
        return 3493711;
      case 140:
        return 49151;
      case 141:
        return 11201279;
      case 142:
        return 36285;
      case 143:
        return 8302013;
      case 144:
        return 24705;
      case 145:
        return 5666433;
      case 146:
        return 20072;
      case 147:
        return 4546408;
      case 148:
        return 15183;
      case 149:
        return 3492175;
      case 150:
        return 32767;
      case 151:
        return 11195647;
      case 152:
        return 24253;
      case 153:
        return 8297917;
      case 154:
        return 16513;
      case 155:
        return 5663617;
      case 156:
        return 13416;
      case 157:
        return 4544104;
      case 158:
        return 10063;
      case 159:
        return 3490383;
      case 160:
        return 16383;
      case 161:
        return 11190271;
      case 162:
        return 11965;
      case 163:
        return 8293821;
      case 164:
        return 8065;
      case 165:
        return 5660801;
      case 166:
        return 6504;
      case 167:
        return 4542056;
      case 168:
        return 4943;
      case 169:
        return 3488591;
      case 170:
        return 255;
      case 171:
        return 11184895;
      case 172:
        return 189;
      case 173:
        return 8289981;
      case 174:
        return 129;
      case 175:
        return 5658241;
      case 176:
        return 104;
      case 177:
        return 4539752;
      case 178:
        return 79;
      case 179:
        return 3487055;
      case 180:
        return 4129023;
      case 181:
        return 12561151;
      case 182:
        return 3014845;
      case 183:
        return 9273021;
      case 184:
        return 2031745;
      case 185:
        return 6313601;
      case 186:
        return 1638504;
      case 187:
        return 5129576;
      case 188:
        return 1245263;
      case 189:
        return 3880271;
      case 190:
        return 8323327;
      case 191:
        return 13937407;
      case 192:
        return 6160573;
      case 193:
        return 10321597;
      case 194:
        return 4194433;
      case 195:
        return 7034497;
      case 196:
        return 3407976;
      case 197:
        return 5653864;
      case 198:
        return 2555983;
      case 199:
        return 4339023;
      case 200:
        return 12517631;
      case 201:
        return 15379199;
      case 202:
        return 9240765;
      case 203:
        return 11370173;
      case 204:
        return 6291585;
      case 205:
        return 7755393;
      case 206:
        return 5111912;
      case 207:
        return 6243688;
      case 208:
        return 3866703;
      case 209:
        return 4797775;
      case 210:
        return 16711935;
      case 211:
        return 16755455;
      case 212:
        return 12386493;
      case 213:
        return 12418749;
      case 214:
        return 8454273;
      case 215:
        return 8476289;
      case 216:
        return 6815848;
      case 217:
        return 6833512;
      case 218:
        return 5177423;
      case 219:
        return 5190991;
      case 220:
        return 16711871;
      case 221:
        return 16755434;
      case 222:
        return 12386445;
      case 223:
        return 12418733;
      case 224:
        return 8454240;
      case 225:
        return 8476278;
      case 226:
        return 6815822;
      case 227:
        return 6833503;
      case 228:
        return 5177403;
      case 229:
        return 5190985;
      case 230:
        return 16711807;
      case 231:
        return 16755412;
      case 232:
        return 12386398;
      case 233:
        return 12418717;
      case 234:
        return 8454208;
      case 235:
        return 8476267;
      case 236:
        return 6815796;
      case 237:
        return 6833494;
      case 238:
        return 5177383;
      case 239:
        return 5190978;
      case 240:
        return 16711743;
      case 241:
        return 16755391;
      case 242:
        return 12386350;
      case 243:
        return 12418701;
      case 244:
        return 8454175;
      case 245:
        return 8476256;
      case 246:
        return 6815769;
      case 247:
        return 6833486;
      case 248:
        return 5177363;
      case 249:
        return 5190971;
      case 250:
        return 3355443;
      case 251:
        return 5263440;
      case 252:
        return 6908265;
      case 253:
        return 8553090;
      case 254:
        return 12500670;
      case 255:
        return 16777215;
    }
    return 16777215;
  }
}
class Tu {
  constructor() {
    this.xAxis = new g(1, 0, 0), this.yAxis = new g(0, 1, 0), this.zAxis = new g(0, 0, 1);
  }
  /**
   * Returns an index array for a line.
   * @param points {Array} vertex array to create an index.
      * @return {Array} index array
  */
  generatePointIndex(t) {
    let e = [];
    for (let r = 1; r < t.length; r++)
      e.push(r - 1), e.push(r);
    return e;
  }
  /**
   * Prepares given THREE.Line object to draw dashed lines, changing to a non indexed geometry & computing line distances.
   * @param line {THREE.Line} THREE.Line object to prepare for dashed lines.
  */
  fixMeshToDrawDashedLines(t) {
    t.geometry.index && (t.geometry = t.geometry.toNonIndexed()), t.computeLineDistances();
  }
}
class pc {
  constructor() {
  }
  parse(t) {
    const e = {};
    let r = new Bn();
    const s = Object.keys(t);
    for (let i = 0; i < s.length; i++) {
      const n = t[s[i]];
      e[s[i]] = {
        name: n.name,
        lineTypeName: n.lineTypeName,
        lineWeightEnum: n.lineWeightEnum,
        color: r.getColorByNumber(n.colorNumber),
        visible: this.isVisible(n),
        flags: this.parseFlags(n.flags)
      };
    }
    return e;
  }
  /**
   * Returns the separated flags based on the flag number.
      * @param flag {Number} A flag to indicate the type of material to be created. It can be 'shape', 'line' or 'dashed'.
      * @return {Array} frozen, locaked and dependent flags
  */
  parseFlags(t) {
    if (t === 0) return [];
    let e = [];
    return t % 2 !== 0 && e.push("frozen"), (4 <= t && t < 16 || t === 20 || t === 36 || t === 52) && e.push("locked"), 16 <= t && t < 64 && e.push("dependent"), e;
  }
  /**
   * Returns if layer is visible ot not.
      * @param layer {Layer} layer object.
      * @return {Boolean} layer visibility
  */
  isVisible(t) {
    return !(t.colorNumber < 0 || typeof t.plot < "u" && !t.plot);
  }
}
class Bt extends Fu {
  constructor(t) {
    super(), this.data = t, this._colorHelper = new Bn(), this._geometryHelper = new Tu(), this._layerHelper = new pc();
  }
  /**
      * 
      * @param entity {Entity} hides the entity according to entity's flags & general properties
      */
  _hideEntity(t) {
    if (typeof t.visible < "u" && !t.visible || typeof t.paperSpace < "u" && H.showFrozen !== t.paperSpace || t.lineTypeName === "HIDDEN") return !0;
    let e = Object.prototype.hasOwnProperty.call(this.data.tables.layers, t.layer) ? this.data.tables.layers[t.layer] : null;
    return !!(e && (!e.visible || !H.showFrozen && e.flags.includes("frozen") || !H.showLocked && e.flags.includes("locked")));
  }
  //micro-optimization. Use this instead of find
  _getBlock(t, e) {
    for (let r = 0; r < t.length; r++)
      if (t[r].name === e) return t[r];
    return null;
  }
}
/**
 * @license
 * Credits to vagran (https://github.com/vagran/dxf-viewer) for the original code.
 */
const N = Object.freeze({
  TEXT: 0,
  ESCAPE: 1,
  /* Skip currently unsupported format codes till ';' */
  SKIP_FORMAT: 2,
  /* For \pxq* paragraph formatting. Not found documentation yet, so temporal naming for now. */
  PARAGRAPH1: 3,
  PARAGRAPH2: 4,
  PARAGRAPH3: 5
}), jt = Object.freeze({
  TEXT: 0,
  SCOPE: 1,
  PARAGRAPH: 2,
  NON_BREAKING_SPACE: 3,
  /** "alignment" property is either "r", "c", "l", "j", "d" for right, center, left, justify
      * (seems to be the same as left), distribute (justify) alignment.
      */
  PARAGRAPH_ALIGNMENT: 4
  /* Many others are not yet implemented. */
}), Eu = /* @__PURE__ */ new Set([
  "L",
  "l",
  "O",
  "o",
  "K",
  "k",
  "P",
  "X",
  "~"
]), Pu = /* @__PURE__ */ new Set([
  "f",
  "F",
  "p",
  "Q",
  "H",
  "W",
  "S",
  "A",
  "C",
  "T"
]), zu = /* @__PURE__ */ new Set([
  "\\",
  "{",
  "}"
]);
class Ee {
  constructor() {
    this.entities = [];
  }
  /**
      * @param text {string} MTEXT formatted text.
      * @return {Array} this
      */
  Parse(t) {
    const e = t.length;
    let r = 0, s = N.TEXT, i = [], n = this.entities, o = 0;
    const h = this;
    function c() {
      s !== N.TEXT || r === o || (n.push({
        type: jt.TEXT,
        content: t.slice(r, o)
      }), r = o);
    }
    function l(d) {
      n.push({ type: d });
    }
    function u() {
      const d = {
        type: jt.SCOPE,
        content: []
      };
      n.push(d), n = d.content, i.push(d);
    }
    function f() {
      i.length !== 0 && (i.pop(), i.length === 0 ? n = h.entities : n = i[i.length - 1].content);
    }
    for (; o < e; o++) {
      const d = t.charAt(o);
      switch (s) {
        case N.TEXT:
          if (d === "{") {
            c(), u(), r = o + 1;
            continue;
          }
          if (d === "}") {
            c(), f(), r = o + 1;
            continue;
          }
          if (d === "\\") {
            c(), s = N.ESCAPE;
            continue;
          }
          continue;
        case N.ESCAPE:
          if (Eu.has(d)) {
            switch (d) {
              case "P":
                l(jt.PARAGRAPH);
                break;
              case "~":
                l(jt.NON_BREAKING_SPACE);
                break;
            }
            s = N.TEXT, r = o + 1;
            continue;
          }
          if (Pu.has(d)) {
            switch (d) {
              case "p":
                s = N.PARAGRAPH1;
                continue;
            }
            s = N.SKIP_FORMAT;
            continue;
          }
          zu.has(d) ? r = o : r = o - 1, s = N.TEXT;
          continue;
        case N.PARAGRAPH1:
          s = d === "x" ? N.PARAGRAPH2 : N.SKIP_FORMAT;
          continue;
        case N.PARAGRAPH2:
          s = d === "q" ? N.PARAGRAPH3 : N.SKIP_FORMAT;
          continue;
        case N.PARAGRAPH3:
          n.push({ type: jt.PARAGRAPH_ALIGNMENT, alignment: d }), s = N.SKIP_FORMAT;
          continue;
        case N.SKIP_FORMAT:
          d === ";" && (r = o + 1, s = N.TEXT);
          continue;
        default:
          throw new Error("Unhandled state");
      }
    }
    return c(), this;
  }
  /** @typedef MTextFormatEntity
      * @property type One of EntityType
      *
      * @return {MTextFormatEntity[]} List of format chunks. Each chunk is either a text chunk with
      * TEXT type or some format entity. Entity with type SCOPE represents format scope which has
      * nested list of entities in "content" property.
      */
  GetContent() {
    return this.entities;
  }
  /** Return only text chunks in a flattened sequence of strings. */
  *GetText() {
    function* t(e) {
      for (const r of e)
        r.type === jt.TEXT ? yield r.content : r.type === jt.SCOPE && (yield* t(r.content));
    }
    yield* t(this.GetContent());
  }
}
Ee.EntityType = jt;
class Dn extends Bt {
  constructor(t, e) {
    super(t), this._font = e, this._textParser = new Ee();
  }
  /**
   * It filters all the text, mtext and attrib entities and draw them.
   * @param data {DXFData} dxf parsed data.
      * @return {THREE.Group} ThreeJS object with all the generated geometry. DXF entity is added into userData
  */
  draw(t) {
    let e = t.entities.filter((s) => s.type === "MTEXT" || s.type === "TEXT" || s.type === "ATTRIB");
    if (e.length === 0) return null;
    let r = new it();
    r.name = "TEXTS";
    for (let s = 0; s < e.length; s++) {
      let i = e[s];
      if (this._hideEntity(i)) continue;
      let n = this._getCached(i), o = null, h = null;
      if (n)
        o = n.geometry, h = n.material;
      else {
        let l = this.drawText(i);
        o = l.geometry, h = l.material, H.onBeforeTextDraw || this._setCache(i, l);
      }
      let c = new Pt(o, h);
      c.userData = { entity: i }, r.add(c);
    }
    return r;
  }
  /**
   * Draws text, mtext and attrib entities.
   * @param entity {entity} dxf parsed text, mtext or attrib entity.
      * @return {Object} object composed as {geometry: THREE.Geometry, material: THREE.Material}
  */
  drawText(t) {
    if (t.type === "ATTRIB")
      return Object.keys(t.mtext).length !== 0 ? this.drawText(t.mtext) : this.drawText(t.text);
    let e = this._getTextGeometry(t);
    this._scaleText(e, t);
    let r = this._getPosAndRotation(t);
    r.rotation && e.applyQuaternion(r.rotation), e.translate(r.pos.x, r.pos.y, r.pos.z), this._alignText(e, t, r.pos), this._translateCenter(e, t, r.pos);
    let s = this._colorHelper.getMaterial(t, "shape", this.data.tables);
    return { geometry: e, material: s };
  }
  _getTextGeometry(t) {
    let r = this._getTextStrings(t).join("");
    if (H.onBeforeTextDraw) {
      let n = { text: r };
      H.onBeforeTextDraw(n), r = n.text;
    }
    let s = this._getTextHeight(t), i = this._font.generateShapes(r, s);
    return new Ve(i);
  }
  _getTextHeight(t) {
    let e = 12;
    return typeof t.nominalTextHeight < "u" ? e = t.nominalTextHeight : typeof t.textHeight < "u" && (e = t.textHeight), e;
  }
  _scaleText(t, e) {
    t.computeBoundingBox();
    let r = t.boundingBox.max.x - t.boundingBox.min.x, s = t.boundingBox.max.y - t.boundingBox.min.y, i = typeof e.horizontalWidth < "u" ? e.horizontalWidth / r : 1, n = typeof e.verticalHeight < "u" ? e.verticalHeight / s : 1;
    t.scale(i, n, 1);
  }
  _getTextStrings(t) {
    let e = (i) => {
      let n = [];
      for (let o = 0; o < i.length; o++) {
        const h = i[o];
        if ((h.type === Ee.EntityType.PARAGRAPH || h.type === Ee.EntityType.PARAGRAPH_ALIGNMENT) && n.push(`
`), typeof h.content == "string")
          n.push(h.content);
        else if (h.content instanceof Array) {
          let c = e(h.content);
          n.push(c);
        }
      }
      return n;
    }, r = new Ee().Parse(t.string);
    return e(r.entities);
  }
  _getPosAndRotation(t) {
    let e = { pos: { x: 0, y: 0, z: 0 }, rotation: null }, r = t.x, s = t.y, i = t.z, n = t.rotation, o = t.xAxisX, h = t.xAxisY, c = t.xAxisZ, l = t.drawingDirection, u = "0".repeat(H.decimals), f = "0." + u, d = "1." + u, p = typeof r < "u" ? r.toFixed(H.decimals) : f, x = typeof s < "u" ? s.toFixed(H.decimals) : f, m = typeof i < "u" ? i.toFixed(H.decimals) : f, y = p === d && x === f && m === f || p === f && x === d && m === f || p === f && x === f && m === d;
    return e.pos.x = y ? o : r, e.pos.y = y ? h : s, e.pos.z = y ? c : i, n ? e.rotation = new Kt().setFromAxisAngle(this._geometryHelper.zAxis, n * Math.PI / 180) : (l === 3 || y && s === 1 || !y && h === 1) && (e.rotation = new Kt().setFromAxisAngle(this._geometryHelper.zAxis, Math.PI / 2)), e;
  }
  _translateCenter(t, e, r) {
    let s = e.attachmentPoint;
    if (!s) return;
    t.computeBoundingBox();
    let i = t.boundingBox.max.x - t.boundingBox.min.x, n = t.boundingBox.max.y - t.boundingBox.min.y, o = t.boundingBox.max.z - t.boundingBox.min.z, h = {
      x: t.boundingBox.min.x + i / 2,
      y: t.boundingBox.min.y + n / 2
    };
    switch (s) {
      case 1:
        t.translate(r.x - t.boundingBox.min.x, r.y - t.boundingBox.max.y, -0.5 * o);
        break;
      case 2:
        t.translate(r.x - h.x, r.y - t.boundingBox.max.y, -0.5 * o);
        break;
      case 3:
        t.translate(r.x - t.boundingBox.max.x, r.y - t.boundingBox.max.y, -0.5 * o);
        break;
      case 4:
        t.translate(r.x - t.boundingBox.min.x, r.y - h.y, -0.5 * o);
        break;
      case 5:
        t.translate(r.x - h.x, r.y - h.y, -0.5 * o);
        break;
      case 6:
        t.translate(r.x - t.boundingBox.max.x, r.y - h.y, -0.5 * o);
        break;
      case 7:
        t.translate(r.x - t.boundingBox.min.x, r.y - t.boundingBox.min.y, -0.5 * o);
        break;
      case 8:
        t.translate(r.x - h.x, t.boundingBox.min.y, -0.5 * o);
        break;
      case 9:
        t.translate(r.x - t.boundingBox.max.x, t.boundingBox.min.y, -0.5 * o);
        break;
    }
  }
  _alignText(t, e, r) {
    t.computeBoundingBox();
    let s = t.boundingBox.max.x - t.boundingBox.min.x, i = t.boundingBox.max.y - t.boundingBox.min.y, n = {
      x: t.boundingBox.min.x + s / 2,
      y: t.boundingBox.min.y + i / 2
    }, o = 0, h = i;
    switch (e.hAlign) {
      case 0:
        o = r.x - t.boundingBox.min.x;
        break;
      case 1:
        o = r.x - n.x;
        break;
      case 2:
        o = r.x - t.boundingBox.max.x;
        break;
    }
    switch (e.vAlign) {
      case 0:
        h = r.y - n.y;
        break;
      case 1:
        h = i / 2;
        break;
      case 2:
        h = r.y - n.y;
        break;
      case 3:
        h = r.y - t.boundingBox.max.y;
        break;
    }
    t.translate(o, h, 0);
  }
  _replaceSpecialChars(t) {
    return t.replaceAll("\\P", `
`).replaceAll("\\X", `
`).replaceAll("%%d", "°").replaceAll("%%p", "±").replaceAll("%%c", "∅").replaceAll("%%%", "%");
  }
}
var gr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function In(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
var hs = {}, cs = {}, ls = {}, Da;
function Rn() {
  return Da || (Da = 1, function(a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.default = void 0;
    function t(o) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(c) {
        return typeof c;
      } : t = function(c) {
        return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
      }, t(o);
    }
    function e(o, h) {
      if (!(o instanceof h))
        throw new TypeError("Cannot call a class as a function");
    }
    function r(o, h) {
      for (var c = 0; c < h.length; c++) {
        var l = h[c];
        l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(o, l.key, l);
      }
    }
    function s(o, h, c) {
      return r(o.prototype, h), o;
    }
    var i = /* @__PURE__ */ function() {
      function o(h, c) {
        e(this, o), t(h) === "object" ? (this.x = h.x, this.y = h.y) : (this.x = h, this.y = c);
      }
      return s(o, [{
        key: "equals",
        value: function(c) {
          return this.x === c.x && this.y === c.y;
        }
      }, {
        key: "length",
        value: function() {
          return Math.sqrt(this.dot(this));
        }
      }, {
        key: "neg",
        value: function() {
          return new o(-this.x, -this.y);
        }
      }, {
        key: "add",
        value: function(c) {
          return new o(this.x + c.x, this.y + c.y);
        }
      }, {
        key: "sub",
        value: function(c) {
          return new o(this.x - c.x, this.y - c.y);
        }
      }, {
        key: "multiply",
        value: function(c) {
          return new o(this.x * c, this.y * c);
        }
      }, {
        key: "norm",
        value: function() {
          return this.multiply(1 / this.length());
        }
      }, {
        key: "dot",
        value: function(c) {
          return this.x * c.x + this.y * c.y;
        }
      }]), o;
    }(), n = i;
    a.default = n;
  }(ls)), ls;
}
var us = {}, Ia;
function kr() {
  return Ia || (Ia = 1, function(a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.default = void 0;
    function t(o) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(c) {
        return typeof c;
      } : t = function(c) {
        return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
      }, t(o);
    }
    function e(o, h) {
      if (!(o instanceof h))
        throw new TypeError("Cannot call a class as a function");
    }
    function r(o, h) {
      for (var c = 0; c < h.length; c++) {
        var l = h[c];
        l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(o, l.key, l);
      }
    }
    function s(o, h, c) {
      return r(o.prototype, h), o;
    }
    var i = /* @__PURE__ */ function() {
      function o(h, c, l) {
        e(this, o), t(h) === "object" ? (this.x = h.x, this.y = h.y, this.z = h.z) : h === void 0 ? (this.x = 0, this.y = 0, this.z = 0) : (this.x = h, this.y = c, this.z = l);
      }
      return s(o, [{
        key: "equals",
        value: function(c, l) {
          return l === void 0 && (l = 0), Math.abs(this.x - c.x) <= l && Math.abs(this.y - c.y) <= l && Math.abs(this.z - c.z) <= l;
        }
      }, {
        key: "length",
        value: function() {
          return Math.sqrt(this.dot(this));
        }
      }, {
        key: "neg",
        value: function() {
          return new o(-this.x, -this.y, -this.z);
        }
      }, {
        key: "add",
        value: function(c) {
          return new o(this.x + c.x, this.y + c.y, this.z + c.z);
        }
      }, {
        key: "sub",
        value: function(c) {
          return new o(this.x - c.x, this.y - c.y, this.z - c.z);
        }
      }, {
        key: "multiply",
        value: function(c) {
          return new o(this.x * c, this.y * c, this.z * c);
        }
      }, {
        key: "norm",
        value: function() {
          return this.multiply(1 / this.length());
        }
      }, {
        key: "dot",
        value: function(c) {
          return this.x * c.x + this.y * c.y + this.z * c.z;
        }
      }, {
        key: "cross",
        value: function(c) {
          return new o(this.y * c.z - this.z * c.y, this.z * c.x - this.x * c.z, this.x * c.y - this.y * c.x);
        }
      }]), o;
    }(), n = i;
    a.default = n;
  }(us)), us;
}
var fs = {}, Ra;
function Cu() {
  return Ra || (Ra = 1, function(a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.default = void 0;
    var t = e(Rn());
    function e(c) {
      return c && c.__esModule ? c : { default: c };
    }
    function r(c) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(u) {
        return typeof u;
      } : r = function(u) {
        return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
      }, r(c);
    }
    function s(c, l) {
      if (!(c instanceof l))
        throw new TypeError("Cannot call a class as a function");
    }
    function i(c, l) {
      for (var u = 0; u < l.length; u++) {
        var f = l[u];
        f.enumerable = f.enumerable || !1, f.configurable = !0, "value" in f && (f.writable = !0), Object.defineProperty(c, f.key, f);
      }
    }
    function n(c, l, u) {
      return i(c.prototype, l), c;
    }
    var o = /* @__PURE__ */ function() {
      function c(l, u) {
        if (s(this, c), r(l) === "object" && r(u) === "object" && l.x !== void 0 && l.y !== void 0 && u.x !== void 0 && u.y !== void 0)
          this.min = new t.default(l), this.max = new t.default(u), this.valid = !0;
        else if (l === void 0 && u === void 0)
          this.min = new t.default(1 / 0, 1 / 0), this.max = new t.default(-1 / 0, -1 / 0), this.valid = !1;
        else
          throw Error("Illegal construction - must use { x, y } objects");
      }
      return n(c, [{
        key: "equals",
        value: function(u) {
          if (!this.valid)
            throw Error("Box2 is invalid");
          return this.min.equals(u.min) && this.max.equals(u.max);
        }
      }, {
        key: "expandByPoint",
        value: function(u) {
          return this.min = new t.default(Math.min(this.min.x, u.x), Math.min(this.min.y, u.y)), this.max = new t.default(Math.max(this.max.x, u.x), Math.max(this.max.y, u.y)), this.valid = !0, this;
        }
      }, {
        key: "expandByPoints",
        value: function(u) {
          var f = this;
          return u.forEach(function(d) {
            f.expandByPoint(d);
          }, this), this;
        }
      }, {
        key: "isPointInside",
        value: function(u) {
          return u.x >= this.min.x && u.y >= this.min.y && u.x <= this.max.x && u.y <= this.max.y;
        }
      }, {
        key: "width",
        get: function() {
          if (!this.valid)
            throw Error("Box2 is invalid");
          return this.max.x - this.min.x;
        }
      }, {
        key: "height",
        get: function() {
          if (!this.valid)
            throw Error("Box2 is invalid");
          return this.max.y - this.min.y;
        }
      }]), c;
    }();
    o.fromPoints = function(c) {
      return new o().expandByPoints(c);
    };
    var h = o;
    a.default = h;
  }(fs)), fs;
}
var ds = {}, La;
function Bu() {
  return La || (La = 1, function(a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.default = void 0;
    var t = e(kr());
    function e(c) {
      return c && c.__esModule ? c : { default: c };
    }
    function r(c) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(u) {
        return typeof u;
      } : r = function(u) {
        return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
      }, r(c);
    }
    function s(c, l) {
      if (!(c instanceof l))
        throw new TypeError("Cannot call a class as a function");
    }
    function i(c, l) {
      for (var u = 0; u < l.length; u++) {
        var f = l[u];
        f.enumerable = f.enumerable || !1, f.configurable = !0, "value" in f && (f.writable = !0), Object.defineProperty(c, f.key, f);
      }
    }
    function n(c, l, u) {
      return i(c.prototype, l), c;
    }
    var o = /* @__PURE__ */ function() {
      function c(l, u) {
        if (s(this, c), r(l) === "object" && r(u) === "object" && l.x !== void 0 && l.y !== void 0 && l.z !== void 0 && u.x !== void 0 && u.y !== void 0 && u.z !== void 0)
          this.min = new t.default(l), this.max = new t.default(u), this.valid = !0;
        else if (l === void 0 && u === void 0)
          this.min = new t.default(1 / 0, 1 / 0, 1 / 0), this.max = new t.default(-1 / 0, -1 / 0, -1 / 0), this.valid = !1;
        else
          throw Error("Illegal construction - must use { x, y, z } objects");
      }
      return n(c, [{
        key: "equals",
        value: function(u) {
          if (!this.valid)
            throw Error("Box3 is invalid");
          return this.min.equals(u.min) && this.max.equals(u.max);
        }
      }, {
        key: "expandByPoint",
        value: function(u) {
          return this.min = new t.default(Math.min(this.min.x, u.x), Math.min(this.min.y, u.y), Math.min(this.min.z, u.z)), this.max = new t.default(Math.max(this.max.x, u.x), Math.max(this.max.y, u.y), Math.max(this.max.z, u.z)), this.valid = !0, this;
        }
      }, {
        key: "expandByPoints",
        value: function(u) {
          var f = this;
          return u.forEach(function(d) {
            f.expandByPoint(d);
          }, this), this;
        }
      }, {
        key: "isPointInside",
        value: function(u) {
          return u.x >= this.min.x && u.y >= this.min.y && u.z >= this.min.z && u.x <= this.max.x && u.y <= this.max.y && u.z <= this.max.z;
        }
      }, {
        key: "width",
        get: function() {
          if (!this.valid)
            throw Error("Box3 is invalid");
          return this.max.x - this.min.x;
        }
      }, {
        key: "depth",
        get: function() {
          if (!this.valid)
            throw Error("Box3 is invalid");
          return this.max.y - this.min.y;
        }
      }, {
        key: "height",
        get: function() {
          if (!this.valid)
            throw Error("Box3 is invalid");
          return this.max.z - this.min.z;
        }
      }]), c;
    }();
    o.fromPoints = function(c) {
      return new o().expandByPoints(c);
    };
    var h = o;
    a.default = h;
  }(ds)), ds;
}
var ps = {}, Oa;
function Du() {
  return Oa || (Oa = 1, function(a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.default = void 0;
    function t(n, o) {
      if (!(n instanceof o))
        throw new TypeError("Cannot call a class as a function");
    }
    function e(n, o) {
      for (var h = 0; h < o.length; h++) {
        var c = o[h];
        c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(n, c.key, c);
      }
    }
    function r(n, o, h) {
      return e(n.prototype, o), n;
    }
    var s = /* @__PURE__ */ function() {
      function n(o, h, c, l) {
        t(this, n), this.a = o, this.b = h, this.c = c, this.d = l;
      }
      return r(n, [{
        key: "distanceToPoint",
        value: function(h) {
          var c = (this.a * h.x + this.b * h.y + this.c * h.z + this.d) / Math.sqrt(this.a * this.a + this.b * this.b + this.c * this.c);
          return c;
        }
      }, {
        key: "equals",
        value: function(h) {
          return this.a === h.a && this.b === h.b && this.c === h.c && this.d === h.d;
        }
      }, {
        key: "coPlanar",
        value: function(h) {
          var c = this.a === h.a && this.b === h.b && this.c === h.c && this.d === h.d, l = this.a === -h.a && this.b === -h.b && this.c === -h.c && this.d === -h.d;
          return c || l;
        }
      }]), n;
    }();
    s.fromPointAndNormal = function(n, o) {
      var h = o.x, c = o.y, l = o.z, u = -(n.x * h + n.y * c + n.z * l);
      return new s(o.x, o.y, o.z, u);
    }, s.fromPoints = function(n) {
      for (var o, h = 0, c = n.length; h < c; ++h) {
        var l = n[(h + 1) % c].sub(n[h]), u = n[(h + 2) % c].sub(n[(h + 1) % c]), f = l.cross(u);
        if (!(isNaN(f.length()) || f.length() === 0))
          if (!o)
            o = f.norm();
          else {
            var d = f.norm().equals(o, 1e-6), p = f.neg().norm().equals(o, 1e-6);
            if (!(d || p))
              throw Error("points not on a plane");
          }
      }
      if (!o)
        throw Error("points not on a plane");
      return s.fromPointAndNormal(n[0], o.norm());
    };
    var i = s;
    a.default = i;
  }(ps)), ps;
}
var xs = {}, qa;
function Iu() {
  return qa || (qa = 1, function(a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.default = void 0;
    var t = e(kr());
    function e(h) {
      return h && h.__esModule ? h : { default: h };
    }
    function r(h, c) {
      if (!(h instanceof c))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(h, c) {
      for (var l = 0; l < c.length; l++) {
        var u = c[l];
        u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(h, u.key, u);
      }
    }
    function i(h, c, l) {
      return s(h.prototype, c), h;
    }
    var n = /* @__PURE__ */ function() {
      function h(c, l, u, f) {
        r(this, h), this.x = c, this.y = l, this.z = u, this.w = f;
      }
      return i(h, [{
        key: "applyToVec3",
        value: function(l) {
          var u = l.x, f = l.y, d = l.z, p = this.x, x = this.y, m = this.z, y = this.w, _ = y * u + x * d - m * f, b = y * f + m * u - p * d, w = y * d + p * f - x * u, M = -p * u - x * f - m * d;
          return new t.default(_ * y + M * -p + b * -m - w * -x, b * y + M * -x + w * -p - _ * -m, w * y + M * -m + _ * -x - b * -p);
        }
      }]), h;
    }();
    n.fromAxisAngle = function(h, c) {
      var l = h.norm(), u = c / 2, f = Math.sin(u);
      return new n(l.x * f, l.y * f, l.z * f, Math.cos(u));
    };
    var o = n;
    a.default = o;
  }(xs)), xs;
}
var ms = {}, Na;
function Ru() {
  return Na || (Na = 1, function(a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.default = void 0;
    var t = e(Rn());
    function e(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function r(d) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(x) {
        return typeof x;
      } : r = function(x) {
        return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
      }, r(d);
    }
    function s(d, p) {
      if (!(d instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function i(d, p) {
      for (var x = 0; x < p.length; x++) {
        var m = p[x];
        m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(d, m.key, m);
      }
    }
    function n(d, p, x) {
      return i(d.prototype, p), d;
    }
    var o = function(p, x, m) {
      var y = p.x, _ = p.y, b = x.x, w = x.y, M = m.x, A = m.y, v = (A - _) * (b - y), S = (w - _) * (M - y);
      return v > S + Number.EPSILON ? 1 : v + Number.EPSILON < S ? -1 : 0;
    }, h = function(p, x) {
      var m = p.a, y = p.b, _ = x.a, b = x.b;
      return o(m, _, b) !== o(y, _, b) && o(m, y, _) !== o(m, y, b);
    }, c = function(p, x) {
      var m = p.a.x, y = p.b.x, _ = p.a.y, b = p.b.y, w = x.a.x, M = x.b.x, A = x.a.y, v = x.b.y, S = m - y, F = w - M, T = _ - b, k = A - v, L = S * k - T * F, B = ((m * b - _ * y) * F - S * (w * v - A * M)) / L, G = ((m * b - _ * y) * k - T * (w * v - A * M)) / L;
      return isNaN(B) || isNaN(G) ? null : new t.default(B, G);
    }, l = function(p, x) {
      return Math.sqrt(Math.pow(p.x - x.x, 2) + Math.pow(p.y - x.y, 2));
    }, u = /* @__PURE__ */ function() {
      function d(p, x) {
        if (s(this, d), r(p) !== "object" || p.x === void 0 || p.y === void 0)
          throw Error("expected first argument to have x and y properties");
        if (r(x) !== "object" || x.x === void 0 || x.y === void 0)
          throw Error("expected second argument to have x and y properties");
        this.a = new t.default(p), this.b = new t.default(x);
      }
      return n(d, [{
        key: "length",
        value: function() {
          return this.a.sub(this.b).length();
        }
      }, {
        key: "intersects",
        value: function(x) {
          if (!(x instanceof d))
            throw new Error("expected argument to be an instance of vecks.Line2");
          return h(this, x);
        }
      }, {
        key: "getIntersection",
        value: function(x) {
          return this.intersects(x) ? c(this, x) : null;
        }
      }, {
        key: "containsPoint",
        value: function(x) {
          var m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e-12;
          return Math.abs(l(this.a, this.b) - l(x, this.a) - l(x, this.b)) < m;
        }
      }]), d;
    }(), f = u;
    a.default = f;
  }(ms)), ms;
}
var ys = {}, Ha;
function Lu() {
  return Ha || (Ha = 1, function(a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.default = void 0;
    var t = e(kr());
    function e(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function r(l) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(f) {
        return typeof f;
      } : r = function(f) {
        return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
      }, r(l);
    }
    function s(l, u) {
      if (!(l instanceof u))
        throw new TypeError("Cannot call a class as a function");
    }
    function i(l, u) {
      for (var f = 0; f < u.length; f++) {
        var d = u[f];
        d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(l, d.key, d);
      }
    }
    function n(l, u, f) {
      return i(l.prototype, u), l;
    }
    var o = function(u, f) {
      return Math.sqrt(Math.pow(u.x - f.x, 2) + Math.pow(u.y - f.y, 2) + Math.pow(u.z - f.z, 2));
    }, h = /* @__PURE__ */ function() {
      function l(u, f) {
        if (s(this, l), r(u) !== "object" || u.x === void 0 || u.y === void 0 || u.z === void 0)
          throw Error("expected first argument to have x, y and z properties");
        if (r(f) !== "object" || f.x === void 0 || f.y === void 0 || f.y === void 0)
          throw Error("expected second argument to have x, y and z properties");
        this.a = new t.default(u), this.b = new t.default(f);
      }
      return n(l, [{
        key: "length",
        value: function() {
          return this.a.sub(this.b).length();
        }
      }, {
        key: "containsPoint",
        value: function(f) {
          var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e-12;
          return Math.abs(o(this.a, this.b) - o(f, this.a) - o(f, this.b)) < d;
        }
      }]), l;
    }(), c = h;
    a.default = c;
  }(ys)), ys;
}
var Va;
function xc() {
  return Va || (Va = 1, function(a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), Object.defineProperty(a, "V2", {
      enumerable: !0,
      get: function() {
        return t.default;
      }
    }), Object.defineProperty(a, "V3", {
      enumerable: !0,
      get: function() {
        return e.default;
      }
    }), Object.defineProperty(a, "Box2", {
      enumerable: !0,
      get: function() {
        return r.default;
      }
    }), Object.defineProperty(a, "Box3", {
      enumerable: !0,
      get: function() {
        return s.default;
      }
    }), Object.defineProperty(a, "Plane3", {
      enumerable: !0,
      get: function() {
        return i.default;
      }
    }), Object.defineProperty(a, "Quaternion", {
      enumerable: !0,
      get: function() {
        return n.default;
      }
    }), Object.defineProperty(a, "Line2", {
      enumerable: !0,
      get: function() {
        return o.default;
      }
    }), Object.defineProperty(a, "Line3", {
      enumerable: !0,
      get: function() {
        return h.default;
      }
    });
    var t = c(Rn()), e = c(kr()), r = c(Cu()), s = c(Bu()), i = c(Du()), n = c(Iu()), o = c(Ru()), h = c(Lu());
    function c(l) {
      return l && l.__esModule ? l : { default: l };
    }
  }(cs)), cs;
}
var ja;
function Ou() {
  return ja || (ja = 1, function(a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.default = void 0;
    var t = xc(), e = function(s, i, n, o) {
      o || (o = 5);
      var h, c, l;
      n < 0 ? (h = Math.atan(-n) * 4, c = new t.V2(s[0], s[1]), l = new t.V2(i[0], i[1])) : (h = Math.atan(n) * 4, c = new t.V2(i[0], i[1]), l = new t.V2(s[0], s[1]));
      var u = l.sub(c), f = u.length(), d = c.add(u.multiply(0.5)), p = Math.abs(f / 2 / Math.tan(h / 2)), x = u.norm(), m;
      if (h < Math.PI) {
        var y = new t.V2(x.x * Math.cos(Math.PI / 2) - x.y * Math.sin(Math.PI / 2), x.y * Math.cos(Math.PI / 2) + x.x * Math.sin(Math.PI / 2));
        m = d.add(y.multiply(-p));
      } else {
        var _ = new t.V2(x.x * Math.cos(Math.PI / 2) - x.y * Math.sin(Math.PI / 2), x.y * Math.cos(Math.PI / 2) + x.x * Math.sin(Math.PI / 2));
        m = d.add(_.multiply(p));
      }
      var b = Math.atan2(l.y - m.y, l.x - m.x) / Math.PI * 180, w = Math.atan2(c.y - m.y, c.x - m.x) / Math.PI * 180;
      w < b && (w += 360);
      for (var M = l.sub(m).length(), A = Math.floor(b / o) * o + o, v = Math.ceil(w / o) * o - o, S = [], F = A; F <= v; F += o)
        S.push(m.add(new t.V2(Math.cos(F / 180 * Math.PI) * M, Math.sin(F / 180 * Math.PI) * M)));
      return n < 0 && S.reverse(), S.map(function(T) {
        return [T.x, T.y];
      });
    };
    a.default = e;
  }(hs)), hs;
}
var qu = Ou();
const Nu = /* @__PURE__ */ In(qu);
class Fr extends Bt {
  constructor(t) {
    super(t);
  }
  /**
   * It filters all the line, polyline and lwpolylin entities and draw them.
   * @param data {DXFData} dxf parsed data.
      * @return {THREE.Group} ThreeJS object with all the generated geometry. DXF entity is added into userData
  */
  draw(t) {
    let e = new it();
    e.name = "LINES";
    let r = t.entities.filter((s) => s.type === "LINE" || s.type === "POLYLINE" || s.type === "LWPOLYLINE");
    if (r.length === 0) return null;
    for (let s = 0; s < r.length; s++) {
      let i = r[s];
      if (this._hideEntity(i)) continue;
      let n = this._getCached(i), o = null, h = null;
      if (n)
        o = n.geometry, h = n.material;
      else {
        let l = i.type === "LINE" ? this.drawLine(i) : this.drawPolyLine(i);
        o = l.geometry, h = l.material, this._setCache(i, l);
      }
      let c = new Ft(o, h);
      h.type === "LineDashedMaterial" && this._geometryHelper.fixMeshToDrawDashedLines(c), c.userData = { entity: i }, e.add(c);
    }
    return e;
  }
  /**
   * Draws a line entity.
   * @param entity {entity} dxf parsed line entity.
      * @return {Object} object composed as {geometry: THREE.Geometry, material: THREE.Material}
  */
  drawLine(t, e = 1) {
    let r = "line";
    if (t.lineTypeName) {
      let n = this.data.tables.ltypes[t.lineTypeName];
      n && n.pattern.length > 0 && (r = "dashed");
    }
    let s = this._colorHelper.getMaterial(t, r, this.data.tables), i = new ht().setFromPoints([
      new g(e * t.start.x, t.start.y, t.start.z),
      new g(e * t.end.x, t.end.y, t.end.z)
    ]);
    return i.setIndex(new K(new Uint16Array([0, 1]), 1)), { geometry: i, material: s };
  }
  /**
   * Draws a polyline or lwpolyline entity.
   * @param entity {entity} dxf parsed polyline or lwpolyline entity.
      * @return {Object} object composed as {geometry: THREE.Geometry, material: THREE.Material}
  */
  drawPolyLine(t) {
    let e = "line";
    if (t.lineTypeName) {
      let n = this.data.tables.ltypes[t.lineTypeName];
      n && n.pattern.length > 0 && (e = "dashed");
    }
    let r = this._colorHelper.getMaterial(t, e, this.data.tables), s = this._getPolyLinePoints(t.vertices, t.closed), i = new ht().setFromPoints(s);
    return i.setIndex(new K(new Uint16Array(this._geometryHelper.generatePointIndex(s)), 1)), { geometry: i, material: r };
  }
  _getPolyLinePoints(t, e, r = 1) {
    let s = [];
    for (let i = 0, n = t.length; i < n - 1; ++i) {
      let o = t[i], h = t[i + 1], c = t[i].bulge, l = new g(o.x, o.y, o.z), u = new g(h.x, h.y, h.z);
      if (s.push(l), c) {
        let f = Nu([l.x, l.y, l.z], [u.x, u.y, u.z], c);
        for (let d = 0, p = f.length; d < p; ++d) {
          const x = f[d];
          s.push(new g(r * x[0], x[1], x.length > 2 ? x[2] : 0));
        }
      }
      i === n - 2 && s.push(u);
    }
    return e && s.push(s[0]), s;
  }
}
class Ln extends Bt {
  constructor(t) {
    super(t);
  }
  /**
   * It filters all the solid entities and draw them.
   * @param data {DXFData} dxf parsed data.
      * @return {THREE.Group} ThreeJS object with all the generated geometry. DXF entity is added into userData
  */
  draw(t) {
    let e = t.entities.filter((s) => s.type === "SOLID");
    if (e.length === 0) return null;
    let r = new it();
    r.name = "SOLIDS";
    for (let s = 0; s < e.length; s++) {
      let i = e[s];
      if (this._hideEntity(i)) continue;
      let n = this._getCached(i), o = null, h = null;
      if (n)
        o = n.geometry, h = n.material;
      else {
        let l = this.drawSolid(i);
        o = l.geometry, h = l.material, this._setCache(i, l);
      }
      let c = new Pt(o, h);
      c.userData = { entity: i }, r.add(c);
    }
    return r;
  }
  /**
   * Draws a solid entity.
   * @param entity {entity} dxf parsed solid entity.
      * @return {Object} object composed as {geometry: THREE.Geometry, material: THREE.Material}
  */
  drawSolid(t) {
    let e = this._colorHelper.getMaterial(t, "shape", this.data.tables), r = t.corners.map((n) => new g(n.x, n.y, n.z));
    r.splice(0, 0, r.pop());
    const s = new Jt(r);
    let i = new Ve(s);
    return this._extrusionTransform(t, i), { geometry: i, material: e };
  }
  _extrusionTransform(t, e) {
    t.extrusionZ < 0 && e.scale(-1, 1, 1);
  }
}
class mc extends Bt {
  constructor(t) {
    super(t);
  }
  /**
   * It filters all the circle, arc and ellipse entities and draw them.
   * @param data {DXFData} dxf parsed data.
      * @return {THREE.Group} ThreeJS object with all the generated geometry. DXF entity is added into userData
  */
  draw(t) {
    let e = t.entities.filter((s) => s.type === "ARC" || s.type === "CIRCLE" || s.type === "ELLIPSE");
    if (e.length === 0) return null;
    let r = new it();
    r.name = "CIRCLES";
    for (let s = 0; s < e.length; s++) {
      let i = e[s];
      if (this._hideEntity(i)) continue;
      let n = this._getCached(i), o = null, h = null;
      if (n)
        o = n.geometry, h = n.material;
      else {
        let l = i.type === "ELLIPSE" ? this.drawEllipse(i) : this.drawCircle(i);
        o = l.geometry, h = l.material, this._setCache(i, l);
      }
      let c = new Ft(o, h);
      h.type === "LineDashedMaterial" && this._geometryHelper.fixMeshToDrawDashedLines(c), c.userData = { entity: i }, r.add(c);
    }
    return r;
  }
  /**
   * Draws a circle or arc entity.
   * @param entity {entity} dxf parsed circle or arc entity.
      * @return {Object} object composed as {geometry: THREE.Geometry, material: THREE.Material}
  */
  drawCircle(t) {
    let e = "line";
    if (t.lineTypeName) {
      let l = this.data.tables.ltypes[t.lineTypeName];
      l && l.pattern.length > 0 && (e = "dashed");
    }
    let r = this._colorHelper.getMaterial(t, e, this.data.tables), s, i;
    if (t.type === "CIRCLE")
      s = t.startAngle || 0, i = s + 2 * Math.PI;
    else if (s = t.startAngle, i = t.endAngle, t.extrusionZ < 0) {
      let l = this._rotateXY(t.startAngle, t.endAngle);
      s = l[1], i = l[0];
    }
    let o = new Pn(
      0,
      0,
      t.r,
      s,
      i
    ).getPoints(32);
    var h = new ht().setFromPoints(o);
    h.setIndex(new K(new Uint16Array(this._geometryHelper.generatePointIndex(o)), 1));
    let c = {
      x: t.center ? t.center.x : t.x,
      y: t.center ? t.center.y : t.y,
      z: t.center ? t.center.z : t.z
    };
    return h.translate(t.extrusionZ < 0 ? -c.x : c.x, c.y, c.z), { geometry: h, material: r };
  }
  /**
   * Draws an ellipse entity.
   * @param entity {entity} dxf parsed ellipse entity.
      * @return {Object} object composed as {geometry: THREE.Geometry, material: THREE.Material}
  */
  drawEllipse(t) {
    let e = "line";
    if (t.lineTypeName) {
      let u = this.data.tables.ltypes[t.lineTypeName];
      u && u.pattern.length > 0 && (e = "dashed");
    }
    let r = this._colorHelper.getMaterial(t, e, this.data.tables), s = Math.sqrt(Math.pow(t.majorX, 2) + Math.pow(t.majorY, 2)), i = s * t.axisRatio, n = Math.atan2(t.majorY, t.majorX), o = {
      x: t.center ? t.center.x : t.x,
      y: t.center ? t.center.y : t.y,
      z: t.center ? t.center.z : t.z
    }, c = new He(
      o.x,
      o.y,
      s,
      i,
      t.startAngle,
      t.endAngle,
      !1,
      // Always counterclockwise
      n
    ).getPoints(32), l = new ht().setFromPoints(c);
    return l.setIndex(new K(new Uint16Array(this._geometryHelper.generatePointIndex(c)), 1)), this._extrusionTransform(t, l, o), { geometry: l, material: r };
  }
  _extrusionTransform(t, e, r) {
    t.extrusionZ < 0 && (e.translate(-r.x, -r.y, -r.z), e.scale(-1, 1, 1), e.translate(r.x, r.y, r.z));
  }
  _rotateXY(t, e) {
    const r = this._geometryHelper.xAxis.clone().applyAxisAngle(this._geometryHelper.zAxis, t), s = this._geometryHelper.xAxis.clone().applyAxisAngle(this._geometryHelper.zAxis, e);
    return r.applyAxisAngle(this._geometryHelper.yAxis, Math.PI), s.applyAxisAngle(this._geometryHelper.yAxis, Math.PI), [Math.atan2(r.y, r.x), Math.atan2(s.y, s.x)];
  }
}
var gs = {}, bs = {}, Ua;
function Hu() {
  return Ua || (Ua = 1, function(a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.default = void 0;
    var t = function(r, s) {
      return typeof s > "u" || +s == 0 ? Math.round(r) : (r = +r, s = +s, isNaN(r) || !(typeof s == "number" && s % 1 === 0) ? NaN : (r = r.toString().split("e"), r = Math.round(+(r[0] + "e" + (r[1] ? +r[1] - s : -s))), r = r.toString().split("e"), +(r[0] + "e" + (r[1] ? +r[1] + s : s))));
    };
    a.default = t;
  }(bs)), bs;
}
var Ga;
function Vu() {
  return Ga || (Ga = 1, function(a) {
    Object.defineProperty(a, "__esModule", {
      value: !0
    }), a.default = void 0;
    var t = e(Hu());
    function e(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var r = function(i, n, o, h, c) {
      var l = o.length, u = o[0].length;
      if (i < 0 || i > 1)
        throw new Error("t out of bounds [0,1]: " + i);
      if (n < 1) throw new Error("degree must be at least 1 (linear)");
      if (n > l - 1) throw new Error("degree must be less than or equal to point count - 1");
      if (!c) {
        c = [];
        for (var f = 0; f < l; f++)
          c[f] = 1;
      }
      if (h) {
        if (h.length !== l + n + 1) throw new Error("bad knot vector length");
      } else {
        h = [];
        for (var d = 0; d < l + n + 1; d++)
          h[d] = d;
      }
      var p = [n, h.length - 1 - n], x = h[p[0]], m = h[p[1]];
      i = i * (m - x) + x, i = Math.max(i, x), i = Math.min(i, m);
      var y;
      for (y = p[0]; y < p[1] && !(i >= h[y] && i <= h[y + 1]); y++)
        ;
      for (var _ = [], b = 0; b < l; b++) {
        _[b] = [];
        for (var w = 0; w < u; w++)
          _[b][w] = o[b][w] * c[b];
        _[b][u] = c[b];
      }
      for (var M, A = 1; A <= n + 1; A++)
        for (var v = y; v > y - n - 1 + A; v--) {
          M = (i - h[v]) / (h[v + n + 1 - A] - h[v]);
          for (var S = 0; S < u + 1; S++)
            _[v][S] = (1 - M) * _[v - 1][S] + M * _[v][S];
        }
      for (var F = [], T = 0; T < u; T++)
        F[T] = (0, t.default)(_[y][T] / _[y][u], -9);
      return F;
    };
    a.default = r;
  }(gs)), gs;
}
var ju = Vu();
const Uu = /* @__PURE__ */ In(ju);
class On extends Bt {
  constructor(t) {
    super(t);
  }
  /**
   * It filters all the spline entities and draw them.
   * @param data {DXFData} dxf parsed data.
      * @return {THREE.Group} ThreeJS object with all the generated geometry. DXF entity is added into userData
  */
  draw(t) {
    let e = t.entities.filter((s) => s.type === "SPLINE");
    if (e.length === 0) return null;
    let r = new it();
    r.name = "SPLINES";
    for (let s = 0; s < e.length; s++) {
      let i = e[s];
      if (this._hideEntity(i)) continue;
      let n = this._getCached(i), o = null, h = null;
      if (n)
        o = n.geometry, h = n.material;
      else {
        let l = this.drawSpline(i);
        o = l.geometry, h = l.material, this._setCache(i, l);
      }
      let c = new Ft(o, h);
      h.type === "LineDashedMaterial" && this._geometryHelper.fixMeshToDrawDashedLines(c), c.userData = { entity: i }, r.add(c);
    }
    return r;
  }
  /**
   * Draws a spline entity.
   * @param entity {entity} dxf parsed spline entity.
      * @return {Object} object composed as {geometry: THREE.Geometry, material: THREE.Material}
  */
  drawSpline(t) {
    let e = "line";
    if (t.lineTypeName) {
      let n = this.data.tables.ltypes[t.lineTypeName];
      n && n.pattern.length > 0 && (e = "dashed");
    }
    let r = this._colorHelper.getMaterial(t, e, this.data.tables);
    var s = this.getBSplinePolyline(t.controlPoints, t.degree, t.knots, t.weights);
    let i = new ht().setFromPoints(s);
    return i.setIndex(new K(new Uint16Array(this._geometryHelper.generatePointIndex(s)), 1)), { geometry: i, material: r };
  }
  getBSplinePolyline(t, e, r, s = null, i = 25) {
    const n = [], o = t.map(function(l) {
      return [l.x, l.y];
    }), h = [r[e]], c = [r[e], r[r.length - 1 - e]];
    for (let l = e + 1; l < r.length - e; ++l)
      h[h.length - 1] !== r[l] && h.push(r[l]);
    for (let l = 1; l < h.length; ++l) {
      const u = h[l - 1], f = h[l];
      for (let d = 0; d <= i; ++d) {
        let x = (d / i * (f - u) + u - c[0]) / (c[1] - c[0]);
        x = Math.max(x, 0), x = Math.min(x, 1);
        const m = Uu(x, e, o, r, s);
        n.push(new g(m[0], m[1], 0));
      }
    }
    return n;
  }
}
class yc extends Bt {
  constructor(t, e) {
    super(t), this._font = e, this._lineEntity = new Fr(t), this._splineEntity = new On(t), this._patternHelper = {
      dir: new g(0, 1, 0)
    };
  }
  /**
   * It filters all the hatch entities and draw them.
   * @param data {DXFData} dxf parsed data.
      * @return {THREE.Group} ThreeJS object with all the generated geometry. DXF entity is added into userData
  */
  draw(t) {
    let e = new it();
    e.name = "HATCHES";
    let r = t.entities.filter((s) => s.type === "HATCH");
    if (r.length === 0) return null;
    for (let s = 0; s < r.length; s++) {
      let i = r[s];
      if (this._hideEntity(i)) continue;
      let n = this._getCached(i), o = null, h = null;
      if (n)
        o = n.geometry, h = n.material;
      else {
        let c = this.drawHatch(i);
        o = c.geometry, h = c.material, this._setCache(i, c);
      }
      if (o) {
        let c = new Pt(o, h);
        c.userData = { entity: i }, c.renderOrder = i.fillType === "SOLID" ? -1 : 0, c.position.z = i.fillType === "SOLID" ? -0.1 : 0, e.add(c);
      }
    }
    return e;
  }
  /**
   * Draws a hatch entity.
   * @param entity {entity} dxf parsed hatch entity.
      * @return {Object} object composed as {geometry: THREE.Geometry, material: THREE.Material}
  */
  drawHatch(t) {
    let e = null, r = null;
    return this._calculatePoints(t), e = this._generateBoundary(t), t.fillType === "SOLID" ? r = this._colorHelper.getMaterial(t, "shape", this.data.tables) : t.fillType === "PATTERN" && (r = this._getPatternMaterial(t)), e && this._extrusionTransform(t, e), { geometry: e, material: r };
  }
  _calculatePoints(t) {
    const e = t.boundary;
    for (let r = 0; r < e.count; r++) {
      const s = e.loops[r];
      for (let i = 0; i < s.entities.length; i++) {
        let n = s.entities[i];
        if (!(!n || !n.type))
          switch (n.type) {
            case "LINE":
              this._getLinePoints(n);
              break;
            case "POLYLINE":
              this._getPolyLinePoints(n);
              break;
            case "ARC":
              this._getArcPoints(n, t);
              break;
            case "ELLIPSE":
              this._getEllipsePoints(n);
              break;
            case "SPLINE":
              this._getSplinePoints(n);
              break;
          }
      }
    }
  }
  _getPatternMaterial(t) {
    if (this.__cachedPatternMaterial) return this.__cachedPatternMaterial;
    const e = t.pattern;
    return this._patternHelper.dir.applyAxisAngle(new g(0, 0, 1), e.angle * Math.PI / 180), this.__cachedPatternMaterial = new Ne(), this.__cachedPatternMaterial.transparent = !0, this.__cachedPatternMaterial.color.setHex(this._colorHelper._getColorHex(t, this.data.tables.layers)), this.__cachedPatternMaterial.color.convertSRGBToLinear(), this.__cachedPatternMaterial.onBeforeCompile = (r) => {
      r.vertexShader = `
			  varying vec4 vPos;
			  varying vec4 vCenter;
			  ${r.vertexShader}
			`.replace("#include <begin_vertex>", `
						#include <begin_vertex>
						vPos = modelMatrix * vec4(position, 1.);
						vCenter = modelMatrix * vec4(0);
			`), r.fragmentShader = `
			  #define ss(a, b, c) smoothstep(a, b, c)
			  varying vec4 vPos;
			  varying vec4 vCenter;
			  ${r.fragmentShader}
			`.replace("vec4 diffuseColor = vec4( diffuse, opacity );", `
			  vec3 col = diffuse;
			  vec3 dir = normalize(vec3(${this._patternHelper.dir.x}, ${this._patternHelper.dir.y}, 0.));
			  float dist = fract(dot(vPos.xyz * 2., dir));
			  float fw = length(fwidth(vPos.xy));
			  float line_size = 0.3;
			  float empty_size = 1.0 - line_size;
			  float f = ss(line_size - fw, line_size, dist) - ss(empty_size, empty_size + fw, dist);
			  col = mix(col , col * 0., f);
			  vec4 diffuseColor = vec4( col, opacity );
			  `);
    }, this.__cachedPatternMaterial;
  }
  _getLinePoints(t) {
    t.points = [], t.points.push(new g(t.start.x, t.start.y, 0)), t.points.push(new g(t.end.x, t.end.y, 0));
  }
  _getPolyLinePoints() {
  }
  _getArcPoints(t, e) {
    t.points = [];
    let r = t.startAngle * Math.PI / 180, s = t.endAngle * Math.PI / 180;
    if (!t.counterClockWise && e.extrusionDir.z > 0) {
      const o = -r;
      r = -s, s = o;
    }
    let n = new Pn(
      t.center.x,
      t.center.y,
      t.radius,
      r,
      s,
      !1
    ).getPoints(32);
    for (let o = 0; o < n.length; o++) t.points.push(new g(n[o].x, n[o].y, 0));
  }
  _getEllipsePoints(t) {
    t.points = [];
    let e = t.startAngle * Math.PI / 180, r = t.endAngle * Math.PI / 180, i = new He(
      t.center.x,
      t.center.y,
      t.major.x,
      t.major.y,
      e,
      r,
      !1,
      // Always counterclockwise
      t.minor
    ).getPoints(32);
    for (let n = 0; n < i.length; n++) t.points.push(new g(i[n].x, i[n].y, 0));
  }
  _getSplinePoints(t) {
    t.points = this._splineEntity.getBSplinePolyline(
      t.controlPoints.points,
      t.degree,
      t.knots.knots,
      t.weights
    );
  }
  _generateBoundary(t) {
    const e = t.boundary;
    this._calculateBoxes(e);
    const r = this._getBiggestLoop(e), s = e.loops.filter((o) => o !== r && this._isLoopHole(o, t.style));
    if (this._mergeLoopPoints(r).length === 0) return null;
    const n = new Jt();
    n.setFromPoints(this._mergeLoopPoints(r));
    for (let o = 0; o < s.length; o++) {
      const h = this._mergeLoopPoints(s[o]);
      if (h.length === 0) continue;
      const c = new Jt();
      c.setFromPoints(h), n.holes.push(c);
    }
    return new Ve(n);
  }
  _calculateBoxes(t) {
    for (let e = 0; e < t.loops.length; e++) {
      const r = t.loops[e];
      r.box = this._getLoopBox(r);
    }
  }
  _getLoopBox(t) {
    let e = new g(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), r = new g(Number.MIN_VALUE, Number.MIN_VALUE, Number.MIN_VALUE);
    for (let s = 0; s < t.entities.length; s++) {
      const i = t.entities[s];
      for (let n = 0; n < i.points.length; n++) {
        const o = i.points[n];
        e.min(o), r.max(o);
      }
    }
    return new zt(e, r);
  }
  _getBiggestLoop(t) {
    if (t.loops.length === 1) return t.loops[0];
    let e = t.loops[0], r = this._getLoopArea(e);
    for (let s = 1; s < t.loops.length; s++) {
      const i = t.loops[s], n = this._getLoopArea(i);
      n > r && (e = i, r = n);
    }
    return e;
  }
  _getLoopArea(t) {
    let e = 0;
    const r = t.box;
    return e = (r.max.x - r.min.x) * (r.max.y - r.min.y), e;
  }
  _mergeLoopPoints(t) {
    let e = [];
    const r = this._orderEntityPoints(t.entities);
    if (!r)
      return console.warn("loops with separated entities not supproted yet"), e;
    for (let s = 0; s < r.length; s++) {
      const i = r[s];
      if (i)
        if (i.type === "POLYLINE") {
          let n = this._lineEntity._getPolyLinePoints(i.points, i.closed);
          e = e.concat(n);
        } else {
          if (!i.points) continue;
          let n = e.length > 0 ? e[e.length - 1] : null;
          for (let o = 0; o < i.points.length; o++) {
            const h = i.points[o];
            o === 0 && n && n.x === h.x && n.y === h.y || e.push(h);
          }
        }
    }
    return e;
  }
  _orderEntityPoints(t) {
    let e = [];
    e.push(t[0]);
    let r = e[0];
    for (; e.length < t.length; ) {
      let s = r.points[0], i = r.points[r.points.length - 1];
      const n = e.length;
      for (let o = e.length; o < t.length; o++) {
        const h = t[o];
        if (h) {
          if (this._samePoints(i, h.points[0])) {
            e.push(h), r = h;
            break;
          }
          if (this._samePoints(i, h.points[h.points.length - 1])) {
            h.points.reverse(), e.push(h), r = h;
            break;
          }
          if (this._samePoints(s, h.points[0])) {
            for (let c = 0; c < e.length; c++) e[c].points.reverse();
            e.push(h), r = h;
            break;
          }
          if (this._samePoints(s, h.points[h.points.length - 1])) {
            for (let c = 0; c < e.length; c++) e[c].points.reverse();
            h.points.reverse(), e.push(h), r = h;
            break;
          }
        }
      }
      if (n === e.length)
        return null;
    }
    return e;
  }
  _samePoints(t, e) {
    return t.distanceTo(e) < 1e-4;
  }
  _isLoopHole(t, e) {
    return e === 1 ? (t.type & 16) === 16 && (t.type & 1) !== 1 : !0;
  }
  _isLoopOuter(t) {
    return (t.type & 1) === 1 && (t.type & 16) !== 16;
  }
  _extrusionTransform(t, e) {
    t.extrusionDir.z < 0 && e && e.scale(-1, 1, 1);
  }
}
function Xa(a, t = !1) {
  const e = a[0].index !== null, r = new Set(Object.keys(a[0].attributes)), s = new Set(Object.keys(a[0].morphAttributes)), i = {}, n = {}, o = a[0].morphTargetsRelative, h = new ht();
  let c = 0;
  for (let l = 0; l < a.length; ++l) {
    const u = a[l];
    let f = 0;
    if (e !== (u.index !== null))
      return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + l + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them."), null;
    for (const d in u.attributes) {
      if (!r.has(d))
        return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + l + '. All geometries must have compatible attributes; make sure "' + d + '" attribute exists among all geometries, or in none of them.'), null;
      i[d] === void 0 && (i[d] = []), i[d].push(u.attributes[d]), f++;
    }
    if (f !== r.size)
      return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + l + ". Make sure all geometries have the same number of attributes."), null;
    if (o !== u.morphTargetsRelative)
      return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + l + ". .morphTargetsRelative must be consistent throughout all geometries."), null;
    for (const d in u.morphAttributes) {
      if (!s.has(d))
        return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + l + ".  .morphAttributes must be consistent throughout all geometries."), null;
      n[d] === void 0 && (n[d] = []), n[d].push(u.morphAttributes[d]);
    }
    if (t) {
      let d;
      if (e)
        d = u.index.count;
      else if (u.attributes.position !== void 0)
        d = u.attributes.position.count;
      else
        return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + l + ". The geometry must have either an index or a position attribute"), null;
      h.addGroup(c, d, l), c += d;
    }
  }
  if (e) {
    let l = 0;
    const u = [];
    for (let f = 0; f < a.length; ++f) {
      const d = a[f].index;
      for (let p = 0; p < d.count; ++p)
        u.push(d.getX(p) + l);
      l += a[f].attributes.position.count;
    }
    h.setIndex(u);
  }
  for (const l in i) {
    const u = Ya(i[l]);
    if (!u)
      return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + l + " attribute."), null;
    h.setAttribute(l, u);
  }
  for (const l in n) {
    const u = n[l][0].length;
    if (u === 0) break;
    h.morphAttributes = h.morphAttributes || {}, h.morphAttributes[l] = [];
    for (let f = 0; f < u; ++f) {
      const d = [];
      for (let x = 0; x < n[l].length; ++x)
        d.push(n[l][x][f]);
      const p = Ya(d);
      if (!p)
        return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + l + " morphAttribute."), null;
      h.morphAttributes[l].push(p);
    }
  }
  return h;
}
function Ya(a) {
  let t, e, r, s = -1, i = 0;
  for (let c = 0; c < a.length; ++c) {
    const l = a[c];
    if (t === void 0 && (t = l.array.constructor), t !== l.array.constructor)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes."), null;
    if (e === void 0 && (e = l.itemSize), e !== l.itemSize)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes."), null;
    if (r === void 0 && (r = l.normalized), r !== l.normalized)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes."), null;
    if (s === -1 && (s = l.gpuType), s !== l.gpuType)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes."), null;
    i += l.count * e;
  }
  const n = new t(i), o = new K(n, e, r);
  let h = 0;
  for (let c = 0; c < a.length; ++c) {
    const l = a[c];
    if (l.isInterleavedBufferAttribute) {
      const u = h / e;
      for (let f = 0, d = l.count; f < d; f++)
        for (let p = 0; p < e; p++) {
          const x = l.getComponent(f, p);
          o.setComponent(f + u, p, x);
        }
    } else
      n.set(l.array, h);
    h += l.count * e;
  }
  return s !== void 0 && (o.gpuType = s), o;
}
class Gu {
  constructor() {
  }
  /**
   * Returns a merged scene. Setting clone to true avoids changing original geometry, but its permormance is lower
   * @param scene {THREE.Object3D} Threejs object (usually the scene itself).
   * @param clone {boolean} Flag to change cloning of scene.
   * @param uuids {Array} Array of uuids to merge only specific objects.
      * @return {THREE.Object3D} object with merged data
  */
  merge(t, e = !0, r = []) {
    let { mesh: s, line: i } = this._getMergedObjects(t, e, r);
    if ((s || i) && t.userData && t.userData.entity) {
      let n = t.userData.entity.scaleX ? t.userData.entity.scaleX : 1, o = t.userData.entity.scaleY ? t.userData.entity.scaleY : 1, h = t.userData.entity.scaleZ ? t.userData.entity.scaleZ : 1;
      s && (s.scale.set(n, o, h), t.userData.entity.rotation && (s.rotation.z = t.userData.entity.rotation * Math.PI / 180), s.position.set(t.userData.entity.x, t.userData.entity.y, t.userData.entity.z), t.add(s)), i && (i.scale.set(n, o, h), t.userData.entity.rotation && (i.rotation.z = t.userData.entity.rotation * Math.PI / 180), i.position.set(t.userData.entity.x, t.userData.entity.y, t.userData.entity.z), t.add(i));
    } else
      s && t.add(s), i && t.add(i);
    return this._removeEmptyGroups(t), t;
  }
  _getMergedObjects(t, e, r) {
    let { mesh: s, line: i } = this._getMergedGeometry(t, e, r);
    const n = s.geometry ? new Pt(s.geometry, s.materials) : null, o = i.geometry ? new En(i.geometry, i.materials) : null;
    return n && (n.userData = { entities: s.userData, entity: t.userData.entity }), o && (o.userData = { entities: i.userData, entity: t.userData.entity }), { mesh: n, line: o };
  }
  _getMergedGeometry(t, e, r) {
    let s = [], i = [], n = [], o = [], h = null;
    t.updateWorldMatrix(!1, !0);
    let c = {};
    r.forEach((f) => c[f] = !0), this._removableTraverse(t, (f) => {
      if (!(f.isMesh || f.isLineSegments || f.isLine) || r.length > 0 && !c[f.uuid]) return;
      let d = e ? f.geometry.clone() : f.geometry;
      if (d.applyMatrix4(f.matrixWorld), f.isMesh) {
        d.index && (d = d.toNonIndexed()), d.hasAttribute("normal") || d.computeVertexNormals();
        let m = d.getAttribute("uv");
        if (m || (m = new K(new Float32Array(d.attributes.position.count * 2), 2), d.setAttribute("uv", m)), d.attributes.uv.itemSize > 2) {
          let y = new K(new Float32Array(d.attributes.uv.count * 2), 2);
          for (let _ = 0; _ < d.attributes.uv.count; _++)
            y.set(d.attributes.uv.getX(_), _ * 2), y.set(d.attributes.uv.getY(_), _ * 2 + 1);
          d.deleteAttribute("uv"), d.setAttribute("uv", y);
        }
        h = n;
      } else
        f.geometry.index && (f.geometry = f.geometry.toNonIndexed()), f.computeLineDistances(), d = f.geometry.clone(), d.applyMatrix4(f.matrixWorld), this._indexLineGeometry(d), d.deleteAttribute("uv"), d.deleteAttribute("normal"), h = o;
      h.push({ uuid: f.uuid, userData: f.userData });
      let p = f.isMesh ? s : i, x = this._findGroup(p, f.material);
      x || (x = {
        material: f.material,
        geometries: []
      }, p.push(x)), x.geometries.push(d), d.ent = f, f.parent && f.parent.remove(f);
    });
    let l = s.length > 0 ? this._mergeByMaterial(s) : null, u = i.length > 0 ? this._mergeByMaterial(i) : null;
    return {
      mesh: {
        geometry: l ? l.geometry : null,
        materials: l ? l.materials : null,
        userData: n
      },
      line: {
        geometry: u ? u.geometry : null,
        materials: u ? u.materials : null,
        userData: o
      }
    };
  }
  _mergeByMaterial(t) {
    let e = t.map((s) => s.material);
    return {
      geometry: Xa(
        t.map((s) => Xa(s.geometries, !1)),
        !0
      ),
      materials: e
    };
  }
  _removeEmptyGroups(t) {
    for (let e = t.children.length - 1; e > -1; e--) {
      let r = t.children[e];
      this._removeEmptyGroups(r), r.isGroup && r.children.length === 0 && t.remove(r);
    }
  }
  _indexLineGeometry(t) {
    let e = [], r = t.attributes.position.count;
    for (let s = 0; s < r; s++)
      s > 0 && (e.push(s - 1), e.push(s));
    t.setIndex(new K(new Uint16Array(e), 1));
  }
  //USE THIS INSTEAD OF Array.find: FOR BETTER PERFORMANCE
  _findGroup(t, e) {
    for (let r = 0; r < t.length; r++)
      if (t[r].material === e) return t[r];
    return null;
  }
  _removableTraverse(t, e) {
    for (let r = t.children.length - 1; r > -1; r--)
      this._removableTraverse(t.children[r], e);
    e(t);
  }
}
class Xu extends Gu {
  constructor() {
    super();
  }
  // @override
  merge(t, e = !0, r = []) {
    let { mesh: s, line: i } = this._getMergedObjects(t, e, r);
    if ((s || i) && t.userData && t.userData.entity) {
      let n = t.userData.entity.scaleX ? t.userData.entity.scaleX : 1, o = t.userData.entity.scaleY ? t.userData.entity.scaleY : 1, h = t.userData.entity.scaleZ ? t.userData.entity.scaleZ : 1;
      s && (s.scale.set(n, o, h), t.userData.entity.rotation && (s.rotation.z = t.userData.entity.rotation * Math.PI / 180), s.position.set(t.userData.entity.x, t.userData.entity.y, t.userData.entity.z), t.add(s)), i && (i.scale.set(n, o, h), t.userData.entity.rotation && (i.rotation.z = t.userData.entity.rotation * Math.PI / 180), i.position.set(t.userData.entity.x, t.userData.entity.y, t.userData.entity.z), t.add(i));
    } else
      s && s.add(s), i && t.add(i);
    return this._removeEmptyGroups(t), t;
  }
  // @override 
  _getMergedObjects(t, e, r) {
    let { mesh: s, line: i } = this._getMergedGeometry(t, e, r);
    const n = s.geometry ? new Pt(s.geometry, s.materials) : null, o = i.geometry ? new En(i.geometry, i.materials) : null;
    return n && (n.userData = { entities: s.userData, entity: t.userData.entity }), o && (o.userData = { entities: i.userData, entity: t.userData.entity }), { mesh: n, line: o };
  }
}
class gc extends Bt {
  constructor(t, e) {
    super(t), this._font = e, this._lineEntity = new Fr(t, e), this._textEntity = new Dn(t, e), this._solidEntity = new Ln(t), this._circleEntity = new mc(t), this._splineEntity = new On(t), this._hatchEntity = new yc(t);
  }
  /**
   * Draws the block entity.
   * @param entity {Entity} DXF block entity.
      * @return {THREE.Group} ThreeJS object with all the generated geometry. DXF entity is added into userData
  */
  drawBlock(t, e = 1) {
    let r = new it();
    r.name = "BLOCK", r.position.set(-t.x, -t.y, -t.z), r.userData = {
      entity: t,
      entities: []
    };
    for (let s = 0; s < t.entities.length; s++) {
      let i = t.entities[s];
      if (!this._hideEntity(i))
        switch (i.type) {
          case "LINE":
            {
              let n = this._lineEntity.drawLine(i, e), o = new Ft(n.geometry, n.material);
              n.material.type === "LineDashedMaterial" && this._geometryHelper.fixMeshToDrawDashedLines(o), o.userData = { entity: i }, r.add(o);
            }
            break;
          case "POLYLINE":
          case "LWPOLYLINE":
            {
              let n = this._lineEntity.drawPolyLine(i, e), o = new Ft(n.geometry, n.material);
              n.material.type === "LineDashedMaterial" && this._geometryHelper.fixMeshToDrawDashedLines(o), o.userData = { entity: i }, r.add(o);
            }
            break;
          case "ARC":
          case "CIRCLE":
            {
              let n = this._circleEntity.drawCircle(i, e), o = new Ft(n.geometry, n.material);
              n.material.type === "LineDashedMaterial" && this._geometryHelper.fixMeshToDrawDashedLines(o), o.userData = { entity: i }, r.add(o);
            }
            break;
          case "ELLIPSE":
            {
              let n = this._circleEntity.drawEllipse(i, e), o = new Ft(n.geometry, n.material);
              n.material.type === "LineDashedMaterial" && this._geometryHelper.fixMeshToDrawDashedLines(o), o.userData = { entity: i }, r.add(o);
            }
            break;
          case "SPLINE":
            {
              let n = this._splineEntity.drawSpline(i, e), o = new Ft(n.geometry, n.material);
              n.material.type === "LineDashedMaterial" && this._geometryHelper.fixMeshToDrawDashedLines(o), o.userData = { entity: i }, r.add(o);
            }
            break;
          case "SOLID":
            {
              let n = this._solidEntity.drawSolid(i, e), o = new Pt(n.geometry, n.material);
              o.userData = { entity: i }, r.add(o);
            }
            break;
          case "ATTRIB":
          case "TEXT":
          case "MTEXT":
            {
              let n = this._textEntity.drawText(i, e), o = new Pt(n.geometry, n.material);
              o.userData = { entity: i }, r.add(o);
            }
            break;
          case "INSERT":
            {
              let n = i.blockObj ? i.blockObj : this._getBlock(this.data.blocks, i.block);
              if (n && n.entities.length > 0 && !this._hideBlockEntity(n)) {
                let o = new it();
                o.name = "INSERT", o.add(this.drawBlock(n, e)), o.userData = { entity: i };
                let h = i.scaleX ? i.scaleX : 1, c = i.scaleY ? i.scaleY : 1, l = i.scaleZ ? i.scaleZ : 1;
                i.extrusionZ = i.extrusionZ < 0 ? -1 : 1, o.scale.set(i.extrusionZ * h, c, l), i.rotation && (o.rotation.z = i.extrusionZ * i.rotation * Math.PI / 180), o.position.set(i.extrusionZ * i.x, i.y, i.z), r.add(o);
              }
            }
            break;
          case "HATCH":
            {
              let n = this._hatchEntity.drawHatch(i, e);
              if (n.geometry) {
                let o = i.fillType === "SOLID" ? new Pt(n.geometry, n.material) : new En(n.geometry, n.material);
                n.material.type === "LineDashedMaterial" && this._geometryHelper.fixMeshToDrawDashedLines(o), o.userData = { entity: i }, o.renderOrder = i.fillType === "SOLID" ? -1 : 0, o.position.z = i.fillType === "SOLID" ? -0.1 : 0, r.add(o);
              }
            }
            break;
          case "POINT":
            break;
          case "ATTDEF":
            break;
          case "DIMENSION":
            break;
          default:
            console.log("unknown entity type: " + i.type);
            break;
        }
    }
    return this._mergeGroup(r), r;
  }
  _rotate(t, e) {
    !e || e === 0 || t.rotateOnAxis(this._geometryHelper.zAxis, e * Math.PI / 180);
  }
  _hideBlockEntity(t) {
    return t && t.name.toLowerCase().startsWith("*paper_space") ? !0 : this._hideEntity(t);
  }
  _mergeGroup(t) {
    const e = new Xu(), r = (n) => n.name === "BLOCK" || n.name === "INSERT" || n.name === "DIMENSION", s = [], i = [];
    for (let n = 0; n < t.children.length; n++) {
      const o = t.children[n];
      r(o) ? s.push(o) : i.push(o);
    }
    for (let n = 0; n < s.length; n++) t.remove(s[n]);
    i.length > 0 && (t.userData.entities = [], i.forEach((n) => t.userData.entities.push(n)), e.merge(t));
    for (let n = 0; n < s.length; n++) t.add(s[n]);
  }
}
class bc extends Bt {
  constructor(t, e) {
    super(t), this._font = e, this._blockEntity = new gc(t, e);
  }
  /**
   * It filters all the insert entities and draw them. Uses blockEntity.
   * @param data {DXFData} dxf parsed data.
      * @return {THREE.Group} ThreeJS object with all the generated geometry. DXF entity is added into userData
  */
  draw(t) {
    this.data = t;
    let e = t.entities.filter((s) => s.type === "INSERT");
    if (e.length === 0) return null;
    for (let s = 0; s < e.length; s++) {
      let i = e[s];
      if (typeof i.blockObj < "u") continue;
      let n = this._getBlock(this.data.blocks, i.block);
      n && (i.blockObj = n);
    }
    let r = new it();
    r.name = "INSERTS";
    for (let s = 0; s < e.length; s++) {
      let i = e[s];
      if (this._hideEntity(i)) continue;
      let n = this.drawInsert(i);
      n && r.add(n);
    }
    return r;
  }
  /**
   * Draws an insert entity.
   * @param entity {entity} dxf parsed insert entity.
      * @return {Object} object composed as {geometry: THREE.Geometry, material: THREE.Material}
  */
  drawInsert(t) {
    let e = this._getCached(t);
    if (e)
      return e;
    let r = typeof t.scaleX < "u" ? t.scaleX : 1, s = typeof t.scaleY < "u" ? t.scaleY : 1, i = typeof t.scaleZ < "u" ? t.scaleZ : 1, n = t.blockObj ? t.blockObj : this._getBlock(this.data.blocks, t.block), o = null;
    if (n && !this._blockEntity._hideBlockEntity(n)) {
      o = new it(), o.name = "INSERT", o.userData = { entity: t };
      const h = t.extrusionZ < 0 ? -1 : 1;
      o.add(this._blockEntity.drawBlock(n, h)), o.scale.set(h * r, s, i), t.rotation && (o.rotation.z = h * (t.rotation * Math.PI / 180)), o.position.set(h * t.x, t.y, t.z);
    }
    return this._setCache(t, o), o;
  }
}
class Yu extends Bt {
  constructor(t, e) {
    super(t), this._font = e, this._lineEntity = new Fr(t, e), this._textEntity = new Dn(t, e), this._insertEntity = new bc(t, e), this._solidEntity = new Ln(t), this._blockEntity = new gc(t, e);
  }
  /**
   * It filters all the dimension entities and draw them. Uses Line, Text, Insert, Solid & Block entities.
   * @param data {DXFData} dxf parsed data.
      * @return {THREE.Group} ThreeJS object with all the generated geometry. DXF entity is added into userData
  */
  draw(t) {
    let e = t.entities.filter((s) => s.type === "DIMENSION");
    if (e.length === 0) return null;
    for (let s = 0; s < e.length; s++) {
      let i = e[s], n = this._getBlock(t.blocks, i.block);
      n && (i.blockObj = n);
    }
    let r = new it();
    r.name = "DIMENSIONS";
    for (let s = 0; s < e.length; s++) {
      let i = e[s];
      if (!i.blockObj) continue;
      let n = new it();
      n.name = "DIMENSION", n.userData = { entity: i };
      let o = this._blockEntity.drawBlock(i.blockObj);
      n.add(o), r.add(n);
    }
    return r;
  }
}
function Wu() {
}
function $u() {
}
function Zu() {
  console.error.apply(void 0, arguments);
}
const te = {
  info: Wu,
  warn: $u,
  error: Zu
}, Ju = (a) => {
  let t;
  const e = {};
  return a.forEach((r) => {
    const s = r[0], i = r[1];
    switch (i) {
      case "$MEASUREMENT": {
        t = "measurement";
        break;
      }
      case "$INSUNITS": {
        t = "insUnits";
        break;
      }
      case "$EXTMIN":
        e.extMin = {}, t = "extMin";
        break;
      case "$EXTMAX":
        e.extMax = {}, t = "extMax";
        break;
      case "$DIMASZ":
        e.dimArrowSize = {}, t = "dimArrowSize";
        break;
      default:
        switch (t) {
          case "extMin":
          case "extMax": {
            switch (s) {
              case 10:
                e[t].x = i;
                break;
              case 20:
                e[t].y = i;
                break;
              case 30:
                e[t].z = i, t = void 0;
                break;
            }
            break;
          }
          case "measurement":
          case "insUnits": {
            switch (s) {
              case 70: {
                e[t] = i, t = void 0;
                break;
              }
            }
            break;
          }
          case "dimArrowSize": {
            switch (s) {
              case 40: {
                e[t] = i, t = void 0;
                break;
              }
            }
            break;
          }
        }
    }
  }), e;
}, Ku = (a) => {
  let t = null, e = null;
  return a.reduce(
    (r, s) => {
      const i = s[0], n = s[1];
      switch (i) {
        case 2:
          r.name = n;
          break;
        case 3:
          r.description = n;
          break;
        case 70:
          r.flag = n;
          break;
        case 72:
          r.alignment = n;
          break;
        case 73:
          r.elementCount = parseInt(n);
          break;
        case 40:
          r.patternLength = n;
          break;
        case 49:
          t = /* @__PURE__ */ Object.create({ scales: [], offset: [] }), t.length = n, r.pattern.push(t);
          break;
        case 74:
          t.shape = n;
          break;
        case 75:
          t.shapeNumber = n;
          break;
        case 340:
          t.styleHandle = n;
          break;
        case 46:
          t.scales.push(n);
          break;
        case 50:
          t.rotation = n;
          break;
        case 44:
          e = /* @__PURE__ */ Object.create({ x: n, y: 0 }), t.offset.push(e);
          break;
        case 45:
          e.y = n;
          break;
        case 9:
          t.text = n;
          break;
      }
      return r;
    },
    { type: "LTYPE", pattern: [] }
  );
}, Qu = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 2:
        t.name = s;
        break;
      case 6:
        t.lineTypeName = s;
        break;
      case 62:
        t.colorNumber = s;
        break;
      case 70:
        t.flags = s;
        break;
      case 290:
        t.plot = parseInt(s) !== 0;
        break;
      case 370:
        t.lineWeightEnum = s;
        break;
    }
    return t;
  },
  { type: "LAYER" }
), tf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 2:
        t.name = s;
        break;
      case 6:
        t.lineTypeName = s;
        break;
      case 40:
        t.fixedTextHeight = s;
        break;
      case 41:
        t.widthFactor = s;
        break;
      case 50:
        t.obliqueAngle = s;
        break;
      case 71:
        t.flags = s;
        break;
      case 42:
        t.lastHeightUsed = s;
        break;
      case 3:
        t.primaryFontFileName = s;
        break;
      case 4:
        t.bigFontFileName = s;
        break;
    }
    return t;
  },
  { type: "STYLE" }
), ef = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 2:
        t.name = s;
        break;
      case 5:
        t.handle = s;
        break;
      case 70:
        t.flags = s;
        break;
      case 10:
        t.lowerLeft.x = parseFloat(s);
        break;
      case 20:
        t.lowerLeft.y = parseFloat(s);
        break;
      case 11:
        t.upperRight.x = parseFloat(s);
        break;
      case 21:
        t.upperRight.y = parseFloat(s);
        break;
      case 12:
        t.center.x = parseFloat(s);
        break;
      case 22:
        t.center.y = parseFloat(s);
        break;
      case 14:
        t.snapSpacing.x = parseFloat(s);
        break;
      case 24:
        t.snapSpacing.y = parseFloat(s);
        break;
      case 15:
        t.gridSpacing.x = parseFloat(s);
        break;
      case 25:
        t.gridSpacing.y = parseFloat(s);
        break;
      case 16:
        t.direction.x = parseFloat(s);
        break;
      case 26:
        t.direction.y = parseFloat(s);
        break;
      case 36:
        t.direction.z = parseFloat(s);
        break;
      case 17:
        t.target.x = parseFloat(s);
        break;
      case 27:
        t.target.y = parseFloat(s);
        break;
      case 37:
        t.target.z = parseFloat(s);
        break;
      case 45:
        t.height = parseFloat(s);
        break;
      case 50:
        t.snapAngle = parseFloat(s);
        break;
      case 51:
        t.angle = parseFloat(s);
        break;
      case 110:
        t.x = parseFloat(s);
        break;
      case 120:
        t.y = parseFloat(s);
        break;
      case 130:
        t.z = parseFloat(s);
        break;
      case 111:
        t.xAxisX = parseFloat(s);
        break;
      case 121:
        t.xAxisY = parseFloat(s);
        break;
      case 131:
        t.xAxisZ = parseFloat(s);
        break;
      case 112:
        t.xAxisX = parseFloat(s);
        break;
      case 122:
        t.xAxisY = parseFloat(s);
        break;
      case 132:
        t.xAxisZ = parseFloat(s);
        break;
      case 146:
        t.elevation = parseFloat(s);
        break;
    }
    return t;
  },
  {
    type: "VPORT",
    center: {},
    lowerLeft: {},
    upperRight: {},
    snap: {},
    snapSpacing: {},
    gridSpacing: {},
    direction: {},
    target: {}
  }
), br = (a, t, e) => {
  const r = [];
  let s;
  return a.forEach((i) => {
    const n = i[0], o = i[1];
    (n === 0 || n === 2) && o === t ? (s = [], r.push(s)) : s.push(i);
  }), r.reduce((i, n) => {
    const o = e(n);
    return o.name && (i[o.name] = o), i;
  }, {});
}, rf = (a) => {
  const t = [];
  let e;
  a.forEach((o) => {
    const h = o[1];
    h === "TABLE" ? (e = [], t.push(e)) : h === "ENDTAB" ? t.push(e) : e.push(o);
  });
  let r = [], s = [], i = [], n = [];
  return t.forEach((o) => {
    o[0][1] === "STYLE" ? r = o : o[0][1] === "LTYPE" ? n = o : o[0][1] === "LAYER" ? s = o : o[0][1] === "VPORT" && (i = o);
  }), {
    layers: br(s, "LAYER", Qu),
    styles: br(r, "STYLE", tf),
    vports: br(i, "VPORT", ef),
    ltypes: br(n, "LTYPE", Ku)
  };
}, U = (a, t) => {
  switch (a) {
    case 5:
      return {
        handle: t
      };
    case 6:
      return {
        lineTypeName: t
      };
    case 8:
      return {
        layer: t
      };
    case 48:
      return {
        lineTypeScale: t
      };
    case 60:
      return {
        visible: t === 0
      };
    case 62:
      return {
        colorNumber: t
      };
    case 67:
      return t === 0 ? {} : {
        paperSpace: t
      };
    case 68:
      return {
        viewportOn: t
      };
    case 69:
      return {
        viewport: t
      };
    case 210:
      return {
        extrusionX: t
      };
    case 220:
      return {
        extrusionY: t
      };
    case 230:
      return {
        extrusionZ: t
      };
    case 410:
      return {
        layout: t
      };
    default:
      return {};
  }
}, _c = "POINT", sf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 10:
        t.x = s;
        break;
      case 20:
        t.y = s;
        break;
      case 30:
        t.z = s;
        break;
      case 39:
        t.thickness = s;
        break;
      default:
        Object.assign(t, U(r, s));
        break;
    }
    return t;
  },
  {
    type: _c
  }
), nf = { TYPE: _c, process: sf }, wc = "LINE", af = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 10:
        t.start.x = s;
        break;
      case 20:
        t.start.y = s;
        break;
      case 30:
        t.start.z = s;
        break;
      case 39:
        t.thickness = s;
        break;
      case 11:
        t.end.x = s;
        break;
      case 21:
        t.end.y = s;
        break;
      case 31:
        t.end.z = s;
        break;
      default:
        Object.assign(t, U(r, s));
        break;
    }
    return t;
  },
  {
    type: wc,
    start: {},
    end: {}
  }
), of = { TYPE: wc, process: af }, vc = "LWPOLYLINE", hf = (a) => {
  let t;
  return a.reduce(
    (e, r) => {
      const s = r[0], i = r[1];
      switch (s) {
        case 70:
          e.closed = (i & 1) === 1;
          break;
        case 10:
          t = {
            x: i,
            y: 0
          }, e.vertices.push(t);
          break;
        case 20:
          t.y = i;
          break;
        case 39:
          e.thickness = i;
          break;
        case 42:
          t.bulge = i;
          break;
        default:
          Object.assign(e, U(s, i));
          break;
      }
      return e;
    },
    {
      type: vc,
      vertices: []
    }
  );
}, cf = { TYPE: vc, process: hf }, Mc = "POLYLINE", lf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 70:
        t.closed = (s & 1) === 1, t.polygonMesh = (s & 16) === 16, t.polyfaceMesh = (s & 64) === 64;
        break;
      case 39:
        t.thickness = s;
        break;
      default:
        Object.assign(t, U(r, s));
        break;
    }
    return t;
  },
  {
    type: Mc,
    vertices: []
  }
), uf = { TYPE: Mc, process: lf }, ff = "VERTEX", _r = (a) => {
  a.faces = a.faces || [], "x" in a && !a.x && delete a.x, "y" in a && !a.y && delete a.y, "z" in a && !a.z && delete a.z;
}, df = (a) => a.reduce((t, e) => {
  const r = e[0], s = e[1];
  switch (r) {
    case 10:
      t.x = s;
      break;
    case 20:
      t.y = s;
      break;
    case 30:
      t.z = s;
      break;
    case 42:
      t.bulge = s;
      break;
    case 71:
      _r(t), t.faces[0] = s;
      break;
    case 72:
      _r(t), t.faces[1] = s;
      break;
    case 73:
      _r(t), t.faces[2] = s;
      break;
    case 74:
      _r(t), t.faces[3] = s;
      break;
  }
  return t;
}, {}), pf = { TYPE: ff, process: df }, Ac = "CIRCLE", xf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 10:
        t.x = s;
        break;
      case 20:
        t.y = s;
        break;
      case 30:
        t.z = s;
        break;
      case 40:
        t.r = s;
        break;
      default:
        Object.assign(t, U(r, s));
        break;
    }
    return t;
  },
  {
    type: Ac
  }
), mf = { TYPE: Ac, process: xf }, Sc = "ARC", yf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 10:
        t.x = s;
        break;
      case 20:
        t.y = s;
        break;
      case 30:
        t.z = s;
        break;
      case 39:
        t.thickness = s;
        break;
      case 40:
        t.r = s;
        break;
      case 50:
        t.startAngle = s / 180 * Math.PI;
        break;
      case 51:
        t.endAngle = s / 180 * Math.PI;
        break;
      default:
        Object.assign(t, U(r, s));
        break;
    }
    return t;
  },
  {
    type: Sc
  }
), gf = { TYPE: Sc, process: yf }, kc = "ELLIPSE", bf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 10:
        t.x = s;
        break;
      case 11:
        t.majorX = s;
        break;
      case 20:
        t.y = s;
        break;
      case 21:
        t.majorY = s;
        break;
      case 30:
        t.z = s;
        break;
      case 31:
        t.majorZ = s;
        break;
      case 40:
        t.axisRatio = s;
        break;
      case 41:
        t.startAngle = s;
        break;
      case 42:
        t.endAngle = s;
        break;
      default:
        Object.assign(t, U(r, s));
        break;
    }
    return t;
  },
  {
    type: kc
  }
), _f = { TYPE: kc, process: bf }, Fc = "SPLINE", wf = (a) => {
  let t;
  return a.reduce(
    (e, r) => {
      const s = r[0], i = r[1];
      switch (s) {
        case 10:
          t = {
            x: i,
            y: 0
          }, e.controlPoints.push(t);
          break;
        case 20:
          t.y = i;
          break;
        case 30:
          t.z = i;
          break;
        case 40:
          e.knots.push(i);
          break;
        case 41:
          e.weights || (e.weights = []), e.weights.push(i);
          break;
        case 42:
          e.knotTolerance = i;
          break;
        case 43:
          e.controlPointTolerance = i;
          break;
        case 44:
          e.fitTolerance = i;
          break;
        case 70:
          e.flag = i, e.closed = (i & 1) === 1;
          break;
        case 71:
          e.degree = i;
          break;
        case 72:
          e.numberOfKnots = i;
          break;
        case 73:
          e.numberOfControlPoints = i;
          break;
        case 74:
          e.numberOfFitPoints = i;
          break;
        default:
          Object.assign(e, U(s, i));
          break;
      }
      return e;
    },
    {
      type: Fc,
      controlPoints: [],
      knots: []
    }
  );
}, vf = { TYPE: Fc, process: wf }, Tc = "SOLID", Mf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 10:
        t.corners[0].x = s;
        break;
      case 20:
        t.corners[0].y = s;
        break;
      case 30:
        t.corners[0].z = s;
        break;
      case 11:
        t.corners[1].x = s;
        break;
      case 21:
        t.corners[1].y = s;
        break;
      case 31:
        t.corners[1].z = s;
        break;
      case 12:
        t.corners[2].x = s;
        break;
      case 22:
        t.corners[2].y = s;
        break;
      case 32:
        t.corners[2].z = s;
        break;
      case 13:
        t.corners[3].x = s;
        break;
      case 23:
        t.corners[3].y = s;
        break;
      case 33:
        t.corners[3].z = s;
        break;
      case 39:
        t.thickness = s;
        break;
      default:
        Object.assign(t, U(r, s));
        break;
    }
    return t;
  },
  {
    type: Tc,
    corners: [{}, {}, {}, {}]
  }
), Af = { TYPE: Tc, process: Mf }, Ec = "HATCH";
let Z = "IDLE", z = {}, kt = 0, Ut = !1, me = null, ot = { references: [], entities: [] }, wr = null;
const Sf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 100:
        Z = "IDLE";
        break;
      case 2:
        t.patternName = s;
        break;
      case 10:
        Z === "IDLE" ? t.elevation.x = parseFloat(s) : Z === "POLYLINE" ? (wr = {
          x: parseFloat(s),
          y: 0,
          bulge: 0
        }, ot.entities[0].points.push(wr)) : Z === "SEED" ? (me || (me = { x: 0, y: 0 }, t.seeds.seeds.push(me)), me.x = parseFloat(s)) : Te(r, kt, parseFloat(s));
        break;
      case 20:
        Z === "IDLE" ? t.elevation.y = parseFloat(s) : Z === "POLYLINE" ? wr.y = parseFloat(s) : Z === "SEED" ? (me.y = parseFloat(s), me = null) : Te(r, kt, parseFloat(s));
        break;
      case 30:
        t.elevation.z = parseFloat(s);
        break;
      case 63:
        t.fillColor = s;
        break;
      case 70:
        t.fillType = parseFloat(s) === 1 ? "SOLID" : "PATTERN";
        break;
      case 210:
        t.extrusionDir.x = parseFloat(s);
        break;
      case 220:
        t.extrusionDir.y = parseFloat(s);
        break;
      case 230:
        t.extrusionDir.z = parseFloat(s);
        break;
      case 91:
        t.boundary.count = parseFloat(s);
        break;
      case 92:
        if (ot = { references: [], entities: [] }, t.boundary.loops.push(ot), ot.type = parseFloat(s), Ut = (ot.type & 2) === 2, Ut) {
          const i = {
            type: "POLYLINE",
            points: []
          };
          ot.entities.push(i), Z = "POLYLINE";
        }
        break;
      case 93:
        Z === "IDLE" && (Z = "ENT"), ot.count = parseFloat(s);
        break;
      case 11:
      case 21:
      case 40:
      case 50:
      case 51:
      case 74:
      case 94:
      case 95:
      case 96:
        kt === 4 && (Z = "SPLINE"), Te(r, kt, parseFloat(s));
        break;
      case 42:
        Ut ? wr.bulge = parseFloat(s) : Te(r, kt, parseFloat(s));
        break;
      case 72:
        kt = parseFloat(s), ot[Ut ? "hasBulge" : "edgeType"] = kt, Ut || (z = Ff(kt), ot.entities.push(z));
        break;
      case 73:
        Z === "IDLE" || Ut ? ot.entities[0].closed = s : Te(r, kt, parseFloat(s));
        break;
      case 75:
        Z = "IDLE", t.style = parseFloat(s);
        break;
      case 76:
        t.hatchType = parseFloat(s);
        break;
      case 97:
        Z = "IDLE", Ut = !1, ot.sourceObjects = parseFloat(s);
        break;
      case 98:
        Z = "SEED", t.seeds.count = parseFloat(s);
        break;
      case 52:
        t.shadowPatternAngle = parseFloat(s);
        break;
      case 41:
        t.spacing = parseFloat(s);
        break;
      case 77:
        t.double = parseFloat(s) === 1;
        break;
      case 78:
        t.pattern.lineCount = parseFloat(s);
        break;
      case 53:
        t.pattern.angle = parseFloat(s);
        break;
      case 43:
        t.pattern.x = parseFloat(s);
        break;
      case 44:
        t.pattern.y = parseFloat(s);
        break;
      case 45:
        t.pattern.offsetX = parseFloat(s);
        break;
      case 46:
        t.pattern.offsetY = parseFloat(s);
        break;
      case 79:
        t.pattern.dashCount = parseFloat(s);
        break;
      case 49:
        t.pattern.length.push(s);
        break;
      case 330:
        ot.references.push(s);
        break;
      case 450:
        t.solidOrGradient = parseFloat(s) === 0 ? "SOLID" : "GRADIENT";
        break;
      case 453:
        t.color.count = parseFloat(s);
        break;
      case 460:
        t.color.rotation = s;
        break;
      case 461:
        t.color.gradient = s;
        break;
      case 462:
        t.color.tint = s;
        break;
      default:
        Object.assign(t, U(r, s));
        break;
    }
    return t;
  },
  {
    type: Ec,
    elevation: {},
    extrusionDir: { x: 0, y: 0, z: 1 },
    pattern: { length: [] },
    boundary: { loops: [] },
    seeds: { count: 0, seeds: [] },
    color: {}
  }
), kf = { TYPE: Ec, process: Sf };
function Ff(a) {
  if (Ut) return {};
  switch (a) {
    case 1:
      return {
        type: "LINE",
        start: { x: 0, y: 0 },
        end: { x: 0, y: 0 }
      };
    case 2:
      return {
        type: "ARC",
        center: { x: 0, y: 0 },
        radius: 0,
        startAngle: 0,
        endAngle: 0,
        counterClockWise: !1
      };
    case 3:
      return {
        type: "ELLIPSE",
        center: { x: 0, y: 0 },
        startAngle: 0,
        endAngle: 0,
        counterClockWise: !1,
        major: { x: 0, y: 0 },
        minor: 0
      };
    case 4:
      return {
        type: "SPLINE",
        degree: 0,
        rational: 0,
        periodic: 0,
        knots: { count: 0, knots: [] },
        controlPoints: { count: 0, points: [] },
        weights: 1
      };
  }
  return {};
}
function Te(a, t, e) {
  switch (a) {
    case 10:
      switch (t) {
        case 1:
          z.start.x = e;
          break;
        case 2:
          z.center.x = e;
          break;
        case 3:
          z.center.x = e;
          break;
        case 4:
          z.controlPoints.points.push({ x: e, y: 0 });
          break;
      }
      break;
    case 20: {
      switch (t) {
        case 1:
          z.start.y = e;
          break;
        case 2:
          z.center.y = e;
          break;
        case 3:
          z.center.y = e;
          break;
        case 4:
          z.controlPoints.points[z.controlPoints.points.length - 1].y = e;
          break;
      }
      break;
    }
    case 11:
      switch (t) {
        case 1:
          z.end.x = e;
          break;
        case 3:
          z.major.x = e;
          break;
      }
      break;
    case 21: {
      switch (t) {
        case 1:
          z.end.y = e;
          break;
        case 3:
          z.major.y = e;
          break;
      }
      break;
    }
    case 40:
      switch (t) {
        case 2:
          z.radius = e;
          break;
        case 3:
          z.minor = e;
          break;
        case 4:
          z.knots.knots.push(e);
          break;
      }
      break;
    case 42:
      switch (t) {
        case 4:
          z.weights = e;
          break;
      }
      break;
    case 50:
      switch (t) {
        case 2:
          z.startAngle = e;
          break;
        case 3:
          z.startAngle = e;
          break;
      }
      break;
    case 51:
      switch (t) {
        case 2:
          z.endAngle = e;
          break;
        case 3:
          z.endAngle = e;
          break;
      }
      break;
    case 73:
      switch (t) {
        case 2:
          z.counterClockWise = parseFloat(e) === 1;
          break;
        case 3:
          z.counterClockWise = parseFloat(e) === 1;
          break;
        case 4:
          z.rational = e;
          break;
      }
      break;
    case 74:
      switch (t) {
        case 4:
          z.periodic = e;
          break;
      }
      break;
    case 94:
      switch (t) {
        case 4:
          z.degree = e;
          break;
      }
      break;
    case 95:
      switch (t) {
        case 4:
          z.knots.count = e;
          break;
      }
      break;
    case 96:
      switch (t) {
        case 4:
          z.controlPoints.count = e;
          break;
      }
      break;
  }
}
const Pc = "MTEXT", Wa = {
  10: "x",
  20: "y",
  30: "z",
  40: "nominalTextHeight",
  41: "refRectangleWidth",
  71: "attachmentPoint",
  72: "drawingDirection",
  7: "styleName",
  11: "xAxisX",
  21: "xAxisY",
  31: "xAxisZ",
  42: "horizontalWidth",
  43: "verticalHeight",
  73: "lineSpacingStyle",
  44: "lineSpacingFactor",
  90: "backgroundFill",
  420: "bgColorRGB0",
  421: "bgColorRGB1",
  422: "bgColorRGB2",
  423: "bgColorRGB3",
  424: "bgColorRGB4",
  425: "bgColorRGB5",
  426: "bgColorRGB6",
  427: "bgColorRGB7",
  428: "bgColorRGB8",
  429: "bgColorRGB9",
  430: "bgColorName0",
  431: "bgColorName1",
  432: "bgColorName2",
  433: "bgColorName3",
  434: "bgColorName4",
  435: "bgColorName5",
  436: "bgColorName6",
  437: "bgColorName7",
  438: "bgColorName8",
  439: "bgColorName9",
  45: "fillBoxStyle",
  63: "bgFillColor",
  441: "bgFillTransparency",
  75: "columnType",
  76: "columnCount",
  78: "columnFlowReversed",
  79: "columnAutoheight",
  48: "columnWidth",
  49: "columnGutter",
  50: "columnHeights"
}, Tf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    return I(t, r, s), t;
  },
  {
    type: Pc,
    string: ""
  }
), I = (a, t, e) => (Wa[t] !== void 0 ? a[Wa[t]] = e : t === 1 || t === 3 ? a.string += e : t === 50 ? (a.xAxisX = Math.cos(e), a.xAxisY = Math.sin(e)) : Object.assign(a, U(t, e)), a), Ef = { TYPE: Pc, process: Tf, assign: I }, zc = "TEXT", $a = {
  1: "string",
  10: "x",
  20: "y",
  30: "z",
  11: "x2",
  21: "y2",
  31: "z2",
  39: "thickness",
  40: "textHeight",
  41: "relScaleX",
  50: "rotation",
  51: "obliqueAngle",
  7: "styleName",
  71: "mirror",
  72: "hAlign",
  73: "vAlign"
}, Pf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    return J(t, r, s), t;
  },
  {
    type: zc,
    string: ""
  }
), J = (a, t, e) => {
  $a[t] !== void 0 ? a[$a[t]] = e : Object.assign(a, U(t, e));
}, zf = { TYPE: zc, process: Pf, assign: J }, Cc = "ATTDEF", Cf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    return qn(t, r, s), t;
  },
  {
    type: Cc,
    subclassMarker: "AcDbText",
    thickness: 0,
    scaleX: 1,
    mtext: {},
    text: {}
  }
), qn = (a, t, e) => {
  switch (t) {
    case 100: {
      a.subclassMarker = e;
      break;
    }
    case 1:
      switch (a.subclassMarker) {
        case "AcDbText":
          J(a.text, t, e);
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
      }
      break;
    case 2:
      switch (a.subclassMarker) {
        case "AcDbAttributeDefinition":
        case "AcDbAttribute":
          a.tag = e;
          break;
        case "AcDbXrecord":
          a.attdefFlag = e;
          break;
      }
      break;
    case 3:
      switch (a.subclassMarker) {
        case "AcDbAttributeDefinition":
          a.prompt = e;
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
      }
      break;
    case 7:
      switch (a.subclassMarker) {
        case "AcDbAttributeDefinition":
        case "AcDbAttribute":
          J(a.text, t, e);
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
      }
      break;
    case 10:
      switch (a.subclassMarker) {
        case "AcDbText":
          J(a.text, t, e);
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
        case "AcDbXrecord":
          a.x = e;
          break;
      }
      break;
    case 20:
      switch (a.subclassMarker) {
        case "AcDbText":
          J(a.text, t, e);
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
        case "AcDbXrecord":
          a.y = e;
          break;
      }
      break;
    case 30:
      switch (a.subclassMarker) {
        case "AcDbText":
          J(a.text, t, e);
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
        case "AcDbXrecord":
          a.z = e;
          break;
      }
      break;
    case 11:
      switch (a.subclassMarker) {
        case "AcDbAttributeDefinition":
        case "AcDbAttribute":
          a.x2 = e;
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
      }
      break;
    case 21:
      switch (a.subclassMarker) {
        case "AcDbAttributeDefinition":
        case "AcDbAttribute":
          a.y2 = e;
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
      }
      break;
    case 31:
      switch (a.subclassMarker) {
        case "AcDbAttributeDefinition":
        case "AcDbAttribute":
          a.z2 = e;
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
      }
      break;
    case 39:
      J(a.text, t, e);
      break;
    case 40:
      switch (a.subclassMarker) {
        case "AcDbText":
          J(a.text, t, e);
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
        case "AcDbXrecord":
          a.annotationScale = e;
          break;
      }
      break;
    case 41:
      switch (a.subclassMarker) {
        case "AcDbAttributeDefinition":
        case "AcDbAttribute":
          J(a.text, t, e);
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
      }
      break;
    case 42:
    case 43:
    case 44:
    case 45:
      I(a.mtext, t, e);
      break;
    case 46:
      a.mtext.annotationHeight = e;
      break;
    case 48:
    case 49:
      I(a.mtext, t, e);
      break;
    case 50:
      switch (a.subclassMarker) {
        case "AcDbAttributeDefinition":
        case "AcDbAttribute":
          J(a.text, t, e);
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
      }
      break;
    case 51:
      J(a.text, t, e);
      break;
    case 63:
      I(a.mtext, t, e);
      break;
    case 70:
      switch (a.subclassMarker) {
        case "AcDbAttributeDefinition":
        case "AcDbAttribute":
          a.attributeFlags = e;
          break;
        case "AcDbXrecord":
          typeof a.mTextFlag > "u" ? a.mTextFlag = e : typeof a.isReallyLocked > "u" ? a.isReallyLocked = e : a.secondaryAttdefCount = e;
          break;
      }
      break;
    case 71:
    case 72:
      switch (a.subclassMarker) {
        case "AcDbAttributeDefinition":
        case "AcDbAttribute":
          J(a.text, t, e);
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
      }
      break;
    case 73:
      switch (a.subclassMarker) {
        case "AcDbAttributeDefinition":
        case "AcDbAttribute":
          a.fieldLength = e;
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
      }
      break;
    case 74:
      J(a.text, 73, e);
      break;
    case 75:
    case 76:
    case 78:
    case 79:
      I(a.mtext, t, e);
      break;
    case 90:
      I(a.mtext, t, e);
      break;
    case 210:
    case 220:
    case 230:
      switch (a.subclassMarker) {
        case "AcDbAttributeDefinition":
        case "AcDbAttribute":
          J(a.mtext, t, e);
          break;
        case "AcDbMText":
          I(a.mtext, t, e);
          break;
      }
      break;
    case 280:
      switch (a.subclassMarker) {
        case "AcDbAttributeDefinition":
        case "AcDbAttribute":
          a.lock = e;
          break;
        case "AcDbXrecord":
          a.clone = !0;
          break;
      }
      break;
    case 340:
      a.attdefHandle = e;
      break;
    case 420:
    case 421:
    case 422:
    case 423:
    case 424:
    case 425:
    case 426:
    case 427:
    case 428:
    case 429:
    case 430:
    case 431:
    case 432:
    case 433:
    case 434:
    case 435:
    case 436:
    case 437:
    case 438:
    case 439:
    case 441:
      I(a.mtext, t, e);
      break;
    default:
      Object.assign(a, U(t, e));
      break;
  }
}, Bf = { TYPE: Cc, process: Cf, assign: qn }, Bc = "ATTRIB", Df = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    return qn(t, r, s), t;
  },
  {
    type: Bc,
    subclassMarker: "AcDbText",
    thickness: 0,
    scaleX: 1,
    mtext: {},
    text: {}
  }
), If = { TYPE: Bc, process: Df }, Dc = "INSERT", Rf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 2:
        t.block = s;
        break;
      case 10:
        t.x = s;
        break;
      case 20:
        t.y = s;
        break;
      case 30:
        t.z = s;
        break;
      case 41:
        t.scaleX = s;
        break;
      case 42:
        t.scaleY = s;
        break;
      case 43:
        t.scaleZ = s;
        break;
      case 44:
        t.columnSpacing = s;
        break;
      case 45:
        t.rowSpacing = s;
        break;
      case 50:
        t.rotation = s;
        break;
      case 70:
        t.columnCount = s;
        break;
      case 71:
        t.rowCount = s;
        break;
      case 210:
        t.extrusionX = s;
        break;
      case 220:
        t.extrusionY = s;
        break;
      case 230:
        t.extrusionZ = s;
        break;
      default:
        Object.assign(t, U(r, s));
        break;
    }
    return t;
  },
  {
    type: Dc
  }
), Lf = { TYPE: Dc, process: Rf }, Ic = "3DFACE", Of = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 10:
        t.vertices[0].x = s;
        break;
      case 20:
        t.vertices[0].y = s;
        break;
      case 30:
        t.vertices[0].z = s;
        break;
      case 11:
        t.vertices[1].x = s;
        break;
      case 21:
        t.vertices[1].y = s;
        break;
      case 31:
        t.vertices[1].z = s;
        break;
      case 12:
        t.vertices[2].x = s;
        break;
      case 22:
        t.vertices[2].y = s;
        break;
      case 32:
        t.vertices[2].z = s;
        break;
      case 13:
        t.vertices[3].x = s;
        break;
      case 23:
        t.vertices[3].y = s;
        break;
      case 33:
        t.vertices[3].z = s;
        break;
      default:
        Object.assign(t, U(r, s));
        break;
    }
    return t;
  },
  {
    type: Ic,
    vertices: [{}, {}, {}, {}]
  }
), qf = { TYPE: Ic, process: Of }, Rc = "DIMENSION", Nf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 2:
        t.block = s;
        break;
      case 10:
        t.start.x = s;
        break;
      case 20:
        t.start.y = s;
        break;
      case 30:
        t.start.z = s;
        break;
      case 11:
        t.textMidpoint.x = s;
        break;
      case 21:
        t.textMidpoint.y = s;
        break;
      case 31:
        t.textMidpoint.z = s;
        break;
      case 13:
        t.measureStart.x = s;
        break;
      case 23:
        t.measureStart.y = s;
        break;
      case 33:
        t.measureStart.z = s;
        break;
      case 14:
        t.measureEnd.x = s;
        break;
      case 24:
        t.measureEnd.y = s;
        break;
      case 34:
        t.measureEnd.z = s;
        break;
      case 50:
        t.rotation = s;
        break;
      case 51:
        t.horizonRotation = s;
        break;
      case 52:
        t.extensionRotation = s;
        break;
      case 53:
        t.textRotation = s;
        break;
      case 70: {
        const i = Hf(s);
        i.ordinateType && (t.ordinateType = !0), i.uniqueBlockReference && (t.uniqueBlockReference = !0), i.userDefinedLocation && (t.userDefinedLocation = !0), t.dimensionType = i.dimensionType;
        break;
      }
      case 71:
        t.attachementPoint = s;
        break;
      case 210:
        t.extrudeDirection = t.extrudeDirection || {}, t.extrudeDirection.x = s;
        break;
      case 220:
        t.extrudeDirection = t.extrudeDirection || {}, t.extrudeDirection.y = s;
        break;
      case 230:
        t.extrudeDirection = t.extrudeDirection || {}, t.extrudeDirection.z = s;
        break;
      default:
        Object.assign(t, U(r, s));
        break;
    }
    return t;
  },
  {
    type: Rc,
    start: { x: 0, y: 0, z: 0 },
    measureStart: { x: 0, y: 0, z: 0 },
    measureEnd: { x: 0, y: 0, z: 0 },
    textMidpoint: { x: 0, y: 0, z: 0 },
    attachementPoint: 1,
    dimensionType: 0
  }
);
function Hf(a) {
  let t = !1, e = !1, r = !1;
  if (a > 6) {
    const s = a - 32, i = a - 64, n = a - 32 - 64, o = a - 32 - 128, h = a - 32 - 64 - 128;
    s >= 0 && s <= 6 ? (t = !0, a = s) : i >= 0 && i <= 6 ? (e = !0, a = i) : n >= 0 && n <= 6 ? (t = !0, e = !0, a = n) : o >= 0 && o <= 6 ? (t = !0, r = !0, a = o) : h >= 0 && h <= 6 && (t = !0, e = !0, r = !0, a = h);
  }
  return {
    dimensionType: a,
    uniqueBlockReference: t,
    ordinateType: e,
    userDefinedLocation: r
  };
}
const Vf = { TYPE: Rc, process: Nf }, Lc = "VIEWPORT", jf = (a) => a.reduce(
  (t, e) => {
    const r = e[0], s = e[1];
    switch (r) {
      case 1:
        t.layout = parseFloat(s);
        break;
      case 10:
        t.center.x = parseFloat(s);
        break;
      case 20:
        t.center.y = parseFloat(s);
        break;
      case 30:
        t.center.z = parseFloat(s);
        break;
      case 12:
        t.centerDCS.x = parseFloat(s);
        break;
      case 22:
        t.centerDCS.y = parseFloat(s);
        break;
      case 13:
        t.snap.x = parseFloat(s);
        break;
      case 23:
        t.snap.y = parseFloat(s);
        break;
      case 14:
        t.snapSpacing.x = parseFloat(s);
        break;
      case 24:
        t.snapSpacing.y = parseFloat(s);
        break;
      case 15:
        t.gridSpacing.x = parseFloat(s);
        break;
      case 25:
        t.gridSpacing.y = parseFloat(s);
        break;
      case 16:
        t.direction.x = parseFloat(s);
        break;
      case 26:
        t.direction.y = parseFloat(s);
        break;
      case 36:
        t.direction.z = parseFloat(s);
        break;
      case 17:
        t.target.x = parseFloat(s);
        break;
      case 27:
        t.target.y = parseFloat(s);
        break;
      case 37:
        t.target.z = parseFloat(s);
        break;
      case 40:
        t.width = parseFloat(s);
        break;
      case 41:
        t.height = parseFloat(s);
        break;
      case 50:
        t.snapAngle = parseFloat(s);
        break;
      case 51:
        t.angle = parseFloat(s);
        break;
      case 68:
        t.status = s;
        break;
      case 69:
        t.id = s;
        break;
      case 90:
        t.flags = s;
        break;
      case 110:
        t.x = parseFloat(s);
        break;
      case 120:
        t.y = parseFloat(s);
        break;
      case 130:
        t.z = parseFloat(s);
        break;
      case 111:
        t.xAxisX = parseFloat(s);
        break;
      case 121:
        t.xAxisY = parseFloat(s);
        break;
      case 131:
        t.xAxisZ = parseFloat(s);
        break;
      case 112:
        t.xAxisX = parseFloat(s);
        break;
      case 122:
        t.xAxisY = parseFloat(s);
        break;
      case 132:
        t.xAxisZ = parseFloat(s);
        break;
      case 146:
        t.elevation = parseFloat(s);
        break;
      case 281:
        t.render = s;
        break;
      default:
        Object.assign(t, U(r, s));
        break;
    }
    return t;
  },
  {
    type: Lc,
    center: {},
    centerDCS: {},
    snap: {},
    snapSpacing: {},
    gridSpacing: {},
    direction: {},
    target: {}
  }
), Uf = { TYPE: Lc, process: jf }, Za = [
  nf,
  of,
  cf,
  uf,
  pf,
  mf,
  gf,
  _f,
  vf,
  Af,
  kf,
  Ef,
  Bf,
  If,
  zf,
  Lf,
  Vf,
  qf,
  Uf
].reduce((a, t) => (a[t.TYPE] = t, a), {}), Oc = (a) => {
  const t = [], e = [];
  let r;
  a.forEach((i) => {
    i[0] === 0 && (r = [], e.push(r)), r.push(i);
  });
  let s;
  return e.forEach((i) => {
    const n = i[0][1], o = i.slice(1);
    if (Za[n] !== void 0) {
      const h = Za[n].process(o);
      n === "POLYLINE" ? (s = h, t.push(h)) : n === "VERTEX" ? s ? s.vertices.push(h) : te.error("ignoring invalid VERTEX entity") : n === "SEQEND" ? s = void 0 : t.push(h);
    }
  }), t;
}, Gf = (a) => {
  let t;
  const e = [];
  let r, s = [];
  return a.forEach((i) => {
    const n = i[0], o = i[1];
    if (o === "BLOCK")
      t = "block", r = {}, s = [], e.push(r);
    else if (o === "ENDBLK")
      t === "entities" ? r.entities = Oc(s) : r.entities = [], s = void 0, t = void 0;
    else if (t === "block" && n !== 0)
      switch (n) {
        case 1:
          r.xref = o;
          break;
        case 2:
          r.name = o;
          break;
        case 10:
          r.x = o;
          break;
        case 20:
          r.y = o;
          break;
        case 30:
          r.z = o;
          break;
        case 67:
          o !== 0 && (r.paperSpace = o);
          break;
        case 410:
          r.layout = o;
          break;
      }
    else t === "block" && n === 0 ? (t = "entities", s.push(i)) : t === "entities" && s.push(i);
  }), e;
}, Xf = (a) => {
  let t;
  const e = {
    layouts: []
  };
  let r = {};
  return a.forEach((s, i) => {
    const n = s[0], o = s[1];
    if (n === 0 && (t = "IDLE"), o === "LAYOUT" && (t = "layout", r = {}, e.layouts.push(r)), t === "layout" && n !== 0)
      switch (n) {
        case 100:
          o === "AcDbLayout" && (t = "AcDbLayout");
          break;
      }
    if (t === "AcDbLayout" && n !== 0)
      switch (n) {
        case 1:
          r.name = o;
          break;
        case 5:
          r.handle = o;
          break;
        case 10:
          r.minLimitX = parseFloat(o);
          break;
        case 20:
          r.minLimitY = parseFloat(o);
          break;
        case 11:
          r.maxLimitX = parseFloat(o);
          break;
        case 21:
          r.maxLimitY = parseFloat(o);
          break;
        case 12:
          r.x = parseFloat(o);
          break;
        case 22:
          r.y = parseFloat(o);
          break;
        case 32:
          r.z = parseFloat(o);
          break;
        case 14:
          r.minX = parseFloat(o);
          break;
        case 24:
          r.minY = parseFloat(o);
          break;
        case 34:
          r.minZ = parseFloat(o);
          break;
        case 15:
          r.maxX = parseFloat(o);
          break;
        case 25:
          r.maxY = parseFloat(o);
          break;
        case 35:
          r.maxZ = parseFloat(o);
          break;
        case 70:
          r.flag = o === 1 ? "PSLTSCALE" : "LIMCHECK";
          break;
        case 71:
          r.tabOrder = o;
          break;
        case 146:
          r.elevation = parseFloat(o);
          break;
        case 13:
          r.ucsX = parseFloat(o);
          break;
        case 23:
          r.ucsY = parseFloat(o);
          break;
        case 33:
          r.ucsZ = parseFloat(o);
          break;
        case 16:
          r.ucsXaxisX = parseFloat(o);
          break;
        case 26:
          r.ucsXaxisY = parseFloat(o);
          break;
        case 36:
          r.ucsXaxisZ = parseFloat(o);
          break;
        case 17:
          r.ucsYaxisX = parseFloat(o);
          break;
        case 27:
          r.ucsYaxisY = parseFloat(o);
          break;
        case 37:
          r.ucsYaxisZ = parseFloat(o);
          break;
        case 76:
          switch (o) {
            case 0:
              r.ucsType = "NOT ORTHOGRAPHIC";
              break;
            case 1:
              r.ucsType = "TOP";
              break;
            case 2:
              r.ucsType = "BOTTOM";
              break;
            case 3:
              r.ucsType = "FRONT";
              break;
            case 4:
              r.ucsType = "BACK";
              break;
            case 5:
              r.ucsType = "LEFT";
              break;
            case 6:
              r.ucsType = "RIGHT";
              break;
          }
          break;
        case 330:
          r.tableRecord = o;
          break;
        case 331:
          r.lastActiveViewport = o;
          break;
        case 333:
          r.shadePlot = o;
          break;
      }
  }), e;
}, Yf = (a, t) => a >= 10 && a < 60 || a >= 210 && a < 240 ? parseFloat(t, 10) : a >= 60 && a < 100 ? parseInt(t, 10) : t, Wf = (a) => {
  let t = "type", e;
  const r = [];
  for (const s of a)
    t === "type" ? (e = parseInt(s, 10), t = "value") : (r.push([e, Yf(e, s)]), t = "type");
  return r;
}, $f = (a) => {
  let t;
  return a.reduce((e, r) => (r[0] === 0 && r[1] === "SECTION" ? t = [] : r[0] === 0 && r[1] === "ENDSEC" ? (e.push(t), t = void 0) : t !== void 0 && t.push(r), e), []);
}, Zf = (a, t) => {
  const e = t[0][1], r = t.slice(1);
  switch (e) {
    case "HEADER":
      a.header = Ju(r);
      break;
    case "TABLES":
      a.tables = rf(r);
      break;
    case "BLOCKS":
      a.blocks = Gf(r);
      break;
    case "ENTITIES":
      a.entities = Oc(r);
      break;
    case "OBJECTS":
      a.objects = Xf(r);
      break;
  }
  return a;
}, Jf = (a) => {
  const t = a.split(/\r\n|\r|\n/g), e = Wf(t);
  return $f(e).reduce(Zf, {
    // Start with empty defaults in the event of empty sections
    header: {},
    blocks: [],
    entities: [],
    objects: { layouts: [] },
    tables: { layers: {}, styles: {}, ltypes: {} }
  });
};
var _s, Ja;
function Kf() {
  if (Ja) return _s;
  Ja = 1;
  function a() {
    this.__data__ = [], this.size = 0;
  }
  return _s = a, _s;
}
var ws, Ka;
function qc() {
  if (Ka) return ws;
  Ka = 1;
  function a(t, e) {
    return t === e || t !== t && e !== e;
  }
  return ws = a, ws;
}
var vs, Qa;
function Tr() {
  if (Qa) return vs;
  Qa = 1;
  var a = qc();
  function t(e, r) {
    for (var s = e.length; s--; )
      if (a(e[s][0], r))
        return s;
    return -1;
  }
  return vs = t, vs;
}
var Ms, to;
function Qf() {
  if (to) return Ms;
  to = 1;
  var a = Tr(), t = Array.prototype, e = t.splice;
  function r(s) {
    var i = this.__data__, n = a(i, s);
    if (n < 0)
      return !1;
    var o = i.length - 1;
    return n == o ? i.pop() : e.call(i, n, 1), --this.size, !0;
  }
  return Ms = r, Ms;
}
var As, eo;
function td() {
  if (eo) return As;
  eo = 1;
  var a = Tr();
  function t(e) {
    var r = this.__data__, s = a(r, e);
    return s < 0 ? void 0 : r[s][1];
  }
  return As = t, As;
}
var Ss, ro;
function ed() {
  if (ro) return Ss;
  ro = 1;
  var a = Tr();
  function t(e) {
    return a(this.__data__, e) > -1;
  }
  return Ss = t, Ss;
}
var ks, so;
function rd() {
  if (so) return ks;
  so = 1;
  var a = Tr();
  function t(e, r) {
    var s = this.__data__, i = a(s, e);
    return i < 0 ? (++this.size, s.push([e, r])) : s[i][1] = r, this;
  }
  return ks = t, ks;
}
var Fs, io;
function Er() {
  if (io) return Fs;
  io = 1;
  var a = Kf(), t = Qf(), e = td(), r = ed(), s = rd();
  function i(n) {
    var o = -1, h = n == null ? 0 : n.length;
    for (this.clear(); ++o < h; ) {
      var c = n[o];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = a, i.prototype.delete = t, i.prototype.get = e, i.prototype.has = r, i.prototype.set = s, Fs = i, Fs;
}
var Ts, no;
function sd() {
  if (no) return Ts;
  no = 1;
  var a = Er();
  function t() {
    this.__data__ = new a(), this.size = 0;
  }
  return Ts = t, Ts;
}
var Es, ao;
function id() {
  if (ao) return Es;
  ao = 1;
  function a(t) {
    var e = this.__data__, r = e.delete(t);
    return this.size = e.size, r;
  }
  return Es = a, Es;
}
var Ps, oo;
function nd() {
  if (oo) return Ps;
  oo = 1;
  function a(t) {
    return this.__data__.get(t);
  }
  return Ps = a, Ps;
}
var zs, ho;
function ad() {
  if (ho) return zs;
  ho = 1;
  function a(t) {
    return this.__data__.has(t);
  }
  return zs = a, zs;
}
var Cs, co;
function Nc() {
  if (co) return Cs;
  co = 1;
  var a = typeof gr == "object" && gr && gr.Object === Object && gr;
  return Cs = a, Cs;
}
var Bs, lo;
function gt() {
  if (lo) return Bs;
  lo = 1;
  var a = Nc(), t = typeof self == "object" && self && self.Object === Object && self, e = a || t || Function("return this")();
  return Bs = e, Bs;
}
var Ds, uo;
function Nn() {
  if (uo) return Ds;
  uo = 1;
  var a = gt(), t = a.Symbol;
  return Ds = t, Ds;
}
var Is, fo;
function od() {
  if (fo) return Is;
  fo = 1;
  var a = Nn(), t = Object.prototype, e = t.hasOwnProperty, r = t.toString, s = a ? a.toStringTag : void 0;
  function i(n) {
    var o = e.call(n, s), h = n[s];
    try {
      n[s] = void 0;
      var c = !0;
    } catch {
    }
    var l = r.call(n);
    return c && (o ? n[s] = h : delete n[s]), l;
  }
  return Is = i, Is;
}
var Rs, po;
function hd() {
  if (po) return Rs;
  po = 1;
  var a = Object.prototype, t = a.toString;
  function e(r) {
    return t.call(r);
  }
  return Rs = e, Rs;
}
var Ls, xo;
function Pr() {
  if (xo) return Ls;
  xo = 1;
  var a = Nn(), t = od(), e = hd(), r = "[object Null]", s = "[object Undefined]", i = a ? a.toStringTag : void 0;
  function n(o) {
    return o == null ? o === void 0 ? s : r : i && i in Object(o) ? t(o) : e(o);
  }
  return Ls = n, Ls;
}
var Os, mo;
function je() {
  if (mo) return Os;
  mo = 1;
  function a(t) {
    var e = typeof t;
    return t != null && (e == "object" || e == "function");
  }
  return Os = a, Os;
}
var qs, yo;
function Hc() {
  if (yo) return qs;
  yo = 1;
  var a = Pr(), t = je(), e = "[object AsyncFunction]", r = "[object Function]", s = "[object GeneratorFunction]", i = "[object Proxy]";
  function n(o) {
    if (!t(o))
      return !1;
    var h = a(o);
    return h == r || h == s || h == e || h == i;
  }
  return qs = n, qs;
}
var Ns, go;
function cd() {
  if (go) return Ns;
  go = 1;
  var a = gt(), t = a["__core-js_shared__"];
  return Ns = t, Ns;
}
var Hs, bo;
function ld() {
  if (bo) return Hs;
  bo = 1;
  var a = cd(), t = function() {
    var r = /[^.]+$/.exec(a && a.keys && a.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function e(r) {
    return !!t && t in r;
  }
  return Hs = e, Hs;
}
var Vs, _o;
function Vc() {
  if (_o) return Vs;
  _o = 1;
  var a = Function.prototype, t = a.toString;
  function e(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return Vs = e, Vs;
}
var js, wo;
function ud() {
  if (wo) return js;
  wo = 1;
  var a = Hc(), t = ld(), e = je(), r = Vc(), s = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, n = Function.prototype, o = Object.prototype, h = n.toString, c = o.hasOwnProperty, l = RegExp(
    "^" + h.call(c).replace(s, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function u(f) {
    if (!e(f) || t(f))
      return !1;
    var d = a(f) ? l : i;
    return d.test(r(f));
  }
  return js = u, js;
}
var Us, vo;
function fd() {
  if (vo) return Us;
  vo = 1;
  function a(t, e) {
    return t == null ? void 0 : t[e];
  }
  return Us = a, Us;
}
var Gs, Mo;
function ee() {
  if (Mo) return Gs;
  Mo = 1;
  var a = ud(), t = fd();
  function e(r, s) {
    var i = t(r, s);
    return a(i) ? i : void 0;
  }
  return Gs = e, Gs;
}
var Xs, Ao;
function Hn() {
  if (Ao) return Xs;
  Ao = 1;
  var a = ee(), t = gt(), e = a(t, "Map");
  return Xs = e, Xs;
}
var Ys, So;
function zr() {
  if (So) return Ys;
  So = 1;
  var a = ee(), t = a(Object, "create");
  return Ys = t, Ys;
}
var Ws, ko;
function dd() {
  if (ko) return Ws;
  ko = 1;
  var a = zr();
  function t() {
    this.__data__ = a ? a(null) : {}, this.size = 0;
  }
  return Ws = t, Ws;
}
var $s, Fo;
function pd() {
  if (Fo) return $s;
  Fo = 1;
  function a(t) {
    var e = this.has(t) && delete this.__data__[t];
    return this.size -= e ? 1 : 0, e;
  }
  return $s = a, $s;
}
var Zs, To;
function xd() {
  if (To) return Zs;
  To = 1;
  var a = zr(), t = "__lodash_hash_undefined__", e = Object.prototype, r = e.hasOwnProperty;
  function s(i) {
    var n = this.__data__;
    if (a) {
      var o = n[i];
      return o === t ? void 0 : o;
    }
    return r.call(n, i) ? n[i] : void 0;
  }
  return Zs = s, Zs;
}
var Js, Eo;
function md() {
  if (Eo) return Js;
  Eo = 1;
  var a = zr(), t = Object.prototype, e = t.hasOwnProperty;
  function r(s) {
    var i = this.__data__;
    return a ? i[s] !== void 0 : e.call(i, s);
  }
  return Js = r, Js;
}
var Ks, Po;
function yd() {
  if (Po) return Ks;
  Po = 1;
  var a = zr(), t = "__lodash_hash_undefined__";
  function e(r, s) {
    var i = this.__data__;
    return this.size += this.has(r) ? 0 : 1, i[r] = a && s === void 0 ? t : s, this;
  }
  return Ks = e, Ks;
}
var Qs, zo;
function gd() {
  if (zo) return Qs;
  zo = 1;
  var a = dd(), t = pd(), e = xd(), r = md(), s = yd();
  function i(n) {
    var o = -1, h = n == null ? 0 : n.length;
    for (this.clear(); ++o < h; ) {
      var c = n[o];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = a, i.prototype.delete = t, i.prototype.get = e, i.prototype.has = r, i.prototype.set = s, Qs = i, Qs;
}
var ti, Co;
function bd() {
  if (Co) return ti;
  Co = 1;
  var a = gd(), t = Er(), e = Hn();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new a(),
      map: new (e || t)(),
      string: new a()
    };
  }
  return ti = r, ti;
}
var ei, Bo;
function _d() {
  if (Bo) return ei;
  Bo = 1;
  function a(t) {
    var e = typeof t;
    return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
  }
  return ei = a, ei;
}
var ri, Do;
function Cr() {
  if (Do) return ri;
  Do = 1;
  var a = _d();
  function t(e, r) {
    var s = e.__data__;
    return a(r) ? s[typeof r == "string" ? "string" : "hash"] : s.map;
  }
  return ri = t, ri;
}
var si, Io;
function wd() {
  if (Io) return si;
  Io = 1;
  var a = Cr();
  function t(e) {
    var r = a(this, e).delete(e);
    return this.size -= r ? 1 : 0, r;
  }
  return si = t, si;
}
var ii, Ro;
function vd() {
  if (Ro) return ii;
  Ro = 1;
  var a = Cr();
  function t(e) {
    return a(this, e).get(e);
  }
  return ii = t, ii;
}
var ni, Lo;
function Md() {
  if (Lo) return ni;
  Lo = 1;
  var a = Cr();
  function t(e) {
    return a(this, e).has(e);
  }
  return ni = t, ni;
}
var ai, Oo;
function Ad() {
  if (Oo) return ai;
  Oo = 1;
  var a = Cr();
  function t(e, r) {
    var s = a(this, e), i = s.size;
    return s.set(e, r), this.size += s.size == i ? 0 : 1, this;
  }
  return ai = t, ai;
}
var oi, qo;
function Sd() {
  if (qo) return oi;
  qo = 1;
  var a = bd(), t = wd(), e = vd(), r = Md(), s = Ad();
  function i(n) {
    var o = -1, h = n == null ? 0 : n.length;
    for (this.clear(); ++o < h; ) {
      var c = n[o];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = a, i.prototype.delete = t, i.prototype.get = e, i.prototype.has = r, i.prototype.set = s, oi = i, oi;
}
var hi, No;
function kd() {
  if (No) return hi;
  No = 1;
  var a = Er(), t = Hn(), e = Sd(), r = 200;
  function s(i, n) {
    var o = this.__data__;
    if (o instanceof a) {
      var h = o.__data__;
      if (!t || h.length < r - 1)
        return h.push([i, n]), this.size = ++o.size, this;
      o = this.__data__ = new e(h);
    }
    return o.set(i, n), this.size = o.size, this;
  }
  return hi = s, hi;
}
var ci, Ho;
function Fd() {
  if (Ho) return ci;
  Ho = 1;
  var a = Er(), t = sd(), e = id(), r = nd(), s = ad(), i = kd();
  function n(o) {
    var h = this.__data__ = new a(o);
    this.size = h.size;
  }
  return n.prototype.clear = t, n.prototype.delete = e, n.prototype.get = r, n.prototype.has = s, n.prototype.set = i, ci = n, ci;
}
var li, Vo;
function Td() {
  if (Vo) return li;
  Vo = 1;
  function a(t, e) {
    for (var r = -1, s = t == null ? 0 : t.length; ++r < s && e(t[r], r, t) !== !1; )
      ;
    return t;
  }
  return li = a, li;
}
var ui, jo;
function Ed() {
  if (jo) return ui;
  jo = 1;
  var a = ee(), t = function() {
    try {
      var e = a(Object, "defineProperty");
      return e({}, "", {}), e;
    } catch {
    }
  }();
  return ui = t, ui;
}
var fi, Uo;
function jc() {
  if (Uo) return fi;
  Uo = 1;
  var a = Ed();
  function t(e, r, s) {
    r == "__proto__" && a ? a(e, r, {
      configurable: !0,
      enumerable: !0,
      value: s,
      writable: !0
    }) : e[r] = s;
  }
  return fi = t, fi;
}
var di, Go;
function Uc() {
  if (Go) return di;
  Go = 1;
  var a = jc(), t = qc(), e = Object.prototype, r = e.hasOwnProperty;
  function s(i, n, o) {
    var h = i[n];
    (!(r.call(i, n) && t(h, o)) || o === void 0 && !(n in i)) && a(i, n, o);
  }
  return di = s, di;
}
var pi, Xo;
function Br() {
  if (Xo) return pi;
  Xo = 1;
  var a = Uc(), t = jc();
  function e(r, s, i, n) {
    var o = !i;
    i || (i = {});
    for (var h = -1, c = s.length; ++h < c; ) {
      var l = s[h], u = n ? n(i[l], r[l], l, i, r) : void 0;
      u === void 0 && (u = r[l]), o ? t(i, l, u) : a(i, l, u);
    }
    return i;
  }
  return pi = e, pi;
}
var xi, Yo;
function Pd() {
  if (Yo) return xi;
  Yo = 1;
  function a(t, e) {
    for (var r = -1, s = Array(t); ++r < t; )
      s[r] = e(r);
    return s;
  }
  return xi = a, xi;
}
var mi, Wo;
function Ue() {
  if (Wo) return mi;
  Wo = 1;
  function a(t) {
    return t != null && typeof t == "object";
  }
  return mi = a, mi;
}
var yi, $o;
function zd() {
  if ($o) return yi;
  $o = 1;
  var a = Pr(), t = Ue(), e = "[object Arguments]";
  function r(s) {
    return t(s) && a(s) == e;
  }
  return yi = r, yi;
}
var gi, Zo;
function Cd() {
  if (Zo) return gi;
  Zo = 1;
  var a = zd(), t = Ue(), e = Object.prototype, r = e.hasOwnProperty, s = e.propertyIsEnumerable, i = a(/* @__PURE__ */ function() {
    return arguments;
  }()) ? a : function(n) {
    return t(n) && r.call(n, "callee") && !s.call(n, "callee");
  };
  return gi = i, gi;
}
var bi, Jo;
function Vn() {
  if (Jo) return bi;
  Jo = 1;
  var a = Array.isArray;
  return bi = a, bi;
}
var Pe = { exports: {} }, _i, Ko;
function Bd() {
  if (Ko) return _i;
  Ko = 1;
  function a() {
    return !1;
  }
  return _i = a, _i;
}
Pe.exports;
var Qo;
function Gc() {
  return Qo || (Qo = 1, function(a, t) {
    var e = gt(), r = Bd(), s = t && !t.nodeType && t, i = s && !0 && a && !a.nodeType && a, n = i && i.exports === s, o = n ? e.Buffer : void 0, h = o ? o.isBuffer : void 0, c = h || r;
    a.exports = c;
  }(Pe, Pe.exports)), Pe.exports;
}
var wi, th;
function Dd() {
  if (th) return wi;
  th = 1;
  var a = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function e(r, s) {
    var i = typeof r;
    return s = s ?? a, !!s && (i == "number" || i != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < s;
  }
  return wi = e, wi;
}
var vi, eh;
function Xc() {
  if (eh) return vi;
  eh = 1;
  var a = 9007199254740991;
  function t(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= a;
  }
  return vi = t, vi;
}
var Mi, rh;
function Id() {
  if (rh) return Mi;
  rh = 1;
  var a = Pr(), t = Xc(), e = Ue(), r = "[object Arguments]", s = "[object Array]", i = "[object Boolean]", n = "[object Date]", o = "[object Error]", h = "[object Function]", c = "[object Map]", l = "[object Number]", u = "[object Object]", f = "[object RegExp]", d = "[object Set]", p = "[object String]", x = "[object WeakMap]", m = "[object ArrayBuffer]", y = "[object DataView]", _ = "[object Float32Array]", b = "[object Float64Array]", w = "[object Int8Array]", M = "[object Int16Array]", A = "[object Int32Array]", v = "[object Uint8Array]", S = "[object Uint8ClampedArray]", F = "[object Uint16Array]", T = "[object Uint32Array]", k = {};
  k[_] = k[b] = k[w] = k[M] = k[A] = k[v] = k[S] = k[F] = k[T] = !0, k[r] = k[s] = k[m] = k[i] = k[y] = k[n] = k[o] = k[h] = k[c] = k[l] = k[u] = k[f] = k[d] = k[p] = k[x] = !1;
  function L(B) {
    return e(B) && t(B.length) && !!k[a(B)];
  }
  return Mi = L, Mi;
}
var Ai, sh;
function jn() {
  if (sh) return Ai;
  sh = 1;
  function a(t) {
    return function(e) {
      return t(e);
    };
  }
  return Ai = a, Ai;
}
var ze = { exports: {} };
ze.exports;
var ih;
function Un() {
  return ih || (ih = 1, function(a, t) {
    var e = Nc(), r = t && !t.nodeType && t, s = r && !0 && a && !a.nodeType && a, i = s && s.exports === r, n = i && e.process, o = function() {
      try {
        var h = s && s.require && s.require("util").types;
        return h || n && n.binding && n.binding("util");
      } catch {
      }
    }();
    a.exports = o;
  }(ze, ze.exports)), ze.exports;
}
var Si, nh;
function Rd() {
  if (nh) return Si;
  nh = 1;
  var a = Id(), t = jn(), e = Un(), r = e && e.isTypedArray, s = r ? t(r) : a;
  return Si = s, Si;
}
var ki, ah;
function Yc() {
  if (ah) return ki;
  ah = 1;
  var a = Pd(), t = Cd(), e = Vn(), r = Gc(), s = Dd(), i = Rd(), n = Object.prototype, o = n.hasOwnProperty;
  function h(c, l) {
    var u = e(c), f = !u && t(c), d = !u && !f && r(c), p = !u && !f && !d && i(c), x = u || f || d || p, m = x ? a(c.length, String) : [], y = m.length;
    for (var _ in c)
      (l || o.call(c, _)) && !(x && // Safari 9 has enumerable `arguments.length` in strict mode.
      (_ == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      d && (_ == "offset" || _ == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      p && (_ == "buffer" || _ == "byteLength" || _ == "byteOffset") || // Skip index properties.
      s(_, y))) && m.push(_);
    return m;
  }
  return ki = h, ki;
}
var Fi, oh;
function Gn() {
  if (oh) return Fi;
  oh = 1;
  var a = Object.prototype;
  function t(e) {
    var r = e && e.constructor, s = typeof r == "function" && r.prototype || a;
    return e === s;
  }
  return Fi = t, Fi;
}
var Ti, hh;
function Wc() {
  if (hh) return Ti;
  hh = 1;
  function a(t, e) {
    return function(r) {
      return t(e(r));
    };
  }
  return Ti = a, Ti;
}
var Ei, ch;
function Ld() {
  if (ch) return Ei;
  ch = 1;
  var a = Wc(), t = a(Object.keys, Object);
  return Ei = t, Ei;
}
var Pi, lh;
function Od() {
  if (lh) return Pi;
  lh = 1;
  var a = Gn(), t = Ld(), e = Object.prototype, r = e.hasOwnProperty;
  function s(i) {
    if (!a(i))
      return t(i);
    var n = [];
    for (var o in Object(i))
      r.call(i, o) && o != "constructor" && n.push(o);
    return n;
  }
  return Pi = s, Pi;
}
var zi, uh;
function $c() {
  if (uh) return zi;
  uh = 1;
  var a = Hc(), t = Xc();
  function e(r) {
    return r != null && t(r.length) && !a(r);
  }
  return zi = e, zi;
}
var Ci, fh;
function Xn() {
  if (fh) return Ci;
  fh = 1;
  var a = Yc(), t = Od(), e = $c();
  function r(s) {
    return e(s) ? a(s) : t(s);
  }
  return Ci = r, Ci;
}
var Bi, dh;
function qd() {
  if (dh) return Bi;
  dh = 1;
  var a = Br(), t = Xn();
  function e(r, s) {
    return r && a(s, t(s), r);
  }
  return Bi = e, Bi;
}
var Di, ph;
function Nd() {
  if (ph) return Di;
  ph = 1;
  function a(t) {
    var e = [];
    if (t != null)
      for (var r in Object(t))
        e.push(r);
    return e;
  }
  return Di = a, Di;
}
var Ii, xh;
function Hd() {
  if (xh) return Ii;
  xh = 1;
  var a = je(), t = Gn(), e = Nd(), r = Object.prototype, s = r.hasOwnProperty;
  function i(n) {
    if (!a(n))
      return e(n);
    var o = t(n), h = [];
    for (var c in n)
      c == "constructor" && (o || !s.call(n, c)) || h.push(c);
    return h;
  }
  return Ii = i, Ii;
}
var Ri, mh;
function Yn() {
  if (mh) return Ri;
  mh = 1;
  var a = Yc(), t = Hd(), e = $c();
  function r(s) {
    return e(s) ? a(s, !0) : t(s);
  }
  return Ri = r, Ri;
}
var Li, yh;
function Vd() {
  if (yh) return Li;
  yh = 1;
  var a = Br(), t = Yn();
  function e(r, s) {
    return r && a(s, t(s), r);
  }
  return Li = e, Li;
}
var Ce = { exports: {} };
Ce.exports;
var gh;
function jd() {
  return gh || (gh = 1, function(a, t) {
    var e = gt(), r = t && !t.nodeType && t, s = r && !0 && a && !a.nodeType && a, i = s && s.exports === r, n = i ? e.Buffer : void 0, o = n ? n.allocUnsafe : void 0;
    function h(c, l) {
      if (l)
        return c.slice();
      var u = c.length, f = o ? o(u) : new c.constructor(u);
      return c.copy(f), f;
    }
    a.exports = h;
  }(Ce, Ce.exports)), Ce.exports;
}
var Oi, bh;
function Ud() {
  if (bh) return Oi;
  bh = 1;
  function a(t, e) {
    var r = -1, s = t.length;
    for (e || (e = Array(s)); ++r < s; )
      e[r] = t[r];
    return e;
  }
  return Oi = a, Oi;
}
var qi, _h;
function Gd() {
  if (_h) return qi;
  _h = 1;
  function a(t, e) {
    for (var r = -1, s = t == null ? 0 : t.length, i = 0, n = []; ++r < s; ) {
      var o = t[r];
      e(o, r, t) && (n[i++] = o);
    }
    return n;
  }
  return qi = a, qi;
}
var Ni, wh;
function Zc() {
  if (wh) return Ni;
  wh = 1;
  function a() {
    return [];
  }
  return Ni = a, Ni;
}
var Hi, vh;
function Wn() {
  if (vh) return Hi;
  vh = 1;
  var a = Gd(), t = Zc(), e = Object.prototype, r = e.propertyIsEnumerable, s = Object.getOwnPropertySymbols, i = s ? function(n) {
    return n == null ? [] : (n = Object(n), a(s(n), function(o) {
      return r.call(n, o);
    }));
  } : t;
  return Hi = i, Hi;
}
var Vi, Mh;
function Xd() {
  if (Mh) return Vi;
  Mh = 1;
  var a = Br(), t = Wn();
  function e(r, s) {
    return a(r, t(r), s);
  }
  return Vi = e, Vi;
}
var ji, Ah;
function Jc() {
  if (Ah) return ji;
  Ah = 1;
  function a(t, e) {
    for (var r = -1, s = e.length, i = t.length; ++r < s; )
      t[i + r] = e[r];
    return t;
  }
  return ji = a, ji;
}
var Ui, Sh;
function Kc() {
  if (Sh) return Ui;
  Sh = 1;
  var a = Wc(), t = a(Object.getPrototypeOf, Object);
  return Ui = t, Ui;
}
var Gi, kh;
function Qc() {
  if (kh) return Gi;
  kh = 1;
  var a = Jc(), t = Kc(), e = Wn(), r = Zc(), s = Object.getOwnPropertySymbols, i = s ? function(n) {
    for (var o = []; n; )
      a(o, e(n)), n = t(n);
    return o;
  } : r;
  return Gi = i, Gi;
}
var Xi, Fh;
function Yd() {
  if (Fh) return Xi;
  Fh = 1;
  var a = Br(), t = Qc();
  function e(r, s) {
    return a(r, t(r), s);
  }
  return Xi = e, Xi;
}
var Yi, Th;
function tl() {
  if (Th) return Yi;
  Th = 1;
  var a = Jc(), t = Vn();
  function e(r, s, i) {
    var n = s(r);
    return t(r) ? n : a(n, i(r));
  }
  return Yi = e, Yi;
}
var Wi, Eh;
function Wd() {
  if (Eh) return Wi;
  Eh = 1;
  var a = tl(), t = Wn(), e = Xn();
  function r(s) {
    return a(s, e, t);
  }
  return Wi = r, Wi;
}
var $i, Ph;
function $d() {
  if (Ph) return $i;
  Ph = 1;
  var a = tl(), t = Qc(), e = Yn();
  function r(s) {
    return a(s, e, t);
  }
  return $i = r, $i;
}
var Zi, zh;
function Zd() {
  if (zh) return Zi;
  zh = 1;
  var a = ee(), t = gt(), e = a(t, "DataView");
  return Zi = e, Zi;
}
var Ji, Ch;
function Jd() {
  if (Ch) return Ji;
  Ch = 1;
  var a = ee(), t = gt(), e = a(t, "Promise");
  return Ji = e, Ji;
}
var Ki, Bh;
function Kd() {
  if (Bh) return Ki;
  Bh = 1;
  var a = ee(), t = gt(), e = a(t, "Set");
  return Ki = e, Ki;
}
var Qi, Dh;
function Qd() {
  if (Dh) return Qi;
  Dh = 1;
  var a = ee(), t = gt(), e = a(t, "WeakMap");
  return Qi = e, Qi;
}
var tn, Ih;
function $n() {
  if (Ih) return tn;
  Ih = 1;
  var a = Zd(), t = Hn(), e = Jd(), r = Kd(), s = Qd(), i = Pr(), n = Vc(), o = "[object Map]", h = "[object Object]", c = "[object Promise]", l = "[object Set]", u = "[object WeakMap]", f = "[object DataView]", d = n(a), p = n(t), x = n(e), m = n(r), y = n(s), _ = i;
  return (a && _(new a(new ArrayBuffer(1))) != f || t && _(new t()) != o || e && _(e.resolve()) != c || r && _(new r()) != l || s && _(new s()) != u) && (_ = function(b) {
    var w = i(b), M = w == h ? b.constructor : void 0, A = M ? n(M) : "";
    if (A)
      switch (A) {
        case d:
          return f;
        case p:
          return o;
        case x:
          return c;
        case m:
          return l;
        case y:
          return u;
      }
    return w;
  }), tn = _, tn;
}
var en, Rh;
function tp() {
  if (Rh) return en;
  Rh = 1;
  var a = Object.prototype, t = a.hasOwnProperty;
  function e(r) {
    var s = r.length, i = new r.constructor(s);
    return s && typeof r[0] == "string" && t.call(r, "index") && (i.index = r.index, i.input = r.input), i;
  }
  return en = e, en;
}
var rn, Lh;
function ep() {
  if (Lh) return rn;
  Lh = 1;
  var a = gt(), t = a.Uint8Array;
  return rn = t, rn;
}
var sn, Oh;
function Zn() {
  if (Oh) return sn;
  Oh = 1;
  var a = ep();
  function t(e) {
    var r = new e.constructor(e.byteLength);
    return new a(r).set(new a(e)), r;
  }
  return sn = t, sn;
}
var nn, qh;
function rp() {
  if (qh) return nn;
  qh = 1;
  var a = Zn();
  function t(e, r) {
    var s = r ? a(e.buffer) : e.buffer;
    return new e.constructor(s, e.byteOffset, e.byteLength);
  }
  return nn = t, nn;
}
var an, Nh;
function sp() {
  if (Nh) return an;
  Nh = 1;
  var a = /\w*$/;
  function t(e) {
    var r = new e.constructor(e.source, a.exec(e));
    return r.lastIndex = e.lastIndex, r;
  }
  return an = t, an;
}
var on, Hh;
function ip() {
  if (Hh) return on;
  Hh = 1;
  var a = Nn(), t = a ? a.prototype : void 0, e = t ? t.valueOf : void 0;
  function r(s) {
    return e ? Object(e.call(s)) : {};
  }
  return on = r, on;
}
var hn, Vh;
function np() {
  if (Vh) return hn;
  Vh = 1;
  var a = Zn();
  function t(e, r) {
    var s = r ? a(e.buffer) : e.buffer;
    return new e.constructor(s, e.byteOffset, e.length);
  }
  return hn = t, hn;
}
var cn, jh;
function ap() {
  if (jh) return cn;
  jh = 1;
  var a = Zn(), t = rp(), e = sp(), r = ip(), s = np(), i = "[object Boolean]", n = "[object Date]", o = "[object Map]", h = "[object Number]", c = "[object RegExp]", l = "[object Set]", u = "[object String]", f = "[object Symbol]", d = "[object ArrayBuffer]", p = "[object DataView]", x = "[object Float32Array]", m = "[object Float64Array]", y = "[object Int8Array]", _ = "[object Int16Array]", b = "[object Int32Array]", w = "[object Uint8Array]", M = "[object Uint8ClampedArray]", A = "[object Uint16Array]", v = "[object Uint32Array]";
  function S(F, T, k) {
    var L = F.constructor;
    switch (T) {
      case d:
        return a(F);
      case i:
      case n:
        return new L(+F);
      case p:
        return t(F, k);
      case x:
      case m:
      case y:
      case _:
      case b:
      case w:
      case M:
      case A:
      case v:
        return s(F, k);
      case o:
        return new L();
      case h:
      case u:
        return new L(F);
      case c:
        return e(F);
      case l:
        return new L();
      case f:
        return r(F);
    }
  }
  return cn = S, cn;
}
var ln, Uh;
function op() {
  if (Uh) return ln;
  Uh = 1;
  var a = je(), t = Object.create, e = /* @__PURE__ */ function() {
    function r() {
    }
    return function(s) {
      if (!a(s))
        return {};
      if (t)
        return t(s);
      r.prototype = s;
      var i = new r();
      return r.prototype = void 0, i;
    };
  }();
  return ln = e, ln;
}
var un, Gh;
function hp() {
  if (Gh) return un;
  Gh = 1;
  var a = op(), t = Kc(), e = Gn();
  function r(s) {
    return typeof s.constructor == "function" && !e(s) ? a(t(s)) : {};
  }
  return un = r, un;
}
var fn, Xh;
function cp() {
  if (Xh) return fn;
  Xh = 1;
  var a = $n(), t = Ue(), e = "[object Map]";
  function r(s) {
    return t(s) && a(s) == e;
  }
  return fn = r, fn;
}
var dn, Yh;
function lp() {
  if (Yh) return dn;
  Yh = 1;
  var a = cp(), t = jn(), e = Un(), r = e && e.isMap, s = r ? t(r) : a;
  return dn = s, dn;
}
var pn, Wh;
function up() {
  if (Wh) return pn;
  Wh = 1;
  var a = $n(), t = Ue(), e = "[object Set]";
  function r(s) {
    return t(s) && a(s) == e;
  }
  return pn = r, pn;
}
var xn, $h;
function fp() {
  if ($h) return xn;
  $h = 1;
  var a = up(), t = jn(), e = Un(), r = e && e.isSet, s = r ? t(r) : a;
  return xn = s, xn;
}
var mn, Zh;
function dp() {
  if (Zh) return mn;
  Zh = 1;
  var a = Fd(), t = Td(), e = Uc(), r = qd(), s = Vd(), i = jd(), n = Ud(), o = Xd(), h = Yd(), c = Wd(), l = $d(), u = $n(), f = tp(), d = ap(), p = hp(), x = Vn(), m = Gc(), y = lp(), _ = je(), b = fp(), w = Xn(), M = Yn(), A = 1, v = 2, S = 4, F = "[object Arguments]", T = "[object Array]", k = "[object Boolean]", L = "[object Date]", B = "[object Error]", G = "[object Function]", nt = "[object GeneratorFunction]", Dt = "[object Map]", bt = "[object Number]", ct = "[object Object]", q = "[object RegExp]", V = "[object Set]", $ = "[object String]", It = "[object Symbol]", re = "[object WeakMap]", Dr = "[object ArrayBuffer]", Xe = "[object DataView]", nl = "[object Float32Array]", al = "[object Float64Array]", ol = "[object Int8Array]", hl = "[object Int16Array]", cl = "[object Int32Array]", ll = "[object Uint8Array]", ul = "[object Uint8ClampedArray]", fl = "[object Uint16Array]", dl = "[object Uint32Array]", D = {};
  D[F] = D[T] = D[Dr] = D[Xe] = D[k] = D[L] = D[nl] = D[al] = D[ol] = D[hl] = D[cl] = D[Dt] = D[bt] = D[ct] = D[q] = D[V] = D[$] = D[It] = D[ll] = D[ul] = D[fl] = D[dl] = !0, D[B] = D[G] = D[re] = !1;
  function Ye(C, se, ie, pl, We, Rt) {
    var Q, $e = se & A, Ze = se & v, xl = se & S;
    if (ie && (Q = We ? ie(C, pl, We, Rt) : ie(C)), Q !== void 0)
      return Q;
    if (!_(C))
      return C;
    var Qn = x(C);
    if (Qn) {
      if (Q = f(C), !$e)
        return n(C, Q);
    } else {
      var ne = u(C), ta = ne == G || ne == nt;
      if (m(C))
        return i(C, $e);
      if (ne == ct || ne == F || ta && !We) {
        if (Q = Ze || ta ? {} : p(C), !$e)
          return Ze ? h(C, s(Q, C)) : o(C, r(Q, C));
      } else {
        if (!D[ne])
          return We ? C : {};
        Q = d(C, ne, $e);
      }
    }
    Rt || (Rt = new a());
    var ea = Rt.get(C);
    if (ea)
      return ea;
    Rt.set(C, Q), b(C) ? C.forEach(function(Lt) {
      Q.add(Ye(Lt, se, ie, Lt, C, Rt));
    }) : y(C) && C.forEach(function(Lt, Gt) {
      Q.set(Gt, Ye(Lt, se, ie, Gt, C, Rt));
    });
    var ml = xl ? Ze ? l : c : Ze ? M : w, ra = Qn ? void 0 : ml(C);
    return t(ra || C, function(Lt, Gt) {
      ra && (Gt = Lt, Lt = C[Gt]), e(Q, Gt, Ye(Lt, se, ie, Gt, C, Rt));
    }), Q;
  }
  return mn = Ye, mn;
}
var yn, Jh;
function pp() {
  if (Jh) return yn;
  Jh = 1;
  var a = dp(), t = 1, e = 4;
  function r(s) {
    return a(s, t | e);
  }
  return yn = r, yn;
}
var xp = pp();
const Kh = /* @__PURE__ */ In(xp), Jn = (a) => {
  const t = a.blocks.reduce((r, s) => (r[s.name] = s, r), {}), e = (r, s) => {
    let i = [];
    return r.forEach((n) => {
      if (n.type === "INSERT") {
        const o = n, h = t[o.block];
        if (!h) {
          te.error("no block found for insert. block:", o.block);
          return;
        }
        const c = o.rowCount ?? 1, l = o.columnCount ?? 1, u = o.rowSpacing ?? 0, f = o.columnSpacing ?? 0, d = o.rotation ?? 0;
        let p, x;
        if (c > 1 || l > 1) {
          const m = Math.cos(d * Math.PI / 180), y = Math.sin(d * Math.PI / 180);
          p = { x: -y * u, y: m * u }, x = { x: m * f, y: y * f };
        } else
          p = { x: 0, y: 0 }, x = { x: 0, y: 0 };
        for (let m = 0; m < c; m++)
          for (let y = 0; y < l; y++) {
            const _ = {
              x: o.x + p.x * m + x.x * y,
              y: o.y + p.y * m + x.y * y,
              scaleX: o.scaleX,
              scaleY: o.scaleY,
              scaleZ: o.scaleZ,
              extrusionX: o.extrusionX,
              extrusionY: o.extrusionY,
              extrusionZ: o.extrusionZ,
              rotation: o.rotation
            }, b = s.slice(0);
            b.push(_);
            const w = h.entities.map((M) => {
              const A = Kh(M);
              switch (A.layer = o.layer, A.type) {
                case "LINE": {
                  A.start.x -= h.x, A.start.y -= h.y, A.end.x -= h.x, A.end.y -= h.y;
                  break;
                }
                case "LWPOLYLINE":
                case "POLYLINE": {
                  A.vertices.forEach((v) => {
                    v.x -= h.x, v.y -= h.y;
                  });
                  break;
                }
                case "CIRCLE":
                case "ELLIPSE":
                case "ARC": {
                  A.x -= h.x, A.y -= h.y;
                  break;
                }
                case "SPLINE": {
                  A.controlPoints.forEach((v) => {
                    v.x -= h.x, v.y -= h.y;
                  });
                  break;
                }
              }
              return A;
            });
            i = i.concat(e(w, b));
          }
      } else {
        const o = Kh(n);
        o.transforms = s.slice().reverse(), i.push(o);
      }
    }), i;
  };
  return e(a.entities, []);
};
var W = xc();
const mp = (a, t) => typeof t > "u" || +t == 0 ? Math.round(a) : (a = +a, t = +t, isNaN(a) || !(typeof t == "number" && t % 1 === 0) ? NaN : (a = a.toString().split("e"), a = Math.round(+(a[0] + "e" + (a[1] ? +a[1] - t : -t))), a = a.toString().split("e"), +(a[0] + "e" + (a[1] ? +a[1] + t : t)))), yp = (a, t, e, r, s) => {
  const i = e.length, n = e[0].length;
  if (a < 0 || a > 1)
    throw new Error("t out of bounds [0,1]: " + a);
  if (t < 1) throw new Error("degree must be at least 1 (linear)");
  if (t > i - 1)
    throw new Error("degree must be less than or equal to point count - 1");
  if (!s) {
    s = [];
    for (let p = 0; p < i; p++)
      s[p] = 1;
  }
  if (r) {
    if (r.length !== i + t + 1)
      throw new Error("bad knot vector length");
  } else {
    r = [];
    for (let p = 0; p < i + t + 1; p++)
      r[p] = p;
  }
  const o = [t, r.length - 1 - t], h = r[o[0]], c = r[o[1]];
  a = a * (c - h) + h, a = Math.max(a, h), a = Math.min(a, c);
  let l;
  for (l = o[0]; l < o[1] && !(a >= r[l] && a <= r[l + 1]); l++)
    ;
  const u = [];
  for (let p = 0; p < i; p++) {
    u[p] = [];
    for (let x = 0; x < n; x++)
      u[p][x] = e[p][x] * s[p];
    u[p][n] = s[p];
  }
  let f;
  for (let p = 1; p <= t + 1; p++)
    for (let x = l; x > l - t - 1 + p; x--) {
      f = (a - r[x]) / (r[x + t + 1 - p] - r[x]);
      for (let m = 0; m < n + 1; m++)
        u[x][m] = (1 - f) * u[x - 1][m] + f * u[x][m];
    }
  const d = [];
  for (let p = 0; p < n; p++)
    d[p] = mp(u[l][p] / u[l][n], -9);
  return d;
}, gp = (a, t, e, r) => {
  r || (r = 5);
  let s, i, n;
  e < 0 ? (s = Math.atan(-e) * 4, i = new W.V2(a[0], a[1]), n = new W.V2(t[0], t[1])) : (s = Math.atan(e) * 4, i = new W.V2(t[0], t[1]), n = new W.V2(a[0], a[1]));
  const o = n.sub(i), h = o.length(), c = i.add(o.multiply(0.5)), l = Math.abs(h / 2 / Math.tan(s / 2)), u = o.norm();
  let f;
  if (s < Math.PI) {
    const b = new W.V2(
      u.x * Math.cos(Math.PI / 2) - u.y * Math.sin(Math.PI / 2),
      u.y * Math.cos(Math.PI / 2) + u.x * Math.sin(Math.PI / 2)
    );
    f = c.add(b.multiply(-l));
  } else {
    const b = new W.V2(
      u.x * Math.cos(Math.PI / 2) - u.y * Math.sin(Math.PI / 2),
      u.y * Math.cos(Math.PI / 2) + u.x * Math.sin(Math.PI / 2)
    );
    f = c.add(b.multiply(l));
  }
  const d = Math.atan2(n.y - f.y, n.x - f.x) / Math.PI * 180;
  let p = Math.atan2(i.y - f.y, i.x - f.x) / Math.PI * 180;
  p < d && (p += 360);
  const x = n.sub(f).length(), m = Math.floor(d / r) * r + r, y = Math.ceil(p / r) * r - r, _ = [];
  for (let b = m; b <= y; b += r)
    _.push(
      f.add(
        new W.V2(
          Math.cos(b / 180 * Math.PI) * x,
          Math.sin(b / 180 * Math.PI) * x
        )
      )
    );
  return e < 0 && _.reverse(), _.map((b) => [b.x, b.y]);
}, bp = (a, t) => a.map(function(e) {
  return [
    e[0] * Math.cos(t) - e[1] * Math.sin(t),
    e[1] * Math.cos(t) + e[0] * Math.sin(t)
  ];
}), gn = (a, t, e, r, s, i, n) => {
  i < s && (i += Math.PI * 2);
  let o = [];
  const h = Math.PI * 2 / 72, c = 1e-6;
  for (let l = s; l < i - c; l += h)
    o.push([Math.cos(l) * e, Math.sin(l) * r]);
  return o.push([Math.cos(i) * e, Math.sin(i) * r]), n && (o = bp(o, n)), o = o.map(function(l) {
    return [a + l[0], t + l[1]];
  }), o;
}, _p = (a, t, e, r, s) => {
  const i = [], n = a.map(function(c) {
    return [c.x, c.y];
  }), o = [e[t]], h = [e[t], e[e.length - 1 - t]];
  for (let c = t + 1; c < e.length - t; ++c)
    o[o.length - 1] !== e[c] && o.push(e[c]);
  r = r || 25;
  for (let c = 1; c < o.length; ++c) {
    const l = o[c - 1], u = o[c];
    for (let f = 0; f <= r; ++f) {
      let p = (f / r * (u - l) + l - h[0]) / (h[1] - h[0]);
      p = Math.max(p, 0), p = Math.min(p, 1);
      const x = yp(p, t, n, e, s);
      i.push(x);
    }
  }
  return i;
}, wp = (a) => {
  const t = [], e = [];
  for (const i of a.vertices)
    if (i.faces) {
      const n = { indices: [], hiddens: [] };
      for (const o of i.faces) {
        if (o === 0)
          break;
        n.indices.push(o < 0 ? -o - 1 : o - 1), n.hiddens.push(o < 0);
      }
      [3, 4].includes(n.indices.length) && e.push(n);
    } else
      t.push({ x: i.x, y: i.y });
  const r = [], s = (i, n) => {
    for (const o of r)
      if (o.slice(-1)[0] === i)
        return o.push(n);
    r.push([i, n]);
  };
  for (const i of e)
    for (let n = 0; n < i.indices.length; n++) {
      if (i.hiddens[n])
        continue;
      const o = (n + 1) % i.indices.length;
      s(i.indices[n], i.indices[o]);
    }
  for (const i of r)
    for (const n of r)
      if (i !== n && i[0] === n.slice(-1)[0]) {
        n.push(...i.slice(1)), i.splice(0, i.length);
        break;
      }
  return r.filter((i) => i.length).map((i) => i.map((n) => t[n]).map((n) => [n.x, n.y]));
}, el = (a, t) => {
  t = t || {};
  let e;
  if (a.type === "LINE" && (e = [
    [a.start.x, a.start.y],
    [a.end.x, a.end.y]
  ]), a.type === "LWPOLYLINE" || a.type === "POLYLINE") {
    if (e = [], a.polyfaceMesh)
      e.push(...wp(a)[0]);
    else if (!a.polygonMesh) {
      if (a.vertices.length) {
        a.closed && (a.vertices = a.vertices.concat(a.vertices[0]));
        for (let r = 0, s = a.vertices.length; r < s - 1; ++r) {
          const i = [a.vertices[r].x, a.vertices[r].y], n = [a.vertices[r + 1].x, a.vertices[r + 1].y];
          e.push(i), a.vertices[r].bulge && (e = e.concat(
            gp(i, n, a.vertices[r].bulge)
          )), r === s - 2 && e.push(n);
        }
      }
    }
  }
  if (a.type === "CIRCLE" && (e = gn(
    a.x,
    a.y,
    a.r,
    a.r,
    0,
    Math.PI * 2
  ), a.extrusionZ === -1 && (e = e.map(function(r) {
    return [-r[0], r[1]];
  }))), a.type === "ELLIPSE") {
    const r = Math.sqrt(
      a.majorX * a.majorX + a.majorY * a.majorY
    ), s = a.axisRatio * r, i = -Math.atan2(-a.majorY, a.majorX);
    e = gn(
      a.x,
      a.y,
      r,
      s,
      a.startAngle,
      a.endAngle,
      i
    ), a.extrusionZ === -1 && (e = e.map(function(n) {
      return [-n[0], n[1]];
    }));
  }
  return a.type === "ARC" && (e = gn(
    a.x,
    a.y,
    a.r,
    a.r,
    a.startAngle,
    a.endAngle,
    void 0
  ), a.extrusionZ === -1 && (e = e.map(function(r) {
    return [-r[0], r[1]];
  }))), a.type === "SPLINE" && (e = _p(
    a.controlPoints,
    a.degree,
    a.knots,
    t.interpolationsPerSplineSegment,
    a.weights
  )), e || (te.warn("unsupported entity for converting to polyline:", a.type), []);
}, An = [
  [0, 0, 0],
  [255, 0, 0],
  [255, 255, 0],
  [0, 255, 0],
  [0, 255, 255],
  [0, 0, 255],
  [255, 0, 255],
  [255, 255, 255],
  [65, 65, 65],
  [128, 128, 128],
  [255, 0, 0],
  [255, 170, 170],
  [189, 0, 0],
  [189, 126, 126],
  [129, 0, 0],
  [129, 86, 86],
  [104, 0, 0],
  [104, 69, 69],
  [79, 0, 0],
  [79, 53, 53],
  [255, 63, 0],
  [255, 191, 170],
  [189, 46, 0],
  [189, 141, 126],
  [129, 31, 0],
  [129, 96, 86],
  [104, 25, 0],
  [104, 78, 69],
  [79, 19, 0],
  [79, 59, 53],
  [255, 127, 0],
  [255, 212, 170],
  [189, 94, 0],
  [189, 157, 126],
  [129, 64, 0],
  [129, 107, 86],
  [104, 52, 0],
  [104, 86, 69],
  [79, 39, 0],
  [79, 66, 53],
  [255, 191, 0],
  [255, 234, 170],
  [189, 141, 0],
  [189, 173, 126],
  [129, 96, 0],
  [129, 118, 86],
  [104, 78, 0],
  [104, 95, 69],
  [79, 59, 0],
  [79, 73, 53],
  [255, 255, 0],
  [255, 255, 170],
  [189, 189, 0],
  [189, 189, 126],
  [129, 129, 0],
  [129, 129, 86],
  [104, 104, 0],
  [104, 104, 69],
  [79, 79, 0],
  [79, 79, 53],
  [191, 255, 0],
  [234, 255, 170],
  [141, 189, 0],
  [173, 189, 126],
  [96, 129, 0],
  [118, 129, 86],
  [78, 104, 0],
  [95, 104, 69],
  [59, 79, 0],
  [73, 79, 53],
  [127, 255, 0],
  [212, 255, 170],
  [94, 189, 0],
  [157, 189, 126],
  [64, 129, 0],
  [107, 129, 86],
  [52, 104, 0],
  [86, 104, 69],
  [39, 79, 0],
  [66, 79, 53],
  [63, 255, 0],
  [191, 255, 170],
  [46, 189, 0],
  [141, 189, 126],
  [31, 129, 0],
  [96, 129, 86],
  [25, 104, 0],
  [78, 104, 69],
  [19, 79, 0],
  [59, 79, 53],
  [0, 255, 0],
  [170, 255, 170],
  [0, 189, 0],
  [126, 189, 126],
  [0, 129, 0],
  [86, 129, 86],
  [0, 104, 0],
  [69, 104, 69],
  [0, 79, 0],
  [53, 79, 53],
  [0, 255, 63],
  [170, 255, 191],
  [0, 189, 46],
  [126, 189, 141],
  [0, 129, 31],
  [86, 129, 96],
  [0, 104, 25],
  [69, 104, 78],
  [0, 79, 19],
  [53, 79, 59],
  [0, 255, 127],
  [170, 255, 212],
  [0, 189, 94],
  [126, 189, 157],
  [0, 129, 64],
  [86, 129, 107],
  [0, 104, 52],
  [69, 104, 86],
  [0, 79, 39],
  [53, 79, 66],
  [0, 255, 191],
  [170, 255, 234],
  [0, 189, 141],
  [126, 189, 173],
  [0, 129, 96],
  [86, 129, 118],
  [0, 104, 78],
  [69, 104, 95],
  [0, 79, 59],
  [53, 79, 73],
  [0, 255, 255],
  [170, 255, 255],
  [0, 189, 189],
  [126, 189, 189],
  [0, 129, 129],
  [86, 129, 129],
  [0, 104, 104],
  [69, 104, 104],
  [0, 79, 79],
  [53, 79, 79],
  [0, 191, 255],
  [170, 234, 255],
  [0, 141, 189],
  [126, 173, 189],
  [0, 96, 129],
  [86, 118, 129],
  [0, 78, 104],
  [69, 95, 104],
  [0, 59, 79],
  [53, 73, 79],
  [0, 127, 255],
  [170, 212, 255],
  [0, 94, 189],
  [126, 157, 189],
  [0, 64, 129],
  [86, 107, 129],
  [0, 52, 104],
  [69, 86, 104],
  [0, 39, 79],
  [53, 66, 79],
  [0, 63, 255],
  [170, 191, 255],
  [0, 46, 189],
  [126, 141, 189],
  [0, 31, 129],
  [86, 96, 129],
  [0, 25, 104],
  [69, 78, 104],
  [0, 19, 79],
  [53, 59, 79],
  [0, 0, 255],
  [170, 170, 255],
  [0, 0, 189],
  [126, 126, 189],
  [0, 0, 129],
  [86, 86, 129],
  [0, 0, 104],
  [69, 69, 104],
  [0, 0, 79],
  [53, 53, 79],
  [63, 0, 255],
  [191, 170, 255],
  [46, 0, 189],
  [141, 126, 189],
  [31, 0, 129],
  [96, 86, 129],
  [25, 0, 104],
  [78, 69, 104],
  [19, 0, 79],
  [59, 53, 79],
  [127, 0, 255],
  [212, 170, 255],
  [94, 0, 189],
  [157, 126, 189],
  [64, 0, 129],
  [107, 86, 129],
  [52, 0, 104],
  [86, 69, 104],
  [39, 0, 79],
  [66, 53, 79],
  [191, 0, 255],
  [234, 170, 255],
  [141, 0, 189],
  [173, 126, 189],
  [96, 0, 129],
  [118, 86, 129],
  [78, 0, 104],
  [95, 69, 104],
  [59, 0, 79],
  [73, 53, 79],
  [255, 0, 255],
  [255, 170, 255],
  [189, 0, 189],
  [189, 126, 189],
  [129, 0, 129],
  [129, 86, 129],
  [104, 0, 104],
  [104, 69, 104],
  [79, 0, 79],
  [79, 53, 79],
  [255, 0, 191],
  [255, 170, 234],
  [189, 0, 141],
  [189, 126, 173],
  [129, 0, 96],
  [129, 86, 118],
  [104, 0, 78],
  [104, 69, 95],
  [79, 0, 59],
  [79, 53, 73],
  [255, 0, 127],
  [255, 170, 212],
  [189, 0, 94],
  [189, 126, 157],
  [129, 0, 64],
  [129, 86, 107],
  [104, 0, 52],
  [104, 69, 86],
  [79, 0, 39],
  [79, 53, 66],
  [255, 0, 63],
  [255, 170, 191],
  [189, 0, 46],
  [189, 126, 141],
  [129, 0, 31],
  [129, 86, 96],
  [104, 0, 25],
  [104, 69, 78],
  [79, 0, 19],
  [79, 53, 59],
  [51, 51, 51],
  [80, 80, 80],
  [105, 105, 105],
  [130, 130, 130],
  [190, 190, 190],
  [255, 255, 255]
], vp = (a, t) => {
  const e = a[t.layer];
  if (e) {
    const s = "colorNumber" in t && t.colorNumber !== 256 ? t.colorNumber : e.colorNumber, i = An[s];
    return i || [0, 0, 0];
  } else
    return te.warn("no layer table for layer:" + t.layer), [0, 0, 0];
}, Qh = (a, t) => ({
  x: a.x * Math.cos(t) - a.y * Math.sin(t),
  y: a.y * Math.cos(t) + a.x * Math.sin(t)
}), Mp = (a) => a[0] === 255 && a[1] === 255 && a[2] === 255 ? "rgb(0, 0, 0)" : `rgb(${a[0]}, ${a[1]}, ${a[2]})`, Ap = (a, t, e, r) => {
  const s = e, i = t, n = t.length;
  let o = 0, h = !1;
  for (let f = 0; f < n + a; f++)
    if (r > s[f] && r <= s[f + 1]) {
      o = f, h = !0;
      break;
    }
  if (!h)
    throw new Error("invalid new knot");
  const c = [];
  for (let f = 0; f < n + a + 1; f++)
    f <= o ? c[f] = s[f] : f === o + 1 ? c[f] = r : c[f] = s[f - 1];
  let l;
  const u = [];
  for (let f = 0; f < n + 1; f++)
    f <= o - a + 1 ? l = 1 : o - a + 2 <= f && f <= o ? s[f + a - 1] - s[f] === 0 ? l = 0 : l = (r - s[f]) / (s[f + a - 1] - s[f]) : l = 0, l === 0 ? u[f] = i[f - 1] : l === 1 ? u[f] = i[f] : u[f] = {
      x: (1 - l) * i[f - 1].x + l * i[f].x,
      y: (1 - l) * i[f - 1].y + l * i[f].y
    };
  return { controlPoints: u, knots: c };
}, Sp = (a, t) => {
  for (let e = 1; e < a; ++e)
    if (t[e] !== t[0])
      throw Error(`not pinned. order: ${a} knots: ${t}`);
  for (let e = t.length - 2; e > t.length - a - 1; --e)
    if (t[e] !== t[t.length - 1])
      throw Error(`not pinned. order: ${a} knots: ${t}`);
}, rl = (a, t) => {
  let e = 1;
  for (let r = t + 1; r < a.length && a[r] === a[t]; ++r)
    ++e;
  return e;
}, kp = (a, t) => {
  const e = [];
  let r = a;
  for (; r < t.length - a; ) {
    const s = t[r], i = rl(t, r);
    for (let n = 0; n < a - i - 1; ++n)
      e.push(s);
    r = r + i;
  }
  return e;
}, Fp = (a, t, e) => (Sp(a, e), kp(a, e).reduce(
  (s, i) => Ap(a, s.controlPoints, s.knots, i),
  { controlPoints: t, knots: e }
)), Ge = (a, t, e) => {
  let r = "";
  const s = e.map((n) => {
    const o = n.x || 0, h = n.y || 0, c = n.scaleX || 1, l = n.scaleY || 1, u = (n.rotation || 0) / 180 * Math.PI, { cos: f, sin: d } = Math;
    let p, x, m, y, _, b;
    return n.extrusionZ === -1 ? (p = -c * f(u), x = c * d(u), m = l * d(u), y = l * f(u), _ = -o, b = h) : (p = c * f(u), x = c * d(u), m = -l * d(u), y = l * f(u), _ = o, b = h), [p, x, m, y, _, b];
  });
  let i = new W.Box2();
  if (a.valid) {
    let n = [
      { x: a.min.x, y: a.min.y },
      { x: a.max.x, y: a.min.y },
      { x: a.max.x, y: a.max.y },
      { x: a.min.x, y: a.max.y }
    ];
    s.forEach(([o, h, c, l, u, f]) => {
      n = n.map((d) => ({
        x: d.x * o + d.y * c + u,
        y: d.x * h + d.y * l + f
      }));
    }), i = n.reduce((o, h) => o.expandByPoint(h), new W.Box2());
  }
  return s.reverse(), s.forEach(([n, o, h, c, l, u]) => {
    r += `<g transform="matrix(${n} ${o} ${h} ${c} ${l} ${u})">`;
  }), r += t, s.forEach((n) => {
    r += "</g>";
  }), { bbox: i, element: r };
}, Kn = (a, { bbox: t, element: e }) => a.extrusionZ === -1 ? {
  bbox: new W.Box2().expandByPoint({ x: -t.min.x, y: t.min.y }).expandByPoint({ x: -t.max.x, y: t.max.y }),
  element: `<g transform="matrix(-1 0 0 1 0 0)">
        ${e}
      </g>`
} : { bbox: t, element: e }, bn = (a) => {
  const t = el(a), e = t.reduce(
    (s, [i, n]) => s.expandByPoint({ x: i, y: n }),
    new W.Box2()
  ), r = t.reduce((s, i, n) => (s += n === 0 ? "M" : "L", s += i[0] + "," + i[1], s), "");
  return Ge(
    e,
    `<path d="${r}" />`,
    a.transforms
  );
}, Tp = (a) => {
  const t = new W.Box2().expandByPoint({
    x: a.x + a.r,
    y: a.y + a.r
  }).expandByPoint({
    x: a.x - a.r,
    y: a.y - a.r
  }), e = `<circle cx="${a.x}" cy="${a.y}" r="${a.r}" />`, { bbox: r, element: s } = Kn(a, {
    bbox: t,
    element: e
  });
  return Ge(r, s, a.transforms);
}, sl = (a, t, e, r, s, i, n, o) => {
  const h = Math.sqrt(e * e + r * r), c = s * h, l = -Math.atan2(-r, e), u = Ep(
    a,
    t,
    e,
    r,
    s,
    i,
    n
  );
  if (Math.abs(i - n) < 1e-9 || Math.abs(i - n + Math.PI * 2) < 1e-9) {
    const f = `<g transform="rotate(${l / Math.PI * 180} ${a}, ${t})">
      <ellipse cx="${a}" cy="${t}" rx="${h}" ry="${c}" />
    </g>`;
    return { bbox: u, element: f };
  } else {
    const f = Qh(
      {
        x: Math.cos(i) * h,
        y: Math.sin(i) * c
      },
      l
    ), d = {
      x: a + f.x,
      y: t + f.y
    }, p = Qh(
      {
        x: Math.cos(n) * h,
        y: Math.sin(n) * c
      },
      l
    ), x = {
      x: a + p.x,
      y: t + p.y
    }, y = (n < i ? n + Math.PI * 2 : n) - i < Math.PI ? 0 : 1, b = `<path d="${`M ${d.x} ${d.y} A ${h} ${c} ${l / Math.PI * 180} ${y} 1 ${x.x} ${x.y}`}" />`;
    return { bbox: u, element: b };
  }
}, Ep = (a, t, e, r, s, i, n, o) => {
  for (; i < 0; ) i += Math.PI * 2;
  for (; n <= i; ) n += Math.PI * 2;
  const h = [];
  if (Math.abs(e) < 1e-12 || Math.abs(r) < 1e-12)
    for (let d = 0; d < 4; d++)
      h.push(d / 2 * Math.PI);
  else
    h[0] = Math.atan(-r * s / e) - Math.PI, h[1] = Math.atan(e * s / r) - Math.PI, h[2] = h[0] - Math.PI, h[3] = h[1] - Math.PI;
  for (let d = 4; d >= 0; d--) {
    for (; h[d] < i; ) h[d] += Math.PI * 2;
    h[d] > n && h.splice(d, 1);
  }
  h.push(i), h.push(n);
  const c = h.map((d) => ({
    x: Math.cos(d),
    y: Math.sin(d)
  })), l = [
    [e, -r * s],
    [r, e * s]
  ];
  return c.map((d) => ({
    x: d.x * l[0][0] + d.y * l[0][1] + a,
    y: d.x * l[1][0] + d.y * l[1][1] + t
  })).reduce((d, p) => (d.expandByPoint(p), d), new W.Box2());
}, Pp = (a) => {
  const { bbox: t, element: e } = sl(
    a.x,
    a.y,
    a.majorX,
    a.majorY,
    a.axisRatio,
    a.startAngle,
    a.endAngle
  ), { bbox: r, element: s } = Kn(a, {
    bbox: t,
    element: e
  });
  return Ge(r, s, a.transforms);
}, zp = (a) => {
  const { bbox: t, element: e } = sl(
    a.x,
    a.y,
    a.r,
    0,
    1,
    a.startAngle,
    a.endAngle,
    a.extrusionZ === -1
  ), { bbox: r, element: s } = Kn(a, {
    bbox: t,
    element: e
  });
  return Ge(r, s, a.transforms);
}, Cp = (a, t, e) => {
  const r = [];
  let s = 0, i = a;
  for (; i < t.length - a + 1; ) {
    const n = rl(t, i), o = e.slice(s, s + a);
    a === 4 ? r.push(
      `<path d="M ${o[0].x} ${o[0].y} C ${o[1].x} ${o[1].y} ${o[2].x} ${o[2].y} ${o[3].x} ${o[3].y}" />`
    ) : a === 3 && r.push(
      `<path d="M ${o[0].x} ${o[0].y} Q ${o[1].x} ${o[1].y} ${o[2].x} ${o[2].y}" />`
    ), s += n, i += n;
  }
  return r;
}, Bp = (a) => {
  let t = new W.Box2();
  a.controlPoints.forEach((n) => {
    t = t.expandByPoint(n);
  });
  const e = a.degree + 1, r = Fp(e, a.controlPoints, a.knots), i = `<g>${Cp(e, r.knots, r.controlPoints).join("")}</g>`;
  return Ge(t, i, a.transforms);
}, Dp = (a) => {
  switch (a.type) {
    case "CIRCLE":
      return Tp(a);
    case "ELLIPSE":
      return Pp(a);
    case "ARC":
      return zp(a);
    case "SPLINE": {
      const t = a.weights && a.weights.some((e) => e !== 1);
      if ((a.degree === 2 || a.degree === 3) && !t)
        try {
          return Bp(a);
        } catch {
          return bn(a);
        }
      else
        return bn(a);
    }
    case "LINE":
    case "LWPOLYLINE":
    case "POLYLINE":
      return bn(a);
    default:
      return te.warn("entity type not supported in SVG rendering:", a.type), null;
  }
}, Ip = (a) => {
  const t = Jn(a), { bbox: e, elements: r } = t.reduce(
    (i, n, o) => {
      const h = vp(a.tables.layers, n), c = Dp(n);
      if (c) {
        const { bbox: l, element: u } = c;
        l.valid && (i.bbox.expandByPoint(l.min), i.bbox.expandByPoint(l.max)), i.elements.push(
          `<g stroke="${Mp(h)}">${u}</g>`
        );
      }
      return i;
    },
    {
      bbox: new W.Box2(),
      elements: []
    }
  ), s = e.valid ? {
    x: e.min.x,
    y: -e.max.y,
    width: e.max.x - e.min.x,
    height: e.max.y - e.min.y
  } : {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  };
  return `<?xml version="1.0"?>
<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
  preserveAspectRatio="xMinYMin meet"
  viewBox="${s.x} ${s.y} ${s.width} ${s.height}"
  width="100%" height="100%"
>
  <g stroke="#000000" stroke-width="0.1%" fill="none" transform="matrix(1,0,0,-1,0,0)">
    ${r.join(`
`)}
  </g>
</svg>`;
}, Rp = (a, t) => (t.forEach((e) => {
  a = a.map(function(r) {
    let s = [r[0], r[1]];
    if (e.scaleX && (s[0] = s[0] * e.scaleX), e.scaleY && (s[1] = s[1] * e.scaleY), e.rotation) {
      const i = e.rotation / 180 * Math.PI;
      s = [
        s[0] * Math.cos(i) - s[1] * Math.sin(i),
        s[1] * Math.cos(i) + s[0] * Math.sin(i)
      ];
    }
    return e.x && (s[0] = s[0] + e.x), e.y && (s[1] = s[1] + e.y), e.extrusionZ === -1 && (s[0] = -s[0]), s;
  });
}), a), Lp = (a) => {
  const e = Jn(a).map((s) => {
    const i = a.tables.layers[s.layer];
    let n = 0;
    return "colorNumber" in s ? n = s.colorNumber : i && (n = i.colorNumber), An[n] === void 0 && (n = 0), {
      rgb: An[n],
      layer: i,
      vertices: Rp(el(s), s.transforms)
    };
  }), r = new W.Box2();
  return e.forEach((s) => {
    s.vertices.forEach((i) => {
      r.expandByPoint({ x: i[0], y: i[1] });
    });
  }), { bbox: r, polylines: e };
}, Op = (a) => a.reduce((t, e) => {
  const r = e.layer;
  return t[r] || (t[r] = []), t[r].push(e), t;
}, {});
class qp {
  constructor(t) {
    if (typeof t != "string")
      throw Error("Helper constructor expects a DXF string");
    this._contents = t, this._parsed = null, this._denormalised = null;
  }
  parse() {
    return this._parsed = Jf(this._contents), te.info("parsed:", this.parsed), this._parsed;
  }
  get parsed() {
    return this._parsed === null && this.parse(), this._parsed;
  }
  denormalise() {
    return this._denormalised = Jn(this.parsed), te.info("denormalised:", this._denormalised), this._denormalised;
  }
  get denormalised() {
    return this._denormalised || this.denormalise(), this._denormalised;
  }
  group() {
    this._groups = Op(this.denormalised);
  }
  get groups() {
    return this._groups || this.group(), this._groups;
  }
  toSVG() {
    return Ip(this.parsed);
  }
  toPolylines() {
    return Lp(this.parsed);
  }
}
class Xp {
  constructor() {
    this._cache = {}, this.useCache = !0, this.colorHelper = new Bn(), this.LayerHelper = new pc();
  }
  /**
   * Returns a Three.js object with the dxf data. Calls to getFromPath method internally
   * @param file {File} dxf file to load.
   * @param fontPath {string} path to the font file.
      * @return {THREE.Group} object with the dxf data
  */
  async getFromFile(t, e) {
    let r = URL.createObjectURL(t);
    return await this.getFromPath(r, e);
  }
  /**
   * Returns a Three.js object with the dxf data.
   * @param path path to a dxf file to load. Type: String
   * @param fontPath path to the font file. Type: string	 
      * @return THREE.Group object with the dxf data
  */
  async getFromPath(t, e) {
    return await this._loadFont(e), this._font ? new Promise(async (r) => {
      let s = this._fromCache(t);
      if (s) {
        r(this._drawDXF(s.data ? s.data : s));
        return;
      }
      let i = await fetch(t);
      if (i.status !== 200) return null;
      let n = await i.text(), o = new qp(n).parse();
      this._toCache(t, o), this._lastDXF = o, o.tables.layers = this.LayerHelper.parse(o.tables.layers), this.layers = o.tables.layers, this.unit = o.header ? o.header.insUnits : 0, r(await this._drawDXF(o));
    }) : null;
  }
  async _drawDXF(t) {
    let e = new it();
    e.name = "DXFViewer", this.useCache || (H.cache = !1);
    let r = new Fr(t), s = new mc(t), i = new On(t), n = new Ln(t), o = new Yu(t, this._font), h = new Dn(t, this._font), c = new bc(t, this._font), l = new yc(t, this._font);
    return H.onBeforeTextDraw = this.onBeforeTextDraw, r = r.draw(t), s = s.draw(t), i = i.draw(t), n = n.draw(t), o = o.draw(t), h = h.draw(t), c = c.draw(t, t), l = l.draw(t), r && e.add(r), s && e.add(s), i && e.add(i), n && e.add(n), o && e.add(o), h && e.add(h), c && e.add(c), l && e.add(l), this._rotateByView(e, t), e;
  }
  _toCache(t, e) {
    this._cache[this._replaceEspecialChars(t)] = e;
  }
  _fromCache(t) {
    let e = this._cache[this._replaceEspecialChars(t)];
    return e || null;
  }
  _replaceEspecialChars(t) {
    return t.replaceAll("/", "").replaceAll(".", "").replaceAll("_", "").replaceAll("-", "");
  }
  async _loadFont(t) {
    if (!this._font)
      try {
        this._font = await new Promise((e, r) => {
          new Mu().load(t, e, null, r);
        });
      } catch (e) {
        console.log(e), this._font = null;
      }
  }
  _writeCount(t, e, r, s, i, n, o) {
    t && console.log("lines ", t.children.length), e && console.log("circles ", e.children.length), r && console.log("splines ", r.children.length), s && console.log("solids ", s.children.length), i && console.log("dimensions ", i.children.length), n && console.log("texts ", n.children.length), o && console.log("inserts ", o.children.length);
  }
  _rotateByView(t, e) {
    let r = e.objects && e.objects.layouts ? e.objects.layouts.find((i) => i.name.toLowerCase() === "model") : null;
    if (!r) return;
    let s = Object.keys(e.tables.vports);
    for (let i = 0; i < s.length; i++) {
      let n = e.tables.vports[s[i]];
      if (n.handle === r.lastActiveViewport && n.angle !== 0) {
        t.rotateOnAxis(new g(0, 0, 1), n.angle * Math.PI / 180);
        return;
      }
    }
  }
}
class tc {
  constructor() {
    this.snaps = [], this.min = new g(1 / 0, 1 / 0, 1 / 0), this.max = new g(-1 / 0, -1 / 0, -1 / 0), this.cuts = 5, this.voxel = null, this.decimals = 6;
  }
  /**
   * Fills the snaps array with the points of the scene
   * @param objs {Array|THREE.Object3D} ThreeJS object or array of ThreeJS objects.
  */
  process(t) {
    t = t instanceof Array ? t : [t], this._getSnaps(t, !0, !1), this._getSize(t), this.voxel = this._generateVoxels(this.min, this.max, 1)[0], this.snaps.forEach((e) => this._addPointToVoxel(e, this.voxel.voxels));
  }
  /**
   * Finds the nearest voxel to the point
   * @param {ThreeJS.Vector3} point Point to check near voxels. Type: THREE.Vector3
  */
  findVoxel(t, e = null) {
    let r = {
      x: Number(t.x.toFixed(this.decimals)),
      y: Number(t.y.toFixed(this.decimals)),
      z: Number(t.z.toFixed(this.decimals))
    };
    e = e || this.voxel.voxels;
    for (let s = 0; s < e.length; s++) {
      let i = e[s];
      if (i.min.x <= r.x && r.x <= i.max.x && i.min.y <= r.y && r.y <= i.max.y && i.min.z <= r.z && r.z <= i.max.z)
        return i.voxels.length > 0 ? this.findVoxel(t, i.voxels) : i;
    }
    return null;
  }
  _getSnaps(t, e = !0, r = !0) {
    for (let s = 0; s < t.length; s++)
      t[s].traverse((n) => {
        if (e && (n.isLine || n.isLineSegments)) {
          n.updateWorldMatrix(!0, !1), this.snaps.push({
            entity: n,
            point: new g(
              n.geometry.attributes.position.getX(0),
              n.geometry.attributes.position.getY(0),
              n.geometry.attributes.position.getZ(0)
            ).applyMatrix4(n.matrixWorld)
          });
          let o = n.geometry.attributes.position.count - 1;
          this.snaps.push({
            entity: n,
            point: new g(
              n.geometry.attributes.position.getX(o),
              n.geometry.attributes.position.getY(o),
              n.geometry.attributes.position.getZ(o)
            ).applyMatrix4(n.matrixWorld)
          });
        }
        if (r && n.isMesh) {
          n.updateWorldMatrix(!0, !1);
          for (let o = 0; o < n.geometry.attributes.position.count; o++)
            this.snaps.push({
              entity: n,
              point: new g(
                n.geometry.attributes.position.getX(o),
                n.geometry.attributes.position.getY(o),
                n.geometry.attributes.position.getZ(o)
              ).applyMatrix4(n.matrixWorld)
            });
        }
      });
  }
  _generateVoxels(t, e, r) {
    if (r === this.cuts) return [];
    let s = [], i = e.clone().sub(t).multiplyScalar(1 / r);
    for (let n = 0; n < r; n++)
      for (let o = 0; o < r; o++)
        for (let h = 0; h < r; h++) {
          let c = {
            name: "VOXEL_" + n + "_" + o + "_" + h,
            min: new g(t.x + n * i.x, t.y + o * i.y, t.z + h * i.z),
            max: new g(t.x + (n + 1) * i.x, t.y + (o + 1) * i.y, t.z + (h + 1) * i.z),
            snaps: []
          };
          c.voxels = this._generateVoxels(c.min, c.max, r + 1), s.push(c);
        }
    return s;
  }
  _addPointToVoxel(t, e) {
    for (let r = 0; r < e.length; r++) {
      let s = e[r];
      if (s.min.x <= t.point.x && t.point.x <= s.max.x && s.min.y <= t.point.y && t.point.y <= s.max.y && s.min.z <= t.point.z && t.point.z <= s.max.z) {
        s.voxels.length === 0 ? s.snaps.push(t) : this._addPointToVoxel(t, s.voxels);
        return;
      }
    }
  }
  _getSize(t) {
    t.forEach((e) => {
      let r = new zt().setFromObject(e);
      this.min.set(Math.min(this.min.x, r.min.x), Math.min(this.min.y, r.min.y), Math.min(this.min.z, r.min.z)), this.max.set(Math.max(this.max.x, r.max.x), Math.max(this.max.y, r.max.y), Math.max(this.max.z, r.max.z));
    });
  }
  /**
   * Clears all the data for a correct dispose of the object.
  */
  clear() {
    this.snaps.length = 0, this.min = null, this.max = null, this.voxel = null;
  }
}
class Yp {
  /**
   * Constructor
   * @param dxf {Array|THREE.Object3D} ThreeJS object or array of ThreeJS objects.
   * @param renderer {THREE.WebGLRenderer} ThreeJS renderer.
   * @param scene {THREE.Scene} ThreeJS scene.
   * @param camera {THREE.Camera} ThreeJS camera.
   * @param controls {THREE.OrbitControls} ThreeJS orbit controls.
  */
  constructor(t, e, r, s, i) {
    this.container = e.domElement, this.scene = r, this.camera = s, this.controls = i, this.snaps = new tc(), this.snaps.process(t), this._mouseDownEvent = (n) => {
      this._mouseDown(n);
    }, this._mouseUpEvent = (n) => {
      this._mouseUp(n);
    }, this._mouseMoveEvent = (n) => {
      this._mouseMove(n);
    }, this.container.addEventListener("pointerdown", this._mouseDownEvent), this.container.addEventListener("pointerup", this._mouseUpEvent), this.container.addEventListener("pointermove", this._mouseMoveEvent), this.raycaster = new dc(), this.mouse = new E(), this.plane = new Nl(), this.planeNormal = new g(), this.mousePos = new g(), this.vectorHelper = new g(), document.addEventListener("wheel", () => {
      this._changeSquareSize = !0;
    });
  }
  _mouseDown() {
  }
  _mouseUp() {
  }
  _mouseMove(t) {
    if (this.snaps) {
      t.mousePosInScene = this._getMousePosInScene(t);
      let e = { x: t.mousePosInScene.x, y: t.mousePosInScene.y, z: t.mousePosInScene.z }, r = this.snaps.findVoxel(e);
      if (r) {
        let s = this._findNearestSnapPoint(e, r);
        if (!s.snap) {
          this._hideSnapSquare();
          return;
        }
        s.distance < 5 ? (t.mousePosInScene = { x: s.snap.point.x, y: s.snap.point.y, z: s.snap.point.z }, this._showSnapSquare(s)) : this._hideSnapSquare();
      }
    }
  }
  resetSnaps() {
    this._clearSnapSquare(), this.snaps = new tc(), this.snaps.process(this.__cache.meshes);
  }
  _findNearestSnapPoint(t, e) {
    let r = { snap: null, distance: 1 / 0 };
    for (let s = 0; s < e.snaps.length; s++) {
      const i = e.snaps[s];
      let n = i.point.distanceTo(t);
      n < r.distance && (r.snap = i, r.distance = n);
    }
    return r;
  }
  _hideSnapSquare() {
    this._snapSquare && (this._snapSquare.visible = !1);
  }
  _showSnapSquare(t) {
    if (!this._snapSquare || this._changeSquareSize) {
      this._clearSnapSquare();
      let e = this._getSize();
      this._snapSquare = new Pt(new Fn(e, e, e), new Ne({ color: 16753920, wireframe: !0 })), this._snapSquare.visible = !1, this._snapSquare.initial = !0, this.scene.add(this._snapSquare);
    }
    this._snapSquare.position.copy(t.snap.point), this._snapSquare.visible = !0, console.log(`distance from Mouse: ${t.distance}, 3d entity: ${t.snap.entity.uuid}, DXF entity: ${t.snap.entity.userData.handle}`);
  }
  _getSize() {
    const t = {
      width: this.camera.right / this.camera.zoom - this.camera.left / this.camera.zoom,
      height: this.camera.top / this.camera.zoom - this.camera.bottom / this.camera.zoom
    };
    return delete this._changeSquareSize, Math.max(t.width, t.height) / 100;
  }
  _getMousePosInScene(t) {
    let e = t.currentTarget, r = this.camera.position.distanceTo(this.controls.target);
    this.mouse.x = t.offsetX / e.offsetWidth * 2 - 1, this.mouse.y = -(t.offsetY / e.offsetHeight) * 2 + 1, this.planeNormal.copy(this.camera.getWorldDirection(this.vectorHelper));
    let s = this.camera.position.clone();
    return s.add(this.planeNormal.multiplyScalar(r)), this.plane.setFromNormalAndCoplanarPoint(this.planeNormal, s), this.raycaster.setFromCamera(this.mouse, this.camera), this.raycaster.ray.intersectPlane(this.plane, this.mousePos), this.mousePos;
  }
  /**
   * Clears all the data for a correct dispose of the object.
  */
  clear() {
    this._clearSnapSquare(), this.snaps.clear(), this.container.removeEventListener("pointerdown", this._mouseDownEvent), this.container.removeEventListener("pointerup", this._mouseUpEvent), this.container.removeEventListener("pointermove", this._mouseMoveEvent), this.snaps = null, this.container = null, this.scene = null, this.camera = null, this.controls = null, this.raycaster = null, this.mouse = null, this.plane = null, this.planeNormal = null, this.mousePos = null, this.vectorHelper = null;
  }
  _clearSnapSquare() {
    this._snapSquare && (this._snapSquare.parent && this._snapSquare.parent.remove(this._snapSquare), this._snapSquare.geometry.dispose(), this._snapSquare.material.dispose(), this._snapSquare = null);
  }
}
class Np {
  constructor(t, e, r) {
    this.camera = e, this.container = t, this.raycaster = new dc(), this._calculateThreshold(), this.targets = r, this.container.addEventListener("wheel", () => {
      this._calculateThreshold();
    });
  }
  raycast(t) {
    this.raycaster.setFromCamera(t, this.camera);
    const e = this.raycaster.intersectObjects(this.targets, !0);
    return e.length === 0 ? null : e[0];
  }
  _calculateThreshold() {
    const t = {
      width: this.camera.right / this.camera.zoom - this.camera.left / this.camera.zoom,
      height: this.camera.top / this.camera.zoom - this.camera.bottom / this.camera.zoom
    }, e = Math.min(t.width, t.height);
    this.raycaster.params.Line.threshold = e / 500;
  }
}
class Hp {
  constructor() {
    this.callbacks = [];
  }
  subscribe(t, e) {
    const r = this.callbacks.find((s) => s.name === t);
    typeof r < "u" ? r.callbacks.push(e) : this.callbacks.push({ name: t, callbacks: [e] });
  }
  unSubscribe(t, e) {
    const r = this.callbacks.find((s) => s.name === t);
    if (typeof r < "u") {
      let s = r.callbacks.indexOf(e);
      s > -1 && r.callbacks.splice(s, 1), r.callbacks.length === 0 && (s = this.callbacks.indexOf(r), s > -1 && this.callbacks.splice(s, 1));
    }
  }
  hasSubscribers(t) {
    return typeof this.callbacks.find((r) => r.name === t) < "u";
  }
  async trigger(t, ...e) {
    const r = this.callbacks.find((s) => s.name === t);
    if (typeof r < "u")
      for (const s of r.callbacks)
        s && s.constructor.name === "AsyncFunction" ? await s(...e) : s(...e);
  }
}
class il extends Hp {
  constructor() {
    super();
  }
  _initRaycasting(t, e, r, s) {
    const i = [];
    r.traverse((n) => {
      n.geometry && i.push(n);
    }), this.pointer = new E(), this.raycast = s || new Np(t, e, i);
  }
  _clone(t) {
    const e = {};
    t.traverse((s) => {
      e[s.uuid] = s.userData, s.userData = null;
    });
    const r = t.clone();
    return t.traverse((s) => {
      s.userData = e[s.uuid];
    }), r;
  }
  _setMaterial(t) {
    this._material = new Ne({ depthTest: !1, depthWrite: !1 }), this._material.color.setHex(t), this._material.color.convertSRGBToLinear();
  }
}
class Wp extends il {
  constructor(t, e, r, s = null) {
    super(), this.container = t, this._clonedObjects = {}, this._initRaycasting(t, e, r, s), this._setMaterial(16753920), this.container.addEventListener("pointermove", async (i) => await this._onPointerMove(i), !1);
  }
  async _onPointerMove(t) {
    t.preventDefault();
    var e = t.target.getBoundingClientRect();
    const r = t.clientX - e.left, s = t.clientY - e.top;
    this.pointer.x = r / this.container.clientWidth * 2 - 1, this.pointer.y = -(s / this.container.clientHeight) * 2 + 1;
    const i = this.raycast.raycast(this.pointer);
    if (this.removeHover(), i) {
      const n = i.object.parent;
      if (!n.userData) return;
      this.hover(n), await this.trigger("hover", n);
    }
  }
  hover(t, e = null) {
    this._clonedObjects[t.uuid] || (this._clonedObjects[t.uuid] = { clone: this._clone(t), parent: t.parent });
    const r = this._clonedObjects[t.uuid];
    r.clone.hovered = !0, r.clone.traverse((s) => {
      s.material && (s.material = e || this._material);
    }), this._hovered = r.clone, r.parent.add(this._hovered);
  }
  removeHover() {
    this._hovered && this._hovered.parent && (this._hovered.parent.remove(this._hovered), this._hovered = null);
  }
}
class $p extends il {
  constructor(t, e, r, s = null) {
    super(), this.container = t, this.camera = e, this.dxf = r, this._initRaycasting(t, e, r, s), this._setMaterial(255), this.selecteds = [], this._boxHelpers = {
      start3dpoint: new g(),
      end3dpoint: new g(),
      boxMin: new g(),
      boxMax: new g()
    }, this._isMouseDown = !1, this._isMouseMoving = !1, this.container.addEventListener("pointerdown", async (i) => await this._onPointerDown(i), !1), this.container.addEventListener("pointerup", async (i) => await this._onPointerUp(i), !1), this.container.addEventListener("pointermove", async (i) => await this._onPointerMove(i), !1);
  }
  async _onPointerDown(t) {
    if (t.button === 0 && (this._isMouseDown = !0, t.ctrlKey)) {
      var e = t.target.getBoundingClientRect();
      const r = t.clientX - e.left, s = t.clientY - e.top;
      this._onSelectionBox = {
        start: { x: r, y: s },
        end: { x: r, y: s }
      };
    }
  }
  async _onPointerUp(t) {
    if (this._isMouseDown = !1, this._isMouseMoving) {
      this._isMouseMoving = !1;
      return;
    }
    if (t.button !== 0) return;
    t.preventDefault(), this.deselectAll();
    let e = null;
    if (this._onSelectionBox) {
      const s = this._getEntitiesUnderSelectionBox(this._onSelectionBox.start, this._onSelectionBox.end);
      s && (e = s);
    } else {
      var r = t.target.getBoundingClientRect();
      const s = t.clientX - r.left, i = t.clientY - r.top;
      this.pointer.x = s / this.container.clientWidth * 2 - 1, this.pointer.y = -(i / this.container.clientHeight) * 2 + 1;
      const n = await this.raycast.raycast(this.pointer);
      n && (e = n.object.parent);
    }
    e && (this.select(e), await this.trigger("select", e)), this._removeSelectionBox(), this._onSelectionBox = null;
  }
  async _onPointerMove(t) {
    if (this._onSelectionBox) {
      var e = t.target.getBoundingClientRect();
      const r = t.clientX - e.left, s = t.clientY - e.top;
      this._onSelectionBox.end = { x: r, y: s }, this.drawSelectionBox(this._onSelectionBox.start, this._onSelectionBox.end, e);
      return;
    } else this._isMouseDown && (this._isMouseMoving = !0);
  }
  drawSelectionBox(t, e, r) {
    this._removeSelectionBox();
    const s = Math.max(t.x, e.x) - Math.min(t.x, e.x), i = Math.max(t.y, e.y) - Math.min(t.y, e.y);
    this._selectionBox = document.createElement("div"), this._selectionBox.style.position = "absolute", this._selectionBox.style.border = "1px solid white", this._selectionBox.style.left = Math.min(t.x, e.x) + r.left + "px", this._selectionBox.style.top = Math.min(t.y, e.y) + r.top + "px", this._selectionBox.style.width = s + "px", this._selectionBox.style.height = i + "px", this._selectionBox.style.pointerEvents = "none", this._selectionBox.style.background = "blue", this._selectionBox.style.opacity = 0.25, document.body.appendChild(this._selectionBox);
  }
  _removeSelectionBox() {
    this._selectionBox && (document.body.removeChild(this._selectionBox), this._selectionBox = null);
  }
  _getEntitiesUnderSelectionBox(t, e) {
    t.x = t.x / this.container.clientWidth * 2 - 1, t.y = -(t.y / this.container.clientHeight) * 2 + 1, e.x = e.x / this.container.clientWidth * 2 - 1, e.y = -(e.y / this.container.clientHeight) * 2 + 1, this._boxHelpers.start3dpoint = new g(t.x, t.y, 0).unproject(this.camera), this._boxHelpers.end3dpoint = new g(e.x, e.y, 0).unproject(this.camera), this._boxHelpers.boxMin.set(
      Math.min(this._boxHelpers.start3dpoint.x, this._boxHelpers.end3dpoint.x),
      Math.min(this._boxHelpers.start3dpoint.y, this._boxHelpers.end3dpoint.y),
      0
    ), this._boxHelpers.boxMax.set(
      Math.max(this._boxHelpers.start3dpoint.x, this._boxHelpers.end3dpoint.x),
      Math.max(this._boxHelpers.start3dpoint.y, this._boxHelpers.end3dpoint.y),
      0
    );
    const r = new zt(this._boxHelpers.boxMin, this._boxHelpers.boxMax), s = this._getBlocksUnderBox(r, this.dxf);
    return s.length > 0 ? s : null;
  }
  _getBlocksUnderBox(t, e) {
    const r = [];
    if (!e || !e.children) return r;
    if (e.name !== "" && this._fitInsideBox(t, e))
      r.push(e);
    else
      for (let s = 0; s < e.children.length; s++) {
        const i = e.children[s], n = this._getBlocksUnderBox(t, i);
        n.length > 0 && r.push(...n);
      }
    return r;
  }
  _fitInsideBox(t, e) {
    let r = new zt().setFromObject(e);
    return t.containsBox(r);
  }
  select(t, e = null) {
    (t instanceof Array ? t : [t]).forEach((s) => {
      const i = this._clone(s);
      i.selected = !0, i.traverse((n) => {
        n.material && (n.material = e || this._material);
      }), s.parent.add(i), this.selecteds.push(i);
    });
  }
  deselectAll() {
    this.selecteds && (this.selecteds.forEach((t) => t.parent.remove(t)), this.selecteds.length = 0);
  }
}
const Zp = {
  Unitless: 0,
  Inches: 1,
  Feet: 2,
  Miles: 3,
  Millimeters: 4,
  Centimeters: 5,
  Meters: 6,
  Kilometers: 7,
  Microinches: 8,
  Mils: 9,
  Yards: 10,
  Angstroms: 11,
  Nanometers: 12,
  Microns: 13,
  Decimeters: 14,
  Decameters: 15,
  Hectometers: 16,
  Gigameters: 17,
  "Astronomical units": 18,
  "Light years": 19,
  Parsecs: 20,
  "US Survey Feet": 21,
  "US Survey Inch": 22,
  "US Survey Yard": 23,
  "US Survey Mile": 24
};
export {
  Xp as DXFViewer,
  Wp as Hover,
  Gu as Merger,
  $p as Select,
  Yp as SnapsHelper,
  Zp as UNITS
};
